str001WebpackJsonp(["site__stratco"],{

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/element/disabled.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (context, disabledState) {
  if (!supports) {
    supports = (0, _supports3.default)();
  }

  var element = (0, _contextToElement2.default)({
    label: 'element/disabled',
    context: context
  });

  // accept truthy/falsy values
  disabledState = Boolean(disabledState);
  var currentState = element.hasAttribute('data-ally-disabled');
  // if there's no value to set, we're running as a getter
  var runningAsGetter = arguments.length === 1;

  if ((0, _nativeDisabledSupported2.default)(element)) {
    if (runningAsGetter) {
      return element.disabled;
    }

    // form elements know the disabled attribute, which we shall use instead of our poor man's copy of it
    element.disabled = disabledState;
    return element;
  }

  if (runningAsGetter) {
    return currentState;
  }

  if (currentState === disabledState) {
    // no update necessary
    return element;
  }

  setElementDisabled(element, disabledState);
  return element;
};

var _contextToElement = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/context-to-element.js");

var _contextToElement2 = _interopRequireDefault(_contextToElement);

var _tabindexValue = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/tabindex-value.js");

var _tabindexValue2 = _interopRequireDefault(_tabindexValue);

var _nativeDisabledSupported = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/is/native-disabled-supported.js");

var _nativeDisabledSupported2 = _interopRequireDefault(_nativeDisabledSupported);

var _toggleAttribute = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/toggle-attribute.js");

var _toggleAttribute2 = _interopRequireDefault(_toggleAttribute);

var _toggleAttributeValue = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/toggle-attribute-value.js");

var _toggleAttributeValue2 = _interopRequireDefault(_toggleAttributeValue);

var _logger = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/logger.js");

var _logger2 = _interopRequireDefault(_logger);

var _supports2 = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/supports.js");

var _supports3 = _interopRequireDefault(_supports2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var supports = void 0;
/*
  Utility to make any element inert (disabled). Inert means the elements cannot be interacted
  with and they cannot be focused via script, pointer or keyboard - and thus not receive focus.

  Elements made inert (disabled) by this utility are given the attribute [data-ally-disabled="true"].

  ---------------

  inert attribute was [removed](https://html5.org/r/8536) [tweet by steve](https://twitter.com/stevefaulkner/status/443075900201259008)
  but definition of [inert subtrees](https://www.w3.org/html/wg/drafts/html/master/editing.html#inert-subtrees) remains.

  [implementation idea by Vasilis](https://codepen.io/vasilisvg/pen/scowI)
  [inert attribute polyfill by GoogleChrome](https://github.com/GoogleChrome/inert-polyfill)

  [Gecko Bug: Inert Attribute](https://bugzilla.mozilla.org/show_bug.cgi?id=921504)
  [Chromium Bug: Inert Attribute](https://code.google.com/p/chromium/issues/detail?id=269846)
  [Chromium Bug: Inert Subtree](https://code.google.com/p/chromium/issues/detail?id=241699)
  [WebKit Bug: Inert Subtree](https://bugs.webkit.org/show_bug.cgi?id=110952)
*/

function disabledFocus() {
  _logger2.default.warn('trying to focus inert element', this);
}

function disableTabindex(element, disabledState) {
  if (disabledState) {
    var tabIndex = (0, _tabindexValue2.default)(element);
    (0, _toggleAttributeValue2.default)({
      element: element,
      attribute: 'tabindex',
      temporaryValue: '-1',
      saveValue: tabIndex !== null ? tabIndex : ''
    });
  } else {
    (0, _toggleAttributeValue2.default)({
      element: element,
      attribute: 'tabindex'
    });
  }
}

function disableVideoControls(element, disabledState) {
  (0, _toggleAttribute2.default)({
    element: element,
    attribute: 'controls',
    remove: disabledState
  });
}

function disableSvgFocusable(element, disabledState) {
  (0, _toggleAttributeValue2.default)({
    element: element,
    attribute: 'focusable',
    temporaryValue: disabledState ? 'false' : undefined
  });
}

function disableSvgLink(element, disabledState) {
  (0, _toggleAttribute2.default)({
    element: element,
    attribute: 'xlink:href',
    remove: disabledState
  });
}

function setAriaDisabled(element, disabledState) {
  (0, _toggleAttributeValue2.default)({
    element: element,
    attribute: 'aria-disabled',
    temporaryValue: disabledState ? 'true' : undefined
  });
}

function disableScriptFocus(element, disabledState) {
  if (disabledState) {
    // make sure no script can focus the element
    element.focus = disabledFocus;
  } else {
    // restore original focus function from prototype
    delete element.focus;
  }
}

function disablePointerEvents(element, disabledState) {
  if (disabledState) {
    // remember previous pointer events status so we can restore it
    var pointerEvents = element.style.pointerEvents || '';
    element.setAttribute('data-inert-pointer-events', pointerEvents);
    // make sure no pointer interaction can access the element
    element.style.pointerEvents = 'none';
  } else {
    // restore to previous pointer interaction status
    var _pointerEvents = element.getAttribute('data-inert-pointer-events');
    element.removeAttribute('data-inert-pointer-events');
    element.style.pointerEvents = _pointerEvents;
  }
}

function setElementDisabled(element, disabledState) {
  setAriaDisabled(element, disabledState);
  disableTabindex(element, disabledState);
  disableScriptFocus(element, disabledState);
  disablePointerEvents(element, disabledState);

  var nodeName = element.nodeName.toLowerCase();
  if (nodeName === 'video' || nodeName === 'audio') {
    // Blink and Gecko leave <video controls tabindex="-1"> in document focus navigation sequence
    // Blink leaves <audio controls tabindex="-1"> in document focus navigation sequence
    disableVideoControls(element, disabledState);
  }

  if (nodeName === 'svg' || element.ownerSVGElement) {
    if (supports.focusSvgFocusableAttribute) {
      // Internet Explorer knows focusable="false" instead of tabindex="-1"
      disableSvgFocusable(element, disabledState);
    } else if (!supports.focusSvgTabindexAttribute && nodeName === 'a') {
      // Firefox neither knows focusable="false" nor tabindex="-1"
      disableSvgLink(element, disabledState);
    }
  }

  if (disabledState) {
    element.setAttribute('data-ally-disabled', 'true');
  } else {
    element.removeAttribute('data-ally-disabled');
  }
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/element/focus.svg-foreign-object-hack.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (element) {
  // Edge13, Edge14: foreignObject focus hack
  // https://jsbin.com/kunehinugi/edit?html,js,output
  // https://jsbin.com/fajagi/3/edit?html,js,output
  var isSvgElement = element.ownerSVGElement || element.nodeName.toLowerCase() === 'svg';
  if (!isSvgElement) {
    return false;
  }

  // inject and focus an <input> element into the SVG element to receive focus
  var foreignObject = makeFocusableForeignObject();
  element.appendChild(foreignObject);
  var input = foreignObject.querySelector('input');
  input.focus();

  // upon disabling the activeElement, IE and Edge
  // will not shift focus to <body> like all the other
  // browsers, but instead find the first focusable
  // ancestor and shift focus to that
  input.disabled = true;

  // clean up
  element.removeChild(foreignObject);
  return true;
};

function makeFocusableForeignObject() {
  var fragment = document.createElement('div');
  fragment.innerHTML = '<svg><foreignObject width="30" height="30">\n      <input type="text"/>\n  </foreignObject></svg>';

  return fragment.firstChild.firstChild;
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/event/shadow-focus.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _activeElements = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/get/active-elements.js");

var _activeElements2 = _interopRequireDefault(_activeElements);

var _decorateService = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/decorate-service.js");

var _decorateService2 = _interopRequireDefault(_decorateService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
  Utility to observe focus changes within ShadowDOMs.

  USAGE:
    engage();
    document.body.addEventListener('shadow-focus', function(event) {
      // event.detail.elements: complete focus ancestry (array of nodes)
      // event.detail.active: the actually focused element within the ShadowDOM
      // event.detail.hosts: the shadow host ancestry of the active element
    }, false);

  Alternate implementation: https://github.com/cdata/focus-observer
*/

var engage = void 0;
var disengage = void 0;

if (typeof document === 'undefined' || !document.documentElement.createShadowRoot) {
  // no need to initialize any of this if we don't have ShadowDOM available
  engage = disengage = function disengage() {};
} else {
  var blurTimer = void 0;
  var blurElement = void 0;

  var handleElementBlurEvent = function handleElementBlurEvent() {
    stopHandleElementBlurEvent();
    // abort any handlers that come from document blur handler
    (window.clearImmediate || window.clearTimeout)(blurTimer);
    blurTimer = (window.setImmediate || window.setTimeout)(function () {
      handleFocusChange();
    });
  };

  var observeElementBlurEvent = function observeElementBlurEvent(element) {
    // call us when we're leaving the element
    element.addEventListener('blur', handleElementBlurEvent, true);
    blurElement = element;
  };

  var stopHandleElementBlurEvent = function stopHandleElementBlurEvent() {
    // once() - sometimes I miss jQuery's simplicity…
    blurElement && blurElement.removeEventListener('blur', handleElementBlurEvent, true);
    blurElement = null;
  };

  var handleFocusChange = function handleFocusChange() {
    var _active = (0, _activeElements2.default)();
    if (_active.length === 1) {
      stopHandleElementBlurEvent();
      return;
    }

    // listen for blur so we know when to re-validate
    observeElementBlurEvent(_active[0]);
    var shadowFocusEvent = new CustomEvent('shadow-focus', {
      bubbles: false,
      cancelable: false,
      detail: {
        // complete focus ancestry
        elements: _active,
        // the actually focused element
        active: _active[0],
        // shadow host ancestry
        hosts: _active.slice(1)
      }
    });

    document.dispatchEvent(shadowFocusEvent);
  };

  var handleDocumentFocusEvent = function handleDocumentFocusEvent() {
    (window.clearImmediate || window.clearTimeout)(blurTimer);
    handleFocusChange();
  };

  engage = function engage() {
    document.addEventListener('focus', handleDocumentFocusEvent, true);
  };

  disengage = function disengage() {
    (window.clearImmediate || window.clearTimeout)(blurTimer);
    blurElement && blurElement.removeEventListener('blur', handleElementBlurEvent, true);
    document.removeEventListener('focus', handleDocumentFocusEvent, true);
  };
}

exports.default = (0, _decorateService2.default)({ engage: engage, disengage: disengage });

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/get/active-elements.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  if (document.activeElement === null) {
    // IE10 does not redirect focus to <body> when the activeElement is removed
    document.body.focus();
  }

  // Firefox currently leaks the shadowed element
  // @browser-issue Gecko https://bugzilla.mozilla.org/show_bug.cgi?id=1117535
  if ((0, _shadowed2.default)(document.activeElement)) {
    return walkFromShadowedElement();
  }

  return walkToShadowedElement();
};

var _shadowed = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/is/shadowed.js");

var _shadowed2 = _interopRequireDefault(_shadowed);

var _shadowHostParents = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/get/shadow-host-parents.js");

var _shadowHostParents2 = _interopRequireDefault(_shadowHostParents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// [0] always is the actual active element (even within web-components)
// [0+n] is the hierarchy of shadow-doms with [length -1] being the top most shadow-host

function walkToShadowedElement() {
  var list = [document.activeElement];

  while (list[0] && list[0].shadowRoot) {
    list.unshift(list[0].shadowRoot.activeElement);
  }

  return list;
}

function walkFromShadowedElement() {
  var hosts = (0, _shadowHostParents2.default)({ context: document.activeElement });
  return [document.activeElement].concat(hosts);
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/get/insignificant-branches.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      context = _ref2.context,
      filter = _ref2.filter;

  context = (0, _contextToElement2.default)({
    label: 'get/insignificant-branches',
    defaultToDocument: true,
    context: context
  });

  filter = (0, _nodeArray2.default)(filter);
  if (!filter.length) {
    throw new TypeError('get/insignificant-branches requires valid options.filter');
  }

  return queryInsignificantBranches({
    context: context,
    filter: filter
  });
};

var _contextToElement = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/context-to-element.js");

var _contextToElement2 = _interopRequireDefault(_contextToElement);

var _nodeArray = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/node-array.js");

var _nodeArray2 = _interopRequireDefault(_nodeArray);

var _comparePosition = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/compare-position.js");

var _getDocument = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/get-document.js");

var _getDocument2 = _interopRequireDefault(_getDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// find all highest elements within context that do not contain any of the filter elements.
// (basically the tree minus the parent paths of each filtered element reduced to the top most nodes)
// originally inspired by Marcy Sutton's Material Dialog Component:
// https://github.com/angular/material/blob/v0.11.1/src/components/dialog/dialog.js#L748-L783
// to avoid this behavior: https://marcysutton.com/slides/mobile-a11y-seattlejs/#/36

function queryInsignificantBranches(_ref) {
  var context = _ref.context,
      filter = _ref.filter;

  var containsFilteredElement = function containsFilteredElement(node) {
    var containsNode = (0, _comparePosition.getParentComparator)({ parent: node });
    return filter.some(containsNode);
  };

  // We'd use a Set() for this, if we could
  var insiginificantBranches = [];

  // see https://developer.mozilla.org/en-US/docs/Web/API/NodeFilter
  var CollectInsignificantBranchesFilter = function CollectInsignificantBranchesFilter(node) {
    if (filter.some(function (element) {
      return node === element;
    })) {
      // we've hit a filtered element and can ignore its children
      return NodeFilter.FILTER_REJECT;
    }

    if (containsFilteredElement(node)) {
      // we've hit a significant tree, so we'll have to keep investigating
      return NodeFilter.FILTER_ACCEPT;
    }

    // we've found an insignificant tree
    insiginificantBranches.push(node);
    return NodeFilter.FILTER_REJECT;
  };
  // IE requires a function, Browsers require {acceptNode: function}
  // see https://www.bennadel.com/blog/2607-finding-html-comment-nodes-in-the-dom-using-treewalker.htm
  CollectInsignificantBranchesFilter.acceptNode = CollectInsignificantBranchesFilter;

  var _document = (0, _getDocument2.default)(context);
  // see https://developer.mozilla.org/en-US/docs/Web/API/Document/createTreeWalker
  var walker = _document.createTreeWalker(
  // root element to start search in
  context,
  // element type filter
  NodeFilter.SHOW_ELEMENT,
  // custom NodeFilter filter
  CollectInsignificantBranchesFilter,
  // deprecated, but IE requires it
  false);

  while (walker.nextNode()) {
    // collection things is happening through the filter method
  }

  return insiginificantBranches;
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/get/parents.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      context = _ref.context;

  var list = [];
  var element = (0, _contextToElement2.default)({
    label: 'get/parents',
    context: context
  });

  while (element) {
    list.push(element);
    // IE does know support parentElement on SVGElement
    element = element.parentNode;
    if (element && element.nodeType !== Node.ELEMENT_NODE) {
      element = null;
    }
  }

  return list;
};

var _contextToElement = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/context-to-element.js");

var _contextToElement2 = _interopRequireDefault(_contextToElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/get/shadow-host-parents.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      context = _ref.context;

  var list = [];
  var element = (0, _contextToElement2.default)({
    label: 'get/shadow-host-parents',
    context: context
  });

  while (element) {
    element = (0, _shadowHost2.default)({ context: element });
    if (!element) {
      break;
    }

    list.push(element);
  }

  return list;
};

var _shadowHost = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/get/shadow-host.js");

var _shadowHost2 = _interopRequireDefault(_shadowHost);

var _contextToElement = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/context-to-element.js");

var _contextToElement2 = _interopRequireDefault(_contextToElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/get/shadow-host.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      context = _ref.context;

  var element = (0, _contextToElement2.default)({
    label: 'get/shadow-host',
    context: context
  });

  // walk up to the root
  var container = null;

  while (element) {
    container = element;
    element = element.parentNode;
  }

  // https://developer.mozilla.org/en-US/docs/Web/API/Node.nodeType
  // NOTE: Firefox 34 does not expose ShadowRoot.host (but 37 does)
  if (container.nodeType === container.DOCUMENT_FRAGMENT_NODE && container.host) {
    // the root is attached to a fragment node that has a host
    return container.host;
  }

  return null;
};

var _contextToElement = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/context-to-element.js");

var _contextToElement2 = _interopRequireDefault(_contextToElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/is/disabled.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (context) {
  if (!supports) {
    supports = (0, _supports3.default)();
  }

  var element = (0, _contextToElement2.default)({
    label: 'is/disabled',
    context: context
  });

  if (element.hasAttribute('data-ally-disabled')) {
    // treat ally's element/disabled like the DOM native element.disabled
    return true;
  }

  if (!(0, _nativeDisabledSupported2.default)(element)) {
    // non-form elements do not support the disabled attribute
    return false;
  }

  if (element.disabled) {
    // the element itself is disabled
    return true;
  }

  var parents = (0, _parents2.default)({ context: element });
  if (parents.some(isDisabledFieldset)) {
    // a parental <fieldset> is disabld and inherits the state onto this element
    return true;
  }

  if (!supports.focusFormDisabled && parents.some(isDisabledForm)) {
    // a parental <form> is disabld and inherits the state onto this element
    return true;
  }

  return false;
};

var _contextToElement = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/context-to-element.js");

var _contextToElement2 = _interopRequireDefault(_contextToElement);

var _parents = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/get/parents.js");

var _parents2 = _interopRequireDefault(_parents);

var _nativeDisabledSupported = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/is/native-disabled-supported.js");

var _nativeDisabledSupported2 = _interopRequireDefault(_nativeDisabledSupported);

var _supports2 = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/supports.js");

var _supports3 = _interopRequireDefault(_supports2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Determine if an element is disabled (i.e. not editable)

var supports = void 0;

function isDisabledFieldset(element) {
  var nodeName = element.nodeName.toLowerCase();
  return nodeName === 'fieldset' && element.disabled;
}

function isDisabledForm(element) {
  var nodeName = element.nodeName.toLowerCase();
  return nodeName === 'form' && element.disabled;
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/is/focus-relevant.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _parents = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/get/parents.js");

var _parents2 = _interopRequireDefault(_parents);

var _contextToElement = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/context-to-element.js");

var _contextToElement2 = _interopRequireDefault(_contextToElement);

var _elementMatches = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/element-matches.js");

var _elementMatches2 = _interopRequireDefault(_elementMatches);

var _tabindexValue = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/tabindex-value.js");

var _tabindexValue2 = _interopRequireDefault(_tabindexValue);

var _validTabindex = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/is/valid-tabindex.js");

var _validTabindex2 = _interopRequireDefault(_validTabindex);

var _is = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/is/is.util.js");

var _supports2 = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/supports.js");

var _supports3 = _interopRequireDefault(_supports2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var supports = void 0;
// determine if an element supports.can be focused by script regardless
// of the element actually being focusable at the time of execution
// i.e. <input disabled> is conisdered focus-relevant, but not focusable

function isFocusRelevantRules() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      context = _ref.context,
      _ref$except = _ref.except,
      except = _ref$except === undefined ? {
    flexbox: false,
    scrollable: false,
    shadow: false
  } : _ref$except;

  if (!supports) {
    supports = (0, _supports3.default)();
  }

  var element = (0, _contextToElement2.default)({
    label: 'is/focus-relevant',
    resolveDocument: true,
    context: context
  });

  if (!except.shadow && element.shadowRoot) {
    // a ShadowDOM host receives focus when the focus moves to its content
    return true;
  }

  var nodeName = element.nodeName.toLowerCase();

  if (nodeName === 'input' && element.type === 'hidden') {
    // input[type="hidden"] supports.cannot be focused
    return false;
  }

  if (nodeName === 'input' || nodeName === 'select' || nodeName === 'button' || nodeName === 'textarea') {
    return true;
  }

  if (nodeName === 'legend' && supports.focusRedirectLegend) {
    // specifics filtered in is/focusable
    return true;
  }

  if (nodeName === 'label') {
    // specifics filtered in is/focusable
    return true;
  }

  if (nodeName === 'area') {
    // specifics filtered in is/focusable
    return true;
  }

  if (nodeName === 'a' && element.hasAttribute('href')) {
    return true;
  }

  if (nodeName === 'object' && element.hasAttribute('usemap')) {
    // object[usemap] is not focusable in any browser
    return false;
  }

  if (nodeName === 'object') {
    var svgType = element.getAttribute('type');
    if (!supports.focusObjectSvg && svgType === 'image/svg+xml') {
      // object[type="image/svg+xml"] is not focusable in Internet Explorer
      return false;
    } else if (!supports.focusObjectSwf && svgType === 'application/x-shockwave-flash') {
      // object[type="application/x-shockwave-flash"] is not focusable in Internet Explorer 9
      return false;
    }
  }

  if (nodeName === 'iframe' || nodeName === 'object') {
    // browsing context containers
    return true;
  }

  if (nodeName === 'embed' || nodeName === 'keygen') {
    // embed is considered focus-relevant but not focusable
    // see https://github.com/medialize/ally.js/issues/82
    return true;
  }

  if (element.hasAttribute('contenteditable')) {
    // also see CSS property user-modify below
    return true;
  }

  if (nodeName === 'audio' && (supports.focusAudioWithoutControls || element.hasAttribute('controls'))) {
    return true;
  }

  if (nodeName === 'video' && (supports.focusVideoWithoutControls || element.hasAttribute('controls'))) {
    return true;
  }

  if (supports.focusSummary && nodeName === 'summary') {
    return true;
  }

  var validTabindex = (0, _validTabindex2.default)(element);

  if (nodeName === 'img' && element.hasAttribute('usemap')) {
    // Gecko, Trident and Edge do not allow an image with an image map and tabindex to be focused,
    // it appears the tabindex is overruled so focus is still forwarded to the <map>
    return validTabindex && supports.focusImgUsemapTabindex || supports.focusRedirectImgUsemap;
  }

  if (supports.focusTable && (nodeName === 'table' || nodeName === 'td')) {
    // IE10-11 supports.can focus <table> and <td>
    return true;
  }

  if (supports.focusFieldset && nodeName === 'fieldset') {
    // IE10-11 supports.can focus <fieldset>
    return true;
  }

  var isSvgElement = nodeName === 'svg';
  var isSvgContent = element.ownerSVGElement;
  var focusableAttribute = element.getAttribute('focusable');
  var tabindex = (0, _tabindexValue2.default)(element);

  if (nodeName === 'use' && tabindex !== null && !supports.focusSvgUseTabindex) {
    // <use> cannot be made focusable by adding a tabindex attribute anywhere but Blink and WebKit
    return false;
  }

  if (nodeName === 'foreignobject') {
    // <use> can only be made focusable in Blink and WebKit
    return tabindex !== null && supports.focusSvgForeignobjectTabindex;
  }

  if ((0, _elementMatches2.default)(element, 'svg a') && element.hasAttribute('xlink:href')) {
    return true;
  }

  if ((isSvgElement || isSvgContent) && element.focus && !supports.focusSvgNegativeTabindexAttribute && tabindex < 0) {
    // Firefox 51 and 52 treat any natively tabbable SVG element with
    // tabindex="-1" as tabbable and everything else as inert
    // see https://bugzilla.mozilla.org/show_bug.cgi?id=1302340
    return false;
  }

  if (isSvgElement) {
    return validTabindex || supports.focusSvg || supports.focusSvgInIframe
    // Internet Explorer understands the focusable attribute introduced in SVG Tiny 1.2
    || Boolean(supports.focusSvgFocusableAttribute && focusableAttribute && focusableAttribute === 'true');
  }

  if (isSvgContent) {
    if (supports.focusSvgTabindexAttribute && validTabindex) {
      return true;
    }

    if (supports.focusSvgFocusableAttribute) {
      // Internet Explorer understands the focusable attribute introduced in SVG Tiny 1.2
      return focusableAttribute === 'true';
    }
  }

  // https://www.w3.org/TR/html5/editing.html#sequential-focus-navigation-and-the-tabindex-attribute
  if (validTabindex) {
    return true;
  }

  var style = window.getComputedStyle(element, null);
  if ((0, _is.isUserModifyWritable)(style)) {
    return true;
  }

  if (supports.focusImgIsmap && nodeName === 'img' && element.hasAttribute('ismap')) {
    // IE10-11 considers the <img> in <a href><img ismap> focusable
    // https://github.com/medialize/ally.js/issues/20
    var hasLinkParent = (0, _parents2.default)({ context: element }).some(function (parent) {
      return parent.nodeName.toLowerCase() === 'a' && parent.hasAttribute('href');
    });

    if (hasLinkParent) {
      return true;
    }
  }

  // https://github.com/medialize/ally.js/issues/21
  if (!except.scrollable && supports.focusScrollContainer) {
    if (supports.focusScrollContainerWithoutOverflow) {
      // Internet Explorer does will consider the scrollable area focusable
      // if the element is a <div> or a <span> and it is in fact scrollable,
      // regardless of the CSS overflow property
      if ((0, _is.isScrollableContainer)(element, nodeName)) {
        return true;
      }
    } else if ((0, _is.hasCssOverflowScroll)(style)) {
      // Firefox requires proper overflow setting, IE does not necessarily
      // https://developer.mozilla.org/en-US/docs/Web/CSS/overflow
      return true;
    }
  }

  if (!except.flexbox && supports.focusFlexboxContainer && (0, _is.hasCssDisplayFlex)(style)) {
    // elements with display:flex are focusable in IE10-11
    return true;
  }

  var parent = element.parentElement;
  if (!except.scrollable && parent) {
    var parentNodeName = parent.nodeName.toLowerCase();
    var parentStyle = window.getComputedStyle(parent, null);
    if (supports.focusScrollBody && (0, _is.isScrollableContainer)(parent, nodeName, parentNodeName, parentStyle)) {
      // scrollable bodies are focusable Internet Explorer
      // https://github.com/medialize/ally.js/issues/21
      return true;
    }

    // Children of focusable elements with display:flex are focusable in IE10-11
    if (supports.focusChildrenOfFocusableFlexbox) {
      if ((0, _is.hasCssDisplayFlex)(parentStyle)) {
        return true;
      }
    }
  }

  // NOTE: elements marked as inert are not focusable,
  // but that property is not exposed to the DOM
  // https://www.w3.org/TR/html5/editing.html#inert

  return false;
}

// bind exceptions to an iterator callback
isFocusRelevantRules.except = function () {
  var except = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var isFocusRelevant = function isFocusRelevant(context) {
    return isFocusRelevantRules({
      context: context,
      except: except
    });
  };

  isFocusRelevant.rules = isFocusRelevantRules;
  return isFocusRelevant;
};

// provide isFocusRelevant(context) as default iterator callback
var isFocusRelevant = isFocusRelevantRules.except({});
exports.default = isFocusRelevant;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/is/focusable.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _focusRelevant = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/is/focus-relevant.js");

var _focusRelevant2 = _interopRequireDefault(_focusRelevant);

var _validArea = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/is/valid-area.js");

var _validArea2 = _interopRequireDefault(_validArea);

var _visible = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/is/visible.js");

var _visible2 = _interopRequireDefault(_visible);

var _disabled = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/is/disabled.js");

var _disabled2 = _interopRequireDefault(_disabled);

var _onlyTabbable = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/is/only-tabbable.js");

var _onlyTabbable2 = _interopRequireDefault(_onlyTabbable);

var _contextToElement = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/context-to-element.js");

var _contextToElement2 = _interopRequireDefault(_contextToElement);

var _getFrameElement = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/get-frame-element.js");

var _getFrameElement2 = _interopRequireDefault(_getFrameElement);

var _tabindexValue = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/tabindex-value.js");

var _tabindexValue2 = _interopRequireDefault(_tabindexValue);

var _supports2 = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/supports.js");

var _supports3 = _interopRequireDefault(_supports2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var supports = void 0;
// determine if an element can be focused

// https://www.w3.org/TR/html5/editing.html#focus-management

// NOTE: The following known issues exist:
//   Gecko: `svg a[xlink|href]` is not identified as focusable (because SVGElement.prototype.focus is missing)
//   Blink, WebKit: SVGElements that have been made focusable by adding a focus event listener are not identified as focusable

function isOnlyFocusRelevant(element) {
  var nodeName = element.nodeName.toLowerCase();
  if (nodeName === 'embed' || nodeName === 'keygen') {
    // embed is considered focus-relevant but not focusable
    // see https://github.com/medialize/ally.js/issues/82
    return true;
  }

  var _tabindex = (0, _tabindexValue2.default)(element);
  if (element.shadowRoot && _tabindex === null) {
    // ShadowDOM host elements *may* receive focus
    // even though they are not considered focuable
    return true;
  }

  if (nodeName === 'label') {
    // <label tabindex="0"> is only tabbable in Firefox, not script-focusable
    // there's no way to make an element focusable other than by adding a tabindex,
    // and focus behavior of the label element seems hard-wired to ignore tabindex
    // in some browsers (like Gecko, Blink and WebKit)
    return !supports.focusLabelTabindex || _tabindex === null;
  }

  if (nodeName === 'legend') {
    return _tabindex === null;
  }

  if (supports.focusSvgFocusableAttribute && (element.ownerSVGElement || nodeName === 'svg')) {
    // Internet Explorer understands the focusable attribute introduced in SVG Tiny 1.2
    var focusableAttribute = element.getAttribute('focusable');
    return focusableAttribute && focusableAttribute === 'false';
  }

  if (nodeName === 'img' && element.hasAttribute('usemap')) {
    // Gecko, Trident and Edge do not allow an image with an image map and tabindex to be focused,
    // it appears the tabindex is overruled so focus is still forwarded to the <map>
    return _tabindex === null || !supports.focusImgUsemapTabindex;
  }

  if (nodeName === 'area') {
    // all <area>s are considered relevant,
    // but only the valid <area>s are focusable
    return !(0, _validArea2.default)(element);
  }

  return false;
}

function isFocusableRules() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      context = _ref.context,
      _ref$except = _ref.except,
      except = _ref$except === undefined ? {
    disabled: false,
    visible: false,
    onlyTabbable: false
  } : _ref$except;

  if (!supports) {
    supports = (0, _supports3.default)();
  }

  var _isOnlyTabbable = _onlyTabbable2.default.rules.except({
    onlyFocusableBrowsingContext: true,
    visible: except.visible
  });

  var element = (0, _contextToElement2.default)({
    label: 'is/focusable',
    resolveDocument: true,
    context: context
  });

  var focusRelevant = _focusRelevant2.default.rules({
    context: element,
    except: except
  });

  if (!focusRelevant || isOnlyFocusRelevant(element)) {
    return false;
  }

  if (!except.disabled && (0, _disabled2.default)(element)) {
    return false;
  }

  if (!except.onlyTabbable && _isOnlyTabbable(element)) {
    // some elements may be keyboard focusable, but not script focusable
    return false;
  }

  // elements that are not rendered, cannot be focused
  if (!except.visible) {
    var visibilityOptions = {
      context: element,
      except: {}
    };

    if (supports.focusInHiddenIframe) {
      // WebKit and Blink can focus content in hidden <iframe> and <object>
      visibilityOptions.except.browsingContext = true;
    }

    if (supports.focusObjectSvgHidden) {
      // Blink allows focusing the object element, even if it has visibility: hidden;
      // @browser-issue Blink https://code.google.com/p/chromium/issues/detail?id=586191
      var _nodeName2 = element.nodeName.toLowerCase();
      if (_nodeName2 === 'object') {
        visibilityOptions.except.cssVisibility = true;
      }
    }

    if (!_visible2.default.rules(visibilityOptions)) {
      return false;
    }
  }

  var frameElement = (0, _getFrameElement2.default)(element);
  if (frameElement) {
    var _nodeName = frameElement.nodeName.toLowerCase();
    if (_nodeName === 'object' && !supports.focusInZeroDimensionObject) {
      if (!frameElement.offsetWidth || !frameElement.offsetHeight) {
        // WebKit can not focus content in <object> if it doesn't have dimensions
        return false;
      }
    }
  }

  var nodeName = element.nodeName.toLowerCase();
  if (nodeName === 'svg' && supports.focusSvgInIframe && !frameElement && element.getAttribute('tabindex') === null) {
    return false;
  }

  return true;
}

// bind exceptions to an iterator callback
isFocusableRules.except = function () {
  var except = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var isFocusable = function isFocusable(context) {
    return isFocusableRules({
      context: context,
      except: except
    });
  };

  isFocusable.rules = isFocusableRules;
  return isFocusable;
};

// provide isFocusRelevant(context) as default iterator callback
var isFocusable = isFocusableRules.except({});
exports.default = isFocusable;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/is/is.util.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUserModifyWritable = isUserModifyWritable;
exports.hasCssOverflowScroll = hasCssOverflowScroll;
exports.hasCssDisplayFlex = hasCssDisplayFlex;
exports.isScrollableContainer = isScrollableContainer;

// this is a shared utility file for focus-relevant.js and tabbable.js
// separate testing of this file's functions is not necessary,
// as they're implicitly tested by way of the consumers

function isUserModifyWritable(style) {
  // https://www.w3.org/TR/1999/WD-css3-userint-19990916#user-modify
  // https://github.com/medialize/ally.js/issues/17
  var userModify = style.webkitUserModify || '';
  return Boolean(userModify && userModify.indexOf('write') !== -1);
}

function hasCssOverflowScroll(style) {
  return [style.getPropertyValue('overflow'), style.getPropertyValue('overflow-x'), style.getPropertyValue('overflow-y')].some(function (overflow) {
    return overflow === 'auto' || overflow === 'scroll';
  });
}

function hasCssDisplayFlex(style) {
  return style.display.indexOf('flex') > -1;
}

function isScrollableContainer(element, nodeName, parentNodeName, parentStyle) {
  if (nodeName !== 'div' && nodeName !== 'span') {
    // Internet Explorer advances scrollable containers and bodies to focusable
    // only if the scrollable container is <div> or <span> - this does *not*
    // happen for <section>, <article>, …
    return false;
  }

  if (parentNodeName && parentNodeName !== 'div' && parentNodeName !== 'span' && !hasCssOverflowScroll(parentStyle)) {
    return false;
  }

  return element.offsetHeight < element.scrollHeight || element.offsetWidth < element.scrollWidth;
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/is/native-disabled-supported.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (context) {
  if (!supports) {
    supports = (0, _supports3.default)();

    if (supports.focusFieldsetDisabled) {
      delete disabledElements.fieldset;
    }

    if (supports.focusFormDisabled) {
      delete disabledElements.form;
    }

    disabledElementsPattern = new RegExp('^(' + Object.keys(disabledElements).join('|') + ')$');
  }

  var element = (0, _contextToElement2.default)({
    label: 'is/native-disabled-supported',
    context: context
  });

  var nodeName = element.nodeName.toLowerCase();
  return Boolean(disabledElementsPattern.test(nodeName));
};

var _contextToElement = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/context-to-element.js");

var _contextToElement2 = _interopRequireDefault(_contextToElement);

var _supports2 = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/supports.js");

var _supports3 = _interopRequireDefault(_supports2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Determine if an element supports the disabled attribute

var supports = void 0;

// https://www.w3.org/TR/html5/disabled-elements.html#concept-element-disabled
var disabledElementsPattern = void 0;
var disabledElements = {
  input: true,
  select: true,
  textarea: true,
  button: true,
  fieldset: true,
  form: true
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/is/only-tabbable.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _visible = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/is/visible.js");

var _visible2 = _interopRequireDefault(_visible);

var _contextToElement = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/context-to-element.js");

var _contextToElement2 = _interopRequireDefault(_contextToElement);

var _getFrameElement = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/get-frame-element.js");

var _getFrameElement2 = _interopRequireDefault(_getFrameElement);

var _tabindexValue = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/tabindex-value.js");

var _tabindexValue2 = _interopRequireDefault(_tabindexValue);

var _platform = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/platform.js");

var _platform2 = _interopRequireDefault(_platform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isOnlyTabbableRules() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      context = _ref.context,
      _ref$except = _ref.except,
      except = _ref$except === undefined ? {
    onlyFocusableBrowsingContext: false,
    visible: false
  } : _ref$except;

  var element = (0, _contextToElement2.default)({
    label: 'is/only-tabbable',
    resolveDocument: true,
    context: context
  });

  if (!except.visible && !(0, _visible2.default)(element)) {
    return false;
  }

  if (!except.onlyFocusableBrowsingContext && (_platform2.default.is.GECKO || _platform2.default.is.TRIDENT || _platform2.default.is.EDGE)) {
    var frameElement = (0, _getFrameElement2.default)(element);
    if (frameElement) {
      if ((0, _tabindexValue2.default)(frameElement) < 0) {
        // iframe[tabindex="-1"] and object[tabindex="-1"] inherit the
        // tabbable demotion onto elements of their browsing contexts
        return false;
      }
    }
  }

  var nodeName = element.nodeName.toLowerCase();
  var tabindex = (0, _tabindexValue2.default)(element);

  if (nodeName === 'label' && _platform2.default.is.GECKO) {
    // Firefox cannot focus, but tab to: label[tabindex=0]
    return tabindex !== null && tabindex >= 0;
  }

  // SVG Elements were keyboard focusable but not script focusable before Firefox 51.
  // Firefox 51 added the focus management DOM API (.focus and .blur) to SVGElement,
  // see https://bugzilla.mozilla.org/show_bug.cgi?id=778654
  if (_platform2.default.is.GECKO && element.ownerSVGElement && !element.focus) {
    if (nodeName === 'a' && element.hasAttribute('xlink:href')) {
      // any focusable child of <svg> cannot be focused, but tabbed to
      if (_platform2.default.is.GECKO) {
        return true;
      }
    }
  }

  return false;
}

// bind exceptions to an iterator callback
isOnlyTabbableRules.except = function () {
  var except = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var isOnlyTabbable = function isOnlyTabbable(context) {
    return isOnlyTabbableRules({
      context: context,
      except: except
    });
  };

  isOnlyTabbable.rules = isOnlyTabbableRules;
  return isOnlyTabbable;
};

// provide isOnlyTabbable(context) as default iterator callback
var isOnlyTabbable = isOnlyTabbableRules.except({});
exports.default = isOnlyTabbable;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/is/shadowed.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (context) {
  var element = (0, _contextToElement2.default)({
    label: 'is/shadowed',
    resolveDocument: true,
    context: context
  });

  return Boolean((0, _shadowHost2.default)({ context: element }));
};

var _contextToElement = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/context-to-element.js");

var _contextToElement2 = _interopRequireDefault(_contextToElement);

var _shadowHost = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/get/shadow-host.js");

var _shadowHost2 = _interopRequireDefault(_shadowHost);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/is/valid-area.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (context) {
  if (!supports) {
    supports = (0, _supports3.default)();
  }

  var element = (0, _contextToElement2.default)({
    label: 'is/valid-area',
    context: context
  });

  var nodeName = element.nodeName.toLowerCase();
  if (nodeName !== 'area') {
    return false;
  }

  var hasTabindex = element.hasAttribute('tabindex');
  if (!supports.focusAreaTabindex && hasTabindex) {
    // Blink and WebKit do not consider <area tabindex="-1" href="#void"> focusable
    return false;
  }

  var img = (0, _imageMap.getImageOfArea)(element);
  if (!img || !(0, _visible2.default)(img)) {
    return false;
  }

  // Firefox only allows fully loaded images to reference image maps
  // https://stereochro.me/ideas/detecting-broken-images-js
  if (!supports.focusBrokenImageMap && (!img.complete || !img.naturalHeight || img.offsetWidth <= 0 || img.offsetHeight <= 0)) {
    return false;
  }

  // Firefox supports.can focus area elements even if they don't have an href attribute
  if (!supports.focusAreaWithoutHref && !element.href) {
    // Internet explorer supports.can focus area elements without href if either
    // the area element or the image element has a tabindex attribute
    return supports.focusAreaTabindex && hasTabindex || supports.focusAreaImgTabindex && img.hasAttribute('tabindex');
  }

  // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attr-usemap
  var childOfInteractive = (0, _parents2.default)({ context: img }).slice(1).some(function (_element) {
    var name = _element.nodeName.toLowerCase();
    return name === 'button' || name === 'a';
  });

  if (childOfInteractive) {
    return false;
  }

  return true;
};

var _contextToElement = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/context-to-element.js");

var _contextToElement2 = _interopRequireDefault(_contextToElement);

var _visible = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/is/visible.js");

var _visible2 = _interopRequireDefault(_visible);

var _parents = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/get/parents.js");

var _parents2 = _interopRequireDefault(_parents);

var _imageMap = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/image-map.js");

var _supports2 = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/supports.js");

var _supports3 = _interopRequireDefault(_supports2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var supports = void 0;

// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/map
// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attr-usemap
// https://github.com/jquery/jquery-ui/blob/master/ui/core.js#L88-L107

// determine if an <area> element is being properly used by and <img> via a <map>

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/is/valid-tabindex.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (context) {
  if (!supports) {
    supports = (0, _supports3.default)();
  }

  var validIntegerPattern = supports.focusTabindexTrailingCharacters ? validIntegerPatternWithTrailing : validIntegerPatternNoTrailing;

  var element = (0, _contextToElement2.default)({
    label: 'is/valid-tabindex',
    resolveDocument: true,
    context: context
  });

  // Edge 14 has a capitalization problem on SVG elements,
  // see https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/9282058/
  var hasTabindex = element.hasAttribute('tabindex');
  var hasTabIndex = element.hasAttribute('tabIndex');

  if (!hasTabindex && !hasTabIndex) {
    return false;
  }

  // older Firefox and Internet Explorer don't support tabindex on SVG elements
  var isSvgElement = element.ownerSVGElement || element.nodeName.toLowerCase() === 'svg';
  if (isSvgElement && !supports.focusSvgTabindexAttribute) {
    return false;
  }

  // @browser-issue Gecko https://bugzilla.mozilla.org/show_bug.cgi?id=1128054
  if (supports.focusInvalidTabindex) {
    return true;
  }

  // an element matches the tabindex selector even if its value is invalid
  var tabindex = element.getAttribute(hasTabindex ? 'tabindex' : 'tabIndex');
  // IE11 parses tabindex="" as the value "-32768"
  // @browser-issue Trident https://connect.microsoft.com/IE/feedback/details/1072965
  if (tabindex === '-32768') {
    return false;
  }

  return Boolean(tabindex && validIntegerPattern.test(tabindex));
};

var _contextToElement = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/context-to-element.js");

var _contextToElement2 = _interopRequireDefault(_contextToElement);

var _supports2 = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/supports.js");

var _supports3 = _interopRequireDefault(_supports2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// determine if an element's tabindex attribute has a valid value

var supports = void 0;

// https://www.w3.org/TR/html5/infrastructure.html#rules-for-parsing-integers
// NOTE: all browsers agree to allow trailing spaces as well
var validIntegerPatternNoTrailing = /^\s*(-|\+)?[0-9]+\s*$/;
var validIntegerPatternWithTrailing = /^\s*(-|\+)?[0-9]+.*$/;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/is/visible.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _arrayFindIndex = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/array-find-index.js");

var _arrayFindIndex2 = _interopRequireDefault(_arrayFindIndex);

var _parents = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/get/parents.js");

var _parents2 = _interopRequireDefault(_parents);

var _contextToElement = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/context-to-element.js");

var _contextToElement2 = _interopRequireDefault(_contextToElement);

var _getFrameElement = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/get-frame-element.js");

var _getFrameElement2 = _interopRequireDefault(_getFrameElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://www.w3.org/TR/html5/rendering.html#being-rendered
// <area> is not rendered, but we *consider* it visible to simplfiy this function's usage

// determine if an element is rendered
// NOTE: that does not mean an element is visible in the viewport, see util/visible-area

var notRenderedElementsPattern = /^(area)$/;

function computedStyle(element, property) {
  return window.getComputedStyle(element, null).getPropertyValue(property);
}

function notDisplayed(_path) {
  return _path.some(function (element) {
    // display:none is not visible (optimized away at layout)
    return computedStyle(element, 'display') === 'none';
  });
}

function notVisible(_path) {
  // https://github.com/jquery/jquery-ui/blob/master/ui/core.js#L109-L114
  // NOTE: a nested element can reverse visibility:hidden|collapse by explicitly setting visibility:visible
  // NOTE: visibility can be ["", "visible", "hidden", "collapse"]
  var hidden = (0, _arrayFindIndex2.default)(_path, function (element) {
    var visibility = computedStyle(element, 'visibility');
    return visibility === 'hidden' || visibility === 'collapse';
  });

  if (hidden === -1) {
    // there is no hidden element
    return false;
  }

  var visible = (0, _arrayFindIndex2.default)(_path, function (element) {
    return computedStyle(element, 'visibility') === 'visible';
  });

  if (visible === -1) {
    // there is no visible element (but a hidden element)
    return true;
  }

  if (hidden < visible) {
    // there is a hidden element and it's closer than the first visible element
    return true;
  }

  // there may be a hidden element, but the closest element is visible
  return false;
}

function collapsedParent(_path) {
  var offset = 1;
  if (_path[0].nodeName.toLowerCase() === 'summary') {
    offset = 2;
  }

  return _path.slice(offset).some(function (element) {
    // "content children" of a closed details element are not visible
    return element.nodeName.toLowerCase() === 'details' && element.open === false;
  });
}

function isVisibleRules() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      context = _ref.context,
      _ref$except = _ref.except,
      except = _ref$except === undefined ? {
    notRendered: false,
    cssDisplay: false,
    cssVisibility: false,
    detailsElement: false,
    browsingContext: false
  } : _ref$except;

  var element = (0, _contextToElement2.default)({
    label: 'is/visible',
    resolveDocument: true,
    context: context
  });

  var nodeName = element.nodeName.toLowerCase();
  if (!except.notRendered && notRenderedElementsPattern.test(nodeName)) {
    return true;
  }

  var _path = (0, _parents2.default)({ context: element });

  // in Internet Explorer <audio> has a default display: none, where others have display: inline
  // but IE allows focusing <audio style="display:none">, but not <div display:none><audio>
  // this is irrelevant to other browsers, as the controls attribute is required to make <audio> focusable
  var isAudioWithoutControls = nodeName === 'audio' && !element.hasAttribute('controls');
  if (!except.cssDisplay && notDisplayed(isAudioWithoutControls ? _path.slice(1) : _path)) {
    return false;
  }

  if (!except.cssVisibility && notVisible(_path)) {
    return false;
  }

  if (!except.detailsElement && collapsedParent(_path)) {
    return false;
  }

  if (!except.browsingContext) {
    // elements within a browsing context are affected by the
    // browsing context host element's visibility and tabindex
    var frameElement = (0, _getFrameElement2.default)(element);
    var _isVisible = isVisibleRules.except(except);
    if (frameElement && !_isVisible(frameElement)) {
      return false;
    }
  }

  return true;
}

// bind exceptions to an iterator callback
isVisibleRules.except = function () {
  var except = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var isVisible = function isVisible(context) {
    return isVisibleRules({
      context: context,
      except: except
    });
  };

  isVisible.rules = isVisibleRules;
  return isVisible;
};

// provide isVisible(context) as default iterator callback
var isVisible = isVisibleRules.except({});
exports.default = isVisible;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/maintain/disabled.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
/*
  Utility to make a sub-tree of the DOM inert. Inert means the elements cannot be interacted
  with and they cannot be focused via script, pointer or keyboard.

  inert attribute was [removed](https://html5.org/r/8536) [tweet by steve](https://twitter.com/stevefaulkner/status/443075900201259008)
  but definition of [inert subtrees](https://www.w3.org/html/wg/drafts/html/master/editing.html#inert-subtrees) remains.

  [implementation idea by Vasilis](https://codepen.io/vasilisvg/pen/scowI)
  [inert attribute polyfill by GoogleChrome](https://github.com/GoogleChrome/inert-polyfill)

  [Gecko Bug: Inert Attribute](https://bugzilla.mozilla.org/show_bug.cgi?id=921504)
  [Chromium Bug: Inert Attribute](https://code.google.com/p/chromium/issues/detail?id=269846)
  [Chromium Bug: Inert Subtree](https://code.google.com/p/chromium/issues/detail?id=241699)
  [WebKit Bug: Inert Subtree](https://bugs.webkit.org/show_bug.cgi?id=110952)
*/

exports.default = function () {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      context = _ref2.context,
      filter = _ref2.filter;

  var service = new InertSubtree({ context: context, filter: filter });
  return { disengage: service.disengage };
};

var _nodeArray = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/node-array.js");

var _nodeArray2 = _interopRequireDefault(_nodeArray);

var _focusable = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/query/focusable.js");

var _focusable2 = _interopRequireDefault(_focusable);

var _disabled = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/element/disabled.js");

var _disabled2 = _interopRequireDefault(_disabled);

var _shadowMutations = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/observe/shadow-mutations.js");

var _shadowMutations2 = _interopRequireDefault(_shadowMutations);

var _comparePosition = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/compare-position.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function makeElementInert(element) {
  return (0, _disabled2.default)(element, true);
}

function undoElementInert(element) {
  return (0, _disabled2.default)(element, false);
}

var observerConfig = {
  attributes: true,
  childList: true,
  subtree: true,
  attributeFilter: ['tabindex', 'disabled', 'data-ally-disabled']
};

var InertSubtree = function () {
  function InertSubtree() {
    var _this = this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        context = _ref.context,
        filter = _ref.filter;

    _classCallCheck(this, InertSubtree);

    this._context = (0, _nodeArray2.default)(context || document.documentElement)[0];
    this._filter = (0, _nodeArray2.default)(filter);
    this._inertElementCache = [];

    this.disengage = this.disengage.bind(this);
    this.handleMutation = this.handleMutation.bind(this);
    this.renderInert = this.renderInert.bind(this);
    this.filterElements = this.filterElements.bind(this);
    this.filterParentElements = this.filterParentElements.bind(this);

    var focusable = (0, _focusable2.default)({
      context: this._context,
      includeContext: true,
      strategy: 'all'
    });

    this.renderInert(focusable);

    this.shadowObserver = (0, _shadowMutations2.default)({
      context: this._context,
      config: observerConfig,
      callback: function callback(mutations) {
        return mutations.forEach(_this.handleMutation);
      }
    });
  }

  _createClass(InertSubtree, [{
    key: 'disengage',
    value: function disengage() {
      if (!this._context) {
        return;
      }

      undoElementInert(this._context);
      this._inertElementCache.forEach(function (element) {
        return undoElementInert(element);
      });

      this._inertElementCache = null;
      this._filter = null;
      this._context = null;
      this.shadowObserver && this.shadowObserver.disengage();
      this.shadowObserver = null;
    }
  }, {
    key: 'listQueryFocusable',
    value: function listQueryFocusable(list) {
      return list
      // find all focusable elements within the given contexts
      .map(function (element) {
        return (0, _focusable2.default)({ context: element, includeContext: true, strategy: 'all' });
      })
      // flatten nested arrays
      .reduce(function (previous, current) {
        return previous.concat(current);
      }, []);
    }
  }, {
    key: 'renderInert',
    value: function renderInert(elements) {
      var _this2 = this;

      var makeInert = function makeInert(element) {
        _this2._inertElementCache.push(element);
        makeElementInert(element);
      };

      elements.filter(this.filterElements).filter(this.filterParentElements)
      // ignore elements that already are disabled
      // so we don't enable them on disengage()
      .filter(function (element) {
        return !(0, _disabled2.default)(element);
      }).forEach(makeInert);
    }
  }, {
    key: 'filterElements',
    value: function filterElements(element) {
      // ignore elements within the exempted sub-trees
      var isParentOfElement = (0, _comparePosition.getParentComparator)({ element: element, includeSelf: true });
      return !this._filter.some(isParentOfElement);
    }
  }, {
    key: 'filterParentElements',
    value: function filterParentElements(element) {
      // ignore ancestors of the exempted sub-trees
      var isParentOfElement = (0, _comparePosition.getParentComparator)({ parent: element });
      return !this._filter.some(isParentOfElement);
    }
  }, {
    key: 'handleMutation',
    value: function handleMutation(mutation) {
      if (mutation.type === 'childList') {
        var addedElements = (0, _nodeArray2.default)(mutation.addedNodes).filter(function (element) {
          return element.nodeType === Node.ELEMENT_NODE;
        });
        if (!addedElements.length) {
          return;
        }

        var addedFocusableElements = this.listQueryFocusable(addedElements);
        this.renderInert(addedFocusableElements);
      } else if (mutation.type === 'attributes') {
        this.renderInert([mutation.target]);
      }
    }
  }]);

  return InertSubtree;
}();

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/maintain/hidden.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
// Utility to make the entire DOM aria-hidden="true" except for a given set of elements

exports.default = function () {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      context = _ref2.context,
      filter = _ref2.filter;

  var service = new HiddenSubtree({ context: context, filter: filter });
  return { disengage: service.disengage };
};

var _nodeArray = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/node-array.js");

var _nodeArray2 = _interopRequireDefault(_nodeArray);

var _insignificantBranches = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/get/insignificant-branches.js");

var _insignificantBranches2 = _interopRequireDefault(_insignificantBranches);

var _parents = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/get/parents.js");

var _parents2 = _interopRequireDefault(_parents);

var _toggleAttributeValue = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/toggle-attribute-value.js");

var _toggleAttributeValue2 = _interopRequireDefault(_toggleAttributeValue);

var _comparePosition = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/compare-position.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function makeElementHidden(element) {
  (0, _toggleAttributeValue2.default)({
    element: element,
    attribute: 'aria-hidden',
    temporaryValue: 'true'
  });
}

function undoElementHidden(element) {
  (0, _toggleAttributeValue2.default)({
    element: element,
    attribute: 'aria-hidden'
  });
}

var observerConfig = {
  attributes: false,
  childList: true,
  subtree: true
};

var HiddenSubtree = function () {
  function HiddenSubtree() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        context = _ref.context,
        filter = _ref.filter;

    _classCallCheck(this, HiddenSubtree);

    this._context = (0, _nodeArray2.default)(context || document.documentElement)[0];
    this._filter = (0, _nodeArray2.default)(filter);

    this.disengage = this.disengage.bind(this);
    this.handleMutation = this.handleMutation.bind(this);
    this.isInsignificantBranch = this.isInsignificantBranch.bind(this);

    var insignificantBranches = (0, _insignificantBranches2.default)({ context: this._context, filter: this._filter });
    insignificantBranches.forEach(makeElementHidden);
    this.startObserver();
  }

  _createClass(HiddenSubtree, [{
    key: 'disengage',
    value: function disengage() {
      if (!this._context) {
        return;
      }

      [].forEach.call(this._context.querySelectorAll('[data-cached-aria-hidden]'), undoElementHidden);

      this._context = null;
      this._filter = null;
      this._observer && this._observer.disconnect();
      this._observer = null;
    }
  }, {
    key: 'startObserver',
    value: function startObserver() {
      var _this = this;

      if (!window.MutationObserver) {
        // not supporting IE10 via Mutation Events, because they're too expensive
        // https://developer.mozilla.org/en-US/docs/Web/Guide/Events/Mutation_events
        return;
      }
      // http://caniuse.com/#search=mutation
      // https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver
      this._observer = new MutationObserver(function (mutations) {
        return mutations.forEach(_this.handleMutation);
      });
      this._observer.observe(this._context, observerConfig);
    }
  }, {
    key: 'handleMutation',
    value: function handleMutation(mutation) {
      if (mutation.type === 'childList') {
        // a new branch cannot contain a filtered element
        // (unless it is moved there, which is an edge-case we'll ignore for now),
        // so anything that is within context,
        // and not within a previously known insignificant branch and not within a filtered element,
        // must be an insignificant branch as well
        (0, _nodeArray2.default)(mutation.addedNodes).filter(function (element) {
          return element.nodeType === Node.ELEMENT_NODE;
        }).filter(this.isInsignificantBranch).forEach(makeElementHidden);
      }
    }
  }, {
    key: 'isInsignificantBranch',
    value: function isInsignificantBranch(element) {
      var parents = (0, _parents2.default)({ context: element });
      if (parents.some(function (_element) {
        return _element.getAttribute('aria-hidden') === 'true';
      })) {
        // element is child of a hidden element
        return false;
      }

      var isParentOfElement = (0, _comparePosition.getParentComparator)({ element: element });
      if (this._filter.some(isParentOfElement)) {
        // element is a descendant of a filtered element
        return false;
      }

      return true;
    }
  }]);

  return HiddenSubtree;
}();

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/map/keycode.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// codes mostly cloned from https://github.com/keithamus/jwerty/blob/master/jwerty.js
// deliberately not exposing characters like <,.-#* because they vary *wildly*
// across keyboard layouts and may cause various problems
// (e.g. "*" is "Shift +" on a German Mac keyboard)
// (e.g. "@" is "Alt L" on a German Mac keyboard)

var keycode = {
  // Element Focus
  tab: 9,

  // Navigation
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  pageUp: 33,
  'page-up': 33,
  pageDown: 34,
  'page-down': 34,
  end: 35,
  home: 36,

  // Action
  enter: 13,
  escape: 27,
  space: 32,

  // Modifier
  shift: 16,
  capsLock: 20,
  'caps-lock': 20,
  ctrl: 17,
  alt: 18,
  meta: 91,
  // in firefox: 224
  // on mac (chrome): meta-left=91, meta-right=93
  // on win (IE11): meta-left=91, meta-right=92
  pause: 19,

  // Content Manipulation
  insert: 45,
  'delete': 46,
  backspace: 8,

  // the same logical key may be identified through different keyCodes
  _alias: {
    91: [92, 93, 224]
  }
};

// Function keys (112 - 137)
// NOTE: not every keyboard knows F13+
for (var n = 1; n < 26; n++) {
  keycode['f' + n] = n + 111;
}

// Number keys (48-57, numpad 96-105)
// NOTE: not every keyboard knows num-0+
for (var _n = 0; _n < 10; _n++) {
  var code = _n + 48;
  var numCode = _n + 96;
  keycode[_n] = code;
  keycode['num-' + _n] = numCode;
  keycode._alias[code] = [numCode];
}

// Latin characters (65 - 90)
for (var _n2 = 0; _n2 < 26; _n2++) {
  var _code = _n2 + 65;
  var name = String.fromCharCode(_code).toLowerCase();
  keycode[name] = _code;
}

exports.default = keycode;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/observe/interaction-type.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _decorateService = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/decorate-service.js");

var _decorateService2 = _interopRequireDefault(_decorateService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// counters to track primary input
var _activePointers = 0;
/*
  Observe keyboard-, pointer-, mouse- and touch-events so that a query for
  the current interaction type can be made at any time. For pointer interaction
  this observer is limited to pointer button down/up - move is not observed!

  USAGE:
    var listener = engage();
    listener.get() === {pointer: Boolean, key: Boolean}
*/

var _activeKeys = 0;

var pointerStartEvents = ['touchstart', 'pointerdown', 'MSPointerDown', 'mousedown'];
var pointerEndEvents = ['touchend', 'touchcancel', 'pointerup', 'MSPointerUp', 'pointercancel', 'MSPointerCancel', 'mouseup'];

function handleWindowBlurEvent() {
  // reset internal counters when window loses focus
  _activePointers = 0;
  _activeKeys = 0;
}

function handlePointerStartEvent(event) {
  if (event.isPrimary === false) {
    // ignore non-primary pointer events
    // https://w3c.github.io/pointerevents/#widl-PointerEvent-isPrimary
    return;
  }

  // mousedown without following mouseup
  // (likely not possible in Chrome)
  _activePointers++;
}

function handlePointerEndEvent(event) {
  if (event.isPrimary === false) {
    // ignore non-primary pointer events
    // https://w3c.github.io/pointerevents/#widl-PointerEvent-isPrimary
    return;
  } else if (event.touches) {
    _activePointers = event.touches.length;
    return;
  }

  // delay reset to when the current handlers are executed
  (window.setImmediate || window.setTimeout)(function () {
    // mouseup without prior mousedown
    // (drag something out of the window)
    _activePointers = Math.max(_activePointers - 1, 0);
  });
}

function handleKeyStartEvent(event) {
  // ignore modifier keys
  switch (event.keyCode || event.which) {
    case 16: // space
    case 17: // control
    case 18: // alt
    case 91: // command left
    case 93:
      // command right
      return;
  }

  // keydown without a following keyup
  // (may happen on CMD+TAB)
  _activeKeys++;
}

function handleKeyEndEvent(event) {
  // ignore modifier keys
  switch (event.keyCode || event.which) {
    case 16: // space
    case 17: // control
    case 18: // alt
    case 91: // command left
    case 93:
      // command right
      return;
  }

  // delay reset to when the current handlers are executed
  (window.setImmediate || window.setTimeout)(function () {
    // keyup without prior keydown
    // (may happen on CMD+R)
    _activeKeys = Math.max(_activeKeys - 1, 0);
  });
}

function getInteractionType() {
  return {
    pointer: Boolean(_activePointers),
    key: Boolean(_activeKeys)
  };
}

function disengage() {
  _activePointers = _activeKeys = 0;
  window.removeEventListener('blur', handleWindowBlurEvent, false);
  document.documentElement.removeEventListener('keydown', handleKeyStartEvent, true);
  document.documentElement.removeEventListener('keyup', handleKeyEndEvent, true);
  pointerStartEvents.forEach(function (event) {
    document.documentElement.removeEventListener(event, handlePointerStartEvent, true);
  });
  pointerEndEvents.forEach(function (event) {
    document.documentElement.removeEventListener(event, handlePointerEndEvent, true);
  });
}

function engage() {
  // window blur must be in bubble phase so it won't capture regular blurs
  window.addEventListener('blur', handleWindowBlurEvent, false);
  // handlers to identify the method of focus change
  document.documentElement.addEventListener('keydown', handleKeyStartEvent, true);
  document.documentElement.addEventListener('keyup', handleKeyEndEvent, true);
  pointerStartEvents.forEach(function (event) {
    document.documentElement.addEventListener(event, handlePointerStartEvent, true);
  });
  pointerEndEvents.forEach(function (event) {
    document.documentElement.addEventListener(event, handlePointerEndEvent, true);
  });

  return {
    get: getInteractionType
  };
}

exports.default = (0, _decorateService2.default)({ engage: engage, disengage: disengage });

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/observe/shadow-mutations.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = function () {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      context = _ref2.context,
      callback = _ref2.callback,
      config = _ref2.config;

  if (typeof callback !== 'function') {
    throw new TypeError('observe/shadow-mutations requires options.callback to be a function');
  }

  if ((typeof config === 'undefined' ? 'undefined' : _typeof(config)) !== 'object') {
    throw new TypeError('observe/shadow-mutations requires options.config to be an object');
  }

  if (!window.MutationObserver) {
    // not supporting IE10 via Mutation Events, because they're too expensive
    // https://developer.mozilla.org/en-US/docs/Web/Guide/Events/Mutation_events
    return {
      disengage: function disengage() {}
    };
  }

  var element = (0, _contextToElement2.default)({
    label: 'observe/shadow-mutations',
    resolveDocument: true,
    defaultToDocument: true,
    context: context
  });

  var service = new ShadowMutationObserver({
    context: element,
    callback: callback,
    config: config
  });

  return {
    disengage: service.disengage
  };
};

var _nodeArray = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/node-array.js");

var _nodeArray2 = _interopRequireDefault(_nodeArray);

var _shadowHosts = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/query/shadow-hosts.js");

var _shadowHosts2 = _interopRequireDefault(_shadowHosts);

var _contextToElement = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/context-to-element.js");

var _contextToElement2 = _interopRequireDefault(_contextToElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var shadowObserverConfig = {
  childList: true,
  subtree: true
};

var ShadowMutationObserver = function () {
  function ShadowMutationObserver() {
    var _this = this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        context = _ref.context,
        callback = _ref.callback,
        config = _ref.config;

    _classCallCheck(this, ShadowMutationObserver);

    this.config = config;

    this.disengage = this.disengage.bind(this);

    this.clientObserver = new MutationObserver(callback);
    this.hostObserver = new MutationObserver(function (mutations) {
      return mutations.forEach(_this.handleHostMutation, _this);
    });

    this.observeContext(context);
    this.observeShadowHosts(context);
  }

  _createClass(ShadowMutationObserver, [{
    key: 'disengage',
    value: function disengage() {
      this.clientObserver && this.clientObserver.disconnect();
      this.clientObserver = null;
      this.hostObserver && this.hostObserver.disconnect();
      this.hostObserver = null;
    }
  }, {
    key: 'observeShadowHosts',
    value: function observeShadowHosts(context) {
      var _this2 = this;

      var hosts = (0, _shadowHosts2.default)({
        context: context
      });

      hosts.forEach(function (element) {
        return _this2.observeContext(element.shadowRoot);
      });
    }
  }, {
    key: 'observeContext',
    value: function observeContext(context) {
      this.clientObserver.observe(context, this.config);
      this.hostObserver.observe(context, shadowObserverConfig);
    }
  }, {
    key: 'handleHostMutation',
    value: function handleHostMutation(mutation) {
      if (mutation.type !== 'childList') {
        return;
      }

      var addedElements = (0, _nodeArray2.default)(mutation.addedNodes).filter(function (element) {
        return element.nodeType === Node.ELEMENT_NODE;
      });
      addedElements.forEach(this.observeShadowHosts, this);
    }
  }]);

  return ShadowMutationObserver;
}();

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/query/focusable.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      context = _ref.context,
      includeContext = _ref.includeContext,
      includeOnlyTabbable = _ref.includeOnlyTabbable,
      _ref$strategy = _ref.strategy,
      strategy = _ref$strategy === undefined ? 'quick' : _ref$strategy;

  var element = (0, _contextToElement2.default)({
    label: 'query/focusable',
    resolveDocument: true,
    defaultToDocument: true,
    context: context
  });

  var options = {
    context: element,
    includeContext: includeContext,
    includeOnlyTabbable: includeOnlyTabbable,
    strategy: strategy
  };

  if (strategy === 'quick') {
    return (0, _focusable4.default)(options);
  } else if (strategy === 'strict' || strategy === 'all') {
    return (0, _focusable2.default)(options);
  }

  throw new TypeError('query/focusable requires option.strategy to be one of ["quick", "strict", "all"]');
};

var _contextToElement = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/context-to-element.js");

var _contextToElement2 = _interopRequireDefault(_contextToElement);

var _focusable = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/query/focusable.strict.js");

var _focusable2 = _interopRequireDefault(_focusable);

var _focusable3 = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/query/focusable.quick.js");

var _focusable4 = _interopRequireDefault(_focusable3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/query/focusable.quick.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = queryFocusableQuick;

var _focusable = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/selector/focusable.js");

var _focusable2 = _interopRequireDefault(_focusable);

var _focusable3 = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/is/focusable.js");

var _focusable4 = _interopRequireDefault(_focusable3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://www.w3.org/TR/html5/editing.html#focusable
// https://www.w3.org/WAI/PF/aria-practices/#keyboard

function queryFocusableQuick() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      context = _ref.context,
      includeContext = _ref.includeContext,
      includeOnlyTabbable = _ref.includeOnlyTabbable;

  var _selector = (0, _focusable2.default)();
  var elements = context.querySelectorAll(_selector);
  // the selector potentially matches more than really is focusable

  var _isFocusable = _focusable4.default.rules.except({
    onlyTabbable: includeOnlyTabbable
  });

  var result = [].filter.call(elements, _isFocusable);

  // add context if requested and focusable
  if (includeContext && _isFocusable(context)) {
    result.unshift(context);
  }

  return result;
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/query/focusable.strict.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = queryFocusableStrict;

var _focusable = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/is/focusable.js");

var _focusable2 = _interopRequireDefault(_focusable);

var _focusRelevant = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/is/focus-relevant.js");

var _focusRelevant2 = _interopRequireDefault(_focusRelevant);

var _getDocument = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/get-document.js");

var _getDocument2 = _interopRequireDefault(_getDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createFilter(condition) {
  // see https://developer.mozilla.org/en-US/docs/Web/API/NodeFilter
  var filter = function filter(node) {
    if (node.shadowRoot) {
      // return ShadowRoot elements regardless of them being focusable,
      // so they can be walked recursively later
      return NodeFilter.FILTER_ACCEPT;
    }

    if (condition(node)) {
      // finds elements that could have been found by document.querySelectorAll()
      return NodeFilter.FILTER_ACCEPT;
    }

    return NodeFilter.FILTER_SKIP;
  };
  // IE requires a function, Browsers require {acceptNode: function}
  // see http://www.bennadel.com/blog/2607-finding-html-comment-nodes-in-the-dom-using-treewalker.htm
  filter.acceptNode = filter;
  return filter;
}
// https://www.w3.org/TR/html5/editing.html#focusable
// https://www.w3.org/WAI/PF/aria-practices/#keyboard

var PossiblyFocusableFilter = createFilter(_focusRelevant2.default);

function queryFocusableStrict() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      context = _ref.context,
      includeContext = _ref.includeContext,
      includeOnlyTabbable = _ref.includeOnlyTabbable,
      strategy = _ref.strategy;

  if (!context) {
    context = document.documentElement;
  }

  var _isFocusable = _focusable2.default.rules.except({
    onlyTabbable: includeOnlyTabbable
  });

  var _document = (0, _getDocument2.default)(context);
  // see https://developer.mozilla.org/en-US/docs/Web/API/Document/createTreeWalker
  var walker = _document.createTreeWalker(
  // root element to start search in
  context,
  // element type filter
  NodeFilter.SHOW_ELEMENT,
  // custom NodeFilter filter
  strategy === 'all' ? PossiblyFocusableFilter : createFilter(_isFocusable),
  // deprecated, but IE requires it
  false);

  var list = [];

  while (walker.nextNode()) {
    if (walker.currentNode.shadowRoot) {
      if (_isFocusable(walker.currentNode)) {
        list.push(walker.currentNode);
      }

      list = list.concat(queryFocusableStrict({
        context: walker.currentNode.shadowRoot,
        includeOnlyTabbable: includeOnlyTabbable,
        strategy: strategy
      }));
    } else {
      list.push(walker.currentNode);
    }
  }

  // add context if requested and focusable
  if (includeContext) {
    if (strategy === 'all') {
      if ((0, _focusRelevant2.default)(context)) {
        list.unshift(context);
      }
    } else if (_isFocusable(context)) {
      list.unshift(context);
    }
  }

  return list;
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/query/shadow-hosts.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = queryShadowHosts;

var _contextToElement = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/context-to-element.js");

var _contextToElement2 = _interopRequireDefault(_contextToElement);

var _getDocument = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/get-document.js");

var _getDocument2 = _interopRequireDefault(_getDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// see https://developer.mozilla.org/en-US/docs/Web/API/NodeFilter
var filter = function filter(node) {
  if (node.shadowRoot) {
    return NodeFilter.FILTER_ACCEPT;
  }

  return NodeFilter.FILTER_SKIP;
};
// IE requires a function, Browsers require {acceptNode: function}
// see http://www.bennadel.com/blog/2607-finding-html-comment-nodes-in-the-dom-using-treewalker.htm
filter.acceptNode = filter;

function queryShadowHosts() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      context = _ref.context;

  var element = (0, _contextToElement2.default)({
    label: 'query/shadow-hosts',
    resolveDocument: true,
    defaultToDocument: true,
    context: context
  });

  var _document = (0, _getDocument2.default)(context);
  // see https://developer.mozilla.org/en-US/docs/Web/API/Document/createTreeWalker
  var walker = _document.createTreeWalker(
  // root element to start search in
  element,
  // element type filter
  NodeFilter.SHOW_ELEMENT,
  // custom NodeFilter filter
  filter,
  // deprecated, but IE requires it
  false);

  var list = [];

  if (element.shadowRoot) {
    // TreeWalker does not run the filter on the context element
    list.push(element);
    list = list.concat(queryShadowHosts({
      context: element.shadowRoot
    }));
  }

  while (walker.nextNode()) {
    list.push(walker.currentNode);
    list = list.concat(queryShadowHosts({
      context: walker.currentNode.shadowRoot
    }));
  }

  return list;
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/selector/focusable.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  if (!supports) {
    supports = (0, _supports3.default)();
  }

  if (typeof selector === 'string') {
    return selector;
  }

  // https://www.w3.org/TR/html5/editing.html#sequential-focus-navigation-and-the-tabindex-attribute
  selector = ''
  // IE11 supports.can focus <table> and <td>
  + (supports.focusTable ? 'table, td,' : '')
  // IE11 supports.can focus <fieldset>
  + (supports.focusFieldset ? 'fieldset,' : '')
  // Namespace problems of [xlink:href] explained in https://stackoverflow.com/a/23047888/515124
  // svg a[*|href] does not match in IE9, but since we're filtering
  // through is/focusable we can include all <a> from SVG
  + 'svg a,'
  // may behave as 'svg, svg *,' in chrome as *every* svg element with a focus event listener is focusable
  // navigational elements
  + 'a[href],'
  // validity determined by is/valid-area.js
  + 'area[href],'
  // validity determined by is/disabled.js
  + 'input, select, textarea, button,'
  // browsing context containers
  + 'iframe, object, embed,'
  // interactive content
  + 'keygen,' + (supports.focusAudioWithoutControls ? 'audio,' : 'audio[controls],') + (supports.focusVideoWithoutControls ? 'video,' : 'video[controls],') + (supports.focusSummary ? 'summary,' : '')
  // validity determined by is/valid-tabindex.js
  + '[tabindex],'
  // editing hosts
  + '[contenteditable]';

  // where ShadowDOM is supported, we also want the shadowed focusable elements (via ">>>" or "/deep/")
  selector = (0, _selectInShadows2.default)(selector);

  return selector;
};

var _selectInShadows = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/select-in-shadows.js");

var _selectInShadows2 = _interopRequireDefault(_selectInShadows);

var _supports2 = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/supports.js");

var _supports3 = _interopRequireDefault(_supports2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// NOTE: this selector MUST *never* be used directly,
// always go through query/focusable or is/focusable.js
// there are too many edge cases that they could be covered in
// a simple CSS selector…

var supports = void 0;

var selector = void 0;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/style/focus-source.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toggleClass = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/toggle-class.js");

var _shadowFocus = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/event/shadow-focus.js");

var _shadowFocus2 = _interopRequireDefault(_shadowFocus);

var _interactionType = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/observe/interaction-type.js");

var _interactionType2 = _interopRequireDefault(_interactionType);

var _decorateService = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/decorate-service.js");

var _decorateService2 = _interopRequireDefault(_decorateService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// preferring focusin/out because they are synchronous in IE10+11

/*
  add data-focus-source attribute to html element containing "key", "pointer" or "script"
  depending on the input method used to change focus.

  USAGE:
    style/focus-source()

    body :focus {
      outline: 1px solid grey;
    }

    html[data-focus-source="key"] body :focus {
      outline: 5px solid red;
    }

    html[data-focus-source="key"] body :focus {
      outline: 1px solid blue;
    }

  NOTE: I don't have a GamePad to test, if you do and you want to
  implement an observer for https://w3c.github.io/gamepad/ - send a PR!

  Alternate implementation: https://github.com/alice/modality
*/

var supportsFocusIn = typeof document !== 'undefined' && 'onfocusin' in document;
var focusEventName = supportsFocusIn ? 'focusin' : 'focus';
var blurEventName = supportsFocusIn ? 'focusout' : 'blur';

// interface to read interaction-type-listener state
var interactionTypeHandler = void 0;
var shadowHandle = void 0;
// keep track of last focus source
var current = null;
// overwrite focus source for use with the every upcoming focus event
var lock = null;
// keep track of ever having used a particular input method to change focus
var used = {
  pointer: false,
  key: false,
  script: false,
  initial: false
};

function handleFocusEvent(event) {
  var source = '';
  if (event.type === focusEventName || event.type === 'shadow-focus') {
    var interactionType = interactionTypeHandler.get();
    source = lock || interactionType.pointer && 'pointer' || interactionType.key && 'key' || 'script';
  } else if (event.type === 'initial') {
    source = 'initial';
  }

  document.documentElement.setAttribute('data-focus-source', source);

  if (event.type !== blurEventName) {
    if (!used[source]) {
      (0, _toggleClass.addClass)(document.documentElement, 'focus-source-' + source);
    }

    used[source] = true;
    current = source;
  }
}

function getCurrentFocusSource() {
  return current;
}

function getUsedFocusSource(source) {
  return used[source];
}

function lockFocusSource(source) {
  lock = source;
}

function unlockFocusSource() {
  lock = false;
}

function disengage() {
  // clear dom state
  handleFocusEvent({ type: blurEventName });
  current = lock = null;
  Object.keys(used).forEach(function (key) {
    (0, _toggleClass.removeClass)(document.documentElement, 'focus-source-' + key);
    used[key] = false;
  });
  // kill interaction type identification listener
  interactionTypeHandler.disengage();
  // kill shadow-focus event dispatcher
  shadowHandle && shadowHandle.disengage();
  document.removeEventListener('shadow-focus', handleFocusEvent, true);
  document.documentElement.removeEventListener(focusEventName, handleFocusEvent, true);
  document.documentElement.removeEventListener(blurEventName, handleFocusEvent, true);
  document.documentElement.removeAttribute('data-focus-source');
}

function engage() {
  // enable the shadow-focus event dispatcher
  shadowHandle = (0, _shadowFocus2.default)();
  // handlers to modify the focused element
  document.addEventListener('shadow-focus', handleFocusEvent, true);
  document.documentElement.addEventListener(focusEventName, handleFocusEvent, true);
  document.documentElement.addEventListener(blurEventName, handleFocusEvent, true);
  // enable the interaction type identification observer
  interactionTypeHandler = (0, _interactionType2.default)();
  // set up initial dom state
  handleFocusEvent({ type: 'initial' });

  return {
    used: getUsedFocusSource,
    current: getCurrentFocusSource,
    lock: lockFocusSource,
    unlock: unlockFocusSource
  };
}

exports.default = (0, _decorateService2.default)({ engage: engage, disengage: disengage });

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/css-shadow-piercing-deep-combinator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var combinator = void 0;

  // see https://dev.w3.org/csswg/css-scoping-1/#deep-combinator
  // https://bugzilla.mozilla.org/show_bug.cgi?id=1117572
  // https://code.google.com/p/chromium/issues/detail?id=446051
  try {
    document.querySelector('html >>> :first-child');
    combinator = '>>>';
  } catch (noArrowArrowArrow) {
    try {
      // old syntax supported at least up to Chrome 41
      // https://code.google.com/p/chromium/issues/detail?id=446051
      document.querySelector('html /deep/ :first-child');
      combinator = '/deep/';
    } catch (noDeep) {
      combinator = '';
    }
  }

  return combinator;
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/detect-focus.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (tests) {
  var data = before();

  var results = {};
  Object.keys(tests).map(function (key) {
    results[key] = test(data, tests[key]);
  });

  after(data);
  return results;
};

var _platform = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/platform.js");

var _platform2 = _interopRequireDefault(_platform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function before() {
  var data = {
    // remember what had focus to restore after test
    activeElement: document.activeElement,
    // remember scroll positions to restore after test
    windowScrollTop: window.scrollTop,
    windowScrollLeft: window.scrollLeft,
    bodyScrollTop: document.body.scrollTop,
    bodyScrollLeft: document.body.scrollLeft
  };

  // wrap tests in an element hidden from screen readers to prevent them
  // from announcing focus, which can be quite irritating to the user
  var iframe = document.createElement('iframe');
  iframe.setAttribute('style', 'position:absolute; position:fixed; top:0; left:-2px; width:1px; height:1px; overflow:hidden;');
  iframe.setAttribute('aria-live', 'off');
  iframe.setAttribute('aria-busy', 'true');
  iframe.setAttribute('aria-hidden', 'true');
  document.body.appendChild(iframe);

  var _window = iframe.contentWindow;
  var _document = _window.document;

  _document.open();
  _document.close();
  var wrapper = _document.createElement('div');
  _document.body.appendChild(wrapper);

  data.iframe = iframe;
  data.wrapper = wrapper;
  data.window = _window;
  data.document = _document;

  return data;
}

// options.element:
//  {string} element name
//  {function} callback(wrapper, document) to generate an element
// options.mutate: (optional)
//  {function} callback(element, wrapper, document) to manipulate element prior to focus-test.
//             Can return DOMElement to define focus target (default: element)
// options.validate: (optional)
//  {function} callback(element, focusTarget, document) to manipulate test-result
function test(data, options) {
  // make sure we operate on a clean slate
  data.wrapper.innerHTML = '';
  // create dummy element to test focusability of
  var element = typeof options.element === 'string' ? data.document.createElement(options.element) : options.element(data.wrapper, data.document);
  // allow callback to further specify dummy element
  // and optionally define element to focus
  var focus = options.mutate && options.mutate(element, data.wrapper, data.document);
  if (!focus && focus !== false) {
    focus = element;
  }
  // element needs to be part of the DOM to be focusable
  !element.parentNode && data.wrapper.appendChild(element);
  // test if the element with invalid tabindex can be focused
  focus && focus.focus && focus.focus();
  // validate test's result
  return options.validate ? options.validate(element, focus, data.document) : data.document.activeElement === focus;
}

function after(data) {
  // restore focus to what it was before test and cleanup
  if (data.activeElement === document.body) {
    document.activeElement && document.activeElement.blur && document.activeElement.blur();
    if (_platform2.default.is.IE10) {
      // IE10 does not redirect focus to <body> when the activeElement is removed
      document.body.focus();
    }
  } else {
    data.activeElement && data.activeElement.focus && data.activeElement.focus();
  }

  document.body.removeChild(data.iframe);

  // restore scroll position
  window.scrollTop = data.windowScrollTop;
  window.scrollLeft = data.windowScrollLeft;
  document.body.scrollTop = data.bodyScrollTop;
  document.body.scrollLeft = data.bodyScrollLeft;
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-area-img-tabindex.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gif = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/media/gif.js");

var _gif2 = _interopRequireDefault(_gif);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attr-usemap
exports.default = {
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = '<map name="image-map-tabindex-test">' + '<area shape="rect" coords="63,19,144,45"></map>' + '<img usemap="#image-map-tabindex-test" tabindex="-1" alt="" src="' + _gif2.default + '">';

    return element.querySelector('area');
  }
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-area-tabindex.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gif = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/media/gif.js");

var _gif2 = _interopRequireDefault(_gif);

var _platform = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/platform.js");

var _platform2 = _interopRequireDefault(_platform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attr-usemap
exports.default = {
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = '<map name="image-map-tabindex-test">' + '<area href="#void" tabindex="-1" shape="rect" coords="63,19,144,45"></map>' + '<img usemap="#image-map-tabindex-test" alt="" src="' + _gif2.default + '">';

    return false;
  },
  validate: function validate(element, focusTarget, _document) {
    if (_platform2.default.is.GECKO) {
      // fixes https://github.com/medialize/ally.js/issues/35
      // Firefox loads the DataURI asynchronously, causing a false-negative
      return true;
    }

    var focus = element.querySelector('area');
    focus.focus();
    return _document.activeElement === focus;
  }
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-area-without-href.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gif = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/media/gif.js");

var _gif2 = _interopRequireDefault(_gif);

var _platform = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/platform.js");

var _platform2 = _interopRequireDefault(_platform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attr-usemap
exports.default = {
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = '<map name="image-map-area-href-test">' + '<area shape="rect" coords="63,19,144,45"></map>' + '<img usemap="#image-map-area-href-test" alt="" src="' + _gif2.default + '">';

    return element.querySelector('area');
  },
  validate: function validate(element, focusTarget, _document) {
    if (_platform2.default.is.GECKO) {
      // fixes https://github.com/medialize/ally.js/issues/35
      // Firefox loads the DataURI asynchronously, causing a false-negative
      return true;
    }

    return _document.activeElement === focusTarget;
  }
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-audio-without-controls.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mp = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/media/mp3.js");

var _mp2 = _interopRequireDefault(_mp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'can-focus-audio-without-controls',
  element: 'audio',
  mutate: function mutate(element) {
    try {
      // invalid media file can trigger warning in console, data-uri to prevent HTTP request
      element.setAttribute('src', _mp2.default);
    } catch (e) {
      // IE9 may throw "Error: Not implemented"
    }
  }
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-broken-image-map.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gif = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/media/gif.invalid.js");

var _gif2 = _interopRequireDefault(_gif);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// NOTE: https://github.com/medialize/ally.js/issues/35
// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attr-usemap
exports.default = {
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = '<map name="broken-image-map-test"><area href="#void" shape="rect" coords="63,19,144,45"></map>' + '<img usemap="#broken-image-map-test" alt="" src="' + _gif2.default + '">';

    return element.querySelector('area');
  }
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-children-of-focusable-flexbox.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// Children of focusable elements with display:flex are focusable in IE10-11
exports.default = {
  element: 'div',
  mutate: function mutate(element) {
    element.setAttribute('tabindex', '-1');
    element.setAttribute('style', 'display: -webkit-flex; display: -ms-flexbox; display: flex;');
    element.innerHTML = '<span style="display: block;">hello</span>';
    return element.querySelector('span');
  }
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-fieldset-disabled.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// fieldset[tabindex=0][disabled] should not be focusable, but Blink and WebKit disagree
// @specification https://www.w3.org/TR/html5/disabled-elements.html#concept-element-disabled
// @browser-issue Chromium https://crbug.com/453847
// @browser-issue WebKit https://bugs.webkit.org/show_bug.cgi?id=141086
exports.default = {
  element: 'fieldset',
  mutate: function mutate(element) {
    element.setAttribute('tabindex', 0);
    element.setAttribute('disabled', 'disabled');
  }
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-fieldset.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  element: 'fieldset',
  mutate: function mutate(element) {
    element.innerHTML = '<legend>legend</legend><p>content</p>';
  }
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-flexbox-container.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// elements with display:flex are focusable in IE10-11
exports.default = {
  element: 'span',
  mutate: function mutate(element) {
    element.setAttribute('style', 'display: -webkit-flex; display: -ms-flexbox; display: flex;');
    element.innerHTML = '<span style="display: block;">hello</span>';
  }
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-form-disabled.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// form[tabindex=0][disabled] should be focusable as the
// specification doesn't know the disabled attribute on the form element
// @specification https://www.w3.org/TR/html5/forms.html#the-form-element
exports.default = {
  element: 'form',
  mutate: function mutate(element) {
    element.setAttribute('tabindex', 0);
    element.setAttribute('disabled', 'disabled');
  }
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-img-ismap.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gif = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/media/gif.js");

var _gif2 = _interopRequireDefault(_gif);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// NOTE: https://github.com/medialize/ally.js/issues/35
// fixes https://github.com/medialize/ally.js/issues/20
// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attr-ismap
exports.default = {
  element: 'a',
  mutate: function mutate(element) {
    element.href = '#void';
    element.innerHTML = '<img ismap src="' + _gif2.default + '" alt="">';
    return element.querySelector('img');
  }
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-img-usemap-tabindex.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gif = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/media/gif.js");

var _gif2 = _interopRequireDefault(_gif);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// NOTE: https://github.com/medialize/ally.js/issues/35
// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attr-usemap
exports.default = {
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = '<map name="image-map-tabindex-test"><area href="#void" shape="rect" coords="63,19,144,45"></map>' + '<img usemap="#image-map-tabindex-test" tabindex="-1" alt="" ' + 'src="' + _gif2.default + '">';

    return element.querySelector('img');
  }
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-in-hidden-iframe.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  element: function element(wrapper, _document) {
    var iframe = _document.createElement('iframe');

    // iframe must be part of the DOM before accessing the contentWindow is possible
    wrapper.appendChild(iframe);

    // create the iframe's default document (<html><head></head><body></body></html>)
    var iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.close();
    return iframe;
  },
  mutate: function mutate(iframe) {
    iframe.style.visibility = 'hidden';

    var iframeDocument = iframe.contentWindow.document;
    var input = iframeDocument.createElement('input');
    iframeDocument.body.appendChild(input);
    return input;
  },
  validate: function validate(iframe) {
    var iframeDocument = iframe.contentWindow.document;
    var focus = iframeDocument.querySelector('input');
    return iframeDocument.activeElement === focus;
  }
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-in-zero-dimension-object.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return result;
};

var _platform = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/platform.js");

var _platform2 = _interopRequireDefault(_platform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var result = !_platform2.default.is.WEBKIT;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-invalid-tabindex.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// Firefox allows *any* value and treats invalid values like tabindex="-1"
// @browser-issue Gecko https://bugzilla.mozilla.org/show_bug.cgi?id=1128054
exports.default = {
  element: 'div',
  mutate: function mutate(element) {
    element.setAttribute('tabindex', 'invalid-value');
  }
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-label-tabindex.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  element: 'label',
  mutate: function mutate(element) {
    element.setAttribute('tabindex', '-1');
  },
  validate: function validate(element, focusTarget, _document) {
    // force layout in Chrome 49, otherwise the element won't be focusable
    /* eslint-disable no-unused-vars */
    var variableToPreventDeadCodeElimination = element.offsetHeight;
    /* eslint-enable no-unused-vars */
    element.focus();
    return _document.activeElement === element;
  }
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-object-svg-hidden.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _svg = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/media/svg.js");

var _svg2 = _interopRequireDefault(_svg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Note: IE10 on BrowserStack does not like this test

exports.default = {
  element: 'object',
  mutate: function mutate(element) {
    element.setAttribute('type', 'image/svg+xml');
    element.setAttribute('data', _svg2.default);
    element.setAttribute('width', '200');
    element.setAttribute('height', '50');
    element.style.visibility = 'hidden';
  }
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-object-svg.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _svg = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/media/svg.js");

var _svg2 = _interopRequireDefault(_svg);

var _platform = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/platform.js");

var _platform2 = _interopRequireDefault(_platform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Note: IE10 on BrowserStack does not like this test

exports.default = {
  name: 'can-focus-object-svg',
  element: 'object',
  mutate: function mutate(element) {
    element.setAttribute('type', 'image/svg+xml');
    element.setAttribute('data', _svg2.default);
    element.setAttribute('width', '200');
    element.setAttribute('height', '50');
  },
  validate: function validate(element, focusTarget, _document) {
    if (_platform2.default.is.GECKO) {
      // Firefox seems to be handling the object creation asynchronously and thereby produces a false negative test result.
      // Because we know Firefox is able to focus object elements referencing SVGs, we simply cheat by sniffing the user agent string
      return true;
    }

    return _document.activeElement === element;
  }
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-object-swf.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return result;
};

var _platform = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/platform.js");

var _platform2 = _interopRequireDefault(_platform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Every Environment except IE9 considers SWF objects focusable
var result = !_platform2.default.is.IE9;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-redirect-img-usemap.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gif = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/media/gif.js");

var _gif2 = _interopRequireDefault(_gif);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = '<map name="focus-redirect-img-usemap"><area href="#void" shape="rect" coords="63,19,144,45"></map>' + '<img usemap="#focus-redirect-img-usemap" alt="" ' + 'src="' + _gif2.default + '">';

    // focus the <img>, not the <div>
    return element.querySelector('img');
  },
  validate: function validate(element, focusTarget, _document) {
    var target = element.querySelector('area');
    return _document.activeElement === target;
  }
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-redirect-legend.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// see https://jsbin.com/nenirisage/edit?html,js,console,output

exports.default = {
  element: 'fieldset',
  mutate: function mutate(element) {
    element.innerHTML = '<legend>legend</legend><input tabindex="-1"><input tabindex="0">';
    // take care of focus in validate();
    return false;
  },
  validate: function validate(element, focusTarget, _document) {
    var focusable = element.querySelector('input[tabindex="-1"]');
    var tabbable = element.querySelector('input[tabindex="0"]');

    // Firefox requires this test to focus the <fieldset> first, while this is not necessary in
    // https://jsbin.com/nenirisage/edit?html,js,console,output
    element.focus();

    element.querySelector('legend').focus();
    return _document.activeElement === focusable && 'focusable' || _document.activeElement === tabbable && 'tabbable' || '';
  }
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-scroll-body.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// https://github.com/medialize/ally.js/issues/21
exports.default = {
  element: 'div',
  mutate: function mutate(element) {
    element.setAttribute('style', 'width: 100px; height: 50px; overflow: auto;');
    element.innerHTML = '<div style="width: 500px; height: 40px;">scrollable content</div>';
    return element.querySelector('div');
  }
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-scroll-container-without-overflow.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// https://github.com/medialize/ally.js/issues/21
exports.default = {
  element: 'div',
  mutate: function mutate(element) {
    element.setAttribute('style', 'width: 100px; height: 50px;');
    element.innerHTML = '<div style="width: 500px; height: 40px;">scrollable content</div>';
  }
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-scroll-container.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// https://github.com/medialize/ally.js/issues/21
exports.default = {
  element: 'div',
  mutate: function mutate(element) {
    element.setAttribute('style', 'width: 100px; height: 50px; overflow: auto;');
    element.innerHTML = '<div style="width: 500px; height: 40px;">scrollable content</div>';
  }
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-summary.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  element: 'details',
  mutate: function mutate(element) {
    element.innerHTML = '<summary>foo</summary><p>content</p>';
    return element.firstElementChild;
  }
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-svg-focusable-attribute.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _svg = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/helper/svg.js");

exports.default = {
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = (0, _svg.generate)('<text focusable="true">a</text>');
    return element.querySelector('text');
  },
  validate: _svg.validate
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-svg-foreignobject-tabindex.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _svg = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/helper/svg.js");

exports.default = {
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = (0, _svg.generate)('<foreignObject tabindex="-1"><input type="text" /></foreignObject>');
    // Safari 8's quersSelector() can't identify foreignObject, but getElementyByTagName() can
    return element.querySelector('foreignObject') || element.getElementsByTagName('foreignObject')[0];
  },
  validate: _svg.validate

};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-svg-in-iframe.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return result;
};

var _platform = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/platform.js");

var _platform2 = _interopRequireDefault(_platform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Firefox seems to be handling the SVG-document-in-iframe creation asynchronously
// and thereby produces a false negative test result. Thus the test is pointless
// and we resort to UA sniffing once again.
// see http://jsbin.com/vunadohoko/1/edit?js,console,output

var result = Boolean(_platform2.default.is.GECKO && typeof SVGElement !== 'undefined' && SVGElement.prototype.focus);

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-svg-negative-tabindex-attribute.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _svg = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/helper/svg.js");

exports.default = {
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = (0, _svg.generate)('<text tabindex="-1">a</text>');
    return element.querySelector('text');
  },
  validate: _svg.validate
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-svg-tabindex-attribute.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _svg = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/helper/svg.js");

exports.default = {
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = (0, _svg.generate)('<text tabindex="0">a</text>');
    return element.querySelector('text');
  },
  validate: _svg.validate
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-svg-use-tabindex.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _svg = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/helper/svg.js");

exports.default = {
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = (0, _svg.generate)(['<g id="ally-test-target"><a xlink:href="#void"><text>link</text></a></g>', '<use xlink:href="#ally-test-target" x="0" y="0" tabindex="-1" />'].join(''));

    return element.querySelector('use');
  },
  validate: _svg.validate
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-svg.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _svg = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/helper/svg.js");

exports.default = {
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = (0, _svg.generate)('');
    return element.firstChild;
  },
  validate: _svg.validate
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-tabindex-trailing-characters.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// Firefox allows *any* value and treats invalid values like tabindex="-1"
// @browser-issue Gecko https://bugzilla.mozilla.org/show_bug.cgi?id=1128054
exports.default = {
  element: 'div',
  mutate: function mutate(element) {
    element.setAttribute('tabindex', '3x');
  }
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-table.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  element: 'table',
  mutate: function mutate(element, wrapper, _document) {
    // IE9 has a problem replacing TBODY contents with innerHTML.
    // https://stackoverflow.com/a/8097055/515124
    // element.innerHTML = '<tr><td>cell</td></tr>';
    var fragment = _document.createDocumentFragment();
    fragment.innerHTML = '<tr><td>cell</td></tr>';
    element.appendChild(fragment);
  }
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-video-without-controls.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mp = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/media/mp4.js");

var _mp2 = _interopRequireDefault(_mp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  element: 'video',
  mutate: function mutate(element) {
    try {
      // invalid media file can trigger warning in console, data-uri to prevent HTTP request
      element.setAttribute('src', _mp2.default);
    } catch (e) {
      // IE9 may throw "Error: Not implemented"
    }
  }
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/helper/svg.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generate = generate;
exports.focus = focus;
exports.validate = validate;

var _focus = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/element/focus.svg-foreign-object-hack.js");

var _focus2 = _interopRequireDefault(_focus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function generate(element) {
  return '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">' + element + '</svg>';
}

function focus(element) {
  if (element.focus) {
    return;
  }

  try {
    HTMLElement.prototype.focus.call(element);
  } catch (e) {
    (0, _focus2.default)(element);
  }
}

function validate(element, focusTarget, _document) {
  focus(focusTarget);
  return _document.activeElement === focusTarget;
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/media/gif.invalid.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZ';

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/media/gif.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/media/mp3.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gif = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/media/gif.js");

var _gif2 = _interopRequireDefault(_gif);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gif2.default;
// export default 'data:audio/mp3;base64,audio-focus-test';

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/media/mp4.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gif = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/media/gif.js");

var _gif2 = _interopRequireDefault(_gif);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gif2.default;
// export default 'data:video/mp4;base64,video-focus-test';

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/media/svg.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtb' + 'G5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBpZD0ic3ZnIj48dGV4dCB4PSIxMCIgeT0iMjAiIGlkPSJ' + 'zdmctbGluay10ZXh0Ij50ZXh0PC90ZXh0Pjwvc3ZnPg==';

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/supports-cache.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _version = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/version.js");

var _version2 = _interopRequireDefault(_version);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function readLocalStorage(key) {
  // allow reading from storage to retrieve previous support results
  // even while the document does not have focus
  var data = void 0;

  try {
    data = window.localStorage && window.localStorage.getItem(key);
    data = data ? JSON.parse(data) : {};
  } catch (e) {
    data = {};
  }

  return data;
} /*
      Facility to cache test results in localStorage.
  
      USAGE:
        cache.get('key');
        cache.set('key', 'value');
   */

function writeLocalStorage(key, value) {
  if (!document.hasFocus()) {
    // if the document does not have focus when tests are executed, focus() may
    // not be handled properly and events may not be dispatched immediately.
    // This can happen when a document is reloaded while Developer Tools have focus.
    try {
      window.localStorage && window.localStorage.removeItem(key);
    } catch (e) {
      // ignore
    }

    return;
  }

  try {
    window.localStorage && window.localStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    // ignore
  }
}

var userAgent = typeof window !== 'undefined' && window.navigator.userAgent || '';
var cacheKey = 'ally-supports-cache';
var cache = readLocalStorage(cacheKey);

// update the cache if ally or the user agent changed (newer version, etc)
if (cache.userAgent !== userAgent || cache.version !== _version2.default) {
  cache = {};
}

cache.userAgent = userAgent;
cache.version = _version2.default;

exports.default = {
  get: function get() {
    return cache;
  },
  set: function set(values) {
    Object.keys(values).forEach(function (key) {
      cache[key] = values[key];
    });

    cache.time = new Date().toISOString();
    writeLocalStorage(cacheKey, cache);
  }
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/supports.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  if (supportsCache) {
    return supportsCache;
  }

  supportsCache = _supportsCache2.default.get();
  if (!supportsCache.time) {
    _supportsCache2.default.set(executeTests());
    supportsCache = _supportsCache2.default.get();
  }

  return supportsCache;
};

var _detectFocus = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/detect-focus.js");

var _detectFocus2 = _interopRequireDefault(_detectFocus);

var _supportsCache = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/supports-cache.js");

var _supportsCache2 = _interopRequireDefault(_supportsCache);

var _cssShadowPiercingDeepCombinator = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/css-shadow-piercing-deep-combinator.js");

var _cssShadowPiercingDeepCombinator2 = _interopRequireDefault(_cssShadowPiercingDeepCombinator);

var _focusAreaImgTabindex = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-area-img-tabindex.js");

var _focusAreaImgTabindex2 = _interopRequireDefault(_focusAreaImgTabindex);

var _focusAreaTabindex = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-area-tabindex.js");

var _focusAreaTabindex2 = _interopRequireDefault(_focusAreaTabindex);

var _focusAreaWithoutHref = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-area-without-href.js");

var _focusAreaWithoutHref2 = _interopRequireDefault(_focusAreaWithoutHref);

var _focusAudioWithoutControls = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-audio-without-controls.js");

var _focusAudioWithoutControls2 = _interopRequireDefault(_focusAudioWithoutControls);

var _focusBrokenImageMap = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-broken-image-map.js");

var _focusBrokenImageMap2 = _interopRequireDefault(_focusBrokenImageMap);

var _focusChildrenOfFocusableFlexbox = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-children-of-focusable-flexbox.js");

var _focusChildrenOfFocusableFlexbox2 = _interopRequireDefault(_focusChildrenOfFocusableFlexbox);

var _focusFieldsetDisabled = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-fieldset-disabled.js");

var _focusFieldsetDisabled2 = _interopRequireDefault(_focusFieldsetDisabled);

var _focusFieldset = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-fieldset.js");

var _focusFieldset2 = _interopRequireDefault(_focusFieldset);

var _focusFlexboxContainer = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-flexbox-container.js");

var _focusFlexboxContainer2 = _interopRequireDefault(_focusFlexboxContainer);

var _focusFormDisabled = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-form-disabled.js");

var _focusFormDisabled2 = _interopRequireDefault(_focusFormDisabled);

var _focusImgIsmap = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-img-ismap.js");

var _focusImgIsmap2 = _interopRequireDefault(_focusImgIsmap);

var _focusImgUsemapTabindex = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-img-usemap-tabindex.js");

var _focusImgUsemapTabindex2 = _interopRequireDefault(_focusImgUsemapTabindex);

var _focusInHiddenIframe = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-in-hidden-iframe.js");

var _focusInHiddenIframe2 = _interopRequireDefault(_focusInHiddenIframe);

var _focusInZeroDimensionObject = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-in-zero-dimension-object.js");

var _focusInZeroDimensionObject2 = _interopRequireDefault(_focusInZeroDimensionObject);

var _focusInvalidTabindex = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-invalid-tabindex.js");

var _focusInvalidTabindex2 = _interopRequireDefault(_focusInvalidTabindex);

var _focusLabelTabindex = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-label-tabindex.js");

var _focusLabelTabindex2 = _interopRequireDefault(_focusLabelTabindex);

var _focusObjectSvgHidden = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-object-svg-hidden.js");

var _focusObjectSvgHidden2 = _interopRequireDefault(_focusObjectSvgHidden);

var _focusObjectSvg = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-object-svg.js");

var _focusObjectSvg2 = _interopRequireDefault(_focusObjectSvg);

var _focusObjectSwf = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-object-swf.js");

var _focusObjectSwf2 = _interopRequireDefault(_focusObjectSwf);

var _focusRedirectImgUsemap = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-redirect-img-usemap.js");

var _focusRedirectImgUsemap2 = _interopRequireDefault(_focusRedirectImgUsemap);

var _focusRedirectLegend = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-redirect-legend.js");

var _focusRedirectLegend2 = _interopRequireDefault(_focusRedirectLegend);

var _focusScrollBody = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-scroll-body.js");

var _focusScrollBody2 = _interopRequireDefault(_focusScrollBody);

var _focusScrollContainerWithoutOverflow = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-scroll-container-without-overflow.js");

var _focusScrollContainerWithoutOverflow2 = _interopRequireDefault(_focusScrollContainerWithoutOverflow);

var _focusScrollContainer = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-scroll-container.js");

var _focusScrollContainer2 = _interopRequireDefault(_focusScrollContainer);

var _focusSummary = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-summary.js");

var _focusSummary2 = _interopRequireDefault(_focusSummary);

var _focusSvgFocusableAttribute = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-svg-focusable-attribute.js");

var _focusSvgFocusableAttribute2 = _interopRequireDefault(_focusSvgFocusableAttribute);

var _focusSvgTabindexAttribute = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-svg-tabindex-attribute.js");

var _focusSvgTabindexAttribute2 = _interopRequireDefault(_focusSvgTabindexAttribute);

var _focusSvgNegativeTabindexAttribute = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-svg-negative-tabindex-attribute.js");

var _focusSvgNegativeTabindexAttribute2 = _interopRequireDefault(_focusSvgNegativeTabindexAttribute);

var _focusSvgUseTabindex = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-svg-use-tabindex.js");

var _focusSvgUseTabindex2 = _interopRequireDefault(_focusSvgUseTabindex);

var _focusSvgForeignobjectTabindex = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-svg-foreignobject-tabindex.js");

var _focusSvgForeignobjectTabindex2 = _interopRequireDefault(_focusSvgForeignobjectTabindex);

var _focusSvgInIframe = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-svg-in-iframe.js");

var _focusSvgInIframe2 = _interopRequireDefault(_focusSvgInIframe);

var _focusSvg = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-svg.js");

var _focusSvg2 = _interopRequireDefault(_focusSvg);

var _focusTabindexTrailingCharacters = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-tabindex-trailing-characters.js");

var _focusTabindexTrailingCharacters2 = _interopRequireDefault(_focusTabindexTrailingCharacters);

var _focusTable = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-table.js");

var _focusTable2 = _interopRequireDefault(_focusTable);

var _focusVideoWithoutControls = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/focus-video-without-controls.js");

var _focusVideoWithoutControls2 = _interopRequireDefault(_focusVideoWithoutControls);

var _tabsequenceAreaAtImgPosition = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/tabsequence-area-at-img-position.js");

var _tabsequenceAreaAtImgPosition2 = _interopRequireDefault(_tabsequenceAreaAtImgPosition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var testCallbacks = {
  cssShadowPiercingDeepCombinator: _cssShadowPiercingDeepCombinator2.default,
  focusInZeroDimensionObject: _focusInZeroDimensionObject2.default,
  focusObjectSwf: _focusObjectSwf2.default,
  focusSvgInIframe: _focusSvgInIframe2.default,
  tabsequenceAreaAtImgPosition: _tabsequenceAreaAtImgPosition2.default
};

var testDescriptions = {
  focusAreaImgTabindex: _focusAreaImgTabindex2.default,
  focusAreaTabindex: _focusAreaTabindex2.default,
  focusAreaWithoutHref: _focusAreaWithoutHref2.default,
  focusAudioWithoutControls: _focusAudioWithoutControls2.default,
  focusBrokenImageMap: _focusBrokenImageMap2.default,
  focusChildrenOfFocusableFlexbox: _focusChildrenOfFocusableFlexbox2.default,
  focusFieldsetDisabled: _focusFieldsetDisabled2.default,
  focusFieldset: _focusFieldset2.default,
  focusFlexboxContainer: _focusFlexboxContainer2.default,
  focusFormDisabled: _focusFormDisabled2.default,
  focusImgIsmap: _focusImgIsmap2.default,
  focusImgUsemapTabindex: _focusImgUsemapTabindex2.default,
  focusInHiddenIframe: _focusInHiddenIframe2.default,
  focusInvalidTabindex: _focusInvalidTabindex2.default,
  focusLabelTabindex: _focusLabelTabindex2.default,
  focusObjectSvg: _focusObjectSvg2.default,
  focusObjectSvgHidden: _focusObjectSvgHidden2.default,
  focusRedirectImgUsemap: _focusRedirectImgUsemap2.default,
  focusRedirectLegend: _focusRedirectLegend2.default,
  focusScrollBody: _focusScrollBody2.default,
  focusScrollContainerWithoutOverflow: _focusScrollContainerWithoutOverflow2.default,
  focusScrollContainer: _focusScrollContainer2.default,
  focusSummary: _focusSummary2.default,
  focusSvgFocusableAttribute: _focusSvgFocusableAttribute2.default,
  focusSvgTabindexAttribute: _focusSvgTabindexAttribute2.default,
  focusSvgNegativeTabindexAttribute: _focusSvgNegativeTabindexAttribute2.default,
  focusSvgUseTabindex: _focusSvgUseTabindex2.default,
  focusSvgForeignobjectTabindex: _focusSvgForeignobjectTabindex2.default,
  focusSvg: _focusSvg2.default,
  focusTabindexTrailingCharacters: _focusTabindexTrailingCharacters2.default,
  focusTable: _focusTable2.default,
  focusVideoWithoutControls: _focusVideoWithoutControls2.default
};

function executeTests() {
  var results = (0, _detectFocus2.default)(testDescriptions);
  Object.keys(testCallbacks).forEach(function (key) {
    results[key] = testCallbacks[key]();
  });

  return results;
}

var supportsCache = null;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/tabsequence-area-at-img-position.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return result;
};

var _platform = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/platform.js");

var _platform2 = _interopRequireDefault(_platform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://jsbin.com/vafaba/3/edit?html,js,console,output
var result = _platform2.default.is.GECKO || _platform2.default.is.TRIDENT || _platform2.default.is.EDGE;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/array-find-index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findIndex;
function findIndex(array, callback) {
  // attempt to use native or polyfilled Array#findIndex first
  if (array.findIndex) {
    return array.findIndex(callback);
  }

  var length = array.length;

  // shortcut if the array is empty
  if (length === 0) {
    return -1;
  }

  // otherwise loop over array
  for (var i = 0; i < length; i++) {
    if (callback(array[i], i, array)) {
      return i;
    }
  }

  return -1;
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/compare-position.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getParentComparator = getParentComparator;

// Node.compareDocumentPosition is available since IE9
// see https://developer.mozilla.org/en-US/docs/Web/API/Node.compareDocumentPosition

// callback returns true when element is contained by parent or is the parent suited for use with Array.some()
/*
  USAGE:
    var isChildOf = getParentComparator({parent: someNode});
    listOfElements.some(isChildOf)
*/

function getParentComparator() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      parent = _ref.parent,
      element = _ref.element,
      includeSelf = _ref.includeSelf;

  if (parent) {
    return function isChildOf(node) {
      return Boolean(includeSelf && node === parent || parent.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY);
    };
  } else if (element) {
    return function isParentOf(node) {
      return Boolean(includeSelf && element === node || node.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_CONTAINED_BY);
    };
  }

  throw new TypeError('util/compare-position#getParentComparator required either options.parent or options.element');
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/context-to-element.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (_ref) {
  var context = _ref.context,
      _ref$label = _ref.label,
      label = _ref$label === undefined ? 'context-to-element' : _ref$label,
      resolveDocument = _ref.resolveDocument,
      defaultToDocument = _ref.defaultToDocument;

  var element = (0, _nodeArray2.default)(context)[0];

  if (resolveDocument && element && element.nodeType === Node.DOCUMENT_NODE) {
    element = element.documentElement;
  }

  if (!element && defaultToDocument) {
    return document.documentElement;
  }

  if (!element) {
    throw new TypeError(label + ' requires valid options.context');
  }

  if (element.nodeType !== Node.ELEMENT_NODE && element.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) {
    throw new TypeError(label + ' requires options.context to be an Element');
  }

  return element;
};

var _nodeArray = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/node-array.js");

var _nodeArray2 = _interopRequireDefault(_nodeArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/decorate-service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      engage = _ref2.engage,
      disengage = _ref2.disengage;

  var data = {
    engage: engage || noop,
    disengage: disengage || noop,
    instances: 0,
    _result: null
  };

  return initialize.bind(data);
};

/*
  The Singleton Decorator is intended to allow modules to initialize a ("singleton") component as if
  it was the only one using it. Every module gets to initialize and destruct the component by itself.
  Via simple reference counting the component keeps track of how many modules have initialized it,
  so it destructs only when the last module is gone. This decorator hides the component's singleton
  nature from the application in order to offer a homogenous API.

  engage() can return an object (result) with methods to expose to the consumer,
  upon initialization result.disengage is added and returned to the consumer.
*/

function destruct() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      force = _ref.force;

  if (force) {
    this.instances = 0;
  } else {
    this.instances--;
  }

  if (!this.instances) {
    this.disengage();
    this._result = null;
  }
}

function initialize() {
  if (this.instances) {
    this.instances++;
    return this._result;
  }

  this.instances++;
  this._result = this.engage() || {};
  this._result.disengage = destruct.bind(this);

  return this._result;
}

function noop() {}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/element-matches.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = elementMatches;

// Element.prototype.matches may be available at a different name
// https://developer.mozilla.org/en/docs/Web/API/Element/matches

var names = ['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector'];
var name = null;

function findMethodName(element) {
  names.some(function (_name) {
    if (!element[_name]) {
      return false;
    }

    name = _name;
    return true;
  });
}

function elementMatches(element, selector) {
  if (!name) {
    findMethodName(element);
  }

  return element[name](selector);
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/get-content-document.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (node) {
  try {
    // works on <object> and <iframe>
    return node.contentDocument
    // works on <object> and <iframe>
    || node.contentWindow && node.contentWindow.document
    // works on <object> and <iframe> that contain SVG
    || node.getSVGDocument && node.getSVGDocument() || null;
  } catch (e) {
    // SecurityError: Failed to read the 'contentDocument' property from 'HTMLObjectElement'
    // also IE may throw member not found exception e.g. on <object type="image/png">
    return null;
  }
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/get-document.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (node) {
  if (!node) {
    return document;
  }

  if (node.nodeType === Node.DOCUMENT_NODE) {
    return node;
  }

  return node.ownerDocument || document;
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/get-frame-element.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getFrameElement;

var _getContentDocument = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/get-content-document.js");

var _getContentDocument2 = _interopRequireDefault(_getContentDocument);

var _getWindow = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/get-window.js");

var _getWindow2 = _interopRequireDefault(_getWindow);

var _selectInShadows = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/select-in-shadows.js");

var _selectInShadows2 = _interopRequireDefault(_selectInShadows);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selector = void 0;

function findDocumentHostElement(_window) {
  if (!selector) {
    selector = (0, _selectInShadows2.default)('object, iframe');
  }

  if (_window._frameElement !== undefined) {
    return _window._frameElement;
  }

  _window._frameElement = null;

  var potentialHosts = _window.parent.document.querySelectorAll(selector);
  [].some.call(potentialHosts, function (element) {
    var _document = (0, _getContentDocument2.default)(element);
    if (_document !== _window.document) {
      return false;
    }

    _window._frameElement = element;
    return true;
  });

  return _window._frameElement;
}

function getFrameElement(element) {
  var _window = (0, _getWindow2.default)(element);
  if (!_window.parent || _window.parent === _window) {
    // if there is no parent browsing context,
    // we're not going to get a frameElement either way
    return null;
  }

  try {
    // see https://developer.mozilla.org/en-US/docs/Web/API/Window/frameElement
    // does not work within <embed> anywhere, and not within in <object> in IE
    return _window.frameElement || findDocumentHostElement(_window);
  } catch (e) {
    return null;
  }
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/get-window.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (node) {
  var _document = (0, _getDocument2.default)(node);
  return _document.defaultView || window;
};

var _getDocument = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/get-document.js");

var _getDocument2 = _interopRequireDefault(_getDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/image-map.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMapByName = getMapByName;
exports.getMapOfImage = getMapOfImage;
exports.getImageOfArea = getImageOfArea;

var _css = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/css.escape/css.escape.js");

var _css2 = _interopRequireDefault(_css);

var _getDocument = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/get-document.js");

var _getDocument2 = _interopRequireDefault(_getDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getMapByName(name, _document) {
  // apparently getElementsByName() also considers id attribute in IE & opera
  // https://developer.mozilla.org/en-US/docs/Web/API/Document/getElementsByName
  var map = _document.querySelector('map[name="' + (0, _css2.default)(name) + '"]');
  return map || null;
}

function getMapOfImage(element) {
  var usemap = element.getAttribute('usemap');
  if (!usemap) {
    return null;
  }

  var _document = (0, _getDocument2.default)(element);
  return getMapByName(usemap.slice(1), _document);
}

function getImageOfArea(element) {
  var map = element.parentElement;

  if (!map.name || map.nodeName.toLowerCase() !== 'map') {
    return null;
  }

  // NOTE: image maps can also be applied to <object> with image content,
  // but no browser supports this at the moment

  // HTML5 specifies HTMLMapElement.images to be an HTMLCollection of all
  // <img> and <object> referencing the <map> element, but no browser implements this
  //   https://www.w3.org/TR/html5/embedded-content-0.html#the-map-element
  //   https://developer.mozilla.org/en-US/docs/Web/API/HTMLMapElement
  // the image must be valid and loaded for the map to take effect
  var _document = (0, _getDocument2.default)(element);
  return _document.querySelector('img[usemap="#' + (0, _css2.default)(map.name) + '"]') || null;
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/logger.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var noop = function noop() {};
var _console = {
  log: noop,
  debug: noop,
  info: noop,
  warn: noop,
  error: noop
};

exports.default = typeof console !== 'undefined' ? console : _console;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/node-array.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (input) {
  if (!input) {
    return [];
  }

  if (Array.isArray(input)) {
    return input;
  }

  // instanceof Node - does not work with iframes
  if (input.nodeType !== undefined) {
    return [input];
  }

  if (typeof input === 'string') {
    input = document.querySelectorAll(input);
  }

  if (input.length !== undefined) {
    return [].slice.call(input, 0);
  }

  throw new TypeError('unexpected input ' + String(input));
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/platform.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _platform2 = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/platform/platform.js");

var _platform3 = _interopRequireDefault(_platform2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// deep clone of original platform
var platform = JSON.parse(JSON.stringify(_platform3.default));

// operating system

// sugar for https://github.com/bestiejs/platform.js
// make sure to ALWAYS reference the layout engine,
// even if it is not necessary for the condition,
// as this makes grepping for this stuff simpler

var os = platform.os.family || '';
var ANDROID = os === 'Android';
var WINDOWS = os.slice(0, 7) === 'Windows';
var OSX = os === 'OS X';
var IOS = os === 'iOS';

// layout
var BLINK = platform.layout === 'Blink';
var GECKO = platform.layout === 'Gecko';
var TRIDENT = platform.layout === 'Trident';
var EDGE = platform.layout === 'EdgeHTML';
var WEBKIT = platform.layout === 'WebKit';

// browser version (not layout engine version!)
var version = parseFloat(platform.version);
var majorVersion = Math.floor(version);
platform.majorVersion = majorVersion;

platform.is = {
  // operating system
  ANDROID: ANDROID,
  WINDOWS: WINDOWS,
  OSX: OSX,
  IOS: IOS,
  // layout
  BLINK: BLINK, // "Chrome", "Chrome Mobile", "Opera"
  GECKO: GECKO, // "Firefox"
  TRIDENT: TRIDENT, // "Internet Explorer"
  EDGE: EDGE, // "Microsoft Edge"
  WEBKIT: WEBKIT, // "Safari"
  // INTERNET EXPLORERS
  IE9: TRIDENT && majorVersion === 9,
  IE10: TRIDENT && majorVersion === 10,
  IE11: TRIDENT && majorVersion === 11
};

exports.default = platform;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/select-in-shadows.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (selector) {
  if (typeof shadowPrefix !== 'string') {
    var operator = (0, _cssShadowPiercingDeepCombinator2.default)();
    if (operator) {
      shadowPrefix = ', html ' + operator + ' ';
    }
  }

  if (!shadowPrefix) {
    return selector;
  }

  return selector + shadowPrefix + selector.replace(/\s*,\s*/g, ',').split(',').join(shadowPrefix);
};

var _cssShadowPiercingDeepCombinator = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/supports/css-shadow-piercing-deep-combinator.js");

var _cssShadowPiercingDeepCombinator2 = _interopRequireDefault(_cssShadowPiercingDeepCombinator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var shadowPrefix = void 0;
// convert a CSS selector so that it also pierces ShadowDOM
// takes ".a, #b" and turns it into ".a, #b, html >>> .a, html >>> #b"

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/tabindex-value.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (element) {
  if (!(0, _validTabindex2.default)(element)) {
    return null;
  }

  // Edge 14 has a capitalization problem on SVG elements,
  // see https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/9282058/
  var hasTabindex = element.hasAttribute('tabindex');
  var attributeName = hasTabindex ? 'tabindex' : 'tabIndex';

  // @browser-issue Gecko https://bugzilla.mozilla.org/show_bug.cgi?id=1128054
  var tabindex = parseInt(element.getAttribute(attributeName), 10);
  return isNaN(tabindex) ? -1 : tabindex;
};

var _validTabindex = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/is/valid-tabindex.js");

var _validTabindex2 = _interopRequireDefault(_validTabindex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/toggle-attribute-value.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (_ref) {
  var element = _ref.element,
      attribute = _ref.attribute,
      temporaryValue = _ref.temporaryValue,
      saveValue = _ref.saveValue;

  var temporaryAttribute = 'data-cached-' + attribute;

  if (temporaryValue !== undefined) {
    var _value = saveValue || element.getAttribute(attribute);
    element.setAttribute(temporaryAttribute, _value || '');
    element.setAttribute(attribute, temporaryValue);
  } else {
    var _value2 = element.getAttribute(temporaryAttribute);
    element.removeAttribute(temporaryAttribute);
    if (_value2 === '') {
      element.removeAttribute(attribute);
    } else {
      element.setAttribute(attribute, _value2);
    }
  }
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/toggle-attribute.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (_ref) {
  var element = _ref.element,
      attribute = _ref.attribute;

  var temporaryAttribute = 'data-cached-' + attribute;
  var temporaryAttributeValue = element.getAttribute(temporaryAttribute);

  if (temporaryAttributeValue === null) {
    var _value = element.getAttribute(attribute);
    if (_value === null) {
      // can't remove what's not there
      return;
    }

    element.setAttribute(temporaryAttribute, _value || '');
    element.removeAttribute(attribute);
  } else {
    var _value2 = element.getAttribute(temporaryAttribute);
    element.removeAttribute(temporaryAttribute);
    element.setAttribute(attribute, _value2);
  }
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/toggle-class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleClass = toggleClass;
exports.removeClass = removeClass;
exports.addClass = addClass;
//
// This util allows to easily add, remove or toggle classes.
//
// Using it is neccessary as IE 9 doesn't support element classList
// and IE 11 doesn't support classList for SVG elements
// see also https://developer.mozilla.org/en/docs/Web/API/Element/classList
//
// This file is a replacement for domtokenlist because of
// https://github.com/medialize/ally.js/issues/147
//
// Usage:
//
// toggleClass(div, 'demo'); // Toggles the class `demo`
// toggleClass(div, 'demo', true); // Adds the class `demo`
// toggleClass(div, 'demo', false); // removes the class `demo`
//
// removeClass(div, 'demo');
// addClass(div, 'demo');
//

/**
 * Extract an array of all classNames of the given DOM or SVG node
 */
function getClassNames(element) {
  var className = element.getAttribute && element.getAttribute('class') || '';
  return className === '' ? [] : className.split(' ');
}

function toggleClass(element, className, force) {
  var classNames = getClassNames(element);
  var idx = classNames.indexOf(className);
  var hasClass = idx !== -1;
  var shouldHaveClass = force !== undefined ? force : !hasClass;
  // Break if classes are already set/removed
  if (shouldHaveClass === hasClass) {
    return;
  }
  // Remove class
  if (!shouldHaveClass) {
    classNames.splice(idx, 1);
  }
  // Add class
  if (shouldHaveClass) {
    classNames.push(className);
  }
  element.setAttribute('class', classNames.join(' '));
}

function removeClass(element, className) {
  return toggleClass(element, className, false);
}

function addClass(element, className) {
  return toggleClass(element, className, true);
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/version.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// this file is overwritten by `npm run build:pre`
var version = '1.4.1';
exports.default = version;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/when/key.binding.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (text) {
  return text.split(/\s+/).map(function (_text) {
    var tokens = _text.split('+');
    var _modifiers = resolveModifiers(tokens.slice(0, -1));
    var _keyCodes = resolveKey(tokens.slice(-1));
    return {
      keyCodes: _keyCodes,
      modifiers: _modifiers,
      matchModifiers: matchModifiers.bind(null, _modifiers)
    };
  });
};

var _keycode = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/map/keycode.js");

var _keycode2 = _interopRequireDefault(_keycode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifier = {
  alt: 'altKey',
  ctrl: 'ctrlKey',
  meta: 'metaKey',
  shift: 'shiftKey'
};
/*
  decodes a key binding token to a JavaScript structure

  returns an array of objects:
    {
      // key name translated to keyCode (possibly more than one)
      keyCodes: [<number>],
      // translated modifiers
      modifiers: {
        altKey: null,   // ignore
        ctrKey: false,  // expect not pressed
        metaKey: true,  // expect pressed
        shiftKey: true, // expect pressed
      },
      // callback that returns true if event's
      // modifier keys match the expected state
      matchModifiers: function(event){},
    }
*/

var modifierSequence = Object.keys(modifier).map(function (name) {
  return modifier[name];
});

function createExpectedModifiers(ignoreModifiers) {
  var value = ignoreModifiers ? null : false;
  return {
    altKey: value,
    ctrlKey: value,
    metaKey: value,
    shiftKey: value
  };
}

function resolveModifiers(modifiers) {
  var ignoreModifiers = modifiers.indexOf('*') !== -1;
  var expected = createExpectedModifiers(ignoreModifiers);

  modifiers.forEach(function (token) {
    if (token === '*') {
      // we've already covered the all-in operator
      return;
    }

    // we want the modifier pressed
    var value = true;
    var operator = token.slice(0, 1);
    if (operator === '?') {
      // we don't care if the modifier is pressed
      value = null;
    } else if (operator === '!') {
      // we do not want the modifier pressed
      value = false;
    }

    if (value !== true) {
      // compensate for the modifier's operator
      token = token.slice(1);
    }

    var propertyName = modifier[token];
    if (!propertyName) {
      throw new TypeError('Unknown modifier "' + token + '"');
    }

    expected[propertyName] = value;
  });

  return expected;
}

function resolveKey(key) {
  var code = _keycode2.default[key] || parseInt(key, 10);
  if (!code || typeof code !== 'number' || isNaN(code)) {
    throw new TypeError('Unknown key "' + key + '"');
  }

  return [code].concat(_keycode2.default._alias[code] || []);
}

function matchModifiers(expected, event) {
  // returns true on match
  return !modifierSequence.some(function (prop) {
    // returns true on mismatch
    return typeof expected[prop] === 'boolean' && Boolean(event[prop]) !== expected[prop];
  });
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/when/key.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var map = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var bindings = {};

  var context = (0, _nodeArray2.default)(map.context)[0] || document.documentElement;
  delete map.context;
  var filter = (0, _nodeArray2.default)(map.filter);
  delete map.filter;

  var mapKeys = Object.keys(map);
  if (!mapKeys.length) {
    throw new TypeError('when/key requires at least one option key');
  }

  var registerBinding = function registerBinding(event) {
    event.keyCodes.forEach(function (code) {
      if (!bindings[code]) {
        bindings[code] = [];
      }

      bindings[code].push(event);
    });
  };

  mapKeys.forEach(function (text) {
    if (typeof map[text] !== 'function') {
      throw new TypeError('when/key requires option["' + text + '"] to be a function');
    }

    var addCallback = function addCallback(event) {
      event.callback = map[text];
      return event;
    };

    (0, _key2.default)(text).map(addCallback).forEach(registerBinding);
  });

  var handleKeyDown = function handleKeyDown(event) {
    if (event.defaultPrevented) {
      return;
    }

    if (filter.length) {
      // ignore elements within the exempted sub-trees
      var isParentOfElement = (0, _comparePosition.getParentComparator)({ element: event.target, includeSelf: true });
      if (filter.some(isParentOfElement)) {
        return;
      }
    }

    var key = event.keyCode || event.which;
    if (!bindings[key]) {
      return;
    }

    bindings[key].forEach(function (_event) {
      if (!_event.matchModifiers(event)) {
        return;
      }

      _event.callback.call(context, event, disengage);
    });
  };

  context.addEventListener('keydown', handleKeyDown, false);

  var disengage = function disengage() {
    context.removeEventListener('keydown', handleKeyDown, false);
  };

  return { disengage: disengage };
};

var _key = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/when/key.binding.js");

var _key2 = _interopRequireDefault(_key);

var _nodeArray = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/node-array.js");

var _nodeArray2 = _interopRequireDefault(_nodeArray);

var _comparePosition = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/util/compare-position.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/css.escape/css.escape.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*! https://mths.be/cssescape v1.5.1 by @mathias | MIT license */
;(function (root, factory) {
	// https://github.com/umdjs/umd/blob/master/returnExports.js
	if (( false ? 'undefined' : _typeof(exports)) == 'object') {
		// For Node.js.
		module.exports = factory(root);
	} else if (true) {
		// For AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory.bind(root, root)),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		// For browser globals (not exposing the function separately).
		factory(root);
	}
})(typeof global != 'undefined' ? global : undefined, function (root) {

	if (root.CSS && root.CSS.escape) {
		return root.CSS.escape;
	}

	// https://drafts.csswg.org/cssom/#serialize-an-identifier
	var cssEscape = function cssEscape(value) {
		if (arguments.length == 0) {
			throw new TypeError('`CSS.escape` requires an argument.');
		}
		var string = String(value);
		var length = string.length;
		var index = -1;
		var codeUnit;
		var result = '';
		var firstCodeUnit = string.charCodeAt(0);
		while (++index < length) {
			codeUnit = string.charCodeAt(index);
			// Note: there’s no need to special-case astral symbols, surrogate
			// pairs, or lone surrogates.

			// If the character is NULL (U+0000), then the REPLACEMENT CHARACTER
			// (U+FFFD).
			if (codeUnit == 0x0000) {
				result += '\uFFFD';
				continue;
			}

			if (
			// If the character is in the range [\1-\1F] (U+0001 to U+001F) or is
			// U+007F, […]
			codeUnit >= 0x0001 && codeUnit <= 0x001F || codeUnit == 0x007F ||
			// If the character is the first character and is in the range [0-9]
			// (U+0030 to U+0039), […]
			index == 0 && codeUnit >= 0x0030 && codeUnit <= 0x0039 ||
			// If the character is the second character and is in the range [0-9]
			// (U+0030 to U+0039) and the first character is a `-` (U+002D), […]
			index == 1 && codeUnit >= 0x0030 && codeUnit <= 0x0039 && firstCodeUnit == 0x002D) {
				// https://drafts.csswg.org/cssom/#escape-a-character-as-code-point
				result += '\\' + codeUnit.toString(16) + ' ';
				continue;
			}

			if (
			// If the character is the first character and is a `-` (U+002D), and
			// there is no second character, […]
			index == 0 && length == 1 && codeUnit == 0x002D) {
				result += '\\' + string.charAt(index);
				continue;
			}

			// If the character is not handled by one of the above rules and is
			// greater than or equal to U+0080, is `-` (U+002D) or `_` (U+005F), or
			// is in one of the ranges [0-9] (U+0030 to U+0039), [A-Z] (U+0041 to
			// U+005A), or [a-z] (U+0061 to U+007A), […]
			if (codeUnit >= 0x0080 || codeUnit == 0x002D || codeUnit == 0x005F || codeUnit >= 0x0030 && codeUnit <= 0x0039 || codeUnit >= 0x0041 && codeUnit <= 0x005A || codeUnit >= 0x0061 && codeUnit <= 0x007A) {
				// the character itself
				result += string.charAt(index);
				continue;
			}

			// Otherwise, the escaped character.
			// https://drafts.csswg.org/cssom/#escape-a-character
			result += '\\' + string.charAt(index);
		}
		return result;
	};

	if (!root.CSS) {
		root.CSS = {};
	}

	root.CSS.escape = cssEscape;
	return cssEscape;
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/debug.js");
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome && 'undefined' != typeof chrome.storage ? chrome.storage.local : localstorage();

/**
 * Colors.
 */

exports.colors = ['#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC', '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF', '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC', '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF', '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC', '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033', '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366', '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933', '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC', '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF', '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // Internet Explorer and Edge do not support colors.
  if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
    return false;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance ||
  // is firebug? http://stackoverflow.com/a/398120/376773
  typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) ||
  // is firefox >= v31?
  // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 ||
  // double check webkit in userAgent just in case we are in a worker
  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function (v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};

/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '') + this.namespace + (useColors ? ' %c' : ' ') + args[0] + (useColors ? '%c ' : ' ') + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit');

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function (match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === (typeof console === 'undefined' ? 'undefined' : _typeof(console)) && console.log && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch (e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch (e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = process.env.DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/process/browser.js")))

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/debug.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ms/index.js");

/**
 * Active `debug` instances.
 */
exports.instances = [];

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0,
      i;

  for (i in namespace) {
    hash = (hash << 5) - hash + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  var prevTime;

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function (match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);
  debug.destroy = destroy;

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  exports.instances.push(debug);

  return debug;
}

function destroy() {
  var index = exports.instances.indexOf(this);
  if (index !== -1) {
    exports.instances.splice(index, 1);
    return true;
  } else {
    return false;
  }
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var i;
  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }

  for (i = 0; i < exports.instances.length; i++) {
    var instance = exports.instances[i];
    instance.enabled = exports.enabled(instance.namespace);
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  if (name[name.length - 1] === '*') {
    return true;
  }
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/es6-promise/dist/es6-promise.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.4+314e4831
 */

(function (global, factory) {
  ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : global.ES6Promise = factory();
})(undefined, function () {
  'use strict';

  function objectOrFunction(x) {
    var type = typeof x === 'undefined' ? 'undefined' : _typeof(x);
    return x !== null && (type === 'object' || type === 'function');
  }

  function isFunction(x) {
    return typeof x === 'function';
  }

  var _isArray = void 0;
  if (Array.isArray) {
    _isArray = Array.isArray;
  } else {
    _isArray = function _isArray(x) {
      return Object.prototype.toString.call(x) === '[object Array]';
    };
  }

  var isArray = _isArray;

  var len = 0;
  var vertxNext = void 0;
  var customSchedulerFn = void 0;

  var asap = function asap(callback, arg) {
    queue[len] = callback;
    queue[len + 1] = arg;
    len += 2;
    if (len === 2) {
      // If len is 2, that means that we need to schedule an async flush.
      // If additional callbacks are queued before the queue is flushed, they
      // will be processed by this flush that we are scheduling.
      if (customSchedulerFn) {
        customSchedulerFn(flush);
      } else {
        scheduleFlush();
      }
    }
  };

  function setScheduler(scheduleFn) {
    customSchedulerFn = scheduleFn;
  }

  function setAsap(asapFn) {
    asap = asapFn;
  }

  var browserWindow = typeof window !== 'undefined' ? window : undefined;
  var browserGlobal = browserWindow || {};
  var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
  var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';

  // test for web worker but not in IE10
  var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

  // node
  function useNextTick() {
    // node version 0.10.x displays a deprecation warning when nextTick is used recursively
    // see https://github.com/cujojs/when/issues/410 for details
    return function () {
      return process.nextTick(flush);
    };
  }

  // vertx
  function useVertxTimer() {
    if (typeof vertxNext !== 'undefined') {
      return function () {
        vertxNext(flush);
      };
    }

    return useSetTimeout();
  }

  function useMutationObserver() {
    var iterations = 0;
    var observer = new BrowserMutationObserver(flush);
    var node = document.createTextNode('');
    observer.observe(node, { characterData: true });

    return function () {
      node.data = iterations = ++iterations % 2;
    };
  }

  // web worker
  function useMessageChannel() {
    var channel = new MessageChannel();
    channel.port1.onmessage = flush;
    return function () {
      return channel.port2.postMessage(0);
    };
  }

  function useSetTimeout() {
    // Store setTimeout reference so es6-promise will be unaffected by
    // other code modifying setTimeout (like sinon.useFakeTimers())
    var globalSetTimeout = setTimeout;
    return function () {
      return globalSetTimeout(flush, 1);
    };
  }

  var queue = new Array(1000);
  function flush() {
    for (var i = 0; i < len; i += 2) {
      var callback = queue[i];
      var arg = queue[i + 1];

      callback(arg);

      queue[i] = undefined;
      queue[i + 1] = undefined;
    }

    len = 0;
  }

  function attemptVertx() {
    try {
      var vertx = Function('return this')().require('vertx');
      vertxNext = vertx.runOnLoop || vertx.runOnContext;
      return useVertxTimer();
    } catch (e) {
      return useSetTimeout();
    }
  }

  var scheduleFlush = void 0;
  // Decide what async method to use to triggering processing of queued callbacks:
  if (isNode) {
    scheduleFlush = useNextTick();
  } else if (BrowserMutationObserver) {
    scheduleFlush = useMutationObserver();
  } else if (isWorker) {
    scheduleFlush = useMessageChannel();
  } else if (browserWindow === undefined && "function" === 'function') {
    scheduleFlush = attemptVertx();
  } else {
    scheduleFlush = useSetTimeout();
  }

  function then(onFulfillment, onRejection) {
    var parent = this;

    var child = new this.constructor(noop);

    if (child[PROMISE_ID] === undefined) {
      makePromise(child);
    }

    var _state = parent._state;

    if (_state) {
      var callback = arguments[_state - 1];
      asap(function () {
        return invokeCallback(_state, child, callback, parent._result);
      });
    } else {
      subscribe(parent, child, onFulfillment, onRejection);
    }

    return child;
  }

  /**
    `Promise.resolve` returns a promise that will become resolved with the
    passed `value`. It is shorthand for the following:
  
    ```javascript
    let promise = new Promise(function(resolve, reject){
      resolve(1);
    });
  
    promise.then(function(value){
      // value === 1
    });
    ```
  
    Instead of writing the above, your code now simply becomes the following:
  
    ```javascript
    let promise = Promise.resolve(1);
  
    promise.then(function(value){
      // value === 1
    });
    ```
  
    @method resolve
    @static
    @param {Any} value value that the returned promise will be resolved with
    Useful for tooling.
    @return {Promise} a promise that will become fulfilled with the given
    `value`
  */
  function resolve$1(object) {
    /*jshint validthis:true */
    var Constructor = this;

    if (object && (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && object.constructor === Constructor) {
      return object;
    }

    var promise = new Constructor(noop);
    resolve(promise, object);
    return promise;
  }

  var PROMISE_ID = Math.random().toString(36).substring(2);

  function noop() {}

  var PENDING = void 0;
  var FULFILLED = 1;
  var REJECTED = 2;

  var TRY_CATCH_ERROR = { error: null };

  function selfFulfillment() {
    return new TypeError("You cannot resolve a promise with itself");
  }

  function cannotReturnOwn() {
    return new TypeError('A promises callback cannot return that same promise.');
  }

  function getThen(promise) {
    try {
      return promise.then;
    } catch (error) {
      TRY_CATCH_ERROR.error = error;
      return TRY_CATCH_ERROR;
    }
  }

  function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
    try {
      then$$1.call(value, fulfillmentHandler, rejectionHandler);
    } catch (e) {
      return e;
    }
  }

  function handleForeignThenable(promise, thenable, then$$1) {
    asap(function (promise) {
      var sealed = false;
      var error = tryThen(then$$1, thenable, function (value) {
        if (sealed) {
          return;
        }
        sealed = true;
        if (thenable !== value) {
          resolve(promise, value);
        } else {
          fulfill(promise, value);
        }
      }, function (reason) {
        if (sealed) {
          return;
        }
        sealed = true;

        reject(promise, reason);
      }, 'Settle: ' + (promise._label || ' unknown promise'));

      if (!sealed && error) {
        sealed = true;
        reject(promise, error);
      }
    }, promise);
  }

  function handleOwnThenable(promise, thenable) {
    if (thenable._state === FULFILLED) {
      fulfill(promise, thenable._result);
    } else if (thenable._state === REJECTED) {
      reject(promise, thenable._result);
    } else {
      subscribe(thenable, undefined, function (value) {
        return resolve(promise, value);
      }, function (reason) {
        return reject(promise, reason);
      });
    }
  }

  function handleMaybeThenable(promise, maybeThenable, then$$1) {
    if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
      handleOwnThenable(promise, maybeThenable);
    } else {
      if (then$$1 === TRY_CATCH_ERROR) {
        reject(promise, TRY_CATCH_ERROR.error);
        TRY_CATCH_ERROR.error = null;
      } else if (then$$1 === undefined) {
        fulfill(promise, maybeThenable);
      } else if (isFunction(then$$1)) {
        handleForeignThenable(promise, maybeThenable, then$$1);
      } else {
        fulfill(promise, maybeThenable);
      }
    }
  }

  function resolve(promise, value) {
    if (promise === value) {
      reject(promise, selfFulfillment());
    } else if (objectOrFunction(value)) {
      handleMaybeThenable(promise, value, getThen(value));
    } else {
      fulfill(promise, value);
    }
  }

  function publishRejection(promise) {
    if (promise._onerror) {
      promise._onerror(promise._result);
    }

    publish(promise);
  }

  function fulfill(promise, value) {
    if (promise._state !== PENDING) {
      return;
    }

    promise._result = value;
    promise._state = FULFILLED;

    if (promise._subscribers.length !== 0) {
      asap(publish, promise);
    }
  }

  function reject(promise, reason) {
    if (promise._state !== PENDING) {
      return;
    }
    promise._state = REJECTED;
    promise._result = reason;

    asap(publishRejection, promise);
  }

  function subscribe(parent, child, onFulfillment, onRejection) {
    var _subscribers = parent._subscribers;
    var length = _subscribers.length;

    parent._onerror = null;

    _subscribers[length] = child;
    _subscribers[length + FULFILLED] = onFulfillment;
    _subscribers[length + REJECTED] = onRejection;

    if (length === 0 && parent._state) {
      asap(publish, parent);
    }
  }

  function publish(promise) {
    var subscribers = promise._subscribers;
    var settled = promise._state;

    if (subscribers.length === 0) {
      return;
    }

    var child = void 0,
        callback = void 0,
        detail = promise._result;

    for (var i = 0; i < subscribers.length; i += 3) {
      child = subscribers[i];
      callback = subscribers[i + settled];

      if (child) {
        invokeCallback(settled, child, callback, detail);
      } else {
        callback(detail);
      }
    }

    promise._subscribers.length = 0;
  }

  function tryCatch(callback, detail) {
    try {
      return callback(detail);
    } catch (e) {
      TRY_CATCH_ERROR.error = e;
      return TRY_CATCH_ERROR;
    }
  }

  function invokeCallback(settled, promise, callback, detail) {
    var hasCallback = isFunction(callback),
        value = void 0,
        error = void 0,
        succeeded = void 0,
        failed = void 0;

    if (hasCallback) {
      value = tryCatch(callback, detail);

      if (value === TRY_CATCH_ERROR) {
        failed = true;
        error = value.error;
        value.error = null;
      } else {
        succeeded = true;
      }

      if (promise === value) {
        reject(promise, cannotReturnOwn());
        return;
      }
    } else {
      value = detail;
      succeeded = true;
    }

    if (promise._state !== PENDING) {
      // noop
    } else if (hasCallback && succeeded) {
      resolve(promise, value);
    } else if (failed) {
      reject(promise, error);
    } else if (settled === FULFILLED) {
      fulfill(promise, value);
    } else if (settled === REJECTED) {
      reject(promise, value);
    }
  }

  function initializePromise(promise, resolver) {
    try {
      resolver(function resolvePromise(value) {
        resolve(promise, value);
      }, function rejectPromise(reason) {
        reject(promise, reason);
      });
    } catch (e) {
      reject(promise, e);
    }
  }

  var id = 0;
  function nextId() {
    return id++;
  }

  function makePromise(promise) {
    promise[PROMISE_ID] = id++;
    promise._state = undefined;
    promise._result = undefined;
    promise._subscribers = [];
  }

  function validationError() {
    return new Error('Array Methods must be provided an Array');
  }

  var Enumerator = function () {
    function Enumerator(Constructor, input) {
      this._instanceConstructor = Constructor;
      this.promise = new Constructor(noop);

      if (!this.promise[PROMISE_ID]) {
        makePromise(this.promise);
      }

      if (isArray(input)) {
        this.length = input.length;
        this._remaining = input.length;

        this._result = new Array(this.length);

        if (this.length === 0) {
          fulfill(this.promise, this._result);
        } else {
          this.length = this.length || 0;
          this._enumerate(input);
          if (this._remaining === 0) {
            fulfill(this.promise, this._result);
          }
        }
      } else {
        reject(this.promise, validationError());
      }
    }

    Enumerator.prototype._enumerate = function _enumerate(input) {
      for (var i = 0; this._state === PENDING && i < input.length; i++) {
        this._eachEntry(input[i], i);
      }
    };

    Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
      var c = this._instanceConstructor;
      var resolve$$1 = c.resolve;

      if (resolve$$1 === resolve$1) {
        var _then = getThen(entry);

        if (_then === then && entry._state !== PENDING) {
          this._settledAt(entry._state, i, entry._result);
        } else if (typeof _then !== 'function') {
          this._remaining--;
          this._result[i] = entry;
        } else if (c === Promise$1) {
          var promise = new c(noop);
          handleMaybeThenable(promise, entry, _then);
          this._willSettleAt(promise, i);
        } else {
          this._willSettleAt(new c(function (resolve$$1) {
            return resolve$$1(entry);
          }), i);
        }
      } else {
        this._willSettleAt(resolve$$1(entry), i);
      }
    };

    Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
      var promise = this.promise;

      if (promise._state === PENDING) {
        this._remaining--;

        if (state === REJECTED) {
          reject(promise, value);
        } else {
          this._result[i] = value;
        }
      }

      if (this._remaining === 0) {
        fulfill(promise, this._result);
      }
    };

    Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
      var enumerator = this;

      subscribe(promise, undefined, function (value) {
        return enumerator._settledAt(FULFILLED, i, value);
      }, function (reason) {
        return enumerator._settledAt(REJECTED, i, reason);
      });
    };

    return Enumerator;
  }();

  /**
    `Promise.all` accepts an array of promises, and returns a new promise which
    is fulfilled with an array of fulfillment values for the passed promises, or
    rejected with the reason of the first passed promise to be rejected. It casts all
    elements of the passed iterable to promises as it runs this algorithm.
  
    Example:
  
    ```javascript
    let promise1 = resolve(1);
    let promise2 = resolve(2);
    let promise3 = resolve(3);
    let promises = [ promise1, promise2, promise3 ];
  
    Promise.all(promises).then(function(array){
      // The array here would be [ 1, 2, 3 ];
    });
    ```
  
    If any of the `promises` given to `all` are rejected, the first promise
    that is rejected will be given as an argument to the returned promises's
    rejection handler. For example:
  
    Example:
  
    ```javascript
    let promise1 = resolve(1);
    let promise2 = reject(new Error("2"));
    let promise3 = reject(new Error("3"));
    let promises = [ promise1, promise2, promise3 ];
  
    Promise.all(promises).then(function(array){
      // Code here never runs because there are rejected promises!
    }, function(error) {
      // error.message === "2"
    });
    ```
  
    @method all
    @static
    @param {Array} entries array of promises
    @param {String} label optional string for labeling the promise.
    Useful for tooling.
    @return {Promise} promise that is fulfilled when all `promises` have been
    fulfilled, or rejected if any of them become rejected.
    @static
  */
  function all(entries) {
    return new Enumerator(this, entries).promise;
  }

  /**
    `Promise.race` returns a new promise which is settled in the same way as the
    first passed promise to settle.
  
    Example:
  
    ```javascript
    let promise1 = new Promise(function(resolve, reject){
      setTimeout(function(){
        resolve('promise 1');
      }, 200);
    });
  
    let promise2 = new Promise(function(resolve, reject){
      setTimeout(function(){
        resolve('promise 2');
      }, 100);
    });
  
    Promise.race([promise1, promise2]).then(function(result){
      // result === 'promise 2' because it was resolved before promise1
      // was resolved.
    });
    ```
  
    `Promise.race` is deterministic in that only the state of the first
    settled promise matters. For example, even if other promises given to the
    `promises` array argument are resolved, but the first settled promise has
    become rejected before the other promises became fulfilled, the returned
    promise will become rejected:
  
    ```javascript
    let promise1 = new Promise(function(resolve, reject){
      setTimeout(function(){
        resolve('promise 1');
      }, 200);
    });
  
    let promise2 = new Promise(function(resolve, reject){
      setTimeout(function(){
        reject(new Error('promise 2'));
      }, 100);
    });
  
    Promise.race([promise1, promise2]).then(function(result){
      // Code here never runs
    }, function(reason){
      // reason.message === 'promise 2' because promise 2 became rejected before
      // promise 1 became fulfilled
    });
    ```
  
    An example real-world use case is implementing timeouts:
  
    ```javascript
    Promise.race([ajax('foo.json'), timeout(5000)])
    ```
  
    @method race
    @static
    @param {Array} promises array of promises to observe
    Useful for tooling.
    @return {Promise} a promise which settles in the same way as the first passed
    promise to settle.
  */
  function race(entries) {
    /*jshint validthis:true */
    var Constructor = this;

    if (!isArray(entries)) {
      return new Constructor(function (_, reject) {
        return reject(new TypeError('You must pass an array to race.'));
      });
    } else {
      return new Constructor(function (resolve, reject) {
        var length = entries.length;
        for (var i = 0; i < length; i++) {
          Constructor.resolve(entries[i]).then(resolve, reject);
        }
      });
    }
  }

  /**
    `Promise.reject` returns a promise rejected with the passed `reason`.
    It is shorthand for the following:
  
    ```javascript
    let promise = new Promise(function(resolve, reject){
      reject(new Error('WHOOPS'));
    });
  
    promise.then(function(value){
      // Code here doesn't run because the promise is rejected!
    }, function(reason){
      // reason.message === 'WHOOPS'
    });
    ```
  
    Instead of writing the above, your code now simply becomes the following:
  
    ```javascript
    let promise = Promise.reject(new Error('WHOOPS'));
  
    promise.then(function(value){
      // Code here doesn't run because the promise is rejected!
    }, function(reason){
      // reason.message === 'WHOOPS'
    });
    ```
  
    @method reject
    @static
    @param {Any} reason value that the returned promise will be rejected with.
    Useful for tooling.
    @return {Promise} a promise rejected with the given `reason`.
  */
  function reject$1(reason) {
    /*jshint validthis:true */
    var Constructor = this;
    var promise = new Constructor(noop);
    reject(promise, reason);
    return promise;
  }

  function needsResolver() {
    throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
  }

  function needsNew() {
    throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
  }

  /**
    Promise objects represent the eventual result of an asynchronous operation. The
    primary way of interacting with a promise is through its `then` method, which
    registers callbacks to receive either a promise's eventual value or the reason
    why the promise cannot be fulfilled.
  
    Terminology
    -----------
  
    - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
    - `thenable` is an object or function that defines a `then` method.
    - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
    - `exception` is a value that is thrown using the throw statement.
    - `reason` is a value that indicates why a promise was rejected.
    - `settled` the final resting state of a promise, fulfilled or rejected.
  
    A promise can be in one of three states: pending, fulfilled, or rejected.
  
    Promises that are fulfilled have a fulfillment value and are in the fulfilled
    state.  Promises that are rejected have a rejection reason and are in the
    rejected state.  A fulfillment value is never a thenable.
  
    Promises can also be said to *resolve* a value.  If this value is also a
    promise, then the original promise's settled state will match the value's
    settled state.  So a promise that *resolves* a promise that rejects will
    itself reject, and a promise that *resolves* a promise that fulfills will
    itself fulfill.
  
  
    Basic Usage:
    ------------
  
    ```js
    let promise = new Promise(function(resolve, reject) {
      // on success
      resolve(value);
  
      // on failure
      reject(reason);
    });
  
    promise.then(function(value) {
      // on fulfillment
    }, function(reason) {
      // on rejection
    });
    ```
  
    Advanced Usage:
    ---------------
  
    Promises shine when abstracting away asynchronous interactions such as
    `XMLHttpRequest`s.
  
    ```js
    function getJSON(url) {
      return new Promise(function(resolve, reject){
        let xhr = new XMLHttpRequest();
  
        xhr.open('GET', url);
        xhr.onreadystatechange = handler;
        xhr.responseType = 'json';
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.send();
  
        function handler() {
          if (this.readyState === this.DONE) {
            if (this.status === 200) {
              resolve(this.response);
            } else {
              reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
            }
          }
        };
      });
    }
  
    getJSON('/posts.json').then(function(json) {
      // on fulfillment
    }, function(reason) {
      // on rejection
    });
    ```
  
    Unlike callbacks, promises are great composable primitives.
  
    ```js
    Promise.all([
      getJSON('/posts'),
      getJSON('/comments')
    ]).then(function(values){
      values[0] // => postsJSON
      values[1] // => commentsJSON
  
      return values;
    });
    ```
  
    @class Promise
    @param {Function} resolver
    Useful for tooling.
    @constructor
  */

  var Promise$1 = function () {
    function Promise(resolver) {
      this[PROMISE_ID] = nextId();
      this._result = this._state = undefined;
      this._subscribers = [];

      if (noop !== resolver) {
        typeof resolver !== 'function' && needsResolver();
        this instanceof Promise ? initializePromise(this, resolver) : needsNew();
      }
    }

    /**
    The primary way of interacting with a promise is through its `then` method,
    which registers callbacks to receive either a promise's eventual value or the
    reason why the promise cannot be fulfilled.
     ```js
    findUser().then(function(user){
      // user is available
    }, function(reason){
      // user is unavailable, and you are given the reason why
    });
    ```
     Chaining
    --------
     The return value of `then` is itself a promise.  This second, 'downstream'
    promise is resolved with the return value of the first promise's fulfillment
    or rejection handler, or rejected if the handler throws an exception.
     ```js
    findUser().then(function (user) {
      return user.name;
    }, function (reason) {
      return 'default name';
    }).then(function (userName) {
      // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
      // will be `'default name'`
    });
     findUser().then(function (user) {
      throw new Error('Found user, but still unhappy');
    }, function (reason) {
      throw new Error('`findUser` rejected and we're unhappy');
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
      // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
    });
    ```
    If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
     ```js
    findUser().then(function (user) {
      throw new PedagogicalException('Upstream error');
    }).then(function (value) {
      // never reached
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // The `PedgagocialException` is propagated all the way down to here
    });
    ```
     Assimilation
    ------------
     Sometimes the value you want to propagate to a downstream promise can only be
    retrieved asynchronously. This can be achieved by returning a promise in the
    fulfillment or rejection handler. The downstream promise will then be pending
    until the returned promise is settled. This is called *assimilation*.
     ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // The user's comments are now available
    });
    ```
     If the assimliated promise rejects, then the downstream promise will also reject.
     ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // If `findCommentsByAuthor` fulfills, we'll have the value here
    }, function (reason) {
      // If `findCommentsByAuthor` rejects, we'll have the reason here
    });
    ```
     Simple Example
    --------------
     Synchronous Example
     ```javascript
    let result;
     try {
      result = findResult();
      // success
    } catch(reason) {
      // failure
    }
    ```
     Errback Example
     ```js
    findResult(function(result, err){
      if (err) {
        // failure
      } else {
        // success
      }
    });
    ```
     Promise Example;
     ```javascript
    findResult().then(function(result){
      // success
    }, function(reason){
      // failure
    });
    ```
     Advanced Example
    --------------
     Synchronous Example
     ```javascript
    let author, books;
     try {
      author = findAuthor();
      books  = findBooksByAuthor(author);
      // success
    } catch(reason) {
      // failure
    }
    ```
     Errback Example
     ```js
     function foundBooks(books) {
     }
     function failure(reason) {
     }
     findAuthor(function(author, err){
      if (err) {
        failure(err);
        // failure
      } else {
        try {
          findBoooksByAuthor(author, function(books, err) {
            if (err) {
              failure(err);
            } else {
              try {
                foundBooks(books);
              } catch(reason) {
                failure(reason);
              }
            }
          });
        } catch(error) {
          failure(err);
        }
        // success
      }
    });
    ```
     Promise Example;
     ```javascript
    findAuthor().
      then(findBooksByAuthor).
      then(function(books){
        // found books
    }).catch(function(reason){
      // something went wrong
    });
    ```
     @method then
    @param {Function} onFulfilled
    @param {Function} onRejected
    Useful for tooling.
    @return {Promise}
    */

    /**
    `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
    as the catch block of a try/catch statement.
    ```js
    function findAuthor(){
    throw new Error('couldn't find that author');
    }
    // synchronous
    try {
    findAuthor();
    } catch(reason) {
    // something went wrong
    }
    // async with promises
    findAuthor().catch(function(reason){
    // something went wrong
    });
    ```
    @method catch
    @param {Function} onRejection
    Useful for tooling.
    @return {Promise}
    */

    Promise.prototype.catch = function _catch(onRejection) {
      return this.then(null, onRejection);
    };

    /**
      `finally` will be invoked regardless of the promise's fate just as native
      try/catch/finally behaves
    
      Synchronous example:
    
      ```js
      findAuthor() {
        if (Math.random() > 0.5) {
          throw new Error();
        }
        return new Author();
      }
    
      try {
        return findAuthor(); // succeed or fail
      } catch(error) {
        return findOtherAuther();
      } finally {
        // always runs
        // doesn't affect the return value
      }
      ```
    
      Asynchronous example:
    
      ```js
      findAuthor().catch(function(reason){
        return findOtherAuther();
      }).finally(function(){
        // author was either found, or not
      });
      ```
    
      @method finally
      @param {Function} callback
      @return {Promise}
    */

    Promise.prototype.finally = function _finally(callback) {
      var promise = this;
      var constructor = promise.constructor;

      return promise.then(function (value) {
        return constructor.resolve(callback()).then(function () {
          return value;
        });
      }, function (reason) {
        return constructor.resolve(callback()).then(function () {
          throw reason;
        });
      });
    };

    return Promise;
  }();

  Promise$1.prototype.then = then;
  Promise$1.all = all;
  Promise$1.race = race;
  Promise$1.resolve = resolve$1;
  Promise$1.reject = reject$1;
  Promise$1._setScheduler = setScheduler;
  Promise$1._setAsap = setAsap;
  Promise$1._asap = asap;

  /*global self*/
  function polyfill() {
    var local = void 0;

    if (typeof global !== 'undefined') {
      local = global;
    } else if (typeof self !== 'undefined') {
      local = self;
    } else {
      try {
        local = Function('return this')();
      } catch (e) {
        throw new Error('polyfill failed because global object is unavailable in this environment');
      }
    }

    var P = local.Promise;

    if (P) {
      var promiseToString = null;
      try {
        promiseToString = Object.prototype.toString.call(P.resolve());
      } catch (e) {
        // silently ignored
      }

      if (promiseToString === '[object Promise]' && !P.cast) {
        return;
      }
    }

    local.Promise = Promise$1;
  }

  // Strange compat..
  Promise$1.polyfill = polyfill;
  Promise$1.Promise = Promise$1;

  return Promise$1;
});

//# sourceMappingURL=es6-promise.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/process/browser.js"), __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_Symbol.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var root = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_root.js");

/** Built-in value references. */
var _Symbol = root.Symbol;

module.exports = _Symbol;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_apply.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_arrayLikeKeys.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseTimes = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_baseTimes.js"),
    isArguments = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isArguments.js"),
    isArray = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isArray.js"),
    isBuffer = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isBuffer.js"),
    isIndex = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_isIndex.js"),
    isTypedArray = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isTypedArray.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (
    // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' ||
    // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') ||
    // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
    // Skip index properties.
    isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_arrayMap.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_baseGetTag.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Symbol = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_Symbol.js"),
    getRawTag = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_getRawTag.js"),
    objectToString = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_objectToString.js");

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
    if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
    }
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}

module.exports = baseGetTag;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_baseIsArguments.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseGetTag = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_baseGetTag.js"),
    isObjectLike = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isObjectLike.js");

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_baseIsNative.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isFunction = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isFunction.js"),
    isMasked = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_isMasked.js"),
    isObject = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isObject.js"),
    toSource = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_toSource.js");

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_baseIsTypedArray.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseGetTag = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_baseGetTag.js"),
    isLength = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isLength.js"),
    isObjectLike = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isObjectLike.js");

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_baseKeysIn.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isObject = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isObject.js"),
    isPrototype = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_isPrototype.js"),
    nativeKeysIn = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_nativeKeysIn.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_baseRest.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var identity = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/identity.js"),
    overRest = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_overRest.js"),
    setToString = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_setToString.js");

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_baseSetToString.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var constant = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/constant.js"),
    defineProperty = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_defineProperty.js"),
    identity = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/identity.js");

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function (func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_baseTimes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_baseToString.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Symbol = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_Symbol.js"),
    arrayMap = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_arrayMap.js"),
    isArray = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isArray.js"),
    isSymbol = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isSymbol.js");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

module.exports = baseToString;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_baseUnary.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}

module.exports = baseUnary;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_coreJsData.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var root = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_root.js");

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_defineProperty.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getNative = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_getNative.js");

var defineProperty = function () {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}();

module.exports = defineProperty;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_freeGlobal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/** Detect free variable `global` from Node.js. */
var freeGlobal = (typeof global === 'undefined' ? 'undefined' : _typeof(global)) == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_getNative.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseIsNative = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_baseIsNative.js"),
    getValue = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_getValue.js");

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_getRawTag.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Symbol = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_Symbol.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_getValue.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_isIndex.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

module.exports = isIndex;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_isIterateeCall.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var eq = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/eq.js"),
    isArrayLike = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isArrayLike.js"),
    isIndex = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_isIndex.js"),
    isObject = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isObject.js");

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index === 'undefined' ? 'undefined' : _typeof(index);
  if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_isMasked.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var coreJsData = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_coreJsData.js");

/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

module.exports = isMasked;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_isPrototype.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;

  return value === proto;
}

module.exports = isPrototype;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_nativeKeysIn.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_nodeUtil.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var freeGlobal = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_freeGlobal.js");

/** Detect free variable `exports`. */
var freeExports = ( false ? 'undefined' : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && ( false ? 'undefined' : _typeof(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = function () {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}();

module.exports = nodeUtil;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_objectToString.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_overRest.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var apply = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_apply.js");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? func.length - 1 : start, 0);
  return function () {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_root.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var freeGlobal = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_freeGlobal.js");

/** Detect free variable `self`. */
var freeSelf = (typeof self === 'undefined' ? 'undefined' : _typeof(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_setToString.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseSetToString = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_baseSetToString.js"),
    shortOut = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_shortOut.js");

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_shortOut.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function () {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_toSource.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/constant.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function () {
    return value;
  };
}

module.exports = constant;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/defaults.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseRest = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_baseRest.js"),
    eq = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/eq.js"),
    isIterateeCall = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_isIterateeCall.js"),
    keysIn = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/keysIn.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var defaults = baseRest(function (object, sources) {
  object = Object(object);

  var index = -1;
  var length = sources.length;
  var guard = length > 2 ? sources[2] : undefined;

  if (guard && isIterateeCall(sources[0], sources[1], guard)) {
    length = 1;
  }

  while (++index < length) {
    var source = sources[index];
    var props = keysIn(source);
    var propsIndex = -1;
    var propsLength = props.length;

    while (++propsIndex < propsLength) {
      var key = props[propsIndex];
      var value = object[key];

      if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) {
        object[key] = source[key];
      }
    }
  }

  return object;
});

module.exports = defaults;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/eq.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

module.exports = eq;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/identity.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isArguments.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseIsArguments = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_baseIsArguments.js"),
    isObjectLike = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isObjectLike.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function () {
    return arguments;
}()) ? baseIsArguments : function (value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isArray.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isArrayLike.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isFunction = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isFunction.js"),
    isLength = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isLength.js");

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isBuffer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var root = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_root.js"),
    stubFalse = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/stubFalse.js");

/** Detect free variable `exports`. */
var freeExports = ( false ? 'undefined' : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && ( false ? 'undefined' : _typeof(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isFunction.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseGetTag = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_baseGetTag.js"),
    isObject = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isObject.js");

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
    if (!isObject(value)) {
        return false;
    }
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isLength.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isObject.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isObjectLike.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object';
}

module.exports = isObjectLike;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isSymbol.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var baseGetTag = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_baseGetTag.js"),
    isObjectLike = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isObjectLike.js");

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
    return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
}

module.exports = isSymbol;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isTypedArray.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseIsTypedArray = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_baseIsTypedArray.js"),
    baseUnary = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_baseUnary.js"),
    nodeUtil = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_nodeUtil.js");

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/keysIn.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var arrayLikeKeys = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_arrayLikeKeys.js"),
    baseKeysIn = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_baseKeysIn.js"),
    isArrayLike = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isArrayLike.js");

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/stubFalse.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/toString.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseToString = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_baseToString.js");

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/uniqueId.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toString = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/toString.js");

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}

module.exports = uniqueId;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ms/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function (val, options) {
  options = options || {};
  var type = typeof val === 'undefined' ? 'undefined' : _typeof(val);
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') || plural(ms, h, 'hour') || plural(ms, m, 'minute') || plural(ms, s, 'second') || ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/platform/platform.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * Platform.js <https://mths.be/platform>
 * Copyright 2014-2016 Benjamin Tan <https://demoneaux.github.io/>
 * Copyright 2011-2013 John-David Dalton <http://allyoucanleet.com/>
 * Available under MIT license <https://mths.be/mit>
 */
;(function () {
  'use strict';

  /** Used to determine if values are of the language type `Object`. */

  var objectTypes = {
    'function': true,
    'object': true
  };

  /** Used as a reference to the global object. */
  var root = objectTypes[typeof window === 'undefined' ? 'undefined' : _typeof(window)] && window || this;

  /** Backup possible global object. */
  var oldRoot = root;

  /** Detect free variable `exports`. */
  var freeExports = objectTypes[ false ? 'undefined' : _typeof(exports)] && exports;

  /** Detect free variable `module`. */
  var freeModule = objectTypes[ false ? 'undefined' : _typeof(module)] && module && !module.nodeType && module;

  /** Detect free variable `global` from Node.js or Browserified code and use it as `root`. */
  var freeGlobal = freeExports && freeModule && (typeof global === 'undefined' ? 'undefined' : _typeof(global)) == 'object' && global;
  if (freeGlobal && (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal)) {
    root = freeGlobal;
  }

  /**
   * Used as the maximum length of an array-like object.
   * See the [ES6 spec](http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength)
   * for more details.
   */
  var maxSafeInteger = Math.pow(2, 53) - 1;

  /** Regular expression to detect Opera. */
  var reOpera = /\bOpera/;

  /** Possible global object. */
  var thisBinding = this;

  /** Used for native method references. */
  var objectProto = Object.prototype;

  /** Used to check for own properties of an object. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /** Used to resolve the internal `[[Class]]` of values. */
  var toString = objectProto.toString;

  /*--------------------------------------------------------------------------*/

  /**
   * Capitalizes a string value.
   *
   * @private
   * @param {string} string The string to capitalize.
   * @returns {string} The capitalized string.
   */
  function capitalize(string) {
    string = String(string);
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  /**
   * A utility function to clean up the OS name.
   *
   * @private
   * @param {string} os The OS name to clean up.
   * @param {string} [pattern] A `RegExp` pattern matching the OS name.
   * @param {string} [label] A label for the OS.
   */
  function cleanupOS(os, pattern, label) {
    // Platform tokens are defined at:
    // http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
    // http://web.archive.org/web/20081122053950/http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
    var data = {
      '10.0': '10',
      '6.4': '10 Technical Preview',
      '6.3': '8.1',
      '6.2': '8',
      '6.1': 'Server 2008 R2 / 7',
      '6.0': 'Server 2008 / Vista',
      '5.2': 'Server 2003 / XP 64-bit',
      '5.1': 'XP',
      '5.01': '2000 SP1',
      '5.0': '2000',
      '4.0': 'NT',
      '4.90': 'ME'
    };
    // Detect Windows version from platform tokens.
    if (pattern && label && /^Win/i.test(os) && !/^Windows Phone /i.test(os) && (data = data[/[\d.]+$/.exec(os)])) {
      os = 'Windows ' + data;
    }
    // Correct character case and cleanup string.
    os = String(os);

    if (pattern && label) {
      os = os.replace(RegExp(pattern, 'i'), label);
    }

    os = format(os.replace(/ ce$/i, ' CE').replace(/\bhpw/i, 'web').replace(/\bMacintosh\b/, 'Mac OS').replace(/_PowerPC\b/i, ' OS').replace(/\b(OS X) [^ \d]+/i, '$1').replace(/\bMac (OS X)\b/, '$1').replace(/\/(\d)/, ' $1').replace(/_/g, '.').replace(/(?: BePC|[ .]*fc[ \d.]+)$/i, '').replace(/\bx86\.64\b/gi, 'x86_64').replace(/\b(Windows Phone) OS\b/, '$1').replace(/\b(Chrome OS \w+) [\d.]+\b/, '$1').split(' on ')[0]);

    return os;
  }

  /**
   * An iteration utility for arrays and objects.
   *
   * @private
   * @param {Array|Object} object The object to iterate over.
   * @param {Function} callback The function called per iteration.
   */
  function each(object, callback) {
    var index = -1,
        length = object ? object.length : 0;

    if (typeof length == 'number' && length > -1 && length <= maxSafeInteger) {
      while (++index < length) {
        callback(object[index], index, object);
      }
    } else {
      forOwn(object, callback);
    }
  }

  /**
   * Trim and conditionally capitalize string values.
   *
   * @private
   * @param {string} string The string to format.
   * @returns {string} The formatted string.
   */
  function format(string) {
    string = trim(string);
    return (/^(?:webOS|i(?:OS|P))/.test(string) ? string : capitalize(string)
    );
  }

  /**
   * Iterates over an object's own properties, executing the `callback` for each.
   *
   * @private
   * @param {Object} object The object to iterate over.
   * @param {Function} callback The function executed per own property.
   */
  function forOwn(object, callback) {
    for (var key in object) {
      if (hasOwnProperty.call(object, key)) {
        callback(object[key], key, object);
      }
    }
  }

  /**
   * Gets the internal `[[Class]]` of a value.
   *
   * @private
   * @param {*} value The value.
   * @returns {string} The `[[Class]]`.
   */
  function getClassOf(value) {
    return value == null ? capitalize(value) : toString.call(value).slice(8, -1);
  }

  /**
   * Host objects can return type values that are different from their actual
   * data type. The objects we are concerned with usually return non-primitive
   * types of "object", "function", or "unknown".
   *
   * @private
   * @param {*} object The owner of the property.
   * @param {string} property The property to check.
   * @returns {boolean} Returns `true` if the property value is a non-primitive, else `false`.
   */
  function isHostType(object, property) {
    var type = object != null ? _typeof(object[property]) : 'number';
    return !/^(?:boolean|number|string|undefined)$/.test(type) && (type == 'object' ? !!object[property] : true);
  }

  /**
   * Prepares a string for use in a `RegExp` by making hyphens and spaces optional.
   *
   * @private
   * @param {string} string The string to qualify.
   * @returns {string} The qualified string.
   */
  function qualify(string) {
    return String(string).replace(/([ -])(?!$)/g, '$1?');
  }

  /**
   * A bare-bones `Array#reduce` like utility function.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} callback The function called per iteration.
   * @returns {*} The accumulated result.
   */
  function reduce(array, callback) {
    var accumulator = null;
    each(array, function (value, index) {
      accumulator = callback(accumulator, value, index, array);
    });
    return accumulator;
  }

  /**
   * Removes leading and trailing whitespace from a string.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} The trimmed string.
   */
  function trim(string) {
    return String(string).replace(/^ +| +$/g, '');
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Creates a new platform object.
   *
   * @memberOf platform
   * @param {Object|string} [ua=navigator.userAgent] The user agent string or
   *  context object.
   * @returns {Object} A platform object.
   */
  function parse(ua) {

    /** The environment context object. */
    var context = root;

    /** Used to flag when a custom context is provided. */
    var isCustomContext = ua && (typeof ua === 'undefined' ? 'undefined' : _typeof(ua)) == 'object' && getClassOf(ua) != 'String';

    // Juggle arguments.
    if (isCustomContext) {
      context = ua;
      ua = null;
    }

    /** Browser navigator object. */
    var nav = context.navigator || {};

    /** Browser user agent string. */
    var userAgent = nav.userAgent || '';

    ua || (ua = userAgent);

    /** Used to flag when `thisBinding` is the [ModuleScope]. */
    var isModuleScope = isCustomContext || thisBinding == oldRoot;

    /** Used to detect if browser is like Chrome. */
    var likeChrome = isCustomContext ? !!nav.likeChrome : /\bChrome\b/.test(ua) && !/internal|\n/i.test(toString.toString());

    /** Internal `[[Class]]` value shortcuts. */
    var objectClass = 'Object',
        airRuntimeClass = isCustomContext ? objectClass : 'ScriptBridgingProxyObject',
        enviroClass = isCustomContext ? objectClass : 'Environment',
        javaClass = isCustomContext && context.java ? 'JavaPackage' : getClassOf(context.java),
        phantomClass = isCustomContext ? objectClass : 'RuntimeObject';

    /** Detect Java environments. */
    var java = /\bJava/.test(javaClass) && context.java;

    /** Detect Rhino. */
    var rhino = java && getClassOf(context.environment) == enviroClass;

    /** A character to represent alpha. */
    var alpha = java ? 'a' : '\u03B1';

    /** A character to represent beta. */
    var beta = java ? 'b' : '\u03B2';

    /** Browser document object. */
    var doc = context.document || {};

    /**
     * Detect Opera browser (Presto-based).
     * http://www.howtocreate.co.uk/operaStuff/operaObject.html
     * http://dev.opera.com/articles/view/opera-mini-web-content-authoring-guidelines/#operamini
     */
    var opera = context.operamini || context.opera;

    /** Opera `[[Class]]`. */
    var operaClass = reOpera.test(operaClass = isCustomContext && opera ? opera['[[Class]]'] : getClassOf(opera)) ? operaClass : opera = null;

    /*------------------------------------------------------------------------*/

    /** Temporary variable used over the script's lifetime. */
    var data;

    /** The CPU architecture. */
    var arch = ua;

    /** Platform description array. */
    var description = [];

    /** Platform alpha/beta indicator. */
    var prerelease = null;

    /** A flag to indicate that environment features should be used to resolve the platform. */
    var useFeatures = ua == userAgent;

    /** The browser/environment version. */
    var version = useFeatures && opera && typeof opera.version == 'function' && opera.version();

    /** A flag to indicate if the OS ends with "/ Version" */
    var isSpecialCasedOS;

    /* Detectable layout engines (order is important). */
    var layout = getLayout([{ 'label': 'EdgeHTML', 'pattern': 'Edge' }, 'Trident', { 'label': 'WebKit', 'pattern': 'AppleWebKit' }, 'iCab', 'Presto', 'NetFront', 'Tasman', 'KHTML', 'Gecko']);

    /* Detectable browser names (order is important). */
    var name = getName(['Adobe AIR', 'Arora', 'Avant Browser', 'Breach', 'Camino', 'Epiphany', 'Fennec', 'Flock', 'Galeon', 'GreenBrowser', 'iCab', 'Iceweasel', 'K-Meleon', 'Konqueror', 'Lunascape', 'Maxthon', { 'label': 'Microsoft Edge', 'pattern': 'Edge' }, 'Midori', 'Nook Browser', 'PaleMoon', 'PhantomJS', 'Raven', 'Rekonq', 'RockMelt', 'SeaMonkey', { 'label': 'Silk', 'pattern': '(?:Cloud9|Silk-Accelerated)' }, 'Sleipnir', 'SlimBrowser', { 'label': 'SRWare Iron', 'pattern': 'Iron' }, 'Sunrise', 'Swiftfox', 'WebPositive', 'Opera Mini', { 'label': 'Opera Mini', 'pattern': 'OPiOS' }, 'Opera', { 'label': 'Opera', 'pattern': 'OPR' }, 'Chrome', { 'label': 'Chrome Mobile', 'pattern': '(?:CriOS|CrMo)' }, { 'label': 'Firefox', 'pattern': '(?:Firefox|Minefield)' }, { 'label': 'Firefox for iOS', 'pattern': 'FxiOS' }, { 'label': 'IE', 'pattern': 'IEMobile' }, { 'label': 'IE', 'pattern': 'MSIE' }, 'Safari']);

    /* Detectable products (order is important). */
    var product = getProduct([{ 'label': 'BlackBerry', 'pattern': 'BB10' }, 'BlackBerry', { 'label': 'Galaxy S', 'pattern': 'GT-I9000' }, { 'label': 'Galaxy S2', 'pattern': 'GT-I9100' }, { 'label': 'Galaxy S3', 'pattern': 'GT-I9300' }, { 'label': 'Galaxy S4', 'pattern': 'GT-I9500' }, 'Google TV', 'Lumia', 'iPad', 'iPod', 'iPhone', 'Kindle', { 'label': 'Kindle Fire', 'pattern': '(?:Cloud9|Silk-Accelerated)' }, 'Nexus', 'Nook', 'PlayBook', 'PlayStation 3', 'PlayStation 4', 'PlayStation Vita', 'TouchPad', 'Transformer', { 'label': 'Wii U', 'pattern': 'WiiU' }, 'Wii', 'Xbox One', { 'label': 'Xbox 360', 'pattern': 'Xbox' }, 'Xoom']);

    /* Detectable manufacturers. */
    var manufacturer = getManufacturer({
      'Apple': { 'iPad': 1, 'iPhone': 1, 'iPod': 1 },
      'Archos': {},
      'Amazon': { 'Kindle': 1, 'Kindle Fire': 1 },
      'Asus': { 'Transformer': 1 },
      'Barnes & Noble': { 'Nook': 1 },
      'BlackBerry': { 'PlayBook': 1 },
      'Google': { 'Google TV': 1, 'Nexus': 1 },
      'HP': { 'TouchPad': 1 },
      'HTC': {},
      'LG': {},
      'Microsoft': { 'Xbox': 1, 'Xbox One': 1 },
      'Motorola': { 'Xoom': 1 },
      'Nintendo': { 'Wii U': 1, 'Wii': 1 },
      'Nokia': { 'Lumia': 1 },
      'Samsung': { 'Galaxy S': 1, 'Galaxy S2': 1, 'Galaxy S3': 1, 'Galaxy S4': 1 },
      'Sony': { 'PlayStation 4': 1, 'PlayStation 3': 1, 'PlayStation Vita': 1 }
    });

    /* Detectable operating systems (order is important). */
    var os = getOS(['Windows Phone', 'Android', 'CentOS', { 'label': 'Chrome OS', 'pattern': 'CrOS' }, 'Debian', 'Fedora', 'FreeBSD', 'Gentoo', 'Haiku', 'Kubuntu', 'Linux Mint', 'OpenBSD', 'Red Hat', 'SuSE', 'Ubuntu', 'Xubuntu', 'Cygwin', 'Symbian OS', 'hpwOS', 'webOS ', 'webOS', 'Tablet OS', 'Linux', 'Mac OS X', 'Macintosh', 'Mac', 'Windows 98;', 'Windows ']);

    /*------------------------------------------------------------------------*/

    /**
     * Picks the layout engine from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected layout engine.
     */
    function getLayout(guesses) {
      return reduce(guesses, function (result, guess) {
        return result || RegExp('\\b' + (guess.pattern || qualify(guess)) + '\\b', 'i').exec(ua) && (guess.label || guess);
      });
    }

    /**
     * Picks the manufacturer from an array of guesses.
     *
     * @private
     * @param {Array} guesses An object of guesses.
     * @returns {null|string} The detected manufacturer.
     */
    function getManufacturer(guesses) {
      return reduce(guesses, function (result, value, key) {
        // Lookup the manufacturer by product or scan the UA for the manufacturer.
        return result || (value[product] || value[/^[a-z]+(?: +[a-z]+\b)*/i.exec(product)] || RegExp('\\b' + qualify(key) + '(?:\\b|\\w*\\d)', 'i').exec(ua)) && key;
      });
    }

    /**
     * Picks the browser name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected browser name.
     */
    function getName(guesses) {
      return reduce(guesses, function (result, guess) {
        return result || RegExp('\\b' + (guess.pattern || qualify(guess)) + '\\b', 'i').exec(ua) && (guess.label || guess);
      });
    }

    /**
     * Picks the OS name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected OS name.
     */
    function getOS(guesses) {
      return reduce(guesses, function (result, guess) {
        var pattern = guess.pattern || qualify(guess);
        if (!result && (result = RegExp('\\b' + pattern + '(?:/[\\d.]+|[ \\w.]*)', 'i').exec(ua))) {
          result = cleanupOS(result, pattern, guess.label || guess);
        }
        return result;
      });
    }

    /**
     * Picks the product name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected product name.
     */
    function getProduct(guesses) {
      return reduce(guesses, function (result, guess) {
        var pattern = guess.pattern || qualify(guess);
        if (!result && (result = RegExp('\\b' + pattern + ' *\\d+[.\\w_]*', 'i').exec(ua) || RegExp('\\b' + pattern + '(?:; *(?:[a-z]+[_-])?[a-z]+\\d+|[^ ();-]*)', 'i').exec(ua))) {
          // Split by forward slash and append product version if needed.
          if ((result = String(guess.label && !RegExp(pattern, 'i').test(guess.label) ? guess.label : result).split('/'))[1] && !/[\d.]+/.test(result[0])) {
            result[0] += ' ' + result[1];
          }
          // Correct character case and cleanup string.
          guess = guess.label || guess;
          result = format(result[0].replace(RegExp(pattern, 'i'), guess).replace(RegExp('; *(?:' + guess + '[_-])?', 'i'), ' ').replace(RegExp('(' + guess + ')[-_.]?(\\w)', 'i'), '$1 $2'));
        }
        return result;
      });
    }

    /**
     * Resolves the version using an array of UA patterns.
     *
     * @private
     * @param {Array} patterns An array of UA patterns.
     * @returns {null|string} The detected version.
     */
    function getVersion(patterns) {
      return reduce(patterns, function (result, pattern) {
        return result || (RegExp(pattern + '(?:-[\\d.]+/|(?: for [\\w-]+)?[ /-])([\\d.]+[^ ();/_-]*)', 'i').exec(ua) || 0)[1] || null;
      });
    }

    /**
     * Returns `platform.description` when the platform object is coerced to a string.
     *
     * @name toString
     * @memberOf platform
     * @returns {string} Returns `platform.description` if available, else an empty string.
     */
    function toStringPlatform() {
      return this.description || '';
    }

    /*------------------------------------------------------------------------*/

    // Convert layout to an array so we can add extra details.
    layout && (layout = [layout]);

    // Detect product names that contain their manufacturer's name.
    if (manufacturer && !product) {
      product = getProduct([manufacturer]);
    }
    // Clean up Google TV.
    if (data = /\bGoogle TV\b/.exec(product)) {
      product = data[0];
    }
    // Detect simulators.
    if (/\bSimulator\b/i.test(ua)) {
      product = (product ? product + ' ' : '') + 'Simulator';
    }
    // Detect Opera Mini 8+ running in Turbo/Uncompressed mode on iOS.
    if (name == 'Opera Mini' && /\bOPiOS\b/.test(ua)) {
      description.push('running in Turbo/Uncompressed mode');
    }
    // Detect IE Mobile 11.
    if (name == 'IE' && /\blike iPhone OS\b/.test(ua)) {
      data = parse(ua.replace(/like iPhone OS/, ''));
      manufacturer = data.manufacturer;
      product = data.product;
    }
    // Detect iOS.
    else if (/^iP/.test(product)) {
        name || (name = 'Safari');
        os = 'iOS' + ((data = / OS ([\d_]+)/i.exec(ua)) ? ' ' + data[1].replace(/_/g, '.') : '');
      }
      // Detect Kubuntu.
      else if (name == 'Konqueror' && !/buntu/i.test(os)) {
          os = 'Kubuntu';
        }
        // Detect Android browsers.
        else if (manufacturer && manufacturer != 'Google' && (/Chrome/.test(name) && !/\bMobile Safari\b/i.test(ua) || /\bVita\b/.test(product)) || /\bAndroid\b/.test(os) && /^Chrome/.test(name) && /\bVersion\//i.test(ua)) {
            name = 'Android Browser';
            os = /\bAndroid\b/.test(os) ? os : 'Android';
          }
          // Detect Silk desktop/accelerated modes.
          else if (name == 'Silk') {
              if (!/\bMobi/i.test(ua)) {
                os = 'Android';
                description.unshift('desktop mode');
              }
              if (/Accelerated *= *true/i.test(ua)) {
                description.unshift('accelerated');
              }
            }
            // Detect PaleMoon identifying as Firefox.
            else if (name == 'PaleMoon' && (data = /\bFirefox\/([\d.]+)\b/.exec(ua))) {
                description.push('identifying as Firefox ' + data[1]);
              }
              // Detect Firefox OS and products running Firefox.
              else if (name == 'Firefox' && (data = /\b(Mobile|Tablet|TV)\b/i.exec(ua))) {
                  os || (os = 'Firefox OS');
                  product || (product = data[1]);
                }
                // Detect false positives for Firefox/Safari.
                else if (!name || (data = !/\bMinefield\b/i.test(ua) && /\b(?:Firefox|Safari)\b/.exec(name))) {
                    // Escape the `/` for Firefox 1.
                    if (name && !product && /[\/,]|^[^(]+?\)/.test(ua.slice(ua.indexOf(data + '/') + 8))) {
                      // Clear name of false positives.
                      name = null;
                    }
                    // Reassign a generic name.
                    if ((data = product || manufacturer || os) && (product || manufacturer || /\b(?:Android|Symbian OS|Tablet OS|webOS)\b/.test(os))) {
                      name = /[a-z]+(?: Hat)?/i.exec(/\bAndroid\b/.test(os) ? os : data) + ' Browser';
                    }
                  }
    // Detect non-Opera (Presto-based) versions (order is important).
    if (!version) {
      version = getVersion(['(?:Cloud9|CriOS|CrMo|Edge|FxiOS|IEMobile|Iron|Opera ?Mini|OPiOS|OPR|Raven|Silk(?!/[\\d.]+$))', 'Version', qualify(name), '(?:Firefox|Minefield|NetFront)']);
    }
    // Detect stubborn layout engines.
    if (data = layout == 'iCab' && parseFloat(version) > 3 && 'WebKit' || /\bOpera\b/.test(name) && (/\bOPR\b/.test(ua) ? 'Blink' : 'Presto') || /\b(?:Midori|Nook|Safari)\b/i.test(ua) && !/^(?:Trident|EdgeHTML)$/.test(layout) && 'WebKit' || !layout && /\bMSIE\b/i.test(ua) && (os == 'Mac OS' ? 'Tasman' : 'Trident') || layout == 'WebKit' && /\bPlayStation\b(?! Vita\b)/i.test(name) && 'NetFront') {
      layout = [data];
    }
    // Detect Windows Phone 7 desktop mode.
    if (name == 'IE' && (data = (/; *(?:XBLWP|ZuneWP)(\d+)/i.exec(ua) || 0)[1])) {
      name += ' Mobile';
      os = 'Windows Phone ' + (/\+$/.test(data) ? data : data + '.x');
      description.unshift('desktop mode');
    }
    // Detect Windows Phone 8.x desktop mode.
    else if (/\bWPDesktop\b/i.test(ua)) {
        name = 'IE Mobile';
        os = 'Windows Phone 8.x';
        description.unshift('desktop mode');
        version || (version = (/\brv:([\d.]+)/.exec(ua) || 0)[1]);
      }
      // Detect IE 11.
      else if (name != 'IE' && layout == 'Trident' && (data = /\brv:([\d.]+)/.exec(ua))) {
          if (name) {
            description.push('identifying as ' + name + (version ? ' ' + version : ''));
          }
          name = 'IE';
          version = data[1];
        }
    // Leverage environment features.
    if (useFeatures) {
      // Detect server-side environments.
      // Rhino has a global function while others have a global object.
      if (isHostType(context, 'global')) {
        if (java) {
          data = java.lang.System;
          arch = data.getProperty('os.arch');
          os = os || data.getProperty('os.name') + ' ' + data.getProperty('os.version');
        }
        if (isModuleScope && isHostType(context, 'system') && (data = [context.system])[0]) {
          os || (os = data[0].os || null);
          try {
            data[1] = context.require('ringo/engine').version;
            version = data[1].join('.');
            name = 'RingoJS';
          } catch (e) {
            if (data[0].global.system == context.system) {
              name = 'Narwhal';
            }
          }
        } else if (_typeof(context.process) == 'object' && !context.process.browser && (data = context.process)) {
          name = 'Node.js';
          arch = data.arch;
          os = data.platform;
          version = /[\d.]+/.exec(data.version)[0];
        } else if (rhino) {
          name = 'Rhino';
        }
      }
      // Detect Adobe AIR.
      else if (getClassOf(data = context.runtime) == airRuntimeClass) {
          name = 'Adobe AIR';
          os = data.flash.system.Capabilities.os;
        }
        // Detect PhantomJS.
        else if (getClassOf(data = context.phantom) == phantomClass) {
            name = 'PhantomJS';
            version = (data = data.version || null) && data.major + '.' + data.minor + '.' + data.patch;
          }
          // Detect IE compatibility modes.
          else if (typeof doc.documentMode == 'number' && (data = /\bTrident\/(\d+)/i.exec(ua))) {
              // We're in compatibility mode when the Trident version + 4 doesn't
              // equal the document mode.
              version = [version, doc.documentMode];
              if ((data = +data[1] + 4) != version[1]) {
                description.push('IE ' + version[1] + ' mode');
                layout && (layout[1] = '');
                version[1] = data;
              }
              version = name == 'IE' ? String(version[1].toFixed(1)) : version[0];
            }
      os = os && format(os);
    }
    // Detect prerelease phases.
    if (version && (data = /(?:[ab]|dp|pre|[ab]\d+pre)(?:\d+\+?)?$/i.exec(version) || /(?:alpha|beta)(?: ?\d)?/i.exec(ua + ';' + (useFeatures && nav.appMinorVersion)) || /\bMinefield\b/i.test(ua) && 'a')) {
      prerelease = /b/i.test(data) ? 'beta' : 'alpha';
      version = version.replace(RegExp(data + '\\+?$'), '') + (prerelease == 'beta' ? beta : alpha) + (/\d+\+?/.exec(data) || '');
    }
    // Detect Firefox Mobile.
    if (name == 'Fennec' || name == 'Firefox' && /\b(?:Android|Firefox OS)\b/.test(os)) {
      name = 'Firefox Mobile';
    }
    // Obscure Maxthon's unreliable version.
    else if (name == 'Maxthon' && version) {
        version = version.replace(/\.[\d.]+/, '.x');
      }
      // Detect Xbox 360 and Xbox One.
      else if (/\bXbox\b/i.test(product)) {
          os = null;
          if (product == 'Xbox 360' && /\bIEMobile\b/.test(ua)) {
            description.unshift('mobile mode');
          }
        }
        // Add mobile postfix.
        else if ((/^(?:Chrome|IE|Opera)$/.test(name) || name && !product && !/Browser|Mobi/.test(name)) && (os == 'Windows CE' || /Mobi/i.test(ua))) {
            name += ' Mobile';
          }
          // Detect IE platform preview.
          else if (name == 'IE' && useFeatures && context.external === null) {
              description.unshift('platform preview');
            }
            // Detect BlackBerry OS version.
            // http://docs.blackberry.com/en/developers/deliverables/18169/HTTP_headers_sent_by_BB_Browser_1234911_11.jsp
            else if ((/\bBlackBerry\b/.test(product) || /\bBB10\b/.test(ua)) && (data = (RegExp(product.replace(/ +/g, ' *') + '/([.\\d]+)', 'i').exec(ua) || 0)[1] || version)) {
                data = [data, /BB10/.test(ua)];
                os = (data[1] ? (product = null, manufacturer = 'BlackBerry') : 'Device Software') + ' ' + data[0];
                version = null;
              }
              // Detect Opera identifying/masking itself as another browser.
              // http://www.opera.com/support/kb/view/843/
              else if (this != forOwn && product != 'Wii' && (useFeatures && opera || /Opera/.test(name) && /\b(?:MSIE|Firefox)\b/i.test(ua) || name == 'Firefox' && /\bOS X (?:\d+\.){2,}/.test(os) || name == 'IE' && (os && !/^Win/.test(os) && version > 5.5 || /\bWindows XP\b/.test(os) && version > 8 || version == 8 && !/\bTrident\b/.test(ua))) && !reOpera.test(data = parse.call(forOwn, ua.replace(reOpera, '') + ';')) && data.name) {
                  // When "identifying", the UA contains both Opera and the other browser's name.
                  data = 'ing as ' + data.name + ((data = data.version) ? ' ' + data : '');
                  if (reOpera.test(name)) {
                    if (/\bIE\b/.test(data) && os == 'Mac OS') {
                      os = null;
                    }
                    data = 'identify' + data;
                  }
                  // When "masking", the UA contains only the other browser's name.
                  else {
                      data = 'mask' + data;
                      if (operaClass) {
                        name = format(operaClass.replace(/([a-z])([A-Z])/g, '$1 $2'));
                      } else {
                        name = 'Opera';
                      }
                      if (/\bIE\b/.test(data)) {
                        os = null;
                      }
                      if (!useFeatures) {
                        version = null;
                      }
                    }
                  layout = ['Presto'];
                  description.push(data);
                }
    // Detect WebKit Nightly and approximate Chrome/Safari versions.
    if (data = (/\bAppleWebKit\/([\d.]+\+?)/i.exec(ua) || 0)[1]) {
      // Correct build number for numeric comparison.
      // (e.g. "532.5" becomes "532.05")
      data = [parseFloat(data.replace(/\.(\d)$/, '.0$1')), data];
      // Nightly builds are postfixed with a "+".
      if (name == 'Safari' && data[1].slice(-1) == '+') {
        name = 'WebKit Nightly';
        prerelease = 'alpha';
        version = data[1].slice(0, -1);
      }
      // Clear incorrect browser versions.
      else if (version == data[1] || version == (data[2] = (/\bSafari\/([\d.]+\+?)/i.exec(ua) || 0)[1])) {
          version = null;
        }
      // Use the full Chrome version when available.
      data[1] = (/\bChrome\/([\d.]+)/i.exec(ua) || 0)[1];
      // Detect Blink layout engine.
      if (data[0] == 537.36 && data[2] == 537.36 && parseFloat(data[1]) >= 28 && layout == 'WebKit') {
        layout = ['Blink'];
      }
      // Detect JavaScriptCore.
      // http://stackoverflow.com/questions/6768474/how-can-i-detect-which-javascript-engine-v8-or-jsc-is-used-at-runtime-in-androi
      if (!useFeatures || !likeChrome && !data[1]) {
        layout && (layout[1] = 'like Safari');
        data = (data = data[0], data < 400 ? 1 : data < 500 ? 2 : data < 526 ? 3 : data < 533 ? 4 : data < 534 ? '4+' : data < 535 ? 5 : data < 537 ? 6 : data < 538 ? 7 : data < 601 ? 8 : '8');
      } else {
        layout && (layout[1] = 'like Chrome');
        data = data[1] || (data = data[0], data < 530 ? 1 : data < 532 ? 2 : data < 532.05 ? 3 : data < 533 ? 4 : data < 534.03 ? 5 : data < 534.07 ? 6 : data < 534.10 ? 7 : data < 534.13 ? 8 : data < 534.16 ? 9 : data < 534.24 ? 10 : data < 534.30 ? 11 : data < 535.01 ? 12 : data < 535.02 ? '13+' : data < 535.07 ? 15 : data < 535.11 ? 16 : data < 535.19 ? 17 : data < 536.05 ? 18 : data < 536.10 ? 19 : data < 537.01 ? 20 : data < 537.11 ? '21+' : data < 537.13 ? 23 : data < 537.18 ? 24 : data < 537.24 ? 25 : data < 537.36 ? 26 : layout != 'Blink' ? '27' : '28');
      }
      // Add the postfix of ".x" or "+" for approximate versions.
      layout && (layout[1] += ' ' + (data += typeof data == 'number' ? '.x' : /[.+]/.test(data) ? '' : '+'));
      // Obscure version for some Safari 1-2 releases.
      if (name == 'Safari' && (!version || parseInt(version) > 45)) {
        version = data;
      }
    }
    // Detect Opera desktop modes.
    if (name == 'Opera' && (data = /\bzbov|zvav$/.exec(os))) {
      name += ' ';
      description.unshift('desktop mode');
      if (data == 'zvav') {
        name += 'Mini';
        version = null;
      } else {
        name += 'Mobile';
      }
      os = os.replace(RegExp(' *' + data + '$'), '');
    }
    // Detect Chrome desktop mode.
    else if (name == 'Safari' && /\bChrome\b/.exec(layout && layout[1])) {
        description.unshift('desktop mode');
        name = 'Chrome Mobile';
        version = null;

        if (/\bOS X\b/.test(os)) {
          manufacturer = 'Apple';
          os = 'iOS 4.3+';
        } else {
          os = null;
        }
      }
    // Strip incorrect OS versions.
    if (version && version.indexOf(data = /[\d.]+$/.exec(os)) == 0 && ua.indexOf('/' + data + '-') > -1) {
      os = trim(os.replace(data, ''));
    }
    // Add layout engine.
    if (layout && !/\b(?:Avant|Nook)\b/.test(name) && (/Browser|Lunascape|Maxthon/.test(name) || name != 'Safari' && /^iOS/.test(os) && /\bSafari\b/.test(layout[1]) || /^(?:Adobe|Arora|Breach|Midori|Opera|Phantom|Rekonq|Rock|Sleipnir|Web)/.test(name) && layout[1])) {
      // Don't add layout details to description if they are falsey.
      (data = layout[layout.length - 1]) && description.push(data);
    }
    // Combine contextual information.
    if (description.length) {
      description = ['(' + description.join('; ') + ')'];
    }
    // Append manufacturer to description.
    if (manufacturer && product && product.indexOf(manufacturer) < 0) {
      description.push('on ' + manufacturer);
    }
    // Append product to description.
    if (product) {
      description.push((/^on /.test(description[description.length - 1]) ? '' : 'on ') + product);
    }
    // Parse the OS into an object.
    if (os) {
      data = / ([\d.+]+)$/.exec(os);
      isSpecialCasedOS = data && os.charAt(os.length - data[0].length - 1) == '/';
      os = {
        'architecture': 32,
        'family': data && !isSpecialCasedOS ? os.replace(data[0], '') : os,
        'version': data ? data[1] : null,
        'toString': function toString() {
          var version = this.version;
          return this.family + (version && !isSpecialCasedOS ? ' ' + version : '') + (this.architecture == 64 ? ' 64-bit' : '');
        }
      };
    }
    // Add browser/OS architecture.
    if ((data = /\b(?:AMD|IA|Win|WOW|x86_|x)64\b/i.exec(arch)) && !/\bi686\b/i.test(arch)) {
      if (os) {
        os.architecture = 64;
        os.family = os.family.replace(RegExp(' *' + data), '');
      }
      if (name && (/\bWOW64\b/i.test(ua) || useFeatures && /\w(?:86|32)$/.test(nav.cpuClass || nav.platform) && !/\bWin64; x64\b/i.test(ua))) {
        description.unshift('32-bit');
      }
    }
    // Chrome 39 and above on OS X is always 64-bit.
    else if (os && /^OS X/.test(os.family) && name == 'Chrome' && parseFloat(version) >= 39) {
        os.architecture = 64;
      }

    ua || (ua = null);

    /*------------------------------------------------------------------------*/

    /**
     * The platform object.
     *
     * @name platform
     * @type Object
     */
    var platform = {};

    /**
     * The platform description.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.description = ua;

    /**
     * The name of the browser's layout engine.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.layout = layout && layout[0];

    /**
     * The name of the product's manufacturer.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.manufacturer = manufacturer;

    /**
     * The name of the browser/environment.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.name = name;

    /**
     * The alpha/beta release indicator.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.prerelease = prerelease;

    /**
     * The name of the product hosting the browser.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.product = product;

    /**
     * The browser's user agent string.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.ua = ua;

    /**
     * The browser/environment version.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.version = name && version;

    /**
     * The name of the operating system.
     *
     * @memberOf platform
     * @type Object
     */
    platform.os = os || {

      /**
       * The CPU architecture the OS is built for.
       *
       * @memberOf platform.os
       * @type number|null
       */
      'architecture': null,

      /**
       * The family of the OS.
       *
       * Common values include:
       * "Windows", "Windows Server 2008 R2 / 7", "Windows Server 2008 / Vista",
       * "Windows XP", "OS X", "Ubuntu", "Debian", "Fedora", "Red Hat", "SuSE",
       * "Android", "iOS" and "Windows Phone"
       *
       * @memberOf platform.os
       * @type string|null
       */
      'family': null,

      /**
       * The version of the OS.
       *
       * @memberOf platform.os
       * @type string|null
       */
      'version': null,

      /**
       * Returns the OS string.
       *
       * @memberOf platform.os
       * @returns {string} The OS string.
       */
      'toString': function toString() {
        return 'null';
      }
    };

    platform.parse = parse;
    platform.toString = toStringPlatform;

    if (platform.version) {
      description.unshift(version);
    }
    if (platform.name) {
      description.unshift(name);
    }
    if (os && name && !(os == String(os).split(' ')[0] && (os == name.split(' ')[0] || product))) {
      description.push(product ? '(' + os + ')' : 'on ' + os);
    }
    if (description.length) {
      platform.description = description.join(' ');
    }
    return platform;
  }

  /*--------------------------------------------------------------------------*/

  // Export platform.
  var platform = parse();

  // Some AMD build optimizers, like r.js, check for condition patterns like the following:
  if ("function" == 'function' && _typeof(__webpack_require__("/tool/node_modules/webpack/buildin/amd-options.js")) == 'object' && __webpack_require__("/tool/node_modules/webpack/buildin/amd-options.js")) {
    // Expose platform on the global object to prevent errors when platform is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    root.platform = platform;

    // Define as an anonymous module so platform can be aliased through path mapping.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return platform;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
  else if (freeExports && freeModule) {
      // Export for CommonJS support.
      forOwn(platform, function (value, key) {
        freeExports[key] = value;
      });
    } else {
      // Export to the global object.
      root.platform = platform;
    }
}).call(undefined);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/webpack/buildin/module.js")(module), __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/process/browser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while (len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) {
    return [];
};

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () {
    return '/';
};
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function () {
    return 0;
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/webpack/buildin/global.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/webpack/buildin/module.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function () {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function get() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function get() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _modules = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/index.js");

var _modules2 = _interopRequireDefault(_modules);

var _vendor = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/index.js");

var _vendor2 = _interopRequireDefault(_vendor);

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/utilities/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'app.core'; /* global $:true module:true */
// import 'babel-polyfill';

var log = (0, _debug2.default)(MODULE_NAME);

log('Running...');
// import services from './services';


// vendor.vue.onAfterInit((Vue) => {
//     log("Vue ready", Vue);
// });

$(function () {
    log('Running document ready tasks...');

    // Run Foundation
    log('vendor', _vendor2.default);
    _vendor2.default.foundation.exec();

    // Run Modules
    log('modules', _modules2.default);
    _modules2.default.exec();

    // start Vue ;
    // vendor.vue.exec();

    window.setTimeout(function () {
        _modules2.default.execAfter();
    }, 0);
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/debounce.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = debounce;
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this,
            args = arguments;
        var later = function later() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/objects.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.elementAttrtibutesToObject = elementAttrtibutesToObject;
exports.collectElementOptions = collectElementOptions;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _strings = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/strings.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global Loader:true $:true */

var MODULE_NAME = 'app.core/lib/objects';
var log = (0, _debug2.default)(MODULE_NAME);

var ZERO = 0;

/**
 * Convert an elements attributes to an object, optionally filtering based on some predicate.
 * @param  {DOMElement}   element  [description]
 * @param  {Function} filterFn filtering function. return false to omit attribute.
 * @param  {Function} transformFn transform attribute name function. returns camelCase by default
 * @return {[type]}            [description]
 */
function elementAttrtibutesToObject(element) {
	var filterFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
		return true;
	};
	var transformFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (name) {
		return (0, _strings.toCamelCase)(name);
	};

	var output = {};
	var attrs = Array.from($(element).get(ZERO).attributes);

	if (!attrs) {
		return output;
	}

	log('converting element attributes to object', attrs);

	return attrs.reduce(function (result, attribute) {
		if (filterFn(attribute)) {
			var name = transformFn(attribute.name);
			var value = attribute.value;

			if (value === 'false' || value === 'true') {
				value = Boolean(value);
			}
			result[name] = attribute.value;
		}

		return result;
	}, output);
}

function collectElementOptions(prefix, data) {
	return Object.keys(data).map(function (key) {
		return (0, _strings.toCamelCase)(key);
	}).filter(function (key) {
		return key.indexOf(prefix) >= ZERO;
	}).reduce(function (result, source) {
		var key = (0, _strings.toCamelCase)(source.replace(prefix, ''));
		result[key] = data[source];
		return result;
	}, {});
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = plugin;
exports.jquery = jquery;
exports.defaults = defaults;

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _strings = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/strings.js");

var _objects = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/objects.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Generate a jQuery plugin
 * @param pluginName [string] Plugin name
 * @param className [object] Class of the plugin
 * @param shortHand [bool] Generate a shorthand as $.pluginName
 *
 * @example
 * import plugin from 'plugin';
 *
 * class MyPlugin {
 *     constructor(element, options) {
 *         // ...
 *     }
 * }
 *
 * or
 *
 * function MyPlugin (element, options) {
 *   assert(options.something, true);
 * }
 *
 * then
 *
 * MyPlugin.DEFAULTS = {
 *   something: false
 * };
 *
 * plugin('myPlugin', MyPlugin);
 *
 * $(() => {
 *   $('[data-my-plugin]').myPlugin();
 * })
 *
 * <div data-my-plugin data-my-plugin-something="true"></div>
 */
function plugin(pluginName, className) {
    var shortHand = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var dataName = '__' + pluginName;
    var old = _jquery2.default.fn[pluginName];
    var ZERO = 0;

    className.$bus = {
        subscribe: function subscribe(event, fn) {
            (0, _jquery2.default)(this).bind(event, fn);
        },
        publish: function publish(event, data) {
            (0, _jquery2.default)(this).trigger(event, [data]);
        }
    };

    _jquery2.default.fn[pluginName] = function PluginFactory(option, args) {
        return this.each(function PluginInstanceFactory() {
            var $this = (0, _jquery2.default)(this);
            var overrides = (typeof option === 'undefined' ? 'undefined' : _typeof(option)) === 'object' && option;
            var elementOptions = (0, _objects.collectElementOptions)(pluginName, $this.data());

            var instance = $this.data(dataName);
            var options = _jquery2.default.extend({}, className.DEFAULTS, elementOptions, overrides);

            // store reference to instance
            if (!instance) {
                $this.data(dataName, instance = new className(this, options));
            }

            // execute instance method
            if (typeof option === 'string') {
                if (typeof instance[option] != 'function') {
                    console.warn(pluginName + '.' + option + ' is not a function');
                } else {
                    return instance[option](args);
                }
            }
        });
    };

    // - Short hand
    if (shortHand) {
        _jquery2.default[pluginName] = function (options) {
            return (0, _jquery2.default)({})[pluginName](options);
        };
    }

    // - No conflict
    _jquery2.default.fn[pluginName].noConflict = function noConflict() {
        _jquery2.default.fn[pluginName] = old;
    };
}

_jquery2.default.fn.behaviour = function (name) {
    return (0, _jquery2.default)(this).data('__' + name);
};
function jquery(name) {
    return function decroate(target) {
        plugin(name, target);
    };
}

function defaults(options) {
    return function decorate(target) {
        target.DEFAULTS = options;
    };
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/selectors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.onAvailable = exports.SELECTOR_PATTERNS = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.selectorPattern = selectorPattern;
exports.selectTarget = selectTarget;
exports.onChange = onChange;

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _debug2.default)("core/plugins/lib/selectors");

function selectorPattern() {
    for (var _len = arguments.length, directives = Array(_len), _key = 0; _key < _len; _key++) {
        directives[_key] = arguments[_key];
    }

    return new RegExp("\\((" + directives.join("|") + ")(.*)\\)\\s?(.*)");
}

var SELECTOR_PATTERNS = exports.SELECTOR_PATTERNS = {
    // .find
    children: selectorPattern("children"),

    // .closest
    parent: selectorPattern("parent"),
    from: selectorPattern("from"),
    parents: selectorPattern("parents"),
    siblings: selectorPattern("siblings"),
    here: selectorPattern("here"),
    self: selectorPattern("self")
};

function selectTarget(selector, $element) {
    var $target = void 0;

    var isClosestAncestoral = selector.match(SELECTOR_PATTERNS.parent);
    var isAllAncestoral = selector.match(SELECTOR_PATTERNS.parents);
    var isRetargeted = selector.match(SELECTOR_PATTERNS.from);
    var isAllDescendants = selector.match(SELECTOR_PATTERNS.children);
    var isGenerational = selector.match(SELECTOR_PATTERNS.here);
    var isSiblings = selector.match(SELECTOR_PATTERNS.siblings);
    var isSelfish = selector.match(SELECTOR_PATTERNS.self);

    // special retargeting root
    if (isRetargeted) {
        log("isRetargeted", isRetargeted[2], isRetargeted[3]);
        var $newElement = selectTarget(isRetargeted[2], $element);
        var newSelector = "(children) " + isRetargeted[3];
        log("isRetargeted.newElement", $newElement);
        log("isRetargeted.newSelector", newSelector);
        $target = selectTarget(newSelector, $newElement);
        log("isRetargeted.target", $target);
    }

    // target is all ancestors
    else if (isAllAncestoral) {
            log("isAllAncestoral", isAllAncestoral);
            $target = $element.parents(isAllAncestoral[isAllAncestoral.length - 1]);
        }
        // target is closest ancestor
        else if (isClosestAncestoral) {
                log("isClosestAncestoral", isClosestAncestoral);
                $target = $element.closest(isClosestAncestoral[isClosestAncestoral.length - 1]);
            }
            // target is somewhere under current parent
            else if (isGenerational) {
                    log("isGenerational", isGenerational);
                    $target = $element.parent().find(isGenerational[isGenerational.length - 1]);
                }
                // target is only under self
                else if (isAllDescendants) {
                        log("isAllDescendants", isAllDescendants);
                        $target = $element.find(isAllDescendants[isAllDescendants.length - 1]);
                    }
                    // target is somewhere in siblings only
                    else if (isSiblings) {
                            log("isSiblings", isSiblings);
                            $target = $element.siblings(isSiblings[isSiblings.length - 1]);
                        }
                        // target is source
                        else if (!selector || isSelfish) {
                                log("isSelfish", isSelfish);
                                var selector = isSelfish[isSelfish.length - 1] || "*";
                                $target = $element.filter(selector);
                            }
                            // target could be anywhere
                            else {
                                    log("global", selector);
                                    $target = (0, _jquery2.default)(selector);
                                }
    return $target;
}

var OnAvailable = function () {
    function OnAvailable(root) {
        _classCallCheck(this, OnAvailable);

        this.root = root || window.document.documentElement;
        this.listeners = [];
        this.observer;
    }

    _createClass(OnAvailable, [{
        key: "ready",
        value: function ready(selector, fn) {
            // Store the selector and callback to be monitored
            this.listeners.push({
                selector: selector,
                fn: fn
            });

            if (!this.observer) {
                // Watch for changes in the document
                this.observer = onChange(this.root, this.check.bind(this), {
                    childList: true,
                    subtree: true
                });
            }
            // Check if the element is currently in the DOM
            this.check();
        }
    }, {
        key: "check",
        value: function check() {
            var _this = this;

            var listnersSelectorsArray = [];
            Array.from(this.listeners).forEach(function (listener) {
                listnersSelectorsArray.push(listener.selector);
            });
            var listnersSelectors = listnersSelectorsArray.join(",");
            var matchingElements = this.root.querySelectorAll(listnersSelectors);
            // Check the DOM for elements matching a stored selector

            Array.from(matchingElements).forEach(function (element) {
                Array.from(_this.listeners).forEach(function (listener) {
                    var attributeName = listener.selector.substring(1, listener.selector.length - 1);
                    if (element.hasAttribute(attributeName) && !element[attributeName]) {
                        listener.fn.call(element, element);
                        element[attributeName] = true;
                    }
                });
            });
        }
    }]);

    return OnAvailable;
}();

var onAvailable = exports.onAvailable = new OnAvailable(window.document.documentElement);

function onChange(element, fn, options) {
    var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
    var observer = new MutationObserver(fn);
    observer.observe(element, options || {
        attributes: true,
        childList: true,
        subtree: true
    });
    return observer;
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/strings.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* global Loader:true $:true */

exports.toCamelCase = toCamelCase;
exports.tmpl = tmpl;
exports.$tmpl = $tmpl;
exports.mustache = mustache;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'app.core/lib/strings';
var log = (0, _debug2.default)(MODULE_NAME);

function toCamelCase(str) {
  return str.replace(/^([A-Z])|[\s-_](\w)/g, function (match, p1, p2) {
    if (p2) {
      return p2.toUpperCase();
    }

    return p1.toLowerCase();
  });
}

function tmpl(str, context) {
  var result = str;

  log('templating ' + result + ' with context: ', context);

  if (result) {

    Object.keys(context).forEach(function (item) {
      result = result.replace('{{' + item + '}}', context[item]);
    });

    log('templated ' + result);
  }

  return result;
}

function $tmpl(element, context) {
  var $target = $(element);
  var templateString = $target.attr('data-text-template');

  log('templating [' + templateString + '] with context: ', context);
  var result = tmpl(templateString, context);

  $target.text(result);
}

/**
 * https://github.com/aishikaty/tiny-mustache
 * https://mustache.github.io/
 * @param  {String} template [description]
 * @param  {[type]} self     [description]
 * @param  {[type]} parent   [description]
 * @param  {[type]} invert   [description]
 * @return {[type]}          [description]
 */
function mustache(template, self, parent, invert) {
  var render = mustache;
  var output = "";
  var i;

  function get(ctx, path) {
    path = path.pop ? path : path.split(".");
    ctx = ctx[path.shift()] || "";
    return 0 in path ? get(ctx, path) : ctx;
  }

  self = Array.isArray(self) ? self : self ? [self] : [];
  self = invert ? 0 in self ? [] : [1] : self;

  for (i = 0; i < self.length; i++) {
    var childCode = '';
    var depth = 0;
    var inverted;
    var ctx = _typeof(self[i]) == "object" ? self[i] : {};
    ctx = Object.assign({}, parent, ctx);
    ctx[""] = { "": self[i] };

    template.replace(/([\s\S]*?)({{((\/)|(\^)|#)(.*?)}}|$)/g, function (match, code, y, z, close, invert, name) {
      if (!depth) {
        output += code.replace(/{{{(.*?)}}}|{{(!?)(&?)(>?)(.*?)}}/g, function (match, raw, comment, isRaw, partial, name) {
          return raw ? get(ctx, raw) : isRaw ? get(ctx, name) : partial ? render(get(ctx, name), ctx) : !comment ? new Option(get(ctx, name)).innerHTML : "";
        });
        inverted = invert;
      } else {
        childCode += depth && !close || depth > 1 ? match : code;
      }
      if (close) {
        if (! --depth) {
          name = get(ctx, name);
          if (/^f/.test(typeof name === 'undefined' ? 'undefined' : _typeof(name))) {
            output += name.call(ctx, childCode, function (template) {
              return render(template, ctx);
            });
          } else {
            output += render(childCode, name, ctx, inverted);
          }
          childCode = "";
        }
      } else {
        ++depth;
      }
    });
  }
  return output;
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/types.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isType = isType;
function isType(of) {
    return of.constructor.name.toLowerCase();
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/accept-cookie/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global $:true */


exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

var _store = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/store/store.js");

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MODULE_NAME = 'app.core/modules/accept-cookie';
var log = (0, _debug2.default)(MODULE_NAME);

var AcceptCookiePlugin = function () {
    function AcceptCookiePlugin(element, options) {
        _classCallCheck(this, AcceptCookiePlugin);

        this.element = element;
        this.options = options;
        this.$element = $(element);
        this.$trigger = this.$element.find(this.options.triggerSelector);
        this.store = options.store;
        if (typeof options.store === 'string') {
            this.store = window[options.store];
        }

        log('AcceptCookiePlugin', element);
        this.remember();
        this.watch();
    }

    _createClass(AcceptCookiePlugin, [{
        key: 'onClick',
        value: function onClick() {
            log('clicked', this.$element);
            this.accept();
        }
    }, {
        key: 'watch',
        value: function watch() {
            this.$trigger.on('click', this.onClick.bind(this));
        }
    }, {
        key: 'unwatch',
        value: function unwatch() {
            this.$trigger.off('click', this.onClick);
            log('unbound', this.$element);
        }
    }, {
        key: 'remember',
        value: function remember() {
            var state = this.store.read();
            if (state.includes(this.options.id)) {
                this.hide();
            } else {
                this.show();
            }
        }
    }, {
        key: 'hide',
        value: function hide() {
            this.$element.addClass(this.options.successClass);
        }
    }, {
        key: 'show',
        value: function show() {
            this.$element.removeClass(this.options.successClass);
        }
    }, {
        key: 'accept',
        value: function accept() {
            var _this = this;

            var url = this.options.endpointUrl + '?' + this.options.endpointParam + '=' + this.options.id;
            log('accepting', this.$element, url);
            $.ajax({
                url: url,
                success: function success() {
                    var id = _this.options.id;

                    _this.hide();
                    _this.store.save({ id: id });
                }
            }).done(function () {
                log('accepted', _this.$element, url);
            });
        }
    }]);

    return AcceptCookiePlugin;
}();

AcceptCookiePlugin.DEFAULTS = {
    endpointUrl: $('meta[name="site.cookiesApiEndpoint"]').attr('content'),
    endpointParam: 'guid',
    triggerSelector: 'button',
    successClass: 'accept-cookie--success',
    store: {
        read: function read() {
            return _store2.default.get('accept-cookie') || [];
        },
        save: function save(_ref) {
            var id = _ref.id;

            var state = this.read();
            state.push(id);
            _store2.default.set('accept-cookie', state);
        }
    }
};

(0, _plugin2.default)('acceptCookie', AcceptCookiePlugin);

function exec() {
    $(document).ready(function () {
        log('binding');
        $("[data-accept-cookie]").acceptCookie();
        log('bound');
    });
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/address-validation/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global $:true */


exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

var _googleMapsApi = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/services/google-maps-api/index.js");

var _googleMapsApi2 = _interopRequireDefault(_googleMapsApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = '[data-address-validation]';
var FORM_WRAPPER_SELECTOR = 'data-form-wrapper-element';
var ADDRESS_LINE_0_SELECTOR = '.address-line-0';
var PLUGIN_NAME = 'addressValidation';
var MODULE_NAME = 'app.core/modules/address-validation';
var log = (0, _debug2.default)(MODULE_NAME);

log('registerd');

var AddressValidation = function () {
  function AddressValidation(element, options) {
    _classCallCheck(this, AddressValidation);

    this.element = element;
    this.options = options;
    this.$element = $(element);
    this.$parentEl = $(this.$element.attr(FORM_WRAPPER_SELECTOR));
    this.$addressLine0 = this.$parentEl.find(ADDRESS_LINE_0_SELECTOR);
    this.isInitiated = false;
    this.hasWaited = false;
    this.inputElement = document.getElementById(options.fieldId);

    log('construct', element);
    this.preventSubmit();
    this.watchGoogleMapApiError();
    this.checkForInit();
    this.initGoogleMaps();
  }

  _createClass(AddressValidation, [{
    key: 'initGoogleMaps',
    value: function initGoogleMaps() {
      var _this = this;

      _googleMapsApi2.default.then(function (google) {
        log('googleMapsApiPromise');
        _this.google = google;
        _this.init();
        _this.isInitiated = true;
      }).catch(function (reason) {
        if (typeof window.google !== 'undefined') {
          console.log('googleMapsApiPromise timeout. Setting from window.');
          _this.google = window.google;
          _this.init();
          _this.isInitiated = true;
        }
      });
    }
  }, {
    key: 'watchGoogleMapApiError',
    value: function watchGoogleMapApiError() {
      var oldError = console.error;
      // Stops the input field from being disabled if issue with API
      var $element = this.$element;
      console.error = function (message) {
        if (message.toLowerCase().includes("google maps api error")) {
          $element.removeAttr('disabled');
          $element.attr('placeholder', '');
          $element.removeAttr('style', '');
          $element.parent().find('.field-validation-valid').hide();
        }

        oldError.apply(console, arguments);
      };
    }
  }, {
    key: 'preventSubmit',
    value: function preventSubmit() {

      if (this.$element.closest('form').length) {
        log('preventSubmit.enabled [Preventing form submission on ENTER press.]');

        this.$element.on('keypress', function (event) {
          if (event.keyCode === 13) {
            event.preventDefault();
            log('preventSubmit.keypress', event.keyCode);
          }
        });
      }
    }
  }, {
    key: 'checkForInit',
    value: function checkForInit() {
      var mod = this;
      setTimeout(function () {
        mod.hasWaited = true;
      }, 2000);

      this.$element.on('focus', function () {
        if (!mod.isInitiated && mod.hasWaited) {
          mod.initGoogleMaps();
        }
      });
    }
  }, {
    key: 'init',
    value: function init() {
      this.element.includedRegionCodes = [this.options.countryCode];

      this.element.addEventListener('gmp-select', this.fillInAddress.bind(this));

      log('init');
    }
  }, {
    key: 'fillInAddress',
    value: function fillInAddress(event) {
      var place = event.placePrediction.toPlace();
      place.fetchFields({
        fields: ['formattedAddress', 'location', 'addressComponents']
      }).then(this.fillInAddressAfterFetch.bind(this, place));
    }
  }, {
    key: 'fillInAddressAfterFetch',
    value: function fillInAddressAfterFetch(place) {
      var elementVal = this.$element.val();
      log('fillInAddress', place);
      this.$element.trigger({ type: 'place_selected', place: place });
      for (var component in this.options.componentForm) {
        var compElement = this.$parentEl.find('.' + component);
        if (typeof compElement !== 'undefined' && compElement.length > 0) {
          compElement.val('');
          compElement.attr('disabled', false);
        }
      }

      var addressLine0 = '';
      var addressLine1 = '';
      var premise = '';
      var subpremise = '';
      var route = '';
      var postBox = '';
      var postalTown = '';
      var administrative_area_level_2 = '';
      var locality = '';
      var fullAddress = place.formattedAddress;

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = place.addressComponents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var addressComponent = _step.value;

          var addressType = addressComponent.types[0];
          var _compElement = this.$parentEl.find('.' + addressType);

          if (addressType == 'post_box') {
            postBox = addressComponent[this.options.componentForm['post_box']];
          }
          if (addressType == 'premise') {
            premise = addressComponent[this.options.componentForm['premise']];
          }
          if (addressType == 'subpremise') {
            subpremise = addressComponent[this.options.componentForm['subpremise']];
          }
          if (addressType == 'street_number') {
            addressLine1 = addressLine1.length == 0 ? addressComponent[this.options.componentForm['street_number']] : addressLine1;
          }
          if (addressType == 'route') {
            route = addressComponent[this.options.componentForm['route']];

            // Retain unit numbers entered in form.
            var regex = RegExp('^(.*)' + route.split(' ', 1)[0]),
                result = regex.exec(elementVal);

            if (Array.isArray(result)) {
              addressLine1 = result[1];
            }
          }
          if (addressType == 'postal_town') {
            postalTown = addressComponent[this.options.componentForm['postal_town']];
          }
          if (addressType == 'locality' || addressType == 'colloquial_area') {
            locality = addressComponent[this.options.componentForm['locality']];
          }
          if (addressType == 'administrative_area_level_2') {
            administrative_area_level_2 = addressComponent[this.options.componentForm['administrative_area_level_2']];
          }
          if (this.options.componentForm[addressType] && typeof _compElement !== 'undefined' && _compElement.length > 0) {
            var val = addressComponent[this.options.componentForm[addressType]];
            _compElement.val(val);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var latitudeElement = this.$parentEl.find('.latitude');
      var longitudeElement = this.$parentEl.find('.longitude');
      if (typeof latitudeElement !== 'undefined' && latitudeElement.length > 0) {
        latitudeElement.val(place.location.lat());
      }
      if (typeof longitudeElement !== 'undefined' && longitudeElement.length > 0) {
        longitudeElement.val(place.location.lng());
      }

      if (locality.length == 0) {
        locality = postalTown;
      }
      if (locality.length == 0) {
        locality = administrative_area_level_2;
      }

      var localityEl = this.$parentEl.find('.locality');
      if (typeof localityEl !== 'undefined') {
        localityEl.val(locality);
      }
      var add0 = subpremise.length > 0 ? subpremise + ' ' : '';
      add0 = add0.length > 0 ? add0 : addressLine0;
      add0 = add0.trim();

      var add1 = postBox.length > 0 ? 'PO BOX ' + postBox + ' ' : '';
      add1 += premise.length > 0 ? premise + ' ' : '';
      add1 += addressLine1.length > 0 ? addressLine1 + ' ' : '';
      add1 += route;
      add1 = add1.trim();

      if (typeof this.$addressLine0 !== 'undefined' && this.$addressLine0.length > 0) {
        this.$addressLine0.val(add0);
      }

      if (add1.length > 0) {
        this.inputElement.value = add1;
      } else {
        this.inputElement.value = fullAddress;
      }
      $(this.inputElement).trigger('change');

      $(document).trigger('address-validation-complete');
    }
  }]);

  return AddressValidation;
}();

AddressValidation.DEFAULTS = {
  componentForm: {
    post_box: 'longText',
    premise: 'longText',
    subpremise: 'longText',
    street_number: 'shortText',
    sublocality_level_1: 'shortText',
    route: 'longText',
    locality: 'longText',
    administrative_area_level_1: 'shortText',
    administrative_area_level_2: 'shortText',
    country: 'shortText',
    postal_code: 'shortText',
    postal_town: 'shortText'
  },
  countryCode: $('meta[name="site.countryCode"]').attr('content')
};

(0, _plugin2.default)(PLUGIN_NAME, AddressValidation);

function exec() {
  $(document).ready(function () {
    $(ELEMENT_SELECTOR)[PLUGIN_NAME]();
  });
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/ajax-save-on-change/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global $:true */


exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = '[data-ajax-save-on-change]';
var PLUGIN_NAME = 'ajaxSaveOnChange';
var MODULE_NAME = 'app.core/modules/ajax-save-on-change';
var log = (0, _debug2.default)(MODULE_NAME);

log('registerd');

var AjaxSaveOnChange = function () {
    function AjaxSaveOnChange(element, options) {
        _classCallCheck(this, AjaxSaveOnChange);

        this.element = element;
        this.options = options;
        this.$element = $(element);
        this.value = this.$element.val();
        this.initial = this.value;
        this.endpointUrl = $('meta[name="site.' + this.$element.attr(this.options.endpointMethodAttr) + '"]').attr('content');
        this.$element.on('change', this.change.bind(this));

        log('AddToQuotePlugin', element);
    }

    _createClass(AjaxSaveOnChange, [{
        key: 'change',
        value: function change() {
            this.value = this.$element.val();
            log('change', this.$element, this.value, this.initial);

            if (this.isDirty) {
                this.submit();
            }
        }
    }, {
        key: 'submit',
        value: function submit() {
            this.inputValue = this.value;
            log('submitted', this.$element);
            this.$element.attr('disabled', 'disabled');
            this.post();
        }
    }, {
        key: 'onSuccess',
        value: function onSuccess(result) {
            this.$element.removeAttr('disabled');

            if (typeof result.Success !== 'undefined' && result.Success) {} else {
                var errorList = typeof result.ValidationMessages !== 'undefined' ? result.ValidationMessages : Array();
                log('ajaxSaveOnChangeServerError', errorList);
                this.$element.val(this.initial);
            }
        }
    }, {
        key: 'post',
        value: function post() {
            var _this = this;

            var url = this.endpointUrl + '?' + this.options.endpointParam + '=' + this.inputValue;

            var token = $('#__AjaxAntiForgeryForm input[name="__RequestVerificationToken"]').val();
            log('accepting', this.$element, url);
            $.ajax({
                url: url,
                method: 'post',
                data: {
                    __RequestVerificationToken: token
                },
                success: function success(result) {
                    _this.onSuccess(result);
                },
                error: function error(e) {
                    log('ajaxSaveOnChangeAjaxError', e);
                    _this.$element.removeAttr('disabled');
                    _this.$element.val(_this.initial);
                }
            }).done(function () {
                log('accepted', _this.$element, url);
            });
        }
    }, {
        key: 'isDirty',
        get: function get() {
            var yesno = this.initial !== this.value;
            log('isDirty', this.$element, yesno);

            return yesno;
        }
    }]);

    return AjaxSaveOnChange;
}();

AjaxSaveOnChange.DEFAULTS = {
    endpointMethodAttr: 'data-endpoint-method',
    endpointParam: 'notes',
    submitErrorClassname: 'submit-error'
};

(0, _plugin2.default)(PLUGIN_NAME, AjaxSaveOnChange);

function exec() {
    $(document).ready(function () {
        $(ELEMENT_SELECTOR)[PLUGIN_NAME]();
    });
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/ajax-save-on-check/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global $:true */


exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = '[data-ajax-save-on-check]';
var PLUGIN_NAME = 'ajaxSaveOnCheck';
var MODULE_NAME = 'app.core/modules/ajax-save-on-check';
var log = (0, _debug2.default)(MODULE_NAME);

log('registerd');

var AjaxSaveOnCheck = function () {
	function AjaxSaveOnCheck(element, options) {
		_classCallCheck(this, AjaxSaveOnCheck);

		this.element = element;
		this.options = options;
		this.$element = $(element);
		this.isChecked = this.$element.is(':checked');
		this.endPointParam = this.$element.attr('name');
		this.endpointUrl = $('meta[name="site.' + this.$element.attr(this.options.endpointMethodAttr) + '"]').attr('content');
		this.$element.on('click', this.check.bind(this));
	}

	_createClass(AjaxSaveOnCheck, [{
		key: 'check',
		value: function check() {
			this.isChecked = this.$element.is(':checked');
			log('change', this.$element, this.isChecked, this.initial);
			this.submit();
		}
	}, {
		key: 'submit',
		value: function submit() {
			this.inputValue = this.isChecked ? "1" : "0";
			log('submitted', this.$element);
			this.$element.attr('disabled', 'disabled');
			this.post();
		}
	}, {
		key: 'onSuccess',
		value: function onSuccess(result) {
			this.$element.removeAttr('disabled');

			if (typeof result.Success !== 'undefined' && result.Success) {} else {
				var errorList = typeof result.ValidationMessages !== 'undefined' ? result.ValidationMessages : Array();
				log('AjaxSaveOnCheckServerError', errorList);
				this.$element.val(this.initial);
			}
		}
	}, {
		key: 'post',
		value: function post() {
			var _this = this;

			var url = this.endpointUrl + '?' + this.endPointParam + '=' + this.inputValue;

			var token = $('#__AjaxAntiForgeryForm input[name="__RequestVerificationToken"]').val();
			log('accepting', this.$element, url);
			$.ajax({
				url: url,
				method: 'post',
				data: {
					__RequestVerificationToken: token
				},
				success: function success(result) {
					_this.onSuccess(result);
				},
				error: function error(e) {
					log('AjaxSaveOnCheckAjaxError', e);
					_this.$element.removeAttr('disabled');
					_this.$element.val(_this.initial);
				}
			}).done(function () {
				log('accepted', _this.$element, url);
			});
		}
	}]);

	return AjaxSaveOnCheck;
}();

AjaxSaveOnCheck.DEFAULTS = {
	endpointMethodAttr: 'data-endpoint-method',
	submitErrorClassname: 'submit-error'
};

(0, _plugin2.default)(PLUGIN_NAME, AjaxSaveOnCheck);

function exec() {
	$(document).ready(function () {
		$(ELEMENT_SELECTOR)[PLUGIN_NAME]();
	});
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/ajax-validate/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MODULE_NAME = 'app.core/modules/ajax-validate';
var log = (0, _debug2.default)(MODULE_NAME);

var ELEMENT_SELECTOR = '[data-ajax-validate]';
var CONTAINER_SELECTOR = '[data-ajax-container]';
var PROGRESS_CLASS = 'has-progress';

var AjaxValidate = function () {
    function AjaxValidate(element, options) {
        _classCallCheck(this, AjaxValidate);

        this.element = element;
        this.options = options;
        this.$element = $(element);
        this.$submitButton = $('[type="submit"]', element);
        log('AjaxValidate', element, options);
        this.watch();
    }

    _createClass(AjaxValidate, [{
        key: 'onSubmit',
        value: function onSubmit(event) {
            event.preventDefault();

            var form = this.$element;
            this.$submitButton.attr('disabled', 'disabled').addClass(PROGRESS_CLASS);

            $.ajax({
                type: 'POST',
                url: form[0].action,
                data: form.serialize()
            }).done(function (result, status, xhr) {
                var contentType = xhr.getResponseHeader('content-type') || '';
                var container = form.closest(CONTAINER_SELECTOR);
                var context = container.parent();

                if (contentType.indexOf('json') > -1) {
                    document.location = result.ReturnUrl;
                } else {
                    container.replaceWith($(result));

                    //  Rebind newly inserted form
                    context.find(ELEMENT_SELECTOR).ajaxValidate({ reloaded: true });

                    $(document).trigger('async_update', context.find(ELEMENT_SELECTOR));
                }
            }).error(function () {
                log(arguments);
                this.$submitButton.removeClass(PROGRESS_CLASS).removeAttr('disabled');
            });
        }
    }, {
        key: 'watch',
        value: function watch() {
            this.$element.on('submit.ajaxvalidate', this.onSubmit.bind(this));
            log('bound', this.element);
        }
    }, {
        key: 'unwatch',
        value: function unwatch() {
            this.$element.off('.ajaxvalidate');
            log('unbound', this.element);
        }
    }]);

    return AjaxValidate;
}();

AjaxValidate.DEFAULTS = {};

(0, _plugin2.default)('ajaxValidate', AjaxValidate);

function exec() {
    $(document).ready(function () {
        log('binding');
        $(ELEMENT_SELECTOR).ajaxValidate();
        log('bound');
    });
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/analytics-trigger/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global $:true dataLayer:true */
/**
 * Analytics Trigger
 *
 * Send google analytics on element events.
 *
 * @example
 *    <input
 *        type="radio"
 *        data-analytics-trigger
 *        data-analytics-trigger-on="click"
 *        data-analytics-trigger-event-name="checkboxClicked"
 *        data-analytics-trigger-some-value="foo"
 *        data-analytics-trigger-some-other-value="bar"
 *        data-analytics-trigger-yet-another-value="baz">
 *
 *    <input
 *        type="search"
 *        data-analytics-trigger
 *        data-analytics-trigger-on="click"
 *        data-analytics-trigger-extract-value-as="searchTerm"
 *        data-analytics-trigger-event-name="checkboxClicked">
 */

exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = '[data-analytics-trigger]';
var MODULE_NAME = 'app.core/modules/analytics-trigger';
var log = (0, _debug2.default)(MODULE_NAME);
var ZERO = 0;

var AnalyticsTriggerPlugin = function () {
    function AnalyticsTriggerPlugin(element, options) {
        _classCallCheck(this, AnalyticsTriggerPlugin);

        this.element = element;
        this.options = options;
        this.$element = $(element);
        this.watching = null;
        this.$nodeType = this.$element.get(ZERO).nodeType;
        this.isFormField = ['input', 'textarea', 'select', 'button'].includes(this.$nodeType);
        log('AnalyticsTriggerPlugin', element);

        this.watch();
        log('ready', this.$element);
    }

    _createClass(AnalyticsTriggerPlugin, [{
        key: 'watch',
        value: function watch() {
            this.watching = this.$element.on(this.options.on, this.trigger.bind(this));
            log('watching', this.$element);
        }
    }, {
        key: 'unwatch',
        value: function unwatch() {
            this.$element.off(this.watching);
            log('unwatched', this.$element);
        }
    }, {
        key: 'trigger',
        value: function trigger() {
            var _this = this;

            log('trigger');
            var data = Object.keys(this.options).filter(function (key) {
                return !['on', 'extractValueAs'].includes(key);
            }).reduce(function (result, key) {
                result[key] = _this.options[key];

                return result;
            }, {});

            if (this.isFormField && this.options.extractValueAs) {
                data[this.options.extractValueAs] = this.$element.val();
            }

            log('trigger.data ' + JSON.stringify({ data: data }));
            dataLayer.push(data);
        }
    }]);

    return AnalyticsTriggerPlugin;
}();

AnalyticsTriggerPlugin.DEFAULTS = {
    on: "click",
    event: null,
    extractValueAs: null
};

(0, _plugin2.default)('analyticsTrigger', AnalyticsTriggerPlugin);

function exec() {
    $(document).ready(function () {
        log('binding');
        $(ELEMENT_SELECTOR).analyticsTrigger();
        log('bound');
    });
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/available-colour-swatches/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global $:true */


exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MODULE_NAME = 'app.core/modules/available-colour-swatches';
var log = (0, _debug2.default)(MODULE_NAME);
var ELEMENT_SELECTOR = '[data-available-colour-swatches]';
var QUOTE_ONLY_SELECTOR = '[data-product-detail-page-is-quote-only]';
var QUOTE_ONLY_ATTR = 'data-product-detail-page-is-quote-only';
var SELECT_FIELD_SELECTOR = '[data-colour-list]';
var IDENTIFIER_SELECTOR = '[data-identifier]';
var IDENTIFIER = 'data-identifier';

var AvailableColourSwatches = function () {
	function AvailableColourSwatches(element, options) {
		_classCallCheck(this, AvailableColourSwatches);

		this.element = element;
		this.options = options;
		this.$element = $(element);
		this.$colourLists = $(SELECT_FIELD_SELECTOR);
		this.$colourSwatches = $(IDENTIFIER_SELECTOR);
		this.isQuoteOnly = $(QUOTE_ONLY_SELECTOR).attr(QUOTE_ONLY_ATTR) == 'true';
		log('AvailableColourSwatches', element);
		this.init();
	}

	_createClass(AvailableColourSwatches, [{
		key: 'init',
		value: function init() {
			if (this.$colourLists.length > 0) {
				var allHexes = new Array();
				for (var i = 0; i < this.$colourLists.length; i++) {
					var list = this.$colourLists[i];
					var hexes = $(list).find(IDENTIFIER_SELECTOR);
					for (var j = 0; j < hexes.length; j++) {
						var hex = $(hexes[j]).attr(IDENTIFIER);
						if (allHexes.indexOf(hex) < 0 && hex.length > 0) {
							allHexes.push(hex);
						}
					}
				}
				var numberHidden = 0;
				for (var i = 0; i < this.$colourSwatches.length; i++) {
					var hexVal = $(this.$colourSwatches[i]).attr(IDENTIFIER);
					if (allHexes.indexOf(hexVal) < 0) {
						$(this.$colourSwatches[i]).parent().hide();
						numberHidden++;
					}
				}

				if (numberHidden == this.$colourSwatches.length) {
					this.$element.parent().hide();
				}
			}
			// STRONE-762 - if no colour codes, don't show colour swatches
			// STRONE-769 - if quote only don't hide the colour swatches
			else if (!this.isQuoteOnly) {
					this.$element.parent().hide();
				}
		}
	}]);

	return AvailableColourSwatches;
}();

AvailableColourSwatches.DEFAULTS = {};

(0, _plugin2.default)('availableColourSwatches', AvailableColourSwatches);

function exec() {
	$(document).ready(function () {
		log('binding');
		$(ELEMENT_SELECTOR).availableColourSwatches();
		log('bound');
	});
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/breadcrumbs/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Assigned Dependencies

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.exec = exec;
function exec() {
	$(document).ready(function () {
		$(window).resize(moveBreadcrumbs);
		moveBreadcrumbs();
		setupBreadcrumbs();
	});
}

function moveBreadcrumbs() {
	var listHeight = 'auto',
	    listItemHeight = 'auto';
	var breadcrumbs = $('.breadcrumbs-outer').detach();
	var desktopContainer = $('.breadcrumbs-container__content');
	var mobileContainer = $('.breadcrumbs-container__page-header');
	var isMobile = $(mobileContainer).is(':visible');
	if (isMobile) {
		$(mobileContainer).append(breadcrumbs);
		$('.breadcrumbs-trigger').each(function () {
			listHeight = $('.breadcrumbs-outer').find('.breadcrumbs').outerHeight();
			listItemHeight = $('.breadcrumbs-outer').find('.breadcrumbs > li:last-child').outerHeight();
			toggleBreadcrumbs($(this), true, listHeight, listItemHeight);
		});
	} else {
		$(desktopContainer).append(breadcrumbs);
		$('.breadcrumbs-trigger').each(function () {
			listHeight = 'auto';
			listItemHeight = 'auto';
			toggleBreadcrumbs($(this), true, listHeight, listItemHeight);
		});
	}
}

function setupBreadcrumbs() {
	var listHeight = 'auto',
	    listItemHeight = 'auto';
	var mobileContainer = $('.breadcrumbs-container__page-header');
	var isMobile = $(mobileContainer).is(':visible');
	if (isMobile) {
		listHeight = $('.breadcrumbs-outer').find('.breadcrumbs').outerHeight();
		listItemHeight = $('.breadcrumbs-outer').find('.breadcrumbs > li:last-child').outerHeight();
	}
	$(document).on('menu-opened-overlay-clicked', function () {
		toggleBreadcrumbs($('.breadcrumbs-trigger'), true, listHeight, listItemHeight);
	});

	$(document).on('hide-main-menu-sub-panels', function () {
		toggleBreadcrumbs($('.breadcrumbs-trigger'), true, listHeight, listItemHeight);
	});

	$('.breadcrumbs-trigger').bind('click', function (e) {
		e.preventDefault();
		$('.breadcrumbs-outer').toggleClass('active');
		toggleBreadcrumbs($(this), !$('.breadcrumbs-outer').hasClass('active'), listHeight, listItemHeight);
	});
}

function toggleBreadcrumbs(element, hide, listHeight, listItemHeight) {
	if (!hide) {
		$('.breadcrumb-opened-overlay').addClass('active');
		$(element).closest('.breadcrumbs-inner').height(listHeight);
		$(element).find('.icon--more').hide();
		$(element).find('.icon--less').show();
	} else {
		$('.breadcrumb-opened-overlay').removeClass('active');
		$(element).closest('.breadcrumbs-inner').height(listItemHeight);
		$(element).find('.icon--more').show();
		$(element).find('.icon--less').hide();
		$('.breadcrumbs-outer').removeClass('active');
	}
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/click-tracking/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global $:true */


exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = '[data-click-tracking]';
var TRACK_ID_ATTR = 'data-click-tracking-trackid';
var HIT_ID_ATTR = 'data-click-tracking-hitid';
var HIT_QUERY_ATTR = 'data-click-tracking-hitquery';
var PLUGIN_NAME = 'clickTracking';
var MODULE_NAME = 'app.core/modules/click-tracking';
var log = (0, _debug2.default)(MODULE_NAME);

log('registerd');

var ClickTracking = function () {
	function ClickTracking(element, options) {
		_classCallCheck(this, ClickTracking);

		this.element = element;
		this.options = options;
		this.$element = $(element);
		this.hitId = this.$element.attr(HIT_ID_ATTR);
		this.query = this.$element.attr(HIT_QUERY_ATTR);
		this.trackId = this.$element.attr(TRACK_ID_ATTR);
		log('construct', element);

		this.watch();
	}

	_createClass(ClickTracking, [{
		key: 'sendClickTrackingData',
		value: function sendClickTrackingData() {
			var _this = this;

			var url = this.options.url + '?' + this.options.endpointParam1 + '=' + this.hitId + '&' + this.options.endpointParam2 + '=' + this.query + '&' + this.options.endpointParam3 + '=' + this.trackId;
			$.ajax({
				url: url,
				method: 'get',
				success: function success(result) {},
				error: function error(e) {
					log('sendClickTrackingData', e);
				}
			}).done(function () {
				log('accepted', _this.$element, url);
			});
		}
	}, {
		key: 'watch',
		value: function watch() {
			var module = this;
			this.$element.on('click', function (e) {
				module.sendClickTrackingData();
			});
		}
	}]);

	return ClickTracking;
}();

ClickTracking.DEFAULTS = {
	url: $('meta[name="site.clickTrackingApiEndpoint"]').attr('content'),
	endpointParam1: 'hitId',
	endpointParam2: 'query',
	endpointParam3: 'trackId'
};

(0, _plugin2.default)(PLUGIN_NAME, ClickTracking);

function exec() {
	$(document).ready(function () {
		$(ELEMENT_SELECTOR)[PLUGIN_NAME]();
	});
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/collapsible/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.exec = exec;

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

var _selectors = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/selectors.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global $:true */
var ELEMENT_SELECTOR = '[data-collapsible]';
var PLUGIN_NAME = 'collapsible';

function exec() {
	_selectors.onAvailable.ready(ELEMENT_SELECTOR, function (element) {
		__webpack_require__.e/* import() */("plugin--collapsible").then(__webpack_require__.bind(null, "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/collapsible/collapsible-v1.1.0.js")).then(function (module) {
			(0, _plugin2.default)(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/colour-picker/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'app.core/modules/colour-picker';
var log = (0, _debug2.default)(MODULE_NAME);

function exec() {
    $('.colorPicker').each(function () {
        var $component = $(this);
        log($component);
        $component.find('.colour-box').on('mouseover', function () {
            var colour = $(this).siblings('.colourName').text();
            log(this, { colour: colour });
            $component.attr('data-colour-name', colour);
        }).on('mouseout', function () {
            $component.attr('data-colour-name', '');
        });
    });
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/commerce-analytics-trigger/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global $:true dataLayer:true */
/**
 * Analytics Trigger
 *
 * Send google analytics on element events.
 *
 * @example
 *    <input
 *        type="button"
 *         data-commerce-analytics-trigger
           data-commerce-analytics-trigger-on="click"
           data-commerce-analytics-trigger-groupname="products"
           data-commerce-analytics-trigger-event="productClick"
           data-commerce-analytics-trigger-action="click"
           data-commerce-analytics-trigger-name="#40 Flat fold handle bag"
           data-commerce-analytics-trigger-id="C486S0054"
           data-commerce-analytics-trigger-brand="Stratco"
           data-commerce-analytics-trigger-price="232.00"
           data-commerce-analytics-trigger-category="Carry Bags">
 *
 *    <input
 *        type="button"
 *         data-commerce-analytics-trigger
           data-commerce-analytics-trigger-on="click"
           data-commerce-analytics-trigger-groupname="products"
           data-commerce-analytics-trigger-event="productClick"
           data-commerce-analytics-trigger-action="click"
           data-commerce-analytics-trigger-name="#40 Flat fold handle bag"
           data-commerce-analytics-trigger-id="C486S0054"
           data-commerce-analytics-trigger-brand="Stratco"
           data-commerce-analytics-trigger-price="232.00"
           data-commerce-analytics-trigger-category="Carry Bags"
           data-commerce-analytics-trigger-dynamic="quantity:#quantity:1">

    Dynamic Format
    1. Field Name
    2. Field selector
    3. Default value if selector value is empty (optional)
* @example
    data-commerce-analytics-trigger-dynamic="quantity:#quantity:1"
 */

exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = '[data-commerce-analytics-trigger]';
var MODULE_NAME = 'app.core/modules/commerce-analytics-trigger';
var log = (0, _debug2.default)(MODULE_NAME);
var ZERO = 0;

var CommerceAnalyticsTriggerPlugin = function () {
    function CommerceAnalyticsTriggerPlugin(element, options) {
        _classCallCheck(this, CommerceAnalyticsTriggerPlugin);

        this.element = element;
        this.options = options;
        this.$element = $(element);
        this.watching = null;
        this.$nodeType = this.$element.get(ZERO).nodeType;
        this.isFormField = ['input', 'textarea', 'select', 'button'].includes(this.$nodeType);
        log('CommerceAnalyticsTriggerPlugin', element);

        this.watch();
        log('ready', this.$element);
    }

    _createClass(CommerceAnalyticsTriggerPlugin, [{
        key: 'watch',
        value: function watch() {
            this.watching = this.$element.on(this.options.on, this.trigger.bind(this));
            log('watching', this.$element);
        }
    }, {
        key: 'unwatch',
        value: function unwatch() {
            this.$element.off(this.watching);
            log('unwatched', this.$element);
        }
    }, {
        key: 'trigger',
        value: function trigger() {
            var _this = this;

            log('trigger');
            var dataSet = {
                'event': this.options.event,
                'ecommerce': {}
            };

            var groupname = {};
            dataSet.ecommerce[this.options.action] = groupname;
            dataSet.ecommerce[this.options.action][this.options.groupname] = Array();

            var data = Object.keys(this.options).filter(function (key) {
                return !['on', 'extractValueAs', 'event', 'action', 'groupname'].includes(key);
            }).reduce(function (result, key) {
                if (key.length > 0) {
                    if (key == 'dynamic') {
                        var dynamicData = _this.options[key].split(':');
                        var fieldName = dynamicData.length > 0 ? dynamicData[0] : '';
                        var selector = dynamicData.length > 1 ? dynamicData[1] : '';
                        var defaultVal = dynamicData.length > 2 ? dynamicData[2] : '';

                        if (typeof $(selector) !== 'undefined') {
                            var selectedVal = $(selector).val();
                            result[fieldName] = selectedVal.length > 0 ? selectedVal : defaultVal;
                        }
                    } else {
                        result[key] = _this.options[key];
                    }
                }
                return result;
            }, {});

            dataSet.ecommerce[this.options.action][this.options.groupname].push(data);

            log('trigger.data ' + JSON.stringify({ dataSet: dataSet }));
            if (typeof dataLayer !== 'undefined') {
                dataLayer.push(dataSet);
            }
        }
    }]);

    return CommerceAnalyticsTriggerPlugin;
}();

CommerceAnalyticsTriggerPlugin.DEFAULTS = {
    on: "click",
    event: 'productClick',
    groupname: 'products',
    action: 'click'
};

(0, _plugin2.default)('commerceAnalyticsTrigger', CommerceAnalyticsTriggerPlugin);

function exec() {
    $(document).ready(function () {
        log('binding');
        $(ELEMENT_SELECTOR).commerceAnalyticsTrigger();
        log('bound');
    });
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/countdown-timer/component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.CountdownTimer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global $:true */
//import 'babel-polyfill';

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _index = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/countdown-timer/index.js");

var _objects = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/objects.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _debug2.default)(_index.MODULE_NAME);
var SECOND_ELEMENT_SELECTOR = '[data-coundown-timer-second]';
var MINUTE_ELEMENT_SELECTOR = '[data-coundown-timer-minute]';
var HOUR_ELEMENT_SELECTOR = '[data-coundown-timer-hour]';
var DAY_ELEMENT_SELECTOR = '[data-coundown-timer-day]';

var SECOND = 1000;
var MINUTE = SECOND * 60;
var HOUR = MINUTE * 60;
var DAY = HOUR * 24;

var CountdownTimer = exports.CountdownTimer = function () {
	function CountdownTimer(element, options) {
		_classCallCheck(this, CountdownTimer);

		this.element = element;
		this.$element = $(element);
		this.options = options;

		log((0, _objects.collectElementOptions)(_index.PLUGIN_NAME, this.$element.data()));

		// end-date required to be in the format
		// yyyy-MM-ddTHH:mm:ssZ
		this.end = new Date(this.options.endDate);
		this.timeReached = false;

		// start ticking
		this.timer = setInterval(this.onTick.bind(this), 1000);
		// do the first tick now
		this.onTick();
	}

	_createClass(CountdownTimer, [{
		key: 'onEndReached',
		value: function onEndReached() {
			clearInterval(this.timer);
			this.timeReached = true;
			this.render();
		}
	}, {
		key: 'onTick',
		value: function onTick() {
			var now = new Date();
			var distance = this.end - now;
			if (distance < 0) {
				this.onEndReached();
				return;
			}

			var days = Math.floor(distance / DAY);
			var hours = Math.floor(distance % DAY / HOUR);
			var minutes = Math.floor(distance % HOUR / MINUTE);
			var seconds = Math.floor(distance % MINUTE / SECOND);

			this.render(days, hours, minutes, seconds);
		}
	}, {
		key: 'render',
		value: function render(days, hours, minutes, seconds) {
			// render the time reached message if time has been reached
			if (this.timeReached) {
				$(this.options.timeReachedSelector).removeAttr('hidden');
				// hide the countdown element
				this.$element.attr('hidden', '');
				return;
			}

			var dayStr = '' + days;
			// pad the time values with 0s
			var hourStr = hours < 10 ? '0' + hours : '' + hours;
			var minuteStr = minutes < 10 ? '0' + minutes : '' + minutes;
			var secondStr = seconds < 10 ? '0' + seconds : '' + seconds;

			this.$element.find(DAY_ELEMENT_SELECTOR).text(dayStr);
			this.$element.find(HOUR_ELEMENT_SELECTOR).text(hourStr);
			this.$element.find(MINUTE_ELEMENT_SELECTOR).text(minuteStr);
			this.$element.find(SECOND_ELEMENT_SELECTOR).text(secondStr);
		}
	}]);

	return CountdownTimer;
}();

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/countdown-timer/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.MODULE_NAME = exports.PLUGIN_NAME = exports.ELEMENT_SELECTOR = undefined;
exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global $:true */
var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-countdown-timer]';
var PLUGIN_NAME = exports.PLUGIN_NAME = 'countdownTimer';
var MODULE_NAME = exports.MODULE_NAME = 'module/coundown-timer';
var log = (0, _debug2.default)(MODULE_NAME);

function exec() {
	var elements = $(ELEMENT_SELECTOR).toArray();
	if (!elements || !elements.length) {
		return;
	}

	var _require = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/countdown-timer/component.js"),
	    CountdownTimer = _require.CountdownTimer;

	(0, _plugin2.default)(PLUGIN_NAME, CountdownTimer);
	$(elements)[PLUGIN_NAME]();
	log('Initialized ' + PLUGIN_NAME);
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/country-modal/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
                                                                                                                                                                                                                                                                               * Handle country modal display
                                                                                                                                                                                                                                                                               * @author Oliver Boermans
                                                                                                                                                                                                                                                                               */

// Utilities


exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'core/modules/country-modal';
var log = (0, _debug2.default)(MODULE_NAME);

var MODAL_SELECTOR = '#country-select-modal';
var STORAGE_KEY = 'USER_CLOSED_COUNTRY_MODAL';

function isStorageAvailable() {
    if ((typeof sessionStorage === 'undefined' ? 'undefined' : _typeof(sessionStorage)) === 'object') {
        try {
            sessionStorage.setItem('sessionStorageTested', 1);
            sessionStorage.getItem('sessionStorageTested');
        } catch (error) {
            log('sessionStorage is unavailable');
            return false;
        }
        return true;
    }
    return false;
}

function registerClosed() {
    log('Modal closed');
    sessionStorage.setItem(STORAGE_KEY, 'true');
}

function hasUserClosedModal() {
    var value = sessionStorage.getItem(STORAGE_KEY);
    log(STORAGE_KEY, value);
    return value === 'true';
}

function openModal(modal) {
    modal.foundation('open');
}

function exec() {
    log('exec');
    $(function () {
        var $modal = $(MODAL_SELECTOR);

        //  Note modal may be ommitted server side cookie
        if (!$modal.length) {
            log('Modal is absent');
            return false;
        }

        //  if storage is not available open modal anyway
        if (isStorageAvailable() && !hasUserClosedModal()) {
            log('open modal');
            openModal($modal);
            $modal.on('closed.zf.reveal', registerClosed);
        } else if (!isStorageAvailable()) {
            openModal($modal);
        }
    });
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/custom-select/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global Loader:true $:true */
/**
 * Custom Select Field
 */

// Utilities


exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _mousetrap = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/mousetrap/mousetrap.js");

var _mousetrap2 = _interopRequireDefault(_mousetrap);

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

var _strings = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/strings.js");

var _objects = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/objects.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ZERO = 0;
function NOOP() {}
var MODULE_NAME = 'app.core/modules/custom-select';
var log = (0, _debug2.default)(MODULE_NAME);

var CustomSelectPlugin = function () {

    /**
     * [constructor description]
     * @param  {[type]} element [description]
     * @param  {[type]} options [description]
     * @return {[type]}         [description]
     */
    function CustomSelectPlugin(element, options) {
        _classCallCheck(this, CustomSelectPlugin);

        log('new instance', element, options);

        this.element = element;
        this.options = options;

        this.configure();

        this.$element = $(element);
        this.value = this.$element.attr('value');
        this.$children = this.$element.children('option');

        log('upgrading to custom select', this.$element, this.options);
        this.init();
    }

    /**
     * [configure description]
     * @return {[type]} [description]
     */


    _createClass(CustomSelectPlugin, [{
        key: 'configure',
        value: function configure() {
            if (this.options.itemTemplateSelector) {
                this.options.itemTemplate = $(this.options.itemTemplateSelector).text();
                log('Using item template', this.options.itemTemplate);
            }
        }

        /**
         * [init description]
         * @return {[type]} [description]
         */

    }, {
        key: 'init',
        value: function init() {
            var _this = this;

            /* Add classname to the original select field */
            this.$element.addClass(this.options.hiddenClassName);
            this.$element.addClass(this.options.formFIeldClassName);

            /**
            * Create some new elements
            */
            this.$wrapper = $('<div/>', {
                class: this.options.wrappingClassName + ' ' + this.options.annotateWrappingClasses
            });
            this.$select = $('<button/>', {
                class: this.options.inputFieldClassname
            });
            this.$list = $('<div />', {
                class: this.options.optionsListClassname
            });

            /**
            * Wrap select and insert into DOM
            */
            // wrap the new select with a wrapper
            this.$wrapper.insertAfter(this.$element).append(this.$select).append(this.$list).append(this.$element);

            // has lost it's DOM association, so we need to assign it again.
            // this.$wrapper = this.$select.parent(`.${this.options.wrappingClassName}`);
            // this.$list = this.$select.next(`.${this.options.optionsListClassname}`);

            // Create new custom styled options
            this.$children.each(function (index, element) {
                return _this.createItem(index, element);
            });

            // No interaction if only one option
            if (this.$children.length > 1) {
                this.bindEvents();
            }

            this.setDefaultOption();

            this.setSingleOptionState();
        }

        /**
         * Properties
         */

        /**
         * Custom Items collection
         * @return {Jquery Collection}
         */

    }, {
        key: 'bindEvents',


        /**
         * Events
         */
        value: function bindEvents() {
            $(document).on('click', this.hideAllCustomSelect.bind(this));
            _mousetrap2.default.bind('esc', this.hideAllCustomSelect.bind(this));
            this.$select.on('click', this.onSelectClick.bind(this));
            this.$element.on('click', this.onSelectClick.bind(this));

            if (this.options.disableOnEvent) {
                log('Listening for ' + this.options.disableOnEvent);
                $(document).on(this.options.disableOnEvent, this.onDisableEvent.bind(this));
            }

            // ugh
            var self = this;
            this.$wrapper.on('click', '.' + this.options.optionsListItemClassname, function (event) {
                self.onItemClick(event, this);
            });
        }
    }, {
        key: 'onSelectClick',
        value: function onSelectClick(event) {
            var _this2 = this;

            log('select clicked', this.$select);
            event.preventDefault();
            event.stopPropagation();

            $('.' + this.options.wrappingClassName + '.' + this.options.activeClassname).not(this.$wrapper).each(function (index, item) {
                $(item).removeClass(_this2.options.activeClassname);
            });

            this.$wrapper.toggleClass(this.options.activeClassname);
        }
    }, {
        key: 'onDisableEvent',
        value: function onDisableEvent(event, doEnable) {
            console.log('doEnable', doEnable);

            if (doEnable && this.$children.length > 1) {
                this.$select.removeAttr('disabled');
            } else {
                this.$select.attr('disabled', 'disabled');
            }
        }
    }, {
        key: 'onItemClick',
        value: function onItemClick(event, item) {
            var $item = $(item);
            var context = $item.data('context');
            event.stopPropagation();

            log('clicked item', $item);
            if (this.value !== $item.attr('rel')) {

                this.value = $item.attr('rel');
                this.$element.val(this.value);
                this.$element.trigger('change');
                this.setDisplayItem($item);
                if (context.href) {
                    log('navigating to custom select item href', context.href);
                    var page_y = $(window).scrollTop();
                    this.setProductDetailScrollPositionCookie(page_y);
                    window.location.href = context.href;
                }
            }

            this.$wrapper.removeClass(this.options.activeClassname);
        }
    }, {
        key: 'setProductDetailScrollPositionCookie',
        value: function setProductDetailScrollPositionCookie(scrollPos) {
            var cname = this.options.productDetailScrollCookieName;
            var cvalue = scrollPos;
            var d = new Date();
            d.setTime(d.getTime() + 1 * 24 * 60 * 60 * 1000);
            var expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }

        /**
         * Methods
         */

        /**
         * [createItem description]
         * @param  {[type]} index   [description]
         * @param  {[type]} element [description]
         * @return {[type]}         [description]
         */

    }, {
        key: 'createItem',
        value: function createItem(index, element) {
            var $item = $(element);
            var itemAttrs = (0, _objects.elementAttrtibutesToObject)($item,
            // filter fn
            function () {
                return true;
            },
            // attribute name transform fn
            function (name) {
                return (0, _strings.toCamelCase)(name.replace('data-', ''));
            });
            var isAvailable = typeof itemAttrs.available !== 'undefined' ? itemAttrs.available == 'True' : true;
            var unavailableClass = isAvailable ? "" : this.options.itemUnavailableClassname;
            var itemContext = Object.assign(itemAttrs, {
                text: $item.text(),
                labelclass: unavailableClass,
                index: index
            });

            var newItem = (0, _strings.mustache)(this.options.itemTemplate, itemContext);
            log('templated new item', this.options.itemTemplate, 'with context', itemContext, 'result', newItem);
            var $newItem = $(newItem);

            $newItem.attr('data-custom-select-item');
            $newItem.attr('rel', $item.val());
            $newItem.data('context', itemContext);
            $newItem.addClass(this.options.optionsListItemClassname);
            $newItem.appendTo(this.$list);
            log('Creating new item', this.$list);
        }

        /**
         * [setDefaultOption description]
         * Find the selected option or select the first one.
         */

    }, {
        key: 'setDefaultOption',
        value: function setDefaultOption() {
            var value = this.$element.attr('value');
            var values = Array.from(this.items).map(function (item) {
                return $(item).attr('rel');
            });
            var DefaultItemIndex = values.indexOf(value);

            log('setDefaultOption', { value: value, DefaultItemIndex: DefaultItemIndex, values: values });

            this.setDisplayItem(this.items.get(DefaultItemIndex || ZERO));
        }

        /**
         * [setSingleOptionState description]
         * Set button to disabled state if only one option
         */

    }, {
        key: 'setSingleOptionState',
        value: function setSingleOptionState() {
            if (this.$children.length === 1) {
                log('Single option only');
                this.$select.attr('disabled', 'disabled');
            }
        }

        /**
         * [setDisplayItem description]
         * @param {[type]} element [description]
         */

    }, {
        key: 'setDisplayItem',
        value: function setDisplayItem(element) {
            log('Setting display item', element);
            this.$select.html($(element).html());
        }

        /**
         * [hideAllCustomSelect description]
         * @return {[type]} [description]
         */

    }, {
        key: 'hideAllCustomSelect',
        value: function hideAllCustomSelect() {
            var _this3 = this;

            log('hiding all custom-selects');

            $('.' + this.options.wrappingClassName + '.' + this.options.activeClassname).data('focused', false).each(function (index, item) {
                $(item).removeClass(_this3.options.activeClassname);
            });
        }

        /**
         * [HighlightItem description]
         * @param {String} direction [description]
         */

    }, {
        key: 'highlightItem',
        value: function highlightItem() {
            var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'down';

            var $items = this.$list.children('.' + this.options.optionsListItemClassname);

            var current = $items.find('.' + options.optionsListItemFocusedClassname);
            $items.removeClass(this.options.optionsListItemFocusedClassname);

            log('moving focus ' + direction + ' from', current, 'between', $items);
            if (direction === 'down') {
                current = current.next();
            } else {
                current = current.prev();
            }

            log('focusing', current);
            current.addClass(this.options.optionsListItemFocusedClassname);
        }

        /**
         * [SelectItem description]
         */

    }, {
        key: 'selectItem',
        value: function selectItem() {
            if (this.isFocused) {
                this.items.find(':focus').trigger('click');
            }
        }
    }, {
        key: 'items',
        get: function get() {
            return this.$wrapper.find('.' + this.options.optionsListItemClassname);
        }

        /**
         * [isFocused description]
         * @return {Boolean} [description]
         */

    }, {
        key: 'isFocused',
        get: function get() {
            return this.$wrapper.is(this.options.activeClassname) || false;
        }
    }, {
        key: 'value',
        get: function get() {
            return this.$element.val();
        },
        set: function set(value) {
            return this.$element.val(value);
        }
    }]);

    return CustomSelectPlugin;
}();

CustomSelectPlugin.DEFAULTS = {
    wrappingClassName: 'custom-select',
    annotateWrappingClasses: '',
    hiddenClassName: 'is-hidden',
    formFieldClassName: 'custom-select__input',
    inputFieldClassname: 'custom-select__display',
    optionsListClassname: 'custom-select__list',
    optionsListItemClassname: 'custom-select__item',
    optionsListItemFocusedClassname: 'custom-select__item--focused',
    itemUnavailableClassname: 'custom-select__item-label--unavailable',
    activeClassname: 'custom-select--active',
    itemTemplate: '<div rel="{{rel}}"><span class="custom-select__item-inner"><span class="custom-select__item-label {{labelclass}}">{{text}}</span></span></div>',
    itemTemplateSelector: null,
    productDetailScrollCookieName: 'str001.ProductDetailScrollPosition',
    onSelectFn: NOOP
};

(0, _plugin2.default)('customSelect', CustomSelectPlugin);

function exec() {
    $(document).ready(function () {
        $('select[data-custom-select]').customSelect();
    });
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/disable-on-submit/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MODULE_NAME = 'app.core/modules/disable-on-submit';
var log = (0, _debug2.default)(MODULE_NAME);

var ELEMENT_SELECTOR = '[data-disable-on-submit]';
var PROGRESS_CLASS = 'has-progress';

var DisableOnSubmit = function () {
    function DisableOnSubmit(element, options) {
        _classCallCheck(this, DisableOnSubmit);

        this.element = element;
        this.options = options;
        this.$element = $(element);
        this.$submitButton = $('[type="submit"]', element);
        log('DisableOnSubmit', element, options);
        this.watch();
    }

    _createClass(DisableOnSubmit, [{
        key: 'onSubmit',
        value: function onSubmit(event) {
            var form = this.$element;
            this.$submitButton.attr('disabled', 'disabled').addClass(PROGRESS_CLASS);
        }
    }, {
        key: 'watch',
        value: function watch() {
            this.$element.on('submit.disableonsubmit', this.onSubmit.bind(this));
            log('bound', this.element);
        }
    }, {
        key: 'unwatch',
        value: function unwatch() {
            this.$element.off('.disableonsubmit');
            this.$submitButton.removeAttr('disabled').removeClass(PROGRESS_CLASS);
            log('unbound', this.element);
        }
    }]);

    return DisableOnSubmit;
}();

DisableOnSubmit.DEFAULTS = {};

(0, _plugin2.default)('disableOnSubmit', DisableOnSubmit);

function exec() {
    $(document).ready(function () {
        log('binding');
        $(ELEMENT_SELECTOR).disableOnSubmit();
        log('bound');
    });
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/dismiss/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global $:true */


exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MODULE_NAME = 'app.core/modules/dismiss';
var log = (0, _debug2.default)(MODULE_NAME);
var ELEMENT_ATTRIBUTE = 'data-dismiss';

var DismissPlugin = function () {
    function DismissPlugin(element, options) {
        _classCallCheck(this, DismissPlugin);

        this.element = element;
        this.options = options;
        this.$element = $(element);
        this.dismissTarget = this.$element.attr(ELEMENT_ATTRIBUTE);
        this.$dismissElement = $(this.dismissTarget);

        log('DismissPlugin', element);
        this.watch();
    }

    _createClass(DismissPlugin, [{
        key: 'onClick',
        value: function onClick() {
            log('clicked', this.$element);
            this.dismissTargetElement();
        }
    }, {
        key: 'watch',
        value: function watch() {
            this.$element.on('click', this.onClick.bind(this));
        }
    }, {
        key: 'unwatch',
        value: function unwatch() {
            this.$element.off('click', this.onClick);
            log('unbound', this.$element);
        }
    }, {
        key: 'dismissTargetElement',
        value: function dismissTargetElement() {
            this.$dismissElement.fadeOut();
        }
    }]);

    return DismissPlugin;
}();

DismissPlugin.DEFAULTS = {};

(0, _plugin2.default)('dismiss', DismissPlugin);

function exec() {
    $(document).ready(function () {
        log('binding');
        $("[data-dismiss]").dismiss();
        log('bound');
    });
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/exclusive-collapsible/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.exec = exec;

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

var _selectors = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/selectors.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global $:true */
var ELEMENT_SELECTOR = '[data-exclusive-collapsible]';
var PLUGIN_NAME = 'exclusiveCollapsible';

function exec() {
	_selectors.onAvailable.ready(ELEMENT_SELECTOR, function (element) {
		__webpack_require__.e/* import() */("plugin--exclusive-collapsible").then(__webpack_require__.bind(null, "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/exclusive-collapsible/exclusive-collapsible.js")).then(function (module) {
			(0, _plugin2.default)(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/express-job-widget-block/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global $:true dataLayer:true */
/**
 * Express Job Widget Block
 *
 *
 */

exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = '#expr3ss-jobs-widget';
var MODULE_NAME = 'app.core/modules/express-job-widget-block';
var log = (0, _debug2.default)(MODULE_NAME);
var ZERO = 0;
var SCRIPT = '<script src="https://developers.expr3ss.com/Files/js/widget.min.js" defer="true"></script>';

var ExpressJobWidgetBlock = function () {
    function ExpressJobWidgetBlock(element, options) {
        _classCallCheck(this, ExpressJobWidgetBlock);

        this.element = element;
        this.options = options;
        this.$element = $(element);
        this.$scriptContainer = $(this.options.scriptContainer);

        log('ExpressJobWidgetBlock', element);

        this.loadScript();

        log('ready', this.$element);
    }

    _createClass(ExpressJobWidgetBlock, [{
        key: 'loadScript',
        value: function loadScript() {
            if (typeof this.$scriptContainer !== 'undefined') {
                if (this.$scriptContainer.find('script').length == 0) {
                    this.$scriptContainer.html(SCRIPT);
                }
            }
        }
    }]);

    return ExpressJobWidgetBlock;
}();

ExpressJobWidgetBlock.DEFAULTS = {
    scriptContainer: '.express-job-widget-block-scripts'
};

(0, _plugin2.default)('expressJobWidgetBlock', ExpressJobWidgetBlock);

function exec() {
    $(document).ready(function () {
        log('binding');
        $(ELEMENT_SELECTOR).expressJobWidgetBlock();
        log('bound');
    });
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/facebook-feed-block/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global $:true dataLayer:true */
/**
 * Facebook Feed Block
 *
 *  For more Facebook plugin options see https://developers.facebook.com/docs/plugins/page-plugin
 *
 */

exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = '.fb-page';
var MODULE_NAME = 'app.core/modules/facebook-feed-block';
var log = (0, _debug2.default)(MODULE_NAME);
var ZERO = 0;
var SCRIPT = '<script defer="true"> \
    (function (d, s, id) { \
        var js, fjs = d.getElementsByTagName(s)[0]; \
        if (d.getElementById(id)) return; \
        js = d.createElement(s); \
        js.id = id; \
        js.src = "//connect.facebook.net/en_GB/sdk.js#xfbml=1&version=v2.12"; \
        fjs.parentNode.insertBefore(js, fjs); \
    }(document, "script", "facebook-jssdk")); \
</script>';

var FacebookFeedBlock = function () {
    function FacebookFeedBlock(element, options) {
        _classCallCheck(this, FacebookFeedBlock);

        this.element = element;
        this.options = options;
        this.$element = $(element);
        this.$scriptContainer = $(this.options.scriptContainer);

        log('FacebookFeedBlock', element);

        this.loadScript();

        log('ready', this.$element);
    }

    _createClass(FacebookFeedBlock, [{
        key: 'loadScript',
        value: function loadScript() {
            if (typeof this.$scriptContainer !== 'undefined') {
                if (this.$scriptContainer.find('script').length == 0) {
                    this.$scriptContainer.html(SCRIPT);
                }
            }
        }
    }]);

    return FacebookFeedBlock;
}();

FacebookFeedBlock.DEFAULTS = {
    scriptContainer: '.facebook-feed-block-scripts'
};

(0, _plugin2.default)('facebookFeedBlock', FacebookFeedBlock);

function exec() {
    $(document).ready(function () {
        log('binding');
        $(ELEMENT_SELECTOR).facebookFeedBlock();
        log('bound');
    });
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/field-toggle/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.exec = exec;

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

var _selectors = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/selectors.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global $:true */
var ELEMENT_SELECTOR = '[data-field-toggle]';
var PLUGIN_NAME = 'fieldToggle';

function exec() {
	_selectors.onAvailable.ready(ELEMENT_SELECTOR, function (element) {
		__webpack_require__.e/* import() */("plugin--field-toggle").then(__webpack_require__.bind(null, "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/field-toggle/field-toggle.js")).then(function (module) {
			(0, _plugin2.default)(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/forms/custom-form-container.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Custom Form Container
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @author Kate York
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

// Utilities


exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _debug2.default)('core/modules/forms/custom-form-container');

var ELEMENT_SELECTOR = '[data-custom-form-continer-block]';
var DOT_NAVIGATION_ELEMENT_SELECTOR = '[data-custom-form-dot-navigation]';
var PREV_BUTTON_ELEMENT_SELECTOR = '[data-f-navigation-previous]';
var SUBMIT_BUTTON_ELEMENT_SELECTOR = '[data-f-type="submitbutton"]';
var PREV_BUTTON_CONTAINER = '[data-prev-button-container]';
var NAV_BUTTONS_CONTAINER = '[data-navigation-buttons-container]';
var NAV_BUTTONS_WRAPPER = '[data-navigation-buttons-wrapper]';
var PRIVACY_CONTAINER = '[data-privacy-content-container]';
var PRIVACY_CONTAINER_ATTR = 'data-privacy-content-container';
var SUBMIT_PRIVACY_CONTAINER_POS = '[data-submit-button-block-privacy-content-container="{0}"]';
var SUBMIT_PRIVACY_CONTAINER = '[data-submit-button-block-privacy-content-container]';
var NAVIGATION_WRAPPER = '[data-navigation-wrapper]';
var PRIVACY_ELEMENT = '[data-privacy-content]';
var SUBMIT_BUTTON_STEP = '[data-f-type="step"]';
var GET_A_QUOTE_BUTTON_SELECTOR = '[data-get-a-quote-button]';
var CURRENT_STEP_INDEX_SELECTOR = '[name="__FormCurrentStepIndex"]';
var STEP_INDEX_SELECTOR = '[data-f-stepindex="{0}"]';
var STEP_NAME_ATTR = 'data-f-element-name';
var DOT_SELECTOR = '.dot';
var SELECTED_DOT_CLASSNAME = 'is-selected';
var HIDE_CLASSNAME = 'invisible';
var MARGIN_CLASSNAME = 'remove-margin-bottom';

var CustomFormContainer = function () {
	function CustomFormContainer(element) {
		_classCallCheck(this, CustomFormContainer);

		this.element = element;
		this.$element = $(element);
		this.elementId = '#' + this.$element.attr('id');
		this.$dotNavigationElement = this.$element.find(DOT_NAVIGATION_ELEMENT_SELECTOR);
		this.$prevButtonElement = this.$element.find(PREV_BUTTON_ELEMENT_SELECTOR);
		this.$submitButtonElement = this.$element.find(SUBMIT_BUTTON_ELEMENT_SELECTOR);
		this.$submitButtonStepElement = this.$submitButtonElement.closest(SUBMIT_BUTTON_STEP);
		this.$prevButtonContainerElement = this.$element.find(PREV_BUTTON_CONTAINER);
		this.$navButtonsContainerElement = this.$element.find(NAV_BUTTONS_CONTAINER);
		this.$navButtonsWrapperElement = this.$element.find(NAV_BUTTONS_WRAPPER);
		this.$navigationWrapperElement = this.$element.find(NAVIGATION_WRAPPER);
		this.$currentStepHiddenElement = this.$element.find(CURRENT_STEP_INDEX_SELECTOR);
		this.$getAQuoteButtonElement = $(GET_A_QUOTE_BUTTON_SELECTOR);

		this.$privacyContainerElement = this.$element.find(PRIVACY_CONTAINER);
		this.privacyPosition = this.$privacyContainerElement.attr(PRIVACY_CONTAINER_ATTR);
		this.$privacyElement = this.$element.find(PRIVACY_ELEMENT);
		this.$submitPrivacyContainerElements = this.$element.find(SUBMIT_PRIVACY_CONTAINER);
		this.$submitPrivacyContainerElement = this.$element.find(SUBMIT_PRIVACY_CONTAINER_POS.replace('{0}', this.privacyPosition));

		this.watch();
	}

	_createClass(CustomFormContainer, [{
		key: 'moveContent',
		value: function moveContent(isSubmitStep, isFirstStep) {
			this.$submitPrivacyContainerElements.addClass(HIDE_CLASSNAME);
			this.$navigationWrapperElement.addClass(HIDE_CLASSNAME);
			if (isSubmitStep) {
				this.$navButtonsWrapperElement.addClass(HIDE_CLASSNAME);
				this.$prevButtonElement.addClass(HIDE_CLASSNAME);
				this.$prevButtonElement.detach().appendTo(this.$prevButtonContainerElement).removeClass(HIDE_CLASSNAME);
				this.$privacyElement.detach().appendTo(this.$submitPrivacyContainerElement);
				this.$prevButtonElement.removeAttr('disabled');
				this.$submitPrivacyContainerElement.removeClass(HIDE_CLASSNAME);
			} else {
				this.$prevButtonElement.detach().appendTo(this.$navButtonsContainerElement).removeClass(HIDE_CLASSNAME);
				this.$privacyElement.detach().appendTo(this.$privacyContainerElement);
				this.$navButtonsWrapperElement.removeClass(HIDE_CLASSNAME);
				this.$navigationWrapperElement.removeClass(HIDE_CLASSNAME);
			}
			if (isFirstStep) {
				this.$prevButtonElement.attr('disabled', 'disabled');
			}
		}
	}, {
		key: 'pushThankYouToGtm',
		value: function pushThankYouToGtm() {
			if (typeof dataLayer !== 'undefined') {
				dataLayer.push({
					'event': 'custom_forms_step_event',
					'category': 'Thank you message'
				});
			}
		}
	}, {
		key: 'pushSetpToGtm',
		value: function pushSetpToGtm(step, action) {
			if (typeof dataLayer !== 'undefined') {
				dataLayer.push({
					'event': 'custom_forms_step_event',
					'category': 'Screen ' + step,
					'action': action
				});
			}
		}
	}, {
		key: 'watch',
		value: function watch() {
			var obj = this;
			if (typeof $$epiforms !== 'undefined') {
				$$epiforms(document).ready(function myfunction() {
					$$epiforms(obj.elementId).on('formsNavigationNextStep formsNavigationPrevStep', function (event) {
						var newStep = 1;
						var eleName = '';

						if (typeof event.targetStep !== 'undefined' && typeof event.targetStep.index !== 'undefined') {
							newStep = event.targetStep.index;
						}
						if (typeof event.targetStep !== 'undefined' && typeof event.targetStep.elementName !== 'undefined') {
							eleName = event.targetStep.elementName;
						}

						obj.pushSetpToGtm(newStep, event.type == 'formsNavigationNextStep' ? 'Next' : 'Previous');
						obj.setCurrentStep(newStep, eleName);
					});

					$$epiforms(obj.elementId).on('formsSubmitted', function (event) {
						if (event.isFinalizedSubmission) {
							obj.pushThankYouToGtm();
						}
					});

					$$epiforms(obj.elementId).on('formsSetupCompleted', function (event) {
						var newStep = obj.$currentStepHiddenElement.val();
						var elNameElement = obj.$element.find(STEP_INDEX_SELECTOR.replace('{0}', newStep));
						var eleName = typeof $(elNameElement) !== 'undefined' ? $(elNameElement).attr(STEP_NAME_ATTR) : '';
						if (newStep > 0) {
							obj.setCurrentStep(newStep, eleName);
						}
					});
				});
			}

			if (typeof this.$getAQuoteButtonElement !== 'undefined') {
				this.$getAQuoteButtonElement.on('click', function (e) {
					e.preventDefault();
					obj.$element[0].scrollIntoView();
				});
			}
		}
	}, {
		key: 'setCurrentStep',
		value: function setCurrentStep(step, elementName) {
			var obj = this;
			this.$dotNavigationElement.find(DOT_SELECTOR).removeClass(SELECTED_DOT_CLASSNAME);
			var currentStep = this.$dotNavigationElement.find(DOT_SELECTOR).get(step);
			if (typeof step !== 'undefined') {
				$(currentStep).addClass(SELECTED_DOT_CLASSNAME);
			}

			var $nextStepEl = this.$element.find('[data-f-element-name="' + elementName + '"]');
			var firstEl = $nextStepEl.find('.field-layout__element').first().find('[class^="c-field"]').first();
			var isSubmitStep = $nextStepEl.find(SUBMIT_BUTTON_ELEMENT_SELECTOR).length > 0;
			var isFirstStep = step == 0;
			if (isSubmitStep) {
				$nextStepEl.addClass(MARGIN_CLASSNAME);
			} else {
				$nextStepEl.removeClass(MARGIN_CLASSNAME);
			}

			this.moveContent(isSubmitStep, isFirstStep);

			setTimeout(function () {
				if (typeof firstEl !== 'undefined') {
					$(firstEl).focus();
				}
			}, 1);
		}
	}]);

	return CustomFormContainer;
}();

(0, _plugin2.default)('customFormContainer', CustomFormContainer);

// Export
function exec() {
	$(document).ready(function () {
		log('binding');
		$(ELEMENT_SELECTOR).customFormContainer();
		log('bound');
	});
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/forms/episerver-forms-anchor-fix.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Custom Form Container
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @author Kate York
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * TODO: This is a fix for issue on STRONE-1156. Bug reported to Episerver and should be fixed in next release of forms. That means this is no longer required.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Date Fixed: 20/10/2010
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

// Utilities


exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _debug2.default)('core/modules/forms/episerver-forms-anchor-fix');

var ELEMENT_SELECTOR = '.EPiServerForms';
var FORM_STEP_SELECTOR = '.FormStep';

var EpiserverFormsAnchorFix = function () {
  function EpiserverFormsAnchorFix(element) {
    _classCallCheck(this, EpiserverFormsAnchorFix);

    this.element = element;
    this.$element = $(element);
    this.watch();
  }

  _createClass(EpiserverFormsAnchorFix, [{
    key: 'watch',
    value: function watch() {
      var obj = this;
      if (window.location.hash && this.$element.find(FORM_STEP_SELECTOR).length > 0) {
        if (typeof $$epiforms !== 'undefined') {
          $$epiforms(document).ready(function myfunction() {
            var hash = window.location.hash;
            $('html, body').animate({
              scrollTop: $(hash).offset().top
            }, 1000);
          });
        }
      }
    }
  }]);

  return EpiserverFormsAnchorFix;
}();

(0, _plugin2.default)('episerverFormsAnchorFix', EpiserverFormsAnchorFix);

// Export
function exec() {
  $(document).ready(function () {
    log('binding');
    $(ELEMENT_SELECTOR).episerverFormsAnchorFix();
    log('bound');
  });
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/forms/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.exec = exec;

var _submitsOnChanged = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/forms/submits-on-changed.js");

var _submitsOnChanged2 = _interopRequireDefault(_submitsOnChanged);

var _productFilterGroups = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/forms/product-filter-groups.js");

var _productFilterGroups2 = _interopRequireDefault(_productFilterGroups);

var _customFormContainer = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/forms/custom-form-container.js");

var customFormContainer = _interopRequireWildcard(_customFormContainer);

var _episerverFormsAnchorFix = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/forms/episerver-forms-anchor-fix.js");

var episerverFormsAnchorFix = _interopRequireWildcard(_episerverFormsAnchorFix);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function exec() {
    (0, _productFilterGroups2.default)();
    (0, _submitsOnChanged2.default)();
    customFormContainer.exec();
    episerverFormsAnchorFix.exec();
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/forms/product-filter-groups.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {

    $(document).ready(function () {
        var $selectField = $(SELECTOR);
        var $changeField = $(HIDDEN);

        setTimeout(function () {
            $(LOADINGPANEL).removeClass('active');
            $(CHANGEFILTERS).fadeIn();
        }, 200);

        log('binding data-set-current-filter-group to', $selectField);

        $selectField.on('change', function onChanged() {
            var $this = $(this);
            var selectFieldValue = $this.attr(ATTR);
            log($this, 'changed. updating current filter group');
            $changeField.val(selectFieldValue);
        });
    });
};

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)('core/modules/forms/product-filter-groups'); /**
                                                                             * Product Filter Groups
                                                                             * @author Kate York
                                                                             */

// Utilities

var ATTR = 'data-set-current-filter-group';
var HIDDEN = '[name="CurrentFilterGroup"]';
var SELECTOR = '[' + ATTR + ']';
var CHANGEFILTERS = '.product__filter-item--checkbox,.product__filter-item--radio';
var LOADINGPANEL = '.product-filter__loading-panel';

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/forms/submits-on-changed.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
        value: true
});

exports.default = function () {
        $(document).ready(function () {
                var $selectField = $(SELECTOR);
                var $loading = $(LOADINGPANEL);

                $selectField.show();
                log('binding submit-on-change to', $selectField);

                $selectField.on('change', function onChanged() {
                        var $this = $(this);

                        var form = $this.attr(FORM_ATTR);
                        var $form = $(form);

                        var passValueTo = $this.attr(PASS_VALUE_TO_ATTR);
                        var $passValueToEl = $(passValueTo);

                        if ($passValueToEl.length > 0) {
                                $passValueToEl.val($this.val());
                                $passValueToEl.trigger('change');
                        } else {
                                if ($loading.length > 0) {
                                        $loading.addClass('active');

                                        setTimeout(function () {
                                                log($this, 'changed. submitting', $form);
                                                $form.submit();
                                        }, 200);
                                } else {
                                        log($this, 'changed. submitting', $form);
                                        $form.submit();
                                }
                        }
                });
        });
};

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'core/modules/forms/submits-on-changed'; /**
                                                            * Submit form on checked
                                                            * @author Zeno Jiricek
                                                            */

// Utilities

var log = (0, _debug2.default)(MODULE_NAME);

var ATTR = 'data-submits-on-changed';
var SELECTOR = '[' + ATTR + ']';
var LOADINGPANEL = '.product-index__loading-panel';
var FORM_ATTR = 'data-submits-on-changed-form';
var PASS_VALUE_TO_ATTR = 'data-submits-on-changed-pass-value-to';

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/gallery-carousel/gallery-carousel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _debug2.default)('gallery-carousel');

var GalleryCarousel = function () {
    function GalleryCarousel(element, options) {
        _classCallCheck(this, GalleryCarousel);

        log('element', element);
        log('options', options);

        this.options = options;
        this.element = element;

        this.init();

        log(element, options);
    }

    _createClass(GalleryCarousel, [{
        key: 'init',
        value: function init() {

            if (!this.options.thumbsSelector) {
                log('No thumbsSelector provided. data-gallery-carousel-thumbs-selector="..." Aborting.');
                return false;
            }

            this.thumbs = document.querySelector(this.options.thumbsSelector);
            if (!this.thumbs) {
                log('No thumbs found with selector ' + this.options.thumbsSelector + '. Aborting.');
                return false;
            }

            this.thumbItems = [].concat(_toConsumableArray(this.thumbs.children));
            if (this.thumbItems.length < 2) {
                return false;
            }

            this.selectedThumb = this.thumbItems[0];
            this.updateSelectionState();

            this.flickity = new Flickity(this.element, {
                contain: this.options.contain,
                arrowShape: this.options.arrowShape,
                pageDots: this.options.pageDots
            });

            this.watch();
        }
    }, {
        key: 'watch',
        value: function watch() {
            log('watching');

            this.flickity.on("select", this.onSelect.bind(this));
        }
    }, {
        key: 'onSelect',
        value: function onSelect() {
            this.selectedThumb = this.thumbItems[this.flickity.selectedIndex];
            this.updateSelectionState();
            this.pauseVideo();
            this.pauseYouTube();
        }
    }, {
        key: 'updateSelectionState',
        value: function updateSelectionState() {
            var _this = this;

            this.thumbItems.forEach(function (item) {
                item.dataset.galleryPagerSelected = item === _this.selectedThumb;
            });
        }
    }, {
        key: 'pauseYouTube',
        value: function pauseYouTube() {
            var players = this.element.querySelectorAll('lite-youtube.lyt-activated');
            players.forEach(function (element) {
                element.getYTPlayer().then(function (player) {
                    if (player && player.pauseVideo) {
                        player.pauseVideo();
                    }
                });
            });
        }
    }, {
        key: 'pauseVideo',
        value: function pauseVideo() {
            var videos = this.element.querySelectorAll('video');
            videos.forEach(function (video) {
                video.pause();
            });
        }
    }]);

    return GalleryCarousel;
}();

GalleryCarousel.DEFAULTS = {
    contain: true,
    arrowShape: "M74.38,92.74a4.24,4.24,0,1,1-6,6c-.5-.47-1-1-1.45-1.46l-8.87-8.86L31.94,62.29,23.68,54a9,9,0,0,1-1.88-2.21c-1-2-.12-3.9,1.32-5.34L43,26.63,66.08,3.52c.71-.71,1.41-1.42,2.12-2.12,2.24-2.2,6.14-1.73,7.2,1.47s-2.58,5.9-4.62,7.94l-24.6,24.6-11,11-3,3c-.09.09-.56.43-.57.56s.07.08.14.22.58.58.8.81L34,52.35l4.36,4.36L50.88,69.24,73.1,91.46Z",
    pageDots: true
};

exports.default = GalleryCarousel;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/gallery-carousel/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.exec = exec;

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

var _galleryCarousel = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/gallery-carousel/gallery-carousel.js");

var _galleryCarousel2 = _interopRequireDefault(_galleryCarousel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-gallery-carousel]';
var PLUGIN_NAME = 'galleryCarousel';

function exec() {
    (0, _plugin2.default)(PLUGIN_NAME, _galleryCarousel2.default);
    $(ELEMENT_SELECTOR)[PLUGIN_NAME]();
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/hover-label/hover-label.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _debug2.default)("hover-label");

var HoverLabel = function () {
	function HoverLabel(element, options) {
		_classCallCheck(this, HoverLabel);

		this.element = element;
		this.options = options;
		log(element, options);

		if (!this.options.boxSelector) {
			log('No box selector provided for this instance. Add a selector with data-hover-label-box-selector="...". Aborting.', element);
			return false;
		}

		this.box = document.querySelector(this.options.boxSelector);

		if (!this.box) {
			log("No element found matching the provided data-hover-label-box-selector=\"" + this.options.boxSelector + " Aborting.", element);
			return false;
		}

		if (!this.options.textSelector) {
			log('No text element selector provided for this instance. Add a selector with data-hover-label-text-selector="..." Aborting.', element);
			return false;
		}

		this.labelTextElement = this.element.querySelector(this.options.textSelector);

		if (!this.labelTextElement) {
			log("No element found matching the provided data-hover-label-text-selector=\"" + this.options.textSelector + "\" Aborting.", element);
			return false;
		}

		this.labelText = this.labelTextElement.textContent;

		if (this.labelText.trim() === "") {
			log('No text found in element found with data-hover-label-text-selector="${this.options.textSelector}" Aborting.', element);
			return false;
		}

		// log(element, options);
		this.watch();
	}

	_createClass(HoverLabel, [{
		key: "watch",
		value: function watch() {
			this.element.addEventListener("mouseenter", this.hoverHandler.bind(this));
			this.element.addEventListener("mouseleave", this.unhoverHandler.bind(this));
		}
	}, {
		key: "hoverHandler",
		value: function hoverHandler() {
			var labelMargin = 6;

			// remove transform from box
			this.box.style.transform = null;
			this.box.style.top = null;
			this.box.style.left = null;

			// populate box with label text
			this.box.textContent = this.labelText;

			if (this.options.showBoxClass) {
				this.box.classList.add(this.options.showBoxClass);
			} else {
				this.box.hidden = false;
			}

			var boxRect = this.box.getBoundingClientRect();
			var positionContextRect = this.box.offsetParent.getBoundingClientRect();

			// get rect of hovered item
			var targetRect = this.element.getBoundingClientRect();

			// calc left pos of center of hovered item
			var targetCenter = targetRect.left - positionContextRect.left + targetRect.width / 2;

			// calc left position of box to center with hovered
			// substract half box width for left pos of box
			var boxLeft = targetCenter - boxRect.width / 2;
			var boxTop = targetRect.top - positionContextRect.top + targetRect.height + labelMargin;

			// apply box position
			this.box.style.top = boxTop + "px";

			// avoid setting value less than 0
			this.box.style.left = Math.max(boxLeft, 0) + "px";

			// display box ?

			// intersection observer with viewport
			// apply transform to avoid clipping on left/right
		}
	}, {
		key: "unhoverHandler",
		value: function unhoverHandler() {
			// empty text from box
			this.box.textContent = '';

			if (this.options.showBoxClass) {
				this.box.classList.remove(this.options.showBoxClass);
			} else {
				this.box.hidden = true;
			}
		}
	}]);

	return HoverLabel;
}();

HoverLabel.DEFAULTS = {};

exports.default = HoverLabel;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/hover-label/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.exec = exec;

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

var _hoverLabel = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/hover-label/hover-label.js");

var _hoverLabel2 = _interopRequireDefault(_hoverLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-hover-label]';
var PLUGIN_NAME = 'hoverLabel';

function exec() {
    (0, _jquery2.default)(function () {
        (0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
            (0, _plugin2.default)(PLUGIN_NAME, _hoverLabel2.default);
            (0, _jquery2.default)(this)[PLUGIN_NAME]();
        });
    });
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/iframe-resize/iframe-resize.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

var _debounce = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/debounce.js");

var _debounce2 = _interopRequireDefault(_debounce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _debug2.default)("iframe-resize");

var ELEMENT_SELECTOR = "[data-iframe-resize]";

var IframeResize = function () {
    function IframeResize(element, options) {
        _classCallCheck(this, IframeResize);

        this.element = element;
        this.options = options;
        log(element, options);
        this.watch();
    }

    _createClass(IframeResize, [{
        key: "watch",
        value: function watch() {
            window.addEventListener("message", (0, _debounce2.default)(this.messageHandler.bind(this), 100));
        }
    }, {
        key: "messageHandler",
        value: function messageHandler(event) {
            log("message", event);
            if (event.origin !== window.location.origin) {
                return false;
            }
            if (event.data === "resize" && this.iframe && this.iframe.contentWindow === event.source) {
                this.resize(this.iframe.contentWindow.document.body.scrollHeight);
            }
        }
    }, {
        key: "resize",
        value: function resize(height) {
            log("resize", height);
            this.iframe.style.height = height + "px";
        }
    }, {
        key: "iframe",
        get: function get() {
            return this.element.querySelector("iframe");
        }
    }]);

    return IframeResize;
}();

IframeResize.DEFAULTS = {};

(0, _plugin2.default)("iframeResize", IframeResize);

function exec() {
    $(ELEMENT_SELECTOR).iframeResize();
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/image-gallery/component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ImageGalleryComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global Loader:true $:true Foundation:true Flickity:true */
//import 'babel-polyfill';

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _debounce = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/debounce.js");

var _debounce2 = _interopRequireDefault(_debounce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

jQueryBridget('flickity', Flickity, $);

window.Symbol = Symbol;
var ONE = 1;
var ZERO = 0;
var MODULE_NAME = 'module/block-gallery';
var log = (0, _debug2.default)(MODULE_NAME);
var userAgentContains = function userAgentContains(str) {
    return navigator.userAgent.toLowerCase().indexOf(str.toLowerCase()) > -1;
};
var UA_HAS_SAFARI = userAgentContains("Safari");
var UA_HAS_CHROME = userAgentContains("Crhome");
var UA_HAS_OPERA = userAgentContains("op");
var UA_IS_SAFARI = UA_HAS_SAFARI && !UA_HAS_CHROME;
var UA_IS_CHROME = UA_HAS_CHROME && !UA_HAS_OPERA;

var ImageGalleryComponent = exports.ImageGalleryComponent = function () {
    function ImageGalleryComponent(element, options) {
        _classCallCheck(this, ImageGalleryComponent);

        this.element = element;
        this.$element = $(element);
        this.options = options;
        this.options.nextKeyCodes = this.options.nextKeyCodes.replace(' ', '').split(',') || [];
        this.options.previousKeyCodes = this.options.previousKeyCodes.replace(' ', '').split(',') || [];
        this.SHIFT_PRESSED = false;

        this.$thumbnails = this.$element.find(this.options.thumbnailsContainerSelector);
        this.$main = this.$element.find(this.options.mainContainerSelector);
        this.$modalButtons = this.$element.find(this.options.modalButtonSelector);

        this.element.component = this;
        log('constructed', this.element);

        this.init();
        this.watch();
    }

    _createClass(ImageGalleryComponent, [{
        key: 'watch',
        value: function watch() {
            // window.addEventListener('resize',
            //     debounce(this.init.bind(this), 150));
            // log('watching', this.element);

            this.$modalButtons.on('click', this.openModal.bind(this));
        }
        /**
         * // 1. trigger redraw for transition
         */

    }, {
        key: 'init',
        value: function init() {
            var element = this.element;
            var thumbSlider = void 0;
            var mainSlider = void 0;

            var main = this.$main.get(0);
            this.$main.removeClass(this.options.mainContainerHiddenClass);
            main.offsetHeight; // 1

            if (Foundation.MediaQuery.current === 'small') {
                this.mainSlider = new Flickity(main, {
                    pageDots: true,
                    setGallerySize: true,
                    prevNextButtons: false,
                    autoPlay: this.options.autoplay
                });

                log('initalised.smallScreens', element);
            }

            if (Foundation.MediaQuery.atLeast('medium')) {

                var thumbs = this.$thumbnails.get(0);
                this.$thumbnails.removeClass(this.options.thumbnailsContainerHiddenClass);
                thumbs.offsetHeight; // 1

                mainSlider = new Flickity(main, {
                    pageDots: true,
                    draggable: false,
                    setGallerySize: true,
                    prevNextButtons: false
                });

                thumbSlider = new Flickity(thumbs, {
                    adaptiveHeight: false,
                    setGallerySize: false,
                    // asNavFor: main,
                    pageDots: false,
                    contain: true,
                    arrowShape: this.options.arrowShape,
                    autoPlay: this.options.autoplay
                });

                thumbSlider.on('select', this.onSelect.bind(this));
                this.$thumbnails.on('click', 'button', this.onCellClick.bind(this));

                log('initalised.mediumUpScreens', this.element);
            }
            this.mainSlider = mainSlider;
            this.thumbSlider = thumbSlider;
        }
    }, {
        key: 'onCellClick',
        value: function onCellClick(event) {
            var currentTarget = event.currentTarget;

            var selected = this.$thumbnails.find('button').index(currentTarget);
            log('onCellClick', { currentTarget: currentTarget, selected: selected });
            this.thumbSlider.select(selected);
        }
    }, {
        key: 'onSelect',
        value: function onSelect(index) {
            log('onSelect', index);

            var selected = this.$thumbnails.find('.is-selected');
            //   selected.focus();

            this.mainSlider.select(selected.index());
        }
    }, {
        key: 'openModal',
        value: function openModal(event) {
            var modalId = $(event.currentTarget).attr('data-reveal-id');
            $('#' + modalId).foundation('open');
        }
    }]);

    return ImageGalleryComponent;
}();

ImageGalleryComponent.DEFAULTS = {
    mainContainerSelector: '.image-gallery__main-container',
    mainContainerHiddenClass: 'block-image-gallery__main--is-hidden',
    thumbnailsContainerSelector: '.image-gallery__thumbnails-container',
    thumbnailsItemSelector: '.image-gallery__thumbnail-item',
    thumbnailsContainerHiddenClass: 'block-image-gallery__thumbnails-container--is-hidden',
    nextKeyCodes: '39, 40', // right or down
    previousKeyCodes: '37, 48', // left or up
    // https://flickity.metafizzy.co/options.html#arrowshape
    arrowShape: {
        x0: 10,
        x1: 60, y1: 50,
        x2: 70, y2: 40,
        x3: 30
    }
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/image-gallery/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ELEMENT_SELECTOR = exports.MODULE_NAME = undefined;
exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = exports.MODULE_NAME = 'app.core/modules/image-gallery';
var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-image-gallery]';
var log = (0, _debug2.default)(MODULE_NAME);

function exec() {
    var elements = $(ELEMENT_SELECTOR).toArray();
    if (!elements || !elements.length) {
        return;
    }

    var _require = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/image-gallery/component.js"),
        ImageGalleryComponent = _require.ImageGalleryComponent;

    (0, _plugin2.default)('imageGallery', ImageGalleryComponent);
    $(elements).imageGallery();
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _licencePing = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/licence-ping/index.js");

var licencePing = _interopRequireWildcard(_licencePing);

var _sticky = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/sticky/index.js");

var sticky = _interopRequireWildcard(_sticky);

var _toggleClass = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/toggle-class/index.js");

var toggleClass = _interopRequireWildcard(_toggleClass);

var _toggleDisable = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/toggle-disable/index.js");

var toggleDisable = _interopRequireWildcard(_toggleDisable);

var _navigation = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/navigation/index.js");

var navigation = _interopRequireWildcard(_navigation);

var _sliders = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/sliders/index.js");

var sliders = _interopRequireWildcard(_sliders);

var _breadcrumbs = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/breadcrumbs/index.js");

var breadcrumbs = _interopRequireWildcard(_breadcrumbs);

var _forms = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/forms/index.js");

var forms = _interopRequireWildcard(_forms);

var _customSelect = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/custom-select/index.js");

var customSelect = _interopRequireWildcard(_customSelect);

var _transportElements = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/transport-elements/index.js");

var transportElements = _interopRequireWildcard(_transportElements);

var _videoBlocks = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/video-blocks/index.js");

var videoBlocks = _interopRequireWildcard(_videoBlocks);

var _imageGallery = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/image-gallery/index.js");

var imageGallery = _interopRequireWildcard(_imageGallery);

var _acceptCookie = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/accept-cookie/index.js");

var acceptCookie = _interopRequireWildcard(_acceptCookie);

var _ajaxValidate = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/ajax-validate/index.js");

var ajaxValidate = _interopRequireWildcard(_ajaxValidate);

var _disableOnSubmit = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/disable-on-submit/index.js");

var disableOnSubmit = _interopRequireWildcard(_disableOnSubmit);

var _quote = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/quote/index.js");

var addToQuote = _interopRequireWildcard(_quote);

var _ajaxSaveOnChange = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/ajax-save-on-change/index.js");

var ajaxSaveOnChange = _interopRequireWildcard(_ajaxSaveOnChange);

var _ajaxSaveOnCheck = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/ajax-save-on-check/index.js");

var ajaxSaveOnCheck = _interopRequireWildcard(_ajaxSaveOnCheck);

var _countryModal = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/country-modal/index.js");

var countryModal = _interopRequireWildcard(_countryModal);

var _stickyNavigation = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/sticky-navigation/index.js");

var stickyNavigation = _interopRequireWildcard(_stickyNavigation);

var _toggleOnDirty = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/toggle-on-dirty/index.js");

var toggleOnDirty = _interopRequireWildcard(_toggleOnDirty);

var _toggleIfValue = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/toggle-if-value/index.js");

var toggleIfValue = _interopRequireWildcard(_toggleIfValue);

var _analyticsTrigger = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/analytics-trigger/index.js");

var analyticsTrigger = _interopRequireWildcard(_analyticsTrigger);

var _commerceAnalyticsTrigger = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/commerce-analytics-trigger/index.js");

var commerceAnalyticsTrigger = _interopRequireWildcard(_commerceAnalyticsTrigger);

var _syncValue = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/sync-value/index.js");

var syncValue = _interopRequireWildcard(_syncValue);

var _addressValidation = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/address-validation/index.js");

var addressValidation = _interopRequireWildcard(_addressValidation);

var _popWindow = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/pop-window/index.js");

var popWindow = _interopRequireWildcard(_popWindow);

var _locationChange = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/location-change/index.js");

var locationChange = _interopRequireWildcard(_locationChange);

var _colourPicker = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/colour-picker/index.js");

var colourPicker = _interopRequireWildcard(_colourPicker);

var _facebookFeedBlock = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/facebook-feed-block/index.js");

var facebookFeedBlock = _interopRequireWildcard(_facebookFeedBlock);

var _expressJobWidgetBlock = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/express-job-widget-block/index.js");

var expressJobWidgetBlock = _interopRequireWildcard(_expressJobWidgetBlock);

var _youtubeListBlock = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/youtube-list-block/index.js");

var youtubeListBlock = _interopRequireWildcard(_youtubeListBlock);

var _storeLocatorMap = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/store-locator-map/index.js");

var storeLocatorMap = _interopRequireWildcard(_storeLocatorMap);

var _storeLocatorSearch = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/store-locator-search/index.js");

var storeLocatorSearch = _interopRequireWildcard(_storeLocatorSearch);

var _storeLocation = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/store-location/index.js");

var storeLocation = _interopRequireWildcard(_storeLocation);

var _searchDropdown = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/search-dropdown/index.js");

var searchDropdown = _interopRequireWildcard(_searchDropdown);

var _dismiss = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/dismiss/index.js");

var dismiss = _interopRequireWildcard(_dismiss);

var _registrationForm = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/registration-form/index.js");

var registrationForm = _interopRequireWildcard(_registrationForm);

var _productDetail = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/product-detail/index.js");

var productDetail = _interopRequireWildcard(_productDetail);

var _availableColourSwatches = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/available-colour-swatches/index.js");

var availableColourSwatches = _interopRequireWildcard(_availableColourSwatches);

var _countdownTimer = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/countdown-timer/index.js");

var countdownTimer = _interopRequireWildcard(_countdownTimer);

var _sortableProducts = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/sortable-products/index.js");

var sortableProducts = _interopRequireWildcard(_sortableProducts);

var _clickTracking = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/click-tracking/index.js");

var clickTracking = _interopRequireWildcard(_clickTracking);

var _lazyLoad = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/lazy-load/index.js");

var lazyLoad = _interopRequireWildcard(_lazyLoad);

var _unbxdImplementation = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/unbxd-implementation/index.js");

var unbxd = _interopRequireWildcard(_unbxdImplementation);

var _treeMenu = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/tree-menu/index.js");

var treeMenu = _interopRequireWildcard(_treeMenu);

var _hoverLabel = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/hover-label/index.js");

var hoverLabel = _interopRequireWildcard(_hoverLabel);

var _salesForceCookie = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/sales-force-cookie/index.js");

var salesForceCookie = _interopRequireWildcard(_salesForceCookie);

var _salesForcePush = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/sales-force-push/index.js");

var salesForcePush = _interopRequireWildcard(_salesForcePush);

var _videoBanner = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/video-banner/index.js");

var videoBanner = _interopRequireWildcard(_videoBanner);

var _collapsible = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/collapsible/index.js");

var collapsible = _interopRequireWildcard(_collapsible);

var _triggerEvent = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/trigger-event/index.js");

var triggerEvent = _interopRequireWildcard(_triggerEvent);

var _tabs = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/tabs/index.js");

var tabsController = _interopRequireWildcard(_tabs);

var _exclusiveCollapsible = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/exclusive-collapsible/index.js");

var exclusiveCollapsible = _interopRequireWildcard(_exclusiveCollapsible);

var _iframeResize = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/iframe-resize/iframe-resize.js");

var iframeResize = _interopRequireWildcard(_iframeResize);

var _galleryCarousel = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/gallery-carousel/index.js");

var galleryCarousel = _interopRequireWildcard(_galleryCarousel);

var _swatchRow = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/swatch-row/index.js");

var swatchRow = _interopRequireWildcard(_swatchRow);

var _fieldToggle = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/field-toggle/index.js");

var fieldToggle = _interopRequireWildcard(_fieldToggle);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'app.core/modules'; /**
                                       * Core Modules Index
                                       */

// Utilities

var log = (0, _debug2.default)(MODULE_NAME);

// Export
function exec() {
	log('Running...');

	licencePing.exec();
	sticky.exec();
	navigation.exec();
	sliders.exec();
	breadcrumbs.exec();
	customSelect.exec();
	forms.exec();
	transportElements.exec();
	videoBlocks.exec();
	imageGallery.exec();
	acceptCookie.exec();
	ajaxValidate.exec();
	disableOnSubmit.exec();
	countryModal.exec();
	addToQuote.exec();
	stickyNavigation.exec();
	toggleOnDirty.exec();
	toggleIfValue.exec();
	ajaxSaveOnChange.exec();
	ajaxSaveOnCheck.exec();
	syncValue.exec();
	toggleDisable.exec();
	addressValidation.exec();
	popWindow.exec();
	locationChange.exec();
	colourPicker.exec();
	facebookFeedBlock.exec();
	expressJobWidgetBlock.exec();
	youtubeListBlock.exec();
	storeLocatorMap.exec();
	storeLocatorSearch.exec();
	storeLocation.exec();
	searchDropdown.exec();
	dismiss.exec();
	registrationForm.exec();
	productDetail.exec();
	availableColourSwatches.exec();
	countdownTimer.exec();
	sortableProducts.exec();
	clickTracking.exec();
	lazyLoad.exec();
	unbxd.exec();
	hoverLabel.exec();
	salesForceCookie.exec();
	salesForcePush.exec();
	videoBanner.exec();
	collapsible.exec();
	triggerEvent.exec();
	tabsController.exec();
	iframeResize.exec();
	galleryCarousel.exec();
	swatchRow.exec();
	fieldToggle.exec();
	exclusiveCollapsible.exec();

	//  keep this last - triggers events consumed by customSelect
	toggleClass.exec();
	analyticsTrigger.exec();
	commerceAnalyticsTrigger.exec();
}

function execAfter() {
	log('Running after...');
	treeMenu.exec();
}

exports.default = {
	exec: exec,
	execAfter: execAfter
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/lazy-load/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global $:true */
// Modified from https://developers.google.com/web/fundamentals/performance/lazy-loading-guidance/images-and-video


exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MODULE_NAME = 'app.core/modules/lazy-load';
var log = (0, _debug2.default)(MODULE_NAME);
var ELEMENT_SELECTOR = '[data-lazy-load]';
var LAZY_LOAD_SRC_ATTR = 'data-lazy-load-src';
var LAZY_LOAD_SRCSET_ATTR = 'data-lazy-load-srcset';
var LAZY_LOAD_BACKGROUND_ID_ATTR = 'data-lazy-load-block-id';
var SRC_ATTR = 'src';

var LazyLoad = function () {
	function LazyLoad(element, options) {
		_classCallCheck(this, LazyLoad);

		this.element = element;
		this.options = options;
		this.$element = $(element);
		this.lazyLoadSrc = this.$element.attr(LAZY_LOAD_SRC_ATTR);
		this.lazyLoadSrcSet = this.$element.attr(LAZY_LOAD_SRCSET_ATTR);
		this.backgroundIdAttr = this.$element.attr(LAZY_LOAD_BACKGROUND_ID_ATTR);

		log('LazyLoad', element);
		this.init();
	}

	_createClass(LazyLoad, [{
		key: 'init',
		value: function init() {
			var module = this;
			if ("IntersectionObserver" in window) {
				this.lazyImageObserver = new IntersectionObserver(function (entries, observer) {
					entries.forEach(function (entry) {
						if (entry.isIntersecting) {
							module.setImageSrc();
						}
					});
				});

				this.watch();
			} else {
				this.setImageSrc();
			}
		}
	}, {
		key: 'setImageSrc',
		value: function setImageSrc() {
			if (typeof this.lazyLoadSrc !== 'undefined') {
				this.element.src = this.lazyLoadSrc;
			}
			if (typeof this.lazyLoadSrcSet !== 'undefined') {
				this.element.srcset = this.lazyLoadSrcSet;
			}
			if (typeof this.lazyImageObserver !== 'undefined') {
				this.lazyImageObserver.unobserve(this.element);
			}
			if (typeof this.backgroundIdAttr !== 'undefined') {
				this.$element.attr('id', this.backgroundIdAttr);
			}
			this.$element.addClass('lazyloaded');
		}
	}, {
		key: 'watch',
		value: function watch() {
			this.lazyImageObserver.observe(this.element);
		}
	}]);

	return LazyLoad;
}();

LazyLoad.DEFAULTS = {};

(0, _plugin2.default)('lazyLoad', LazyLoad);

function exec() {
	$(document).ready(function () {
		log('binding');
		$(ELEMENT_SELECTOR).lazyLoad();
		log('bound');
	});
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/licence-ping/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.pingUrl = pingUrl;
exports.ping = ping;
exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)('core/modules/licence-ping');

// Dependencies
/**
 * Licence Ping
 * @author Rhys Lloyd
 */

// Utilities
var TIMEOUT_DEFAULT = 1500;
var RESOLVED = 'resolved';
var REJECTED = 'rejected';
var RESPONDED = 'responded';
var DATA_LICENCE_PING_SELECTOR = '[data-licence-ping]';

/**
 * Source: http://stackoverflow.com/a/31424853/1053199
 * @param {Promise} promise
 * @returns {Promise}
 */
function reflect(promise) {
	return promise.then(function (value) {
		return { value: value, status: RESOLVED };
	}, function (error) {
		return { error: error, status: REJECTED };
	});
}

/**
 * Pings provided URL and returns a promise for the request.
 * @param {Object} urlObject
 * @param {Number} timeout
 * @returns {Promise}
 */
function pingUrl(urlObject) {
	var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : TIMEOUT_DEFAULT;

	return new Promise(function (resolve, reject) {
		var loading = true,


		// Default type is CSS
		elementTag = 'link',
		    timeoutId = 0;

		switch (urlObject.type) {
			case 'js':
			default:
				elementTag = 'script';
		}

		var element = document.createElement(elementTag);

		var respondedFn = function respondedFn() {
			if (loading) {
				loading = false;
				clearTimeout(timeoutId);
				log('Pinged "' + urlObject.url + '"');
				resolve({ url: urlObject.url, type: urlObject.type, status: RESPONDED });
			}
		};

		var rejectFn = function rejectFn(e) {

			if (loading) {
				var errorResponse = { url: urlObject.url, type: urlObject.type, status: REJECTED, error: e };
				// noinspection ReuseOfLocalVariableJS
				loading = false;
				clearTimeout(timeoutId);
				log('Ping failed for', errorResponse);
				reject(errorResponse);
			}
		};

		element.onload = respondedFn;
		element.onerror = rejectFn;

		// Ping URL
		switch (urlObject.type) {
			case 'js':
				element.src = urlObject.url;
				break;
			default:
				element.rel = 'stylesheet';
				element.href = urlObject.url;
		}

		document.head.appendChild(element);

		if (timeout) {
			//noinspection ReuseOfLocalVariableJS
			timeoutId = setTimeout(rejectFn, timeout);
		}
	});
}

/**
 *
 * @param {Array} urls - Array of URLs to ping.
 * @param {Function=} resolve
 * @returns {Promise} Promise - Always resolves success, however object returned contains status.
 */
function ping(urls) {
	var resolve = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (value) {
		return value;
	};

	var promises = [];
	//noinspection JSUnresolvedFunction
	urls.forEach(function (url) {
		return promises.push(pingUrl(url).then(resolve));
	});
	return Promise.all(promises.map(reflect)).then(function (results) {
		var completedResults = results.filter(function (result) {
			return result.status === RESOLVED;
		}),
		    failedResults = results.filter(function (result) {
			return result.status === REJECTED;
		});

		var completedUrls = completedResults.map(function (x) {
			return x.value.url;
		}),
		    failedUrls = failedResults.map(function (x) {
			return x.error.url;
		});

		log('Pings completed', completedUrls);
		log('Pings failed', failedUrls);

		// Pass onto chain
		return results;
	});
}

/**
 * Licence Ping execution
 */
function exec() {
	log('Running...');
	log('[core/modules/licence-ping] ...done.');

	// Gather endpoints
	var licencePingEndpointElements = document.querySelectorAll(DATA_LICENCE_PING_SELECTOR),
	    licencePingEndpoints = [];

	// Extract data
	for (var i = 0; i < licencePingEndpointElements.length; i++) {
		var licencePingEndpoint = licencePingEndpointElements[i];
		licencePingEndpoints.push({
			url: licencePingEndpoint.content,
			type: licencePingEndpoint.dataset.licencePing
		});
	}

	if (licencePingEndpoints.length) {
		log('Pinging licences for', licencePingEndpoints);
		log('[core/modules/licence-ping/exec] Licence pings');
		ping(licencePingEndpoints).then(function () {
			return log('[core/modules/licence-ping/exec] Licence pings');
		});
	} else {
		log('No licences to ping.');
	}

	log('[core/modules/licence-ping/exec] ...done.');
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/location-change/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Sticky Navigation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

// Utilities


exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MODULE_NAME = 'core/modules/location-change';
var log = (0, _debug2.default)(MODULE_NAME);

var validationMessages = {
    connection: $('meta[name="site.locationChangePlugin.connection"]').attr('content') || 'An error occurred sending your request to the server. Please try again later.',
    setLocation: $('meta[name="site.locationChangePlugin.setLocation"]').attr('content') || 'An error occurred setting your location. Please try again later.'
};

var PROGRESS_CLASS = 'has-progress';
var FORM_WRAPPER_SELECTOR = 'data-form-wrapper-element';

var LocationChangePlugin = function () {
    function LocationChangePlugin(element, options) {
        _classCallCheck(this, LocationChangePlugin);

        this.element = element;
        this.options = options;
        this.$element = $(element);
        this.$wrapperElement = $(this.options.wrapperElement);
        this.$changeLocationElement = $(this.options.changeLocationElement);
        this.$changeFormWrapperElement = $(this.options.changeFormWrapperElement);

        this.$locationSearchElement = this.$element.find(this.options.locationSearchElement);

        this.$formWrapperElement = $(this.$locationSearchElement.attr(FORM_WRAPPER_SELECTOR));
        this.$formSubmitElement = this.$element.find(this.options.formSubmitElement);
        this.$formElement = this.$formWrapperElement.find('form');
        this.$storeSelectElement = this.$element.find(this.options.storeSelectElement);

        this.$storeElement = this.$formWrapperElement.find(this.options.storeElement);
        this.$postcodeElement = this.$formWrapperElement.find(this.options.postcodeElement);
        this.$stateElement = this.$formWrapperElement.find(this.options.stateElement);
        this.$suburbElement = this.$formWrapperElement.find(this.options.suburbElement);
        this.$latitudeElement = this.$formWrapperElement.find(this.options.latitudeElement);
        this.$longitudeElement = this.$formWrapperElement.find(this.options.longitudeElement);

        this.$errorElement = this.$element.find(this.options.errorElement);
        this.errorClassname = this.options.errorClassname;
        this.$defaultElement = $(this.options.defaultElement);
        log('LocationChangePlugin', element);

        this.watch();

        if (typeof this.$defaultElement !== 'undefined' && this.$defaultElement.val() == 'true') {
            this.autoDetectLocation();
        }
    }

    _createClass(LocationChangePlugin, [{
        key: 'autoDetectLocation',
        value: function autoDetectLocation() {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(this.setCurrentLocation.bind(this), this.autoDetectError);
            }
        }
    }, {
        key: 'autoDetectError',
        value: function autoDetectError() {
            // Couldn't detect location. This is ok because the back end has a go too.
        }
    }, {
        key: 'fillInAddress',
        value: function fillInAddress(place, latitude, longitude) {
            var suburb = '';
            var state = '';
            var postalTown = '';
            var postcode = '';
            var administrative_area_level_2 = '';

            for (var i = 0; i < place.address_components.length; i++) {
                var addressType = place.address_components[i].types[0];
                if (addressType == 'postal_code') {
                    postcode = place.address_components[i]['short_name'];
                }
                if (addressType == 'postal_town') {
                    postalTown = place.address_components[i]['short_name'];
                }
                if (addressType == 'locality' || addressType == 'colloquial_area') {
                    suburb = place.address_components[i]['long_name'];
                }
                if (addressType == 'administrative_area_level_1') {
                    state = place.address_components[i]['short_name'];
                }
                if (addressType == 'administrative_area_level_2') {
                    administrative_area_level_2 = place.address_components[i]['short_name'];
                }
            }

            if (suburb.length == 0) {
                suburb = postalTown;
            }
            if (suburb.length == 0) {
                suburb = administrative_area_level_2;
            }

            return this.options.setLocationEndpointUrl + '/?latitude=' + latitude + '&longitude=' + longitude + '&postcode=' + postcode + '&state=' + state + '&suburb=' + suburb;
        }
    }, {
        key: 'setGeocodeLocation',
        value: function setGeocodeLocation(result, latitude, longitude) {
            var url = this.fillInAddress(result, latitude, longitude);
            var token = $('#__AjaxAntiForgeryForm input[name="__RequestVerificationToken"]').val();
            var module = this;
            log('accepting', this.$element, url);
            $.ajax({
                url: url,
                method: 'post',
                data: {
                    __RequestVerificationToken: token
                },
                success: function success(result) {
                    module.$formSubmitElement.removeAttr('disabled');
                    module.onSetLocationSuccess(result);
                },
                error: function error(e) {
                    log('getStoresAjaxError', e);
                    module.$formSubmitElement.removeAttr('disabled');
                    module.handleErrors([validationMessages.connection], 'submit');
                }
            }).done(function () {
                log('accepted', module.$element, url);
            });
        }
    }, {
        key: 'setCurrentLocation',
        value: function setCurrentLocation(position) {
            if (navigator.geolocation) {
                var geocoder = new google.maps.Geocoder();
                var module = this;
                var options = {
                    'location': new google.maps.LatLng(position.coords.latitude, position.coords.longitude)
                };

                geocoder.geocode(options, function (results, status) {
                    if (status !== "OK") {
                        reject(status);
                    }
                    if (results.length >= 0) {
                        module.setGeocodeLocation(results[0], position.coords.latitude, position.coords.longitude);
                    }
                });
            }
        }
    }, {
        key: 'setLocation',
        value: function setLocation() {
            this.$formSubmitElement.addClass(PROGRESS_CLASS).attr('disabled', 'disabled');
            if (this.formIsValid()) {
                this.$formSubmitElement.removeClass(PROGRESS_CLASS).removeAttr('disabled');
            }
        }
    }, {
        key: 'formIsValid',
        value: function formIsValid() {
            var isValid = true;
            var state = '';

            if (typeof this.$postcodeElement !== 'undefined') {
                this.$postcodeElement.parent().find('.field-validation-error').addClass('hide');
            }

            if (typeof this.$locationSearchElement == 'undefined' || this.$locationSearchElement.val().length == 0) {
                return false;
            }

            if (typeof this.$storeElement !== 'undefined') {
                if (this.$storeElement.val().length == 0) {
                    return false;
                }
            }

            if (typeof this.$stateElement == 'undefined' || this.$stateElement.val().length == 0) {
                return false;
            } else {
                state = this.$stateElement.val();
            }

            if (typeof this.$postcodeElement == 'undefined' || this.$postcodeElement.val().length == 0) {
                this.$postcodeElement.addClass('input-validation-error');
                return false;
            } else if (this.postcodeIsValid(state, this.$postcodeElement.val()) == false) {
                this.$postcodeElement.addClass('input-validation-error');
                this.$postcodeElement.parent().find('.field-validation-error').removeClass('hide');
                return false;
            }
            return isValid;
        }
    }, {
        key: 'postcodeIsValid',
        value: function postcodeIsValid(state, postcode) {
            var pcode = parseInt(postcode);
            if (isNaN(pcode)) {
                return false;
            }

            switch (state) {
                case 'NSW':
                case 'nsw':
                    return pcode >= 1000 && pcode <= 1999 || pcode >= 2000 && pcode <= 2599 || pcode >= 2619 && pcode <= 2899 || pcode >= 2921 && pcode <= 2999;
                    break;
                case 'ACT':
                case 'act':
                    return pcode >= 200 && pcode <= 299 || pcode >= 2600 && pcode <= 2618 || pcode >= 2900 && pcode <= 2920;
                    break;
                case 'VIC':
                case 'vic':
                    return pcode >= 3000 && pcode <= 3999 || pcode >= 8000 && pcode <= 8999;
                    break;
                case 'QLD':
                case 'qld':
                    return pcode >= 4000 && pcode <= 4999 || pcode >= 9000 && pcode <= 9999;
                    break;
                case 'SA':
                case 'sa':
                    return pcode >= 5000 && pcode <= 5999;
                    break;
                case 'WA':
                case 'wa':
                    return pcode >= 6000 && pcode <= 6799 || pcode >= 6800 && pcode <= 6999;
                    break;
                case 'TAS':
                case 'tas':
                    return pcode >= 7000 && pcode <= 7999;
                    break;
                case 'NT':
                case 'nt':
                    return pcode >= 800 && pcode <= 999;
                    break;
            }

            return false;
        }
    }, {
        key: 'handleErrors',
        value: function handleErrors(errorList, errorSource) {
            var errorMessage = errorList.join(' ');
            var submitErrorClass = errorSource == 'submit' ? this.options.submitErrorClassname : '';
            if (this.$errorElement.length > 0) {
                this.$errorElement.empty().append(errorMessage);
            }

            this.$formSubmitElement.addClass(this.errorClassname + ' ' + submitErrorClass);
        }
    }, {
        key: 'clearErrors',
        value: function clearErrors() {
            this.$formSubmitElement.removeClass(this.errorClassname + ' ' + this.options.submitErrorClassname);
            this.$errorElement.empty();
        }
    }, {
        key: 'resetForm',
        value: function resetForm() {
            this.$locationSearchElement.val('').trigger('keyup');
            this.clearErrors();
        }
    }, {
        key: 'showChangeLocationForm',
        value: function showChangeLocationForm() {
            this.$wrapperElement.hide();
            this.$changeFormWrapperElement.removeClass('hide');
        }
    }, {
        key: 'validateReturnedAddress',
        value: function validateReturnedAddress() {
            var isValid = true;
            var state = '';
            this.$postcodeElement.removeClass('input-validation-error');
            this.$postcodeElement.parent().find('.field-validation-error').addClass('hide');
            if (this.$stateElement.val().length == 0) {
                isValid = false;
                this.$stateElement.closest(this.options.fieldWrapper).removeClass('hide');
                this.$stateElement.attr('data-user-changed', true);
            } else {
                state = this.$stateElement.val();
                if (typeof this.$stateElement.attr('data-user-changed') == 'undefined') {
                    this.$stateElement.closest(this.options.fieldWrapper).addClass('hide');
                }
            }

            if (this.$postcodeElement.val().length == 0 || !this.postcodeIsValid(state, this.$postcodeElement.val())) {
                isValid = false;
                this.$postcodeElement.addClass('input-validation-error');
                this.$postcodeElement.closest(this.options.fieldWrapper).removeClass('hide');
                this.$postcodeElement.attr('data-user-changed', true);
                this.$postcodeElement.parent().find('.field-validation-error').removeClass('hide');
            } else if (typeof this.$postcodeElement.attr('data-user-changed') == 'undefined') {
                this.$postcodeElement.closest(this.options.fieldWrapper).addClass('hide');
            }

            if (this.$suburbElement.val().length == 0) {
                isValid = false;
                this.$suburbElement.closest(this.options.fieldWrapper).removeClass('hide');
                this.$suburbElement.attr('data-user-changed', true);
            } else if (typeof this.$suburbElement.attr('data-user-changed') == 'undefined') {
                this.$suburbElement.closest(this.options.fieldWrapper).addClass('hide');
            }

            if (isValid) {
                this.getStores();
                this.$storeSelectElement.closest(this.options.fieldWrapper).removeClass('hide');
                this.$formSubmitElement.removeAttr('disabled', 'disabled');
            } else {
                this.$storeSelectElement.closest(this.options.fieldWrapper).addClass('hide');
                this.$formSubmitElement.attr('disabled', 'disabled');
            }

            return isValid;
        }
    }, {
        key: 'getStores',
        value: function getStores() {
            var url = this.options.endpointUrl + '/?latitude=' + this.$latitudeElement.val() + '\n            &longitude=' + this.$longitudeElement.val() + '&state=' + this.$stateElement.val();

            var token = $('#__AjaxAntiForgeryForm input[name="__RequestVerificationToken"]').val();

            this.$storeSelectElement.focus();

            var module = this;
            log('accepting', this.$element, url);
            $.ajax({
                url: url,
                method: 'post',
                data: {
                    __RequestVerificationToken: token
                },
                success: function success(result) {
                    module.$formSubmitElement.removeAttr('disabled');
                    module.onGetStoresSuccess(result);
                },
                error: function error(e) {
                    log('getStoresAjaxError', e);
                    module.$formSubmitElement.removeAttr('disabled');
                    module.handleErrors([validationMessages.connection], 'submit');
                }
            }).done(function () {
                log('accepted', module.$element, url);
            });
        }
    }, {
        key: 'setLocationScrollPositionCookie',
        value: function setLocationScrollPositionCookie(scrollPos) {
            var cname = this.options.locationScrollPositionCookieName;
            var cvalue = scrollPos;
            var d = new Date();
            d.setTime(d.getTime() + 1 * 24 * 60 * 60 * 1000);
            var expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }
    }, {
        key: 'getLocationScrollPositionCookie',
        value: function getLocationScrollPositionCookie() {
            var cname = this.options.locationScrollPositionCookieName;
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        }
    }, {
        key: 'deleteLocationScrollPositionCookie',
        value: function deleteLocationScrollPositionCookie() {
            var cname = this.options.locationScrollPositionCookieName;
            document.cookie = cname + '=; Max-Age=-99999999;';
        }
    }, {
        key: 'onSetLocationSuccess',
        value: function onSetLocationSuccess(result) {
            if (typeof result.Success !== 'undefined' && result.Success) {
                var page_y = $(window).scrollTop();
                this.setLocationScrollPositionCookie(page_y);
                location.reload();
            } else {
                var errorList = typeof result.ValidationMessages !== 'undefined' ? result.ValidationMessages : Array();
                log('setLocationError', errorList);
                this.handleErrors([validationMessages.setLocation], 'setLocation');
            }
        }
    }, {
        key: 'onGetStoresSuccess',
        value: function onGetStoresSuccess(result) {
            if (typeof result.Success !== 'undefined' && result.Success) {
                if (typeof result.Stores !== 'undefined') {
                    this.populateStoresList(result.Stores);
                }
            } else {
                var errorList = typeof result.ValidationMessages !== 'undefined' ? result.ValidationMessages : Array();
                log('setLocationServerError', errorList);
                this.handleErrors(errorList, 'server');
            }
        }
    }, {
        key: 'populateStoresList',
        value: function populateStoresList(stores) {
            if (typeof stores !== 'undefined') {
                this.$storeSelectElement.children('option').remove();
                for (var i = 0; i < stores.length; i++) {
                    $("<option/>", {
                        "value": stores[i].BranchCode,
                        "text": stores[i].Name
                    }).appendTo(this.$storeSelectElement);
                }

                this.setStore();
            }
        }
    }, {
        key: 'setStore',
        value: function setStore() {
            this.$storeElement.val(this.$storeSelectElement.val());
        }
    }, {
        key: 'submitForm',
        value: function submitForm() {
            if (this.formIsValid()) {
                this.$formElement.submit();
            }
        }
    }, {
        key: 'watch',
        value: function watch() {
            this.$changeLocationElement.on('click', this.showChangeLocationForm.bind(this));
            this.$storeSelectElement.on('change', this.setStore.bind(this));
            this.$locationSearchElement.on('change', this.setLocation.bind(this));
            this.$formSubmitElement.on('click', this.submitForm.bind(this));
            this.$postcodeElement.on('change', this.validateReturnedAddress.bind(this));
            this.$suburbElement.on('change', this.validateReturnedAddress.bind(this));
            this.$stateElement.on('change', this.validateReturnedAddress.bind(this));

            $(document).on('address-validation-complete', this.validateReturnedAddress.bind(this));
            var module = this;
            window.onload = function () {
                var cookieVal = module.getLocationScrollPositionCookie();
                if (cookieVal != -1) {
                    module.deleteLocationScrollPositionCookie();
                    document.getElementsByTagName("body")[0].scrollTop = cookieVal;
                }
            };
        }
    }, {
        key: 'unwatch',
        value: function unwatch() {
            this.$changeLocationElement.on('off', this.showChangeLocationForm.bind(this));
            log('unbound', this.$element);
        }
    }]);

    return LocationChangePlugin;
}();

LocationChangePlugin.DEFAULTS = {
    wrapperElement: '.location_details__wrapper',
    changeFormWrapperElement: '.change-location-form',
    changeLocationElement: '.input__change-location',
    locationSearchElement: '.input__location-select',
    storeSelectElement: '.input__store-select',
    formSubmitElement: '.input__location-submit',
    suburbElement: '.input__location-suburb',
    stateElement: '.input__location-state',
    storeElement: '.input__location-store',
    postcodeElement: '.input__location-postcode',
    latitudeElement: '.input__location-latitude',
    longitudeElement: '.input__location-longitude',
    defaultElement: '.input__location-default',
    fieldWrapper: '.input__location-select__wrapper',
    errorElement: '.error-message',
    errorClassname: 'error',
    locationScrollPositionCookieName: 'str001.LocationScrollPosition',
    submitErrorClassname: 'submit-error',
    endpointUrl: $('meta[name="site.getStoresApiEndpoint"]').attr('content'),
    setLocationEndpointUrl: $('meta[name="site.setLocationApiEndpoint"]').attr('content')
};

(0, _plugin2.default)('locationChange', LocationChangePlugin);

// Export
function exec() {
    $(document).ready(function () {
        log('binding');
        $(".change-location-form").locationChange();
        log('bound');
    });
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/navigation/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;
exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'core/modules/navigation/mainnav'; /**
                                                      * Main navigation
                                                      * @author Kate York
                                                      * @author Oliver Boermans
                                                      */

// Elements
//	.mobile-menu-container
//	.mobile-menu-container .site-main-menu__main-navigation
//	.mobile-menu-container > .site-main-menu__main-navigation
//	.mobile-menu-container .site-main-menu__main-navigation > li
//	.mega-menu-panel-trigger

//	.site-main-menu__more-button
//	.site-main-menu__nav-col
//	.site-main-menu__main-navigation .has-children
//	.site-main-menu__nav-col > .site-main-menu__main-navigation
//	.site-main-menu__nav-col > .site-main-menu__main-navigation > li
//	.mega-menu-panel
//	.mobile-menu-button
//	.main-menu-opened-overlay

//
// Utilities

var log = (0, _debug2.default)(MODULE_NAME);

//	jQuery element selectors for persistent elements
var selectors = {
	moreListItem: '[data-mainnav-more-item]',
	moreButton: '.site-main-menu__more-button',
	mainNavToggleButtons: '[data-mainnav-toggle]',
	mainNavCloseButtons: '[data-mainnav-close]',
	topHeaderPanelButtons: '.top-header-panel__global-navigation .top-header-panel__button',
	topHeaderPanelButtonsWithBorder: '.top-header-panel__button:not(.main-nav-panel__toggle-button)'
};

//	Contains references to persistent elements (jQuery objects)
var elements = {};

function findElements(selectors, elements) {
	for (var selector in selectors) {
		elements[selector] = $(selectors[selector]);
	}
	log('elements', elements);
}

//  1: Debounce window resize events
//  2: Prevent window resize events when scrolling or presenting the keyboard in mobile chrome or safari
function saneWindowResizeWidth(fn) {
	var executeFunction;
	var timeToExecute = 100,
	    windowWidth = $(window).width();
	$(window).resize(function () {
		clearTimeout(executeFunction);
		executeFunction = setTimeout(function () {
			// 1
			if ($(window).width() !== windowWidth) {
				// 2
				windowWidth = $(window).width();
				fn();
			}
		}, timeToExecute);
	});
}

function setupMainNavMovingItems() {
	setTimeout(moveMainNavItems, 20);
	saneWindowResizeWidth(moveMainNavItems);
}

function moveMainNavItems() {
	$('.mega-menu-panel_has-level-2-navigation .mega-menu-panel__main-sub-navigation').show();

	// Put everything back in main nav
	$('.mobile-menu-container .site-main-menu__main-navigation > li').each(function () {
		var moveEl = $(this).detach();
		$('.site-main-menu__nav-col > .site-main-menu__main-navigation').append(moveEl);
	});

	// Put everything back in top nav
	$('.mobile-menu-container > .top-header-panel__global-navigation > li').each(function () {
		var moveEl = $(this).detach();
		$('.site-global-top-header .top-header-panel__global-navigation').append(moveEl);
	});

	// Move the top header panel back
	$('.mobile-menu-container .top-header-panel').each(function () {
		var moveEl = $(this).detach();
		$('.top-header-panel-wrapper').append(moveEl);
		moveEl.hide();
	});

	// Put everything back in top toggle section
	$('.mobile-menu-container > .top-header-panel__toggle-navigation > li ').each(function () {
		var moveEl = $(this).detach();
		$('.site-global-top-header .top-header-panel__toggle-navigation').append(moveEl);
	});

	// Move the items that don't fit back to mobile nav
	elements.moreListItem.show();

	var itemsWidth = 0;
	var availWidthTolerance = 20;
	var moveAll = false;
	var mobileNavHasItems = false;
	var moreButtonWidth = elements.moreListItem.innerWidth();
	var availWidth = $('.site-main-menu__nav-col').innerWidth();
	var lastAvailWidth = availWidth - availWidthTolerance - moreButtonWidth;
	var totalItems = $('.site-main-menu__nav-col > .site-main-menu__main-navigation > li').length - 1;

	elements.moreListItem.detach();

	if (!$('.site-main-menu__nav-col').is(':visible')) {
		moveAll = true;
	}

	$('.site-main-menu__nav-col > .site-main-menu__main-navigation > li').each(function (index) {
		var width = $(this).outerWidth(true);
		var tmpWidth = width + itemsWidth;
		var isMore = $(this).is(elements.moreListItem[0]);
		var isLast = index == $('.site-main-menu__nav-col > .site-main-menu__main-navigation > li').length - 1;
		var doesntFit = tmpWidth >= lastAvailWidth && !isMore;
		if (totalItems == index) {
			doesntFit = tmpWidth >= availWidth && !isMore;
		}
		if (moveAll || doesntFit) {
			var moveEl = $(this).detach();
			$('.mobile-menu-container > .site-main-menu__main-navigation').append(moveEl);
			moveEl.show();
			mobileNavHasItems = true;
		}
		itemsWidth = tmpWidth;
	});

	$('.site-main-menu__nav-col > .site-main-menu__main-navigation').append(elements.moreListItem);

	if (moveAll) {
		$('.site-global-top-header .top-header-panel__toggle-navigation > li').each(function (index) {
			var moveEl = $(this).detach();
			$('.mobile-menu-container > .top-header-panel__toggle-navigation').append(moveEl);
			moveEl.show();
			mobileNavHasItems = true;
		});
		$('.site-global-top-header .top-header-panel__global-navigation > li').each(function (index) {
			var moveEl = $(this).detach();
			$('.mobile-menu-container > .top-header-panel__global-navigation').append(moveEl);
			moveEl.show();
			mobileNavHasItems = true;
		});

		$('.top-header-panel-wrapper > .top-header-panel').each(function (index) {
			var moveEl = $(this).detach();
			$('.mobile-menu-container > .top-header-panel__toggle-navigation .main-nav-panel__toggle-button').closest('li').append(moveEl);
			moveEl.show();
			mobileNavHasItems = true;
		});
	}
	if (!mobileNavHasItems) {
		elements.moreListItem.hide();
	}
}

function toggleMobileMoreNav(event) {
	event.preventDefault();
	hideMainMenuSubPanels();
	$('.mobile-menu-button').removeClass('active');

	$('.mobile-menu-container').slideToggle(function () {
		if ($('.mobile-menu-container').is(':visible')) {
			$('.main-menu-opened-overlay').addClass('active');
			$('.mobile-menu-button').addClass('active');
			$('.site-main-menu__more-button').closest('li').addClass('active');
		}
	});
}

function bindHandlers() {
	$('.site-main-menu__main-navigation .has-children').click(function (e) {
		e.preventDefault();
		var button = $(this);
		var isSubItem = $(this).parent().find('.mega-menu-panel').length == 0;
		var showEl = !isSubItem ? $(this).parent().find('.mega-menu-panel') : $(this).closest('.columns').find('.mega-menu-panel__main-sub-navigation');
		var activeElement = !isSubItem ? $(this).parent() : $(this);
		toggleMainMenuSubPanel({
			button: button,
			activeElement: activeElement,
			showEl: showEl,
			isSubItem: isSubItem
		});
	});

	elements.mainNavToggleButtons.on('click', handleMainMenuToggle);

	$('[data-mainnav-toggle-focus-element="#q"]').on('click', function () {
		log('before.ClickTouchStart');
		$('#q').trigger('touchstart');
		$('#q').focus();
		$('#q').click();
		log('after.ClickTouchStart');
	});
	$('#q').on('touchstart', function () {
		log('before.TouchStart');
		$('#q').focus();
		log('after.TouchStart');
	});

	elements.mainNavCloseButtons.on('click', handleMainMenuClose);

	elements.topHeaderPanelButtons.on('click', handleTopHeaderPanelButtonsShow);

	elements.topHeaderPanelButtonsWithBorder.on('mouseover', handleTopHeaderPanelButtonBordersHide);

	elements.topHeaderPanelButtonsWithBorder.on('mouseout', handleTopHeaderPanelButtonBordersShow);

	$(window).click(function (e) {
		var target = e.target;
		if (!$(target).hasClass('main-content') && !$(target).hasClass('top-header-panel__sub-navigation-container') && $(target).closest('.top-header-panel__sub-navigation-container').length == 0) {
			handleTopHeaderPanelButtonsHide();
		}
	});

	window.addEventListener("hashchange", function () {
		$(document).trigger('menu-opened-overlay-clicked');
		hideMainMenuSubPanels();
		$('.mobile-menu-container').hide();
	}, false);
	//	main nav buttons
	elements.moreButton.on('click', toggleMobileMoreNav);
	$('.mobile-menu-button').on('click', toggleMobileMoreNav);

	//	overlay closes menus
	$('.main-menu-opened-overlay').click(function (e) {
		$(document).trigger('menu-opened-overlay-clicked');
		hideMainMenuSubPanels();
		$('.mobile-menu-container').hide();
	});
}

//	close all the things
function hideMainMenuSubPanels() {

	$('.mega-menu-panel.active:not(.keep-open)').each(function () {
		notifyMegaMenuClosed(this);
	});

	$('.site-header').removeClass('mega-menu-panel-open');
	$('.site-main-menu').removeClass('sub-menu-opened');
	$('.site-main-menu__more-button').closest('li').removeClass('active');
	$('.site-main-menu__main-navigation > li').removeClass('active');
	$('.top-header-panel__global-navigation > li > button').removeClass('active');
	$('.top-header-panel__toggle-navigation > li > button').removeClass('active');
	$('.mobile-menu-container .has-children').removeClass('active');
	$('.mega-menu-panel:not(.keep-open)').hide();
	$('.main-nav-panel__mega-menu-panel:not(.keep-open)').removeClass('active');
	$('.main-menu-opened-overlay').removeClass('active');
	$('.mobile-menu-button').removeClass('active');
	$('.mobile-menu-container .mega-menu-panel_has-level-2-navigation .mega-menu-panel__main-sub-navigation').hide().removeClass('active');
	$('.mobile-menu-container .mega-menu-panel_has-level-2-navigation .has-children').removeClass('active');
	$(document).trigger('hide-main-menu-sub-panels');
	handleTopHeaderPanelButtonBordersShow();
}

function hideMainMenuLevel2SubPanels() {
	$('.mobile-menu-container .mega-menu-panel_has-level-2-navigation .has-children').removeClass('active');
	$('.mobile-menu-container .mega-menu-panel_has-level-2-navigation .mega-menu-panel__main-sub-navigation').hide().removeClass('active');
}

function handleMainMenuToggle() {
	var button = $(this);
	var showEl = button.attr('data-mainnav-toggle');
	var activeElement = button.attr('data-mainnav-toggle-active-element');
	var focusElement = button.attr('data-mainnav-toggle-focus-element');

	toggleMainMenuSubPanel({
		focusElement: $(focusElement).first(),
		activeElement: $(activeElement),
		showEl: $(showEl),
		button: button
	});
}

function handleMainMenuClose() {
	var button = $(this);
	var showEl = button.attr('data-mainnav-close');
	var activeElement = button.attr('data-mainnav-close-active-element');

	toggleMainMenuSubPanel({
		activeElement: $(activeElement),
		showEl: $(showEl),
		button: button
	});
}

function handleTopHeaderPanelButtonBordersHide() {
	elements.topHeaderPanelButtonsWithBorder.addClass('hide-border');
}

function handleTopHeaderPanelButtonBordersShow() {
	elements.topHeaderPanelButtonsWithBorder.removeClass('hide-border');
}

function handleTopHeaderPanelButtonsHide() {
	elements.topHeaderPanelButtons.removeClass('active');
}

function handleTopHeaderPanelButtonsShow(e) {
	e.stopPropagation();
	var isActive = $(this).hasClass('active');
	if (isActive) {
		$(this).removeClass('active');
	} else {
		elements.topHeaderPanelButtons.removeClass('active');
		hideMainMenuSubPanels();
		$(this).addClass('active');
	}

	//  is the menu in “overflow” mode?
	if ($('.mobile-menu-container').is(':visible')) {
		$('.main-menu-opened-overlay').addClass('active');
		$('.mobile-menu-button').addClass('active');
		$('.site-main-menu__more-button').closest('li').addClass('active');
	} else {
		$('.mobile-menu-button').removeClass('active');
	}
}

function toggleSubMenuPanel(opt) {
	var activeClassName = 'active';

	//	toggle button
	var button = opt.button;

	//	parent nav item li
	var activeElement = opt.activeElement;

	//	element to toggle
	var showEl = opt.showEl;

	//	is element to toggle active already?
	var toOpen = !showEl.hasClass(activeClassName);

	button.toggleClass(activeClassName, toOpen);
	activeElement.toggleClass(activeClassName, toOpen);
	showEl.toggleClass(activeClassName, toOpen);
}

function toggleMainMenuSubPanel(opt) {

	//	nav item li
	var activeElement = opt.activeElement,


	//	element to toggle
	showEl = opt.showEl,


	//	toggle button
	button = opt.button,


	//	element to focus
	focusElement = opt.focusElement,


	//	element to focus
	isSubItem = typeof opt.isSubItem !== 'undefined' ? opt.isSubItem : false,


	// All buttons that toggle this panel
	toggleButtonAttr = typeof button.attr('data-mainnav-toggle') !== 'undefined' ? button.attr('data-mainnav-toggle') : button.attr('data-mainnav-close'),


	// Site header wrapper element
	siteHeaderElement = $('.site-header'),
	    toggleButtonsSelector = '[data-mainnav-toggle="' + toggleButtonAttr + '"]';

	//	check if item is already open
	//	are we opening or closing
	var isActive = $(activeElement).hasClass('active');

	//	top level parent
	var parentElement = $(activeElement).closest('.mobile-menu-container');
	if (typeof parentElement == 'undefined' || parentElement.length == 0) {
		$('.mobile-menu-container').hide();
	}

	//	hide element to toggle (may already be active)
	$(showEl).removeClass('active');
	$(toggleButtonsSelector).removeClass('active');

	//	close the other things
	if (!isSubItem) {
		hideMainMenuSubPanels();
	} else {
		hideMainMenuLevel2SubPanels();
	}

	if (!isSubItem && isActive) {
		notifyMegaMenuClosed(showEl[0]);
	}

	if (!isActive) {

		$(showEl).show(1, function () {
			if (focusElement != '') {
				$(focusElement).focus();
			}
			$(showEl).addClass('active');
			$(activeElement).addClass('active');
			$(toggleButtonsSelector).addClass('active');
			$(siteHeaderElement).addClass('mega-menu-panel-open');
			notifyMegaMenuOpened(showEl[0]);

			setTimeout(function () {
				$('.site-main-menu').addClass('sub-menu-opened');
				$('.main-menu-opened-overlay').addClass('active');
			}, 200);
		});
	} else if (focusElement != '') {
		$(activeElement).focus();
	}

	//	is the menu in “overflow” mode?
	if ($('.mobile-menu-container').is(':visible')) {
		$('.main-menu-opened-overlay').addClass('active');
		$('.mobile-menu-button').addClass('active');
		$('.site-main-menu__more-button').closest('li').addClass('active');
	} else {
		$('.mobile-menu-button').removeClass('active');
	}
}

function notifyMegaMenuOpened(megaMenuElement) {
	megaMenuElement.dispatchEvent(new CustomEvent("menu_opened", {
		bubbles: false
	}));
}

function notifyMegaMenuClosed(megaMenuElement) {
	megaMenuElement.dispatchEvent(new CustomEvent("menu_closed", {
		bubbles: false
	}));
}

function exec(enquire) {
	$(document).ready(function () {
		findElements(selectors, elements);
		bindHandlers();
		setupMainNavMovingItems();
	});
}
exports.default = exec;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/pop-window/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MODULE_NAME = 'app.core/modules/pop-window';
var log = (0, _debug2.default)(MODULE_NAME);

var ELEMENT_SELECTOR = '[data-pop-window]';

function clickHandler(event) {
    log('click');

    //	Ensure script does not interfere with modifier clicks
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
        log('Modifier key detected. Aborting window pop');
        return true;
    }

    event.preventDefault();

    var parameters = 'menubar=' + this.options.menubar + ',height=' + this.options.height + ',width=' + this.options.width + ',toolbar=' + this.options.toolbar + ',scrollbars=' + this.options.scrollbars + ',status=' + this.options.status + ',resizable=' + this.options.resizable;

    log(parameters);

    this.windows[this.options.popname] = window.open(this.element.href, this.options.popname, parameters);
    this.windows[this.options.popname].focus();
}

var PopWindow = function () {
    function PopWindow(element, options) {
        _classCallCheck(this, PopWindow);

        this.element = element;
        this.options = options;
        this.$element = $(element);
        log('PopWindow', element, options);
        this.watch();
    }

    _createClass(PopWindow, [{
        key: 'watch',
        value: function watch() {
            if (!this.element.href) {
                log('Anchor has no href. Aborting...', this.element);
                return false;
            }
            this.$element.on('click.popwindow', clickHandler.bind(this));
        }
    }, {
        key: 'unwatch',
        value: function unwatch() {
            this.$element.off('.popwindow');
            log('unbound', this.element);
        }
    }]);

    return PopWindow;
}();

PopWindow.DEFAULTS = {
    height: 400, // sets the height in pixels of the window.
    width: 500, // sets the width in pixels of the window.
    toolbar: 1, // determines whether a toolbar (includes the forward and back buttons) is displayed {1 (YES) or 0 (NO)}.
    menubar: 1, // determines whether the menubar is displayed {1 (YES) or 0 (NO)}.
    scrollbars: 1, // determines whether scrollbars appear on the window {1 (YES) or 0 (NO)}.
    status: 0, // whether a status line appears at the bottom of the window {1 (YES) or 0 (NO)}.
    resizable: 1, // whether the window can be resized {1 (YES) or 0 (NO)}. Can also be overloaded using resizable.
    popname: 'pop'
};

PopWindow.windows = {};

(0, _plugin2.default)('popWindow', PopWindow);

function exec() {
    $(document).ready(function () {
        log('binding');
        $(ELEMENT_SELECTOR).popWindow();
        log('bound');
    });
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/product-detail/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global $:true */


exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = '.product-detail';
var PLUGIN_NAME = 'productDetail';
var MODULE_NAME = 'app.core/modules/registration-form';
var log = (0, _debug2.default)(MODULE_NAME);
var PRICE_CONTAINER_SELECTOR = '[data-product-detail-price]';

log('registerd');

var ProductDetail = function () {
	function ProductDetail(element, options) {
		_classCallCheck(this, ProductDetail);

		this.element = element;
		this.options = options;
		this.$element = $(element);

		this.$lengthField = $(this.options.lengthField);
		this.$lengthFieldWrapper = $(this.options.lengthFieldWrapperId);
		this.$productDetailOptionGroups = $(this.options.productDetailOptionGroups);
		this.$priceContainer = $(PRICE_CONTAINER_SELECTOR);

		this.lengthVal = '';
		this.codeVal = '';
		this.watch();

		log('construct', element);
	}

	_createClass(ProductDetail, [{
		key: 'lengthFieldChange',
		value: function lengthFieldChange() {
			this.lengthVal = this.$lengthField.val();
			this.codeVal = typeof this.$lengthFieldWrapper.attr(this.options.productCode) == 'undefined' ? '' : this.$lengthFieldWrapper.attr(this.options.productCode);
			this.skuVal = typeof this.$lengthFieldWrapper.attr(this.options.sku) == 'undefined' ? '' : this.$lengthFieldWrapper.attr(this.options.sku);
			this.postLengthFieldValue();
		}
	}, {
		key: 'postLengthFieldValue',
		value: function postLengthFieldValue() {
			var _this = this;

			var url = this.options.endpointUrl + '?' + this.options.endpointParam + '=' + this.codeVal + '&' + this.options.endpointParam2 + '=' + this.lengthVal + '&' + this.options.endpointParam3 + '=' + this.skuVal;

			var token = $('#__AjaxAntiForgeryForm input[name="__RequestVerificationToken"]').val();

			log('accepting', this.$element, url);
			$.ajax({
				url: url,
				method: 'post',
				data: {
					__RequestVerificationToken: token
				},
				success: function success(result) {
					_this.$priceContainer.empty().append(result);
				},
				error: function error(e) {
					log('setProductDetailLengthAjaxError', e);
				}
			}).done(function () {
				log('accepted', _this.$element, url);
			});
		}
	}, {
		key: 'getProductDetailScrollCookie',
		value: function getProductDetailScrollCookie() {
			var cname = this.options.productDetailScrollCookieName;
			var name = cname + "=";
			var decodedCookie = decodeURIComponent(document.cookie);
			var ca = decodedCookie.split(';');
			for (var i = 0; i < ca.length; i++) {
				var c = ca[i];
				while (c.charAt(0) == ' ') {
					c = c.substring(1);
				}
				if (c.indexOf(name) == 0) {
					return c.substring(name.length, c.length);
				}
			}
			return "";
		}
	}, {
		key: 'deleteProductDetailScrollCookie',
		value: function deleteProductDetailScrollCookie() {
			var cname = this.options.productDetailScrollCookieName;
			document.cookie = cname + '=; Max-Age=-99999999;';
		}
	}, {
		key: 'watch',
		value: function watch() {
			this.$lengthField.on('change', this.lengthFieldChange.bind(this));
		}
	}, {
		key: 'unwatch',
		value: function unwatch() {
			this.$lengthField.off('change');

			log('unbound', this.$element);
		}
	}]);

	return ProductDetail;
}();

ProductDetail.DEFAULTS = {
	lengthField: '[name="length"]',
	endpointParam: 'code',
	endpointParam2: 'length',
	endpointParam3: 'sku',
	endpointUrl: $('meta[name="site.setProductDetailLengthApiEndpoint"]').attr('content'),
	productCode: 'data-product-code',
	sku: 'data-sku',
	productDetailScrollCookieName: 'str001.ProductDetailScrollPosition',
	lengthFieldWrapperId: '#product-detail-length'
};

(0, _plugin2.default)(PLUGIN_NAME, ProductDetail);

function exec() {
	$(document).ready(function () {
		$(ELEMENT_SELECTOR)[PLUGIN_NAME]();
	});
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/quote/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global $:true Foundation:true */


exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

var _strings = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/strings.js");

var _sliders = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/sliders/index.js");

var sliders = _interopRequireWildcard(_sliders);

var _lazyLoad = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/lazy-load/index.js");

var lazyLoad = _interopRequireWildcard(_lazyLoad);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MODULE_NAME = 'app.core/modules/quote';
var log = (0, _debug2.default)(MODULE_NAME);
var ELEMENT_SELECTOR = '[data-add-to-quote]';
var PROGRESS_CLASS = 'has-progress';
var PRODUCT_ID_ATTR = 'data-product-id';
var PRICE_ATTR = 'data-price';

//  todo pull these from CMS editable page somehow
var validationMessages = {
    // empty: 'What quantity would you like quoted?',
    // min: 'What quantity would you like quoted?',
    // max: 'Sorry you can’t order more than {{max}}',
    integer: $('meta[name="site.addToQuoteValidation.integer"]').attr('content') || 'Oops! Enter the number as digits only please.',
    connection: $('meta[name="site.addToQuoteValidation.connection"]').attr('content') || 'An error occurred sending your request to the server. Please try again later.'
};

var quantityTests = [
// {
//     //  is not empty
//     test: value => value !== '',
//     message: 'empty'
// },
{
    // is integer
    test: function test(value) {
        return Number.isInteger(value);
    },
    message: 'integer'
    // ,
    // {
    //     // is not less than min (1)
    //     test: value => value > 0,
    //     message: 'min'
    // }
    //  Max test not required at this time
    // ,{
    //     // is not more than max
    //     test: (value, max) => value <= max,
    //     message: `max`
    // }
}];

function getMessage(messageName, context) {
    var message = validationMessages[messageName] || false;
    return context ? (0, _strings.tmpl)(message, context) : message;
}

//  Note the {max} value here is not needed
//  left as example of rendering a dynamic value into a error message
function validateQty(value, max) {
    var error = quantityTests.reduce(function (result, validator) {
        return result ? result : validator.test(value, max) ? false : getMessage(validator.message, { max: max });
    }, false);

    //  Return true or error message encountered
    return error;
}

var AddToQuotePlugin = function () {
    function AddToQuotePlugin(element, options) {
        _classCallCheck(this, AddToQuotePlugin);

        this.element = element;
        this.options = options;
        this.$element = $(element);
        this.$code = this.$element.find('[name="code"]');
        this.codeVal = '';
        this.$qty = this.$element.find('[name="' + this.options.field + '"]');
        this.qtyVal = '';
        this.maxQty = this.$qty.attr('max');
        this.$custom = $('[name="length"]');
        this.customVal = '';
        this.$addToQuoteButton = this.$element.find(this.options.submitButton);
        this.productId = this.$element.attr(PRODUCT_ID_ATTR);
        this.price = this.$element.attr(PRICE_ATTR);

        this.$headerQuoteLink = $(this.options.quoteLink);
        this.$modal = $(this.options.modal);
        this.$productName = this.$element.find(this.options.productName);
        this.$modalProductTitle = $(this.options.modalProductTitle);
        this.$customSelectDisplay = $(this.options.customSelectDisplay);
        this.$optionPanel = $(this.options.optionPanel);
        this.$changeMarketSubmitButton = $(this.options.changeMarketSubmitButton);
        this.$errorElement = this.$element.find(this.options.errorElement);
        this.errorClassname = this.options.errorClassname;
        this.imageUrl = this.options.imageUrl;
        this.imageAlt = this.options.image;
        this.$modalProductImage = $(this.options.modalProductImage);
        this.$modalSuggestedProductsContainer = $(this.options.modalSuggestedProductsContainer);

        this.$productElement = this.$element.closest(this.options.productElementSelector);
        this.$productTickElement = this.$productElement.find(this.options.productTickSelector);

        log('AddToQuotePlugin', element);

        this.watch();
    }

    _createClass(AddToQuotePlugin, [{
        key: 'getErrors',
        value: function getErrors() {
            return validateQty(+this.$qty.val(), +this.maxQty);
        }
    }, {
        key: 'onQtyInput',
        value: function onQtyInput(event) {
            //  ignore: enter, shift, alt, tab, meta key strokes (meta has multiple codes)
            var ignoreKeys = [13, 16, 18, 9, 91, 92, 93, 224];

            //  Ignore keystrokes with modifier key
            if (ignoreKeys.indexOf(event.which) !== -1) {
                return true;
            }

            var error = this.getErrors();

            if (error) {
                this.handleErrors([error], 'client');
            } else {
                this.clearErrors();
            }
        }
    }, {
        key: 'onAddQtyExit',
        value: function onAddQtyExit() {
            var value = this.$qty.val().trim();

            // if value is emptish: '', '0'
            if (value === '' || value === '0') {
                this.clearErrors();
                this.$qty.val('');
            }
        }

        //  0 is a valid value for update form

    }, {
        key: 'onUpdateQtyExit',
        value: function onUpdateQtyExit() {
            var value = this.$qty.val().trim();

            // if value is empty: ''
            if (value === '') {
                this.clearErrors();
                this.$qty.val('');
            }
        }
    }, {
        key: 'catchEnter',
        value: function catchEnter(event) {
            if (event.which === 13 /* enter */) {
                    event.preventDefault();
                    this.submit();
                }
        }

        //  Used on view quote page

    }, {
        key: 'onSubmit',
        value: function onSubmit(event) {
            this.codeVal = this.$code.val();

            this.customVal = this.getCustomValue(this.$custom);
            var error = this.getErrors();

            if (error) {
                event.preventDefault();
                this.handleErrors([error], 'client');
            }
        }
    }, {
        key: 'onAjaxSubmit',
        value: function onAjaxSubmit(event) {
            event.preventDefault();
            this.submit();
        }
    }, {
        key: 'getCustomValue',
        value: function getCustomValue($input) {
            if (!$input.length) {
                return '0';
            }

            if ($input.is(':checkbox')) {
                return $input.is(':checked') && $input.val();
            }

            if ($input.hasClass('custom-select__value-input')) {
                var parentEl = $input.closest('.custom-select');

                return $(parentEl).find('button .custom-select__item-label').text().trim();
            }
            //  hidden input
            return $input.val();
        }
    }, {
        key: 'submit',
        value: function submit() {
            this.codeVal = this.$code.val();

            //  If no quantity entered in the qty field - presume 1
            this.qtyVal = this.$qty.val() ? this.$qty.val() : '1';
            this.customVal = this.getCustomValue(this.$custom);
            var error = this.getErrors();

            if (error) {
                this.handleErrors([error], 'client');
                return false;
            }

            if (this.codeVal.length > 0) {
                log('submitted', this.$element);
                this.$addToQuoteButton.addClass(PROGRESS_CLASS).attr('disabled', 'disabled');
                this.post();
            }
        }
    }, {
        key: 'watch',
        value: function watch() {
            log('ajax', this.options.ajax);
            var submitHandler = this.options.ajax === true ? this.onAjaxSubmit.bind(this) : this.onSubmit.bind(this);

            var exitQtyInputHandler = this.options.type === 'add' ? this.onAddQtyExit.bind(this) : this.onUpdateQtyExit.bind(this);

            if (this.$element.is('form')) {
                this.$element.on('submit.addToQuote', submitHandler);
            } else {
                this.$addToQuoteButton.on('click.addToQuote', this.onAjaxSubmit.bind(this));

                //  avoid submitting containing product listing filter form
                this.$qty.on('keydown.addToQuote', this.catchEnter.bind(this));
            }

            this.$qty.on('keyup.addToQuote', this.onQtyInput.bind(this));
            this.$qty.on('blur.addToQuote', exitQtyInputHandler);
        }
    }, {
        key: 'unwatch',
        value: function unwatch() {
            this.$element.off('.addToQuote');
            this.$addToQuoteButton.off('.addToQuote');
            this.$qty.off('.addToQuote');

            log('unbound', this.$element);
        }
    }, {
        key: 'onSuccess',
        value: function onSuccess(result) {
            this.$addToQuoteButton.removeClass(PROGRESS_CLASS).removeAttr('disabled');

            if (typeof result.Success !== 'undefined' && result.Success) {
                if (typeof result.ItemsInCart !== 'undefined') {
                    if (this.$headerQuoteLink.find('.count').length == 0) {
                        this.$headerQuoteLink.append('<span class="count">' + result.ItemsInCart + '</span>');
                    } else {
                        this.$headerQuoteLink.find('.count').html(result.ItemsInCart);
                    }

                    if (this.options.preventModal) {
                        // add a tick to the product indicating it was added to cart
                        this.$productTickElement.removeAttr('hidden');
                    } else {
                        this.openModal(this.$modal);
                        this.loadSuggestions();
                    }
                    this.resetForm(result.ItemsInCart);
                    $(document).trigger('added-to-cart', [this.productId, this.qtyVal, this.price, this.codeVal]);

                    if (result.Cart && result.Cart.length) {

                        // Sales force tracking
                        this.element.dispatchEvent(new CustomEvent("cart-updated", {
                            bubbles: true,
                            detail: result.Cart
                        }));
                    }
                }
            } else {
                var errorList = typeof result.ValidationMessages !== 'undefined' ? result.ValidationMessages : Array();
                log('addToQuoteServerError', errorList);
                this.handleErrors(errorList, 'server');
            }
        }
    }, {
        key: 'setSliderHeights',
        value: function setSliderHeights() {
            $(this.options.productSliderErrorParentClassname).css('padding-bottom', '0');
            var module = this;
            $(this.options.productSliderErrorClassname).each(function () {
                var messageHeight = $(this).outerHeight();

                $(this).closest(module.options.productSliderErrorParentClassname).css('padding-bottom', messageHeight);
            });

            if ($(this.options.productSliderErrorClassname).length > 0) {
                setTimeout(function () {
                    var flkty = Flickity.data($(module.options.productSliderClassname)[0]);
                    flkty.resize();
                }, 10);
            }
        }
    }, {
        key: 'handleErrors',
        value: function handleErrors(errorList, errorSource) {
            var errorMessage = errorList.join(' ');
            var submitErrorClass = errorSource == 'submit' ? this.options.submitErrorClassname : '';
            if (this.$errorElement.length > 0) {
                this.$errorElement.empty().append(errorMessage);
                this.setSliderHeights();
            }

            this.$qty.addClass(this.errorClassname + ' ' + submitErrorClass);
        }
    }, {
        key: 'clearErrors',
        value: function clearErrors() {
            this.$qty.removeClass(this.errorClassname + ' ' + this.options.submitErrorClassname);
            this.$errorElement.empty();
        }
    }, {
        key: 'resetForm',
        value: function resetForm(itemsInQuote) {
            this.$qty.val('').trigger('keyup');

            this.clearErrors();

            if (this.$custom.length > 0) {
                this.$custom.removeAttr('checked');
                this.$customSelectDisplay.removeAttr('disabled');
            }
            if (this.$optionPanel.length > 0) {
                this.$optionPanel.removeClass('is-customised');
            }

            if (this.$changeMarketSubmitButton.length > 0 && itemsInQuote > 0) {
                if (this.$changeMarketSubmitButton.attr('type') == 'submit') {
                    this.$changeMarketSubmitButton.attr('type', 'button');
                    this.$changeMarketSubmitButton.attr('data-open', 'market-change-confirm-modal');
                }
            }
        }
    }, {
        key: 'openModal',
        value: function openModal(modal) {
            this.$modalProductTitle.html(this.$productName.val());
            this.$modalProductImage.attr('src', this.imageUrl);
            this.$modalProductImage.attr('alt', this.imageAlt);
            modal.foundation('open');
        }
    }, {
        key: 'post',
        value: function post() {
            var _this = this;

            var url = this.options.endpointUrl + '?' + this.options.endpointParam + '=' + this.codeVal + '&' + this.options.endpointParam2 + '=' + this.customVal + '&' + this.options.endpointParam3 + '=' + this.qtyVal;

            var token = $('#__AjaxAntiForgeryForm input[name="__RequestVerificationToken"]').val();

            log('accepting', this.$element, url);
            $.ajax({
                url: url,
                method: 'post',
                data: {
                    __RequestVerificationToken: token
                },
                success: function success(result) {
                    _this.onSuccess(result);
                },
                error: function error(e) {
                    log('addToQuoteAjaxError', e);
                    _this.$addToQuoteButton.removeClass(PROGRESS_CLASS).removeAttr('disabled');
                    _this.handleErrors([validationMessages.connection], 'submit');
                }
            }).done(function () {
                log('accepted', _this.$element, url);
            });
        }
    }, {
        key: 'loadSuggestions',
        value: function loadSuggestions() {
            var _this2 = this;

            var url = this.options.suggestedProductsEndpointUrl + '?' + this.options.endpointParam + '=' + this.codeVal;
            this.$modalSuggestedProductsContainer.empty();
            log('accepting', this.$element, url);
            var myModal = this.$modal;
            $.ajax({
                url: url,
                method: 'post',
                success: function success(result) {
                    _this2.$modalSuggestedProductsContainer.html(result);
                    // prevent flash of un-slidered content by making the slider invisible
                    _this2.$modalSuggestedProductsContainer.css('visibility', 'hidden');

                    setTimeout(function () {
                        // make the slider content visible again
                        _this2.$modalSuggestedProductsContainer.css('visibility', '');
                        // initialise the slider
                        sliders.exec();
                        // ensure that the reveal window recalculates it's size/position
                        myModal.foundation('open');
                        // ensure that the buy buttons work
                        _this2.initialiseOnDynamicContent();
                        //STRONE-976 - ensure suggested product images load
                        lazyLoad.exec();
                    }, 100);
                },
                error: function error(e) {
                    log('loadSuggestionsError', e);
                }
            }).done(function () {
                log('accepted', _this2.$element, url);
            });
        }
    }, {
        key: 'initialiseOnDynamicContent',
        value: function initialiseOnDynamicContent() {
            this.$modalSuggestedProductsContainer.find(ELEMENT_SELECTOR).addToQuote();
        }
    }]);

    return AddToQuotePlugin;
}();

AddToQuotePlugin.DEFAULTS = {
    field: 'qty',
    type: 'add',
    endpointUrl: $('meta[name="site.addToCartApiEndpoint"]').attr('content'),
    suggestedProductsEndpointUrl: $('meta[name="site.suggestedProductsApiEndpoint"]').attr('content'),
    endpointParam: 'code',
    endpointParam2: 'length',
    endpointParam3: 'qty',
    productName: '[name="productName"]',
    modalProductTitle: '#added-to-cart__title',
    quoteLink: '#header-cart-link',
    modal: '#added-to-cart-modal',
    optionPanel: '#option_panel',
    customSelectDisplay: '.custom-select__display',
    changeMarketSubmitButton: '#marketChangeButton',
    submitButton: '[type="submit"]',
    errorElement: '.error-message',
    errorClassname: 'error',
    submitErrorClassname: 'submit-error',
    productSliderClassname: '.block-product-slider',
    productSliderErrorClassname: '.block-product-slider .error-message',
    productSliderErrorParentClassname: '.block-product-slider .product-teaser__content',
    modalSuggestedProductsContainer: '#added-to-cart-suggested-products',
    modalProductImage: '#added-to-cart__img',
    productElementSelector: '.product-teaser',
    productTickSelector: '.product-teaser__tick'
};

(0, _plugin2.default)('addToQuote', AddToQuotePlugin);

function exec() {
    $(document).ready(function () {
        log('binding');
        $(ELEMENT_SELECTOR).addToQuote();
        log('bound');
    });
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/registration-form/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global $:true */


exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = '[data-registration-form]';
var TOGGLE_CLASS_NAME = 'is-hidden';
var TOGGLE_REQUIRED_LABEL_CLASS_NAME = 'form-field__label--required';
var AUS_COUNTRY_CODE = 'AU';
var PLUGIN_NAME = 'registrationForm';
var MODULE_NAME = 'app.core/modules/registration-form';
var log = (0, _debug2.default)(MODULE_NAME);

log('registerd');

var RegistrationForm = function () {
	function RegistrationForm(element, options) {
		_classCallCheck(this, RegistrationForm);

		this.element = element;
		this.options = options;
		this.$element = $(element);

		this.$billingAddress = $(this.options.billingAddress);
		this.$billingAddressRegion = $(this.options.billingAddressRegion);
		this.$billingAddressRegionTextbox = $(this.options.billingAddressRegionTextbox);
		this.$billingAddressCountry = $(this.options.billingAddressCountry);

		this.$deliveryAddress = $(this.options.deliveryAddress);
		this.$deliveryAddressRegion = $(this.options.deliveryAddressRegion);
		this.$deliveryAddressRegionTextbox = $(this.options.deliveryAddressRegionTextbox);
		this.$deliveryAddressCountry = $(this.options.deliveryAddressCountry);

		this.init();
		this.watch();
		log('construct', element);
	}

	_createClass(RegistrationForm, [{
		key: 'init',
		value: function init() {
			this.deliveryRegion();
			this.billingRegion();
			this.billingRegionChange();
			this.deliveryRegionChange();
		}
	}, {
		key: 'deliveryRegion',
		value: function deliveryRegion() {
			var selectedCountry = this.$deliveryAddressCountry.val();
			if (selectedCountry == AUS_COUNTRY_CODE) {
				this.$deliveryAddressRegionTextbox.addClass(TOGGLE_CLASS_NAME);
				this.$deliveryAddressRegion.removeClass(TOGGLE_CLASS_NAME);
				this.deliveryRegionChange();
			} else {
				this.$deliveryAddressRegionTextbox.removeClass(TOGGLE_CLASS_NAME);
				this.$deliveryAddressRegion.addClass(TOGGLE_CLASS_NAME);
			}
		}
	}, {
		key: 'billingRegion',
		value: function billingRegion() {
			var selectedCountry = this.$billingAddressCountry.val();
			if (selectedCountry == AUS_COUNTRY_CODE) {
				this.$billingAddressRegionTextbox.addClass(TOGGLE_CLASS_NAME);
				this.$billingAddressRegion.removeClass(TOGGLE_CLASS_NAME);
				this.billingRegionChange();
			} else {
				this.$billingAddressRegionTextbox.removeClass(TOGGLE_CLASS_NAME);
				this.$billingAddressRegion.addClass(TOGGLE_CLASS_NAME);
			}
		}
	}, {
		key: 'billingRegionChange',
		value: function billingRegionChange() {
			var selectedValue = this.$billingAddressRegion.val();
			this.$billingAddressRegionTextbox.val(selectedValue);
		}
	}, {
		key: 'deliveryRegionChange',
		value: function deliveryRegionChange() {
			var selectedValue = this.$deliveryAddressRegion.val();
			this.$deliveryAddressRegionTextbox.val(selectedValue);
		}
	}, {
		key: 'watch',
		value: function watch() {
			this.$billingAddressRegion.on('change', this.billingRegionChange.bind(this));
			this.$deliveryAddressRegion.on('change', this.deliveryRegionChange.bind(this));
			this.$billingAddressCountry.on('change', this.billingRegion.bind(this));
			this.$deliveryAddressCountry.on('change', this.deliveryRegion.bind(this));
		}
	}, {
		key: 'unwatch',
		value: function unwatch() {
			this.$billingAddressRegion.off('change');
			this.$deliveryAddressRegion.off('change');

			log('unbound', this.$element);
		}
	}]);

	return RegistrationForm;
}();

RegistrationForm.DEFAULTS = {
	billingAddress: "#billing_address",
	billingAddressRegion: '#billing_address_region',
	billingAddressRegionTextbox: '#BillingAddress_Region',
	billingAddressCountry: '#billing-country',
	deliveryAddress: "#delivery_address",
	deliveryAddressSection: "#delivery_address_section",
	deliveryAddressRegion: '#delivery_address_region',
	deliveryAddressRegionTextbox: '#DeliveryAddress_Region',
	deliveryAddressCountry: '#delivery-country'
};

(0, _plugin2.default)(PLUGIN_NAME, RegistrationForm);

function exec() {
	$(document).ready(function () {
		$(ELEMENT_SELECTOR)[PLUGIN_NAME]();
	});
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/sales-force-cookie/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.exec = exec;

var _salesForceCookie = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/sales-force-cookie/sales-force-cookie.js");

var _salesForceCookie2 = _interopRequireDefault(_salesForceCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var metaFlagName = "site.salesforceMarketingCloudEnabled";

function exec() {
    var metaFlag = document.querySelector("meta[name=\"" + metaFlagName + "\"]");

    if (metaFlag && metaFlag.getAttribute("content") === "true") {
        (0, _salesForceCookie2.default)();
    }
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/sales-force-cookie/sales-force-cookie.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = setCookies;
//Set the number of days before your cookie should expire
var ExpireDays = 90;

function setCookies() {
    //Do not change anything below this line
    var qstr = document.location.search;
    qstr = qstr.substring(1, qstr.length);
    function SetCookie(cookieName, cookieValue, nDays) {
        var today = new Date();
        var expire = new Date();
        if (nDays == null || nDays == 0) nDays = 1;
        expire.setTime(today.getTime() + 3600000 * 24 * nDays);
        document.cookie = cookieName + "=" + escape(cookieValue) + "; expires=" + expire.toGMTString() + "; path=/";
    }
    var thevars = qstr.split("&");
    for (var i = 0; i < thevars.length; i++) {
        var cookiecase = thevars[i].split("=");
        switch (cookiecase[0]) {
            case "sfmc_sub":
                var sfmc_sub = cookiecase[1];
                SetCookie("SubscriberID", sfmc_sub, ExpireDays);
                break;
            case "e":
                var e = cookiecase[1];
                SetCookie("EmailAddr_", e, ExpireDays);
                break;
            case "j":
                var j = cookiecase[1];
                SetCookie("JobID", j, ExpireDays);
                break;
            case "l":
                var l = cookiecase[1];
                SetCookie("ListID", l, ExpireDays);
                break;
            case "jb":
                var jb = cookiecase[1];
                SetCookie("BatchID", jb, ExpireDays);
                break;
            case "u":
                var u = cookiecase[1];
                SetCookie("UrlID", u, ExpireDays);
                break;
            case "mid":
                var mid = cookiecase[1];
                SetCookie("MemberID", mid, ExpireDays);
                break;
            default:
                break;
        }
    }
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/sales-force-push/get-cookie.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getCookie;
function getCookie(cookiename) {
    if (document.cookie.length > 0) {
        var startC = document.cookie.indexOf(cookiename + "=");
        if (startC != -1) {
            startC += cookiename.length + 1;
            var endC = document.cookie.indexOf(";", startC);
            if (endC == -1) {
                endC = document.cookie.length;
            }
            return unescape(document.cookie.substring(startC, endC));
        }
    }
    return null;
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/sales-force-push/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.exec = exec;

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

var _salesForcePush = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/sales-force-push/sales-force-push.js");

var _salesForcePush2 = _interopRequireDefault(_salesForcePush);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = "[data-sales-force-push]";

function exec() {
    $(function () {
        (0, _plugin2.default)("salesForcePush", _salesForcePush2.default);
        $(ELEMENT_SELECTOR).salesForcePush();
    });
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/sales-force-push/inject-script.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// import debug from "debug";
// const log = debug("sales-force-push");

function injectScript(src) {
    return new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.addEventListener('load', resolve);
        script.addEventListener('error', function (e) {
            return reject(e.error);
        });
        document.head.appendChild(script);
    });
}

exports.default = injectScript;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/sales-force-push/sales-force-push.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _getCookie = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/sales-force-push/get-cookie.js");

var _getCookie2 = _interopRequireDefault(_getCookie);

var _injectScript = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/sales-force-push/inject-script.js");

var _injectScript2 = _interopRequireDefault(_injectScript);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _debug2.default)("sales-force-push");

var SalesForcePush = function () {
    function SalesForcePush(element, options) {
        _classCallCheck(this, SalesForcePush);

        this.element = element;
        this.options = options;

        log("SalesForcePush", element, options);

        if (!this.options.orgId) {
            log("org id is required. e.g. data-sales-force-push-org-id=\"ORG_ID_HERE\" Aborting.");
            return false;
        }
        if (!this.options.scriptUrl) {
            log("Link to the collect.js script is required. e.g. data-sales-force-push-script-url=\"https://[ORG_ID].collect.igodigital.com/collect.js\" Aborting.");
            return false;
        }
        if (!this.options.emailCookieName) {
            log("user cookie name is required. e.g. data-sales-force-push-email-cookie-name=\"EmailAddr_\" Aborting");
            return false;
        }

        if (this.options.cartItemSelector) {
            this.cartItems = Array.from(document.querySelectorAll(this.options.cartItemSelector));
        }

        this.getValueMethod = this.cartItems && this.cartItems.length ? this.getCartPushValue : this.getPushValue;

        this.init();
    }

    _createClass(SalesForcePush, [{
        key: "init",
        value: function init() {
            var _this = this;

            this.inject().then(function () {
                _this.watch();
                if (_this.options.key) {
                    _this.push(_this.options.key, _this.getValueMethod());
                }
            }).catch(function (error) {
                log("Error injecting script: " + error);
            });
        }
    }, {
        key: "watch",
        value: function watch() {
            document.addEventListener(this.options.cartUpdatedEvent, this.pushCartUpdate.bind(this));
        }
    }, {
        key: "inject",
        value: function inject() {
            var src = this.options.scriptUrl.replace(this.options.scriptUrlIdToken, this.options.orgId);
            return (0, _injectScript2.default)(src);
        }
    }, {
        key: "pushCartUpdate",
        value: function pushCartUpdate(event) {
            var newCart = event.detail;
            if (newCart && newCart.length) {
                // setOrgId and setUserInfo set with trackPageView already
                _etmc.push(["trackCart", { cart: newCart }]);
            }
        }
    }, {
        key: "push",
        value: function push(key, value) {
            var userEmailValue = (0, _getCookie2.default)(this.options.emailCookieName);
            if (!userEmailValue) {
                log("No cookie value found for " + this.options.emailCookieName + " Aborting");
                return false;
            }
            window._etmc = window._etmc || [];
            _etmc.push(["setOrgId", this.options.orgId]);
            _etmc.push(["setUserInfo", { email: userEmailValue }]);
            _etmc.push([key, value]);
        }
    }, {
        key: "getPushValue",
        value: function getPushValue() {
            return this.options.value;
        }
    }, {
        key: "getCartPushValue",
        value: function getCartPushValue() {
            return Object.assign({ cart: this.getCartData() }, this.options.value || {});
        }
    }, {
        key: "getCartData",
        value: function getCartData() {
            var _this2 = this;

            return this.cartItems.map(function (item) {
                return _this2.getCartItemData(item);
            });
        }
    }, {
        key: "getCartItemData",
        value: function getCartItemData(element) {
            return this.options.cartItemKeys.reduce(function (data, key) {
                return Object.assign({}, data, _defineProperty({}, key, element.dataset[key]));
            }, {});
        }
    }]);

    return SalesForcePush;
}();

SalesForcePush.DEFAULTS = {
    cartItemKeys: ["item", "quantity", "price", "unique_id"],
    cartUpdatedEvent: "cart-updated",
    scriptUrlIdToken: "[ORG_ID]"
};

exports.default = SalesForcePush;

/*
data-sales-force-push
data-sales-force-push-org-id=""
data-sales-force-push-email-cookie-name="EmailAddr_"
data-sales-force-push-key="trackPageView"
data-sales-force-push-value='{ "category" : "Fencing" }'

data-sales-force-push-value=`{
    "order_number" : "TESTONLY",
    "discount" : "0.00",
    "shipping" : "10.00"
}`
data-sales-force-push-cart-item-selector="[data-sales-force-push--item]"
...
data-sales-force-push--item='{"item" : "TEST1234SKU2", "quantity":  "2" , "price" : "10.00" ,"unique_id" : "TEST1234SKU2" }'



// Every push - bake into js

["setOrgId", "7229597"]

["setUserInfo",
    {"email": getCookie("EmailAddr_")}
]


// Instance specific:

["trackPageView",
    { "category" : "Fencing" }
]

["trackCart",
    { "clear_cart": true }
]

["trackPageView",
    { "search" : "Fencing" }
]

["trackCart",
    { "cart": [
        {"item" : "TEST1234SKU2", "quantity":  "2" , "price" : "10.00" , "unique_id" : "TEST1234SKU2" }
    ]}
]

["trackConversion",
    {
        "cart": [
            {"item" : "TEST1234SKU2", "quantity":  "2" , "price" : "10.00" ,"unique_id" : "TEST1234SKU2" }
        ],

        // OPTIONAL PARAMETERS
        "order_number" : "TESTONLY",
        "discount" : "0.00",
        "shipping" : "10.00"
    }
]

*/

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/search-dropdown/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PLUGIN_NAME = exports.ELEMENT_SELECTOR = undefined;
exports.exec = exec;

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-search-dropdown]';
var PLUGIN_NAME = exports.PLUGIN_NAME = 'searchDropdown';

function exec() {

    (0, _jquery2.default)(document).ready(function () {
        var $elements = (0, _jquery2.default)(ELEMENT_SELECTOR);

        if ($elements && $elements.length) {
            var _require = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/search-dropdown/plugin.js"),
                SearchDropdown = _require.SearchDropdown;

            (0, _plugin2.default)(PLUGIN_NAME, SearchDropdown);

            $elements.each(function () {
                (0, _jquery2.default)(this)[PLUGIN_NAME]();
            });
        }
    });
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/search-dropdown/plugin.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchDropdown = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     Search Dropdown (js)
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     ### Html Attributes
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     ```
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     data-search-dropdown
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     data-search-dropdown--url="/api/episerver/Search/GetAutoCompleteAndDidYouMean"
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     data-search-dropdown--min-query-length="3"
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     data-search-dropdown--ignore-key-codes="9 16 17 18 33 34 35 36 37 38 39 40 44 91 92 93 224"
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     data-search-dropdown--escape-key-codes="27"
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     data-search-dropdown--search-input-selector="(here) [data-search-dropdown__input-field]"
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     data-search-dropdown--search-cancel-selector="(here) [data-search-dropdown__cancel-button]"
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     data-search-dropdown--search-submit-selector="(here) [data-search-dropdown__submit-button]"
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     data-search-dropdown--dropdown-template-selector="(here) [data-search-dropdown__result-container]"
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     data-search-dropdown--results-container-selector="(here) [data-search-dropdown__result-container]"
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     data-search-dropdown--typing-debounce-ms="500"
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     data-search-dropdown--typing-debounce-edge="trailing | leading"
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     data-search-dropdown--open-class="search-dropdown--is-open"
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     data-search-dropdown--sending-class="search-dropdown--is-sending"
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     data-search-dropdown--error-class="search-dropdown--error"
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     data-search-dropdown--placement="bottom"
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     data-search-dropdown--placement-target="(self)"
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     ```
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     */

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _debounce = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/debounce.js");

var _debounce2 = _interopRequireDefault(_debounce);

var _strings = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/strings.js");

var _selectors = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/selectors.js");

var _types = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/types.js");

var _index = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/search-dropdown/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _debug2.default)('core/modules/' + _index.PLUGIN_NAME);

var SearchDropdown = exports.SearchDropdown = function () {
  function SearchDropdown(element, options) {
    _classCallCheck(this, SearchDropdown);

    log('construct', element, options);

    this.options = options;
    this.element = element;
    this.$element = (0, _jquery2.default)(element);

    this.options.typingDebounceMs = parseInt(this.options.typingDebounceMs);

    this.options.escapeKeyCodes = this.options.escapeKeyCodes.split(' ');
    this.options.ignoreKeyCodes = this.options.ignoreKeyCodes.split(' ');
    this.options.enterKeyCodes = this.options.enterKeyCodes.split(' ');

    this.hasFocus = false;
    this.focsusedElement = null;
    this.searchCancelled = false;

    this.searchField = (0, _selectors.selectTarget)(this.options.searchInputSelector, this.$element);
    this.submitButton = (0, _selectors.selectTarget)(this.options.searchSubmitSelector, this.$element);
    this.cancelButton = (0, _selectors.selectTarget)(this.options.searchCancelSelector, this.$element);
    this.resultsContainer = (0, _selectors.selectTarget)(this.options.resultsContainerSelector, this.$element);
    this.formElement = (0, _selectors.selectTarget)(this.options.formSelector, this.$element);

    this.templateSource = (0, _selectors.selectTarget)(this.options.dropdownTemplateSelector, this.$element);
    this.template = this.templateSource.text();
    this.templateSource.data('original-content', this.template);
    this.templateSource.empty();

    this.watch();

    log('ready', this);
  }

  _createClass(SearchDropdown, [{
    key: 'watch',
    value: function watch() {
      var _this = this;

      var debounceImmediate = this.options.typingDebounceEdge === 'leading';
      this.searchField.on('keyup', (0, _debounce2.default)(this.send.bind(this), this.options.typingDebounceMs, debounceImmediate));

      (0, _jquery2.default)(document).on('click', function (event) {
        var hasTarget = _this.$element.has(event.target);
        if (hasTarget && hasTarget.length) {
          _this.open();
        } else {
          _this.close();
        }
      });

      this.formElement.on('submit', function () {
        _this.formElement.addClass('submitting');
      });

      this.cancelButton.on('click', function () {
        log('cancelClick');
        _this.cancel();
        _this.reset();
      });

      log('watching');
    }
  }, {
    key: 'send',
    value: function send(event) {
      var _this2 = this;

      this.close();
      var query = this.searchField.val();
      var keyCode = event.keyCode;
      var _options = this.options,
          ignoreKeyCodes = _options.ignoreKeyCodes,
          escapeKeyCodes = _options.escapeKeyCodes,
          enterKeyCodes = _options.enterKeyCodes,
          minQueryLength = _options.minQueryLength,
          errorClass = _options.errorClass,
          sendingClass = _options.sendingClass,
          disableSuggest = _options.disableSuggest,
          openClass = _options.openClass,
          url = _options.url;


      log('send', query);
      if (disableSuggest == "1") {
        return;
      } else if (query && query.length < minQueryLength) {
        this.$element.trigger(_index.PLUGIN_NAME + '.notMinLength');

        log('minQueryLength', query.length);
        return;
      } else if (ignoreKeyCodes.includes(keyCode)) {
        this.$element.trigger(_index.PLUGIN_NAME + '.keyIgnored', { keyCode: keyCode });

        log('key[' + keyCode + '] ignored since it\'s in options.ignoreKeyCodes[' + ignoreKeyCodes + ']');
        return;
      } else if (escapeKeyCodes.includes(keyCode)) {
        this.$element.trigger(_index.PLUGIN_NAME + '.escape');
        log('key[' + keyCode + '] triggered close since it\'s in options.escapeKeyCodes[' + escapeKeyCodes + ']');

        this.close();
        return;
      } else if (enterKeyCodes.includes(keyCode)) {
        this.cancel();
      } else if (query && query.length) {
        // this.submitButton.attr('disabled', true);
        this.$element.trigger(_index.PLUGIN_NAME + '.beforeSend');
        this.$element.addClass(sendingClass);
        this.$element.removeClass(errorClass);

        _jquery2.default.ajax({
          url: url,
          data: {
            q: query
          },
          success: function success(data, status, request) {
            log('success', data, status);
            var formSubmitting = _this2.formElement.hasClass('submitting');
            if (!formSubmitting) {
              _this2.submitButton.removeAttr('disabled');
              _this2.$element.removeClass(sendingClass);
              _this2.$element.removeClass(errorClass);
              _this2.render(data);
              _this2.$element.addClass(openClass);
              _this2.$element.trigger(_index.PLUGIN_NAME + '.rendered');
            }
          },
          error: function error(data, status, request) {
            log('error', data, status);

            _this2.submitButton.removeAttr('disabled');
            _this2.$element.removeClass(openClass);
            _this2.$element.removeClass(sendingClass);
            _this2.$element.addClass(errorClass);
            _this2.$element.trigger(_index.PLUGIN_NAME + '.error', { data: data, status: status, request: request });
          }
        });
      } else {
        this.cancel();
      }

      this.$element.trigger(_index.PLUGIN_NAME + '.afterSend');
    }
  }, {
    key: 'onFocusChanged',
    value: function onFocusChanged(event) {
      log('onFocusChanged', event);
      this.focusedElement = event.toElement;
      var hasFocus = this.$element.has(this.focusedElement);
      this.hasFocus = hasFocus && hasFocus.length > 0;

      logger.log('onFocusIn.hasFocus', this.hasFocus);

      if (!this.hasFocus) {
        (0, _debounce2.default)(this.close.bind(this), 50);
      }
    }
  }, {
    key: 'render',
    value: function render(data) {
      log('render', data, this.template);
      var context = Object.keys(data).reduce(function (result, key) {
        var value = data[key];
        result[key] = value;
        if (value === 0) {
          result[key + 'IsEmpty'] = true;
        } else if ((0, _types.isType)(value, 'array')) {
          result[key + 'IsEmpty'] = value.length === 0;
        } else if ((0, _types.isType)(value, 'string')) {
          result[key + 'IsEmpty'] = value.length === 0;
        } else if ((0, _types.isType)(value, 'undefined')) {
          result[key + 'IsEmpty'] = true;
        } else if ((0, _types.isType)(value, 'number')) {
          result[key + 'IsEmpty'] = value == 0;
        } else if ((0, _types.isType)(value, 'object')) {
          result[key + 'IsEmpty'] = Object.keys(value).length == 0;
        }
        return result;
      }, {});
      var html = (0, _strings.mustache)(this.template, context);
      log('rendered', html);
      this.resultsContainer.html(html);
    }
  }, {
    key: 'reset',
    value: function reset(event) {
      log('reset');
      this.submitButton.removeAttr('disabled');
      this.searchField.val('');
      this.searchField.EmitOnDirty && this.searchField.EmitOnDirty('clean');
      this.resultsContainer.empty();
    }
  }, {
    key: 'open',
    value: function open() {
      log('open');
      if (this.options.disableSuggest != "1") {
        this.$element.addClass(this.options.openClass);
        this.$element.trigger(_index.PLUGIN_NAME + '.open');
      }
    }
  }, {
    key: 'close',
    value: function close() {
      log('close');
      this.$element.removeClass(this.options.hasErrorClass);
      this.$element.removeClass(this.options.sendingClass);
      this.$element.removeClass(this.options.openClass);
      this.submitButton.removeAttr('disabled');
      this.$element.trigger(_index.PLUGIN_NAME + '.closed');
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      log('cancel');
      this.searchCancelled = true;
      this.reset();
      this.close();
    }
  }]);

  return SearchDropdown;
}();

SearchDropdown.DEFAULTS = {
  /*
  http://keycode.info/
    9 = tab
    16 = shift
    17 = ctrl
    18 = alt
    37 = left
    38 = up
    39 = right
    40 = down
    32 = space
    91 = left super
    92 = right super
    //https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode#Constants_for_keyCode_value
  */
  minQueryLength: 3,
  ignoreKeyCodes: "9 16 17 18 33 34 35 36 37 38 39 40 44 91 92 93 224",
  escapeKeyCodes: "27",
  enterKeyCodes: "13",
  searchInputSelector: '(here) [data-search-dropdown__input-field]',
  searchCancelSelector: '(here) [data-search-dropdown__cancel-button]',
  searchSubmitSelector: '(here) [data-search-dropdown__submit-button]',
  dropdownTemplateSelector: '(here) [data-search-dropdown__result-container]',
  resultsContainerSelector: '(here) [data-search-dropdown__result-container]',
  formSelector: '(here) form',
  typingDebounceMs: 500,
  typingDebounceEdge: 'trailing',
  openClass: 'search-dropdown--is-open',
  sendingClass: 'search-dropdown--is-sending',
  errorClass: 'search-dropdown--error',
  placement: 'bottom',
  disableSuggest: false,
  placementTarget: '(self)'
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/sliders/blocks.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function () {
	setSlideHeights();
	setupSliders();
};

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ZERO = 0; /* global $:true module:true Flickity:true Foundation:true */

var MODULE_NAME = 'core/modules/sliders/blocks';
var log = (0, _debug2.default)(MODULE_NAME);

function setSlideHeights() {
	log('setSlideHeights');

	$('.block-slider').each(function ReduceSliderHeightFn() {
		var slider = $(this);
		var height = 0;

		$(slider).find('.slide-cell').css('height', 'auto');

		$(slider).find('.slide-cell').each(function FindSlideHeight() {
			var cell = $(this);
			var cellHeight = cell.height();
			if (cellHeight > height) {
				height = cellHeight;
			}
		});

		$(slider).find('.slide-cell').css('height', height);

		$(slider).addClass('height-set');
	});
}

function setupSliders() {
	log('setupSliders');

	$('.block-slider').each(function SetupSlider() {
		var slider = $(this);
		var sliderElement = $(slider).get(ZERO);
		// const wrapAround = $(slider).attr('data-wrap-around') === 'true';
		var autoPlay = $(slider).attr('data-auto-play') === 'true';

		var FlickityOptions = {
			autoPlay: autoPlay,
			wrapAround: true,
			freeScroll: true,
			bgLazyLoad: true,
			adaptiveHeight: false,
			dragThreshold: 10,
			contain: true,
			cellAlign: 'left',
			groupCells: '100%',
			arrowShape: 'M74.38,92.74a4.24,4.24,0,1,1-6,6c-.5-.47-1-1-1.45-1.46l-8.87-8.86L31.94,62.29,23.68,54a9,9,0,0,1-1.88-2.21c-1-2-.12-3.9,1.32-5.34L43,26.63,66.08,3.52c.71-.71,1.41-1.42,2.12-2.12,2.24-2.2,6.14-1.73,7.2,1.47s-2.58,5.9-4.62,7.94l-24.6,24.6-11,11-3,3c-.09.09-.56.43-.57.56s.07.08.14.22.58.58.8.81L34,52.35l4.36,4.36L50.88,69.24,73.1,91.46Z'
		};

		var SliderInstance = new Flickity(sliderElement, FlickityOptions);
	});

	$(window).resize(function () {
		setSlideHeights();
	});
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/sliders/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _blocks = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/sliders/blocks.js");

var _blocks2 = _interopRequireDefault(_blocks);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'core/modules/sliders'; /* global $:true module:true Flickity:true Foundation:true */

var log = (0, _debug2.default)(MODULE_NAME);

function exec() {
	$(document).ready(function () {
		log('loading slider modules');
		(0, _blocks2.default)();
	});
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/sortable-products/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

var _strings = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/strings.js");

var _Sortable = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/sortablejs/Sortable.js");

var _Sortable2 = _interopRequireDefault(_Sortable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PLUGIN_NAME = 'sortableProducts';
var MODULE_NAME = 'app.core/modules/sortable-products';
var log = (0, _debug2.default)(MODULE_NAME);
var ELEMENT_SELECTOR = '[data-sortable-products]';
var CATEGORY_ID_SELECTOR = 'data-category-id';
var ID_SELECTOR = 'data-id';
var ID_ELEMENT_SELECTOR = '[data-id]';
var LOADING_PANEL_SELECTOR = '[data-sortable-products-loading]';
var CONTAINER_SELECTOR = '[data-sortable-products-container]';
var SAVE_SELECTOR = '[data-sortable-products-save]';
var RESET_SELECTOR = '[data-sortable-products-reset]';
var NO_RESULTS_SELECTOR = '[data-sortable-products-no-results]';
var CATEGORIES = 'data-sort-categories';
var TEMPLATE_SELECTOR = '#sortable-products-item-template';
var CATEGORY_TEMPLATE_SELECTOR = '#sortable-products-category-item-template';
var LOADING_PANEL_TOGGLE_CLASS = 'show';

var SortableProducts = function () {
	function SortableProducts(element, options) {
		_classCallCheck(this, SortableProducts);

		this.element = element;
		this.options = options;
		this.$element = $(element);
		this.categoryId = this.$element.attr(CATEGORY_ID_SELECTOR);
		this.$container = this.$element.closest(CONTAINER_SELECTOR);
		this.$loadingPanel = this.$container.find(LOADING_PANEL_SELECTOR);
		this.$saveButton = this.$container.find(SAVE_SELECTOR);
		this.$resetButton = this.$container.find(RESET_SELECTOR);
		this.$noResults = this.$container.find(NO_RESULTS_SELECTOR);
		this.categoryMode = typeof this.$element.attr(CATEGORIES) !== 'undefined';
		this.dataSet = {};

		this.loadItemsIntoTemplate();
	}

	_createClass(SortableProducts, [{
		key: 'init',
		value: function init() {
			var obj = this;
			_Sortable2.default.create(this.element, {
				onSort: function onSort(evt) {}
			});

			this.$saveButton.click(this.applySortOrder.bind(this));
			this.$resetButton.click(this.loadItemsIntoTemplate.bind(this));
		}
	}, {
		key: 'loadItemsIntoTemplate',
		value: function loadItemsIntoTemplate() {
			if (this.categoryMode) {
				this.itemTemplate = $(CATEGORY_TEMPLATE_SELECTOR).html();
				this.loadCategories();
			} else {
				this.itemTemplate = $(TEMPLATE_SELECTOR).html();
				this.loadProducts();
			}
		}
	}, {
		key: 'applySortOrder',
		value: function applySortOrder() {
			if (this.categoryMode) {
				this.setCategorySortOrder();
			} else {
				this.setSortOrder();
			}
		}
	}, {
		key: 'loadProducts',
		value: function loadProducts() {
			var _this = this;

			var url = this.options.loadProductsEndpointUrl + '?' + this.options.endpointParam1 + '=' + this.categoryId;
			this.resetNoResults();
			$.ajax({
				url: url,
				method: 'post',
				success: function success(result) {
					_this.$element.empty();
					for (var i = 0; i < result.length; i++) {
						var newItem = (0, _strings.mustache)(_this.itemTemplate, {
							imageUrl: result[i].ImageUrl,
							sku: result[i].Sku,
							name: result[i].Name,
							type: result[i].Type
						});
						var $newItem = $(newItem);
						$newItem.appendTo(_this.$element);
					}
					if (result.length == 0) {
						_this.noResults();
					}
					_this.init();
				},
				error: function error(e) {}
			}).done(function () {});
		}
	}, {
		key: 'noResults',
		value: function noResults() {
			this.$noResults.show();
			this.$saveButton.hide();
			this.$resetButton.hide();
		}
	}, {
		key: 'resetNoResults',
		value: function resetNoResults() {
			this.$element.empty();
			this.$noResults.hide();
			this.$saveButton.show();
			this.$resetButton.show();
		}
	}, {
		key: 'loadCategories',
		value: function loadCategories() {
			var _this2 = this;

			var url = this.options.loadCategoriesEndpointUrl + '?' + this.options.endpointParam1 + '=' + this.categoryId;
			this.resetNoResults();
			$.ajax({
				url: url,
				method: 'post',
				success: function success(result) {
					_this2.$element.empty();
					for (var i = 0; i < result.length; i++) {
						var newItem = (0, _strings.mustache)(_this2.itemTemplate, {
							imageUrl: result[i].ImageUrl,
							sku: result[i].Sku,
							name: result[i].Name
						});
						var $newItem = $(newItem);
						$newItem.appendTo(_this2.$element);
					}
					if (result.length == 0) {
						_this2.noResults();
					}
					_this2.init();
				},
				error: function error(e) {
					_this2.noResults();
				}
			}).done(function () {});
		}
	}, {
		key: 'getSortOrder',
		value: function getSortOrder() {
			var dataSet = Array();

			this.$element.find(ID_ELEMENT_SELECTOR).each(function (e, i) {
				var sku = $(this).attr(ID_SELECTOR);
				dataSet.push(sku);
			});

			this.dataSet = dataSet;
		}
	}, {
		key: 'setSortOrder',
		value: function setSortOrder() {
			var _this3 = this;

			this.getSortOrder();
			this.$loadingPanel.addClass(LOADING_PANEL_TOGGLE_CLASS);
			var token = $('#__AjaxAntiForgeryForm input[name="__RequestVerificationToken"]').val();
			var url = '' + this.options.endpointUrl;
			var dataPost = {
				categoryId: this.categoryId,
				products: this.dataSet,
				__RequestVerificationToken: token
			};

			$.ajax({
				url: url,
				contentType: 'application/json; charset=utf-8',
				data: JSON.stringify(dataPost),
				method: 'post',
				success: function success(result) {
					_this3.$loadingPanel.removeClass(LOADING_PANEL_TOGGLE_CLASS);
				},
				error: function error(e) {
					_this3.$loadingPanel.removeClass(LOADING_PANEL_TOGGLE_CLASS);
				}
			}).done(function () {
				_this3.$loadingPanel.removeClass(LOADING_PANEL_TOGGLE_CLASS);
			});
		}
	}, {
		key: 'setCategorySortOrder',
		value: function setCategorySortOrder() {
			var _this4 = this;

			this.getSortOrder();
			this.$loadingPanel.addClass(LOADING_PANEL_TOGGLE_CLASS);
			var token = $('#__AjaxAntiForgeryForm input[name="__RequestVerificationToken"]').val();
			var url = '' + this.options.categoriesEndpointUrl;
			var dataPost = {
				categoryId: this.categoryId,
				categories: this.dataSet,
				__RequestVerificationToken: token
			};
			$.ajax({
				url: url,
				method: 'post',
				contentType: 'application/json; charset=utf-8',
				data: JSON.stringify(dataPost),
				success: function success(result) {
					_this4.$loadingPanel.removeClass(LOADING_PANEL_TOGGLE_CLASS);
				},
				error: function error(e) {
					_this4.$loadingPanel.removeClass(LOADING_PANEL_TOGGLE_CLASS);
				}
			}).done(function () {
				_this4.$loadingPanel.removeClass(LOADING_PANEL_TOGGLE_CLASS);
			});
		}
	}]);

	return SortableProducts;
}();

SortableProducts.DEFAULTS = {
	loadProductsEndpointUrl: $('meta[name="site.sortableProductsLoadApiEndpoint"]').attr('content'),
	endpointUrl: $('meta[name="site.sortableProductsApiEndpoint"]').attr('content'),
	loadCategoriesEndpointUrl: $('meta[name="site.sortableCategoriesLoadApiEndpoint"]').attr('content'),
	categoriesEndpointUrl: $('meta[name="site.sortableCategoriesApiEndpoint"]').attr('content'),
	endpointParam: 'products',
	endpointParam1: 'categoryId',
	endpointParam2: 'categories'
};

(0, _plugin2.default)(PLUGIN_NAME, SortableProducts);

function exec() {
	$(document).ready(function () {
		$(ELEMENT_SELECTOR)[PLUGIN_NAME]();
	});
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/sticky-navigation/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Sticky Navigatio
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

// Utilities


exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MODULE_NAME = 'core/modules/sticky-navigation';
var log = (0, _debug2.default)(MODULE_NAME);

var StickyNavigationPlugin = function () {
    function StickyNavigationPlugin(element, options) {
        _classCallCheck(this, StickyNavigationPlugin);

        this.element = element;
        this.options = options;
        this.$element = $(element);
        this.$viewportElement = $(this.options.viewportElement);
        this.executeFunction;
        this.timeToExecute = 200;

        log('StickyNavigationPlugin', element);

        this.watch();
    }

    _createClass(StickyNavigationPlugin, [{
        key: 'onScroll',
        value: function onScroll() {
            clearTimeout(this.executeFunction);
            var plug = this;
            this.executeFunction = setTimeout(function () {
                if (plug.$viewportElement.length > 0) {
                    var viewportElementVisible = true;
                    var offsetTop = $(window).scrollTop();
                    var viewportElementOffsetTop = plug.$viewportElement.offset().top;
                    plug.$element.removeClass('active');
                    if (!plug.isElementInViewport() && offsetTop > viewportElementOffsetTop) {
                        viewportElementVisible = false;
                    }

                    if (!viewportElementVisible) {
                        plug.$element.addClass('active');
                    }
                }
                log('scroll', plug.$element);
            }, this.timeToExecute);
        }
    }, {
        key: 'isElementInViewport',
        value: function isElementInViewport() {
            var el = this.$viewportElement;

            //special bonus for those using jQuery
            el = el[0];
            var rect = el.getBoundingClientRect();
            return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
            rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
            ;
        }
    }, {
        key: 'watch',
        value: function watch() {
            $(window).on('scroll', this.onScroll.bind(this));
        }
    }, {
        key: 'unwatch',
        value: function unwatch() {
            $(window).off('scroll', this.onScroll.bind(this));
            log('unbound', this.$element);
        }
    }]);

    return StickyNavigationPlugin;
}();

StickyNavigationPlugin.DEFAULTS = {
    viewportElement: '.product-detail__quote .product-quote-form'
};

(0, _plugin2.default)('stickyNavigation', StickyNavigationPlugin);

// Export
function exec() {
    $(document).ready(function () {
        log('binding');
        $(".sticky-navigation").stickyNavigation();
        log('bound');
    });
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/sticky/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _defaults = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/defaults.js");

var _defaults2 = _interopRequireDefault(_defaults);

var _uniqueId = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/uniqueId.js");

var _uniqueId2 = _interopRequireDefault(_uniqueId);

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/fixed-sticky/fixedsticky.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'core/modules/sticky'; /**
                                          * Sticky
                                          * @author Rhys Lloyd
                                          */
//
// Utilities

var log = (0, _debug2.default)(MODULE_NAME);
//
// Dependencies


//
// Constants
var DEFAULTS = {
	zIndex: 700
};
var STICKY_SELECTOR = '[data-sticky]';

//
// Cache
var $stickyElements = void 0;

//
// Functions
function initStickyElement() {
	var $this = $(this);

	// Scroll options - custom for this element
	var customOptions = $this.data('options');

	if (!customOptions) {
		customOptions = {};
	}

	// Merge custom options with defaults
	(0, _defaults2.default)(customOptions, DEFAULTS);

	this.id = (0, _uniqueId2.default)('sticky_');
	$this.fixedsticky(customOptions);
}

//
// Exports
function exec() {
	log('Running...');
	log('[core/modules/sticky] ...done.');

	// Fetch links
	$stickyElements = $(STICKY_SELECTOR);

	// Bail if not needed
	if (!$stickyElements.length) {
		log('No sticky elements found');
		log('[core/modules/sticky] ...done.');
	}

	log('$stickyElements:', $stickyElements);

	//
	// Bind Handlers
	setTimeout(function () {
		$stickyElements.each(initStickyElement);
	}, 0);

	log('[core/modules/sticky] ...done.');
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/store-location/component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StoreLocation = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global $:true plyr:true */

/*
Store Location Behaviour

This behaviour attachs to static markup in a result list representing a collection of store locations.

Each store location component will:
1. contain visual elements used inside the map when a marker is clicked. here we do a simple ephemeral clone and append.
2. describe meta data about the store location as attributes (in the standard fusion jquery behaviour form `pluginname-option`)
3. Provide the meta data to the map component so it can place it as a marker.
4. This component should provide a method that controls how the markup displayed in the map popover is sourced.

Styleguide: STR001.Components.StoreLocationBehaviour
*/


var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _index = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/store-location/index.js");

var _googleMapsApi = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/services/google-maps-api/index.js");

var _googleMapsApi2 = _interopRequireDefault(_googleMapsApi);

var _locationMarker = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/store-locator-map/location-marker.js");

var _locationMarker2 = _interopRequireDefault(_locationMarker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _debug2.default)(_index.MODULE_NAME);

var StoreLocation = exports.StoreLocation = function () {
  function StoreLocation(element, options) {
    var _this = this;

    _classCallCheck(this, StoreLocation);

    this.element = element;
    this.$element = $(element);
    this.options = options;

    if (this.options.revealMarkerOn) {
      this.$markerToggle = this.$element.find(this.options.revealMarkerSelector);
    }
    log('construct', this.element);

    this.markerTemplate = document.getElementById(this.options.markerTemplateId);

    _googleMapsApi2.default.then(function (google) {
      _this.google = google;
      var $mapElement = $(_this.options.mapSelector);
      _this.mapComponent = $mapElement && $mapElement.behaviour('storeLocatorMap');

      _this.init();
    });
  }

  _createClass(StoreLocation, [{
    key: 'init',
    value: function init() {
      var _this2 = this;

      // register this store location as a marker
      this.mapComponent && this.mapComponent.on('clustererReady', function () {

        var marker = new _locationMarker2.default({
          id: _this2.options.id,
          lat: _this2.options.lat,
          lng: _this2.options.lng,
          type: _this2.options.type,

          isHighlighted: false,
          resultItem: _this2,
          templateEl: _this2.markerTemplate,
          popoverContent: _this2.options.popover && _this2.popoverContent
        });
        marker.setMarkerIcons(_this2.mapComponent.markerIcons);

        _this2.mapComponent.addMarker(marker).then(function (locationMarker) {
          if (_this2.element) {
            _this2.element.addEventListener("mouseover", _this2.onHover.bind(_this2, locationMarker));
          }
          if (_this2.$markerToggle && _this2.$markerToggle.length) {
            _this2.$markerToggle.addClass(_this2.options.markerToggleClickableClass);
            _this2.$markerToggle.on(_this2.options.revealMarkerOn, function () {
              var $mapElement = _this2.mapComponent.$element;
              var mapElementTop = $mapElement.offset().top;
              var documentTop = $(document).scrollTop();
              if (documentTop > mapElementTop) {
                $(document).scrollTop(mapElementTop);
              }
              _this2.mapComponent.panAndOpenMarkerPopover(locationMarker);
            });
            log('init.toggleListen', _this2.$markerToggle);
          }
        }).catch(function (error) {
          log("Marker not added");
        });
      });
    }
  }, {
    key: 'highlight',
    value: function highlight() {
      if (!this.element) {
        return false;
      }
      this.element.classList.add(this.options.highlightClass);
    }
  }, {
    key: 'unhighlight',
    value: function unhighlight() {
      if (!this.element) {
        return false;
      }
      this.element.classList.remove(this.options.highlightClass);
    }
  }, {
    key: 'onHover',
    value: function onHover(locationMarker) {
      locationMarker.hoverMarker();
      window.addEventListener("mouseover", this.unhoverMarker.bind(this, locationMarker), { once: true });
    }
  }, {
    key: 'unhoverMarker',
    value: function unhoverMarker(locationMarker, event) {
      if (event.target !== this.element && !this.element.contains(event.target)) {
        locationMarker.unhoverMarker();
      }
    }
  }, {
    key: 'popoverContent',
    get: function get() {
      return this.$element.find(this.options.popoverContentSelector).clone().find(this.options.popoverExclusionFilter).remove().end().html();
    }
  }]);

  return StoreLocation;
}();

StoreLocation.DEFAULTS = {
  mapSelector: '[data-store-locator-map]',
  markerIcon: null,
  markerLabel: '',
  popover: true,
  popoverContentSelector: '[data-popover-content]',
  popoverExclusionFilter: '[data-popover-exclude]',
  showsMarkerOnClick: true,
  revealMarkerOn: 'click',
  revealMarkerSelector: '.store-locator-result__marker-toggle-button',
  markerToggleClickableClass: 'u--pointer',
  type: 'store'
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/store-location/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ELEMENT_SELECTOR = exports.MODULE_NAME = undefined;
exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = exports.MODULE_NAME = 'app.core/modules/store-location';
var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-store-location]';
var log = (0, _debug2.default)(MODULE_NAME);

function exec() {
    var elements = $(ELEMENT_SELECTOR).toArray();
    if (!elements || !elements.length) {
        return;
    }

    var _require = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/store-location/component.js"),
        StoreLocation = _require.StoreLocation;

    (0, _plugin2.default)('storeLocation', StoreLocation);
    $(elements).storeLocation();
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/store-locator-map/component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StoreLocatorMap = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global $:true plyr:true */
/*
Store Locator Map Behaviour

This behaviour plugin controls the display of the map, its markers and the popover detail for the markers.

Markers can be defined in two ways:
1. through this components `addMarker` method, supplying lat, lng, icon and html (for the popover)
2. populating similar objects into the `data` option of this component:
    ```
    data-store-locator-map-data="[
        {lat: "", lng: "", icon: "", html: ""},
    ]"
    ```

If popover markup is present here in this component, then details are displayed when a marker is clicked.

Further reading: https://developers.google.com/maps/documentation/javascript/reference/3.exp/


Styleguide: STR001.Components.StoreLocatorMapBehaviour
*/

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _index = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/store-locator-map/index.js");

var _markerclustererV253Esm = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/googlemaps/markerclusterer-v2.5.3.esm.js");

var _googleMapsApi = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/services/google-maps-api/index.js");

var _googleMapsApi2 = _interopRequireDefault(_googleMapsApi);

var _locationMarker = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/store-locator-map/location-marker.js");

var _locationMarker2 = _interopRequireDefault(_locationMarker);

var _debounce = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/debounce.js");

var _debounce2 = _interopRequireDefault(_debounce);

var _mapMarkerIcons = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/store-locator-map/map-marker-icons.js");

var _mapMarkerIcons2 = _interopRequireDefault(_mapMarkerIcons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _debug2.default)(_index.MODULE_NAME);

// https://github.com/appleple/modal-video

var StoreLocatorMap = exports.StoreLocatorMap = function () {
    function StoreLocatorMap(element, options) {
        _classCallCheck(this, StoreLocatorMap);

        this.element = element;
        this.$element = $(element);
        this.options = options;
        log('construct', this.element, this.options);

        this.data = this.options.markers || [];
        this.markers = [];
        this.queues = {
            componentReady: [],
            mapCreated: [],
            markersPlaced: []
        };

        this.markerTemplate = document.getElementById(this.options.markerTemplateId);

        this.markerIcons = _mapMarkerIcons2.default;

        this.$viewportElement = this.$element.find(this.options.viewportSelector);
        this.$maskElement = this.$element.find(this.options.maskSelector);
        this.$popoverElement = this.$element.find(this.options.popoverSelector);
        this.$popoverContentElement = this.$popoverElement.find(this.options.popoverContentSelector);
        this.$popoverCloseButton = this.$popoverElement.find(this.options.popoverCloseSelector);
        this.$popoverCloseButton.on('click', this.closePopover.bind(this));

        this.closePopover();

        this.init();
        this.flush('componentReady');
    }

    _createClass(StoreLocatorMap, [{
        key: 'init',
        value: function init() {
            var _this = this;

            log('init');

            _googleMapsApi2.default.then(function (google) {
                _this.google = google;

                _this.createMap();
                _this.flush('mapCreated');
                _this.placeMarkers();
                _this.flush('markersPlaced');
            });

            this.on('markersPlaced', (0, _debounce2.default)(function () {
                if (_this.options.useBrowserGps) {
                    _this.gpsLocation.then(function (position) {
                        var _position$coords = position.coords,
                            latitude = _position$coords.latitude,
                            longitude = _position$coords.longitude;

                        _this.options.lat = latitude;
                        _this.options.lng = longitude;
                        var center = new _this.google.maps.LatLng(latitude, longitude);
                        _this.moveMapTo(center);
                        var nearestMarker = _this.getNearestMarker();
                        _this.panToFitPosition(nearestMarker.position);

                        if (_this.options.showDirections) {
                            _this.showDirections(center, nearestMarker.position);
                        }
                    }).catch(function (err) {
                        var message = err.message;

                        log('init.geolocationErr: ' + message);
                    });
                }
            }, 150));

            this.$element.on('directions', this.showDirections.bind(this));

            $(window).on('resize', (0, _debounce2.default)(function () {
                if (_this.selectedMarker && _this.popoverIsOpen) {
                    log('window.resize', _this.selectedMarker);
                    _this.pointPopoverAtMarker(_this.selectedMarker.latLng);
                }
            }, 100));

            this.$maskElement.on('click', function () {
                if (_this.popoverIsOpen) {
                    _this.closePopover();
                }
            });
        }
    }, {
        key: 'on',
        value: function on(queueName, fn) {
            if (!this.queues[queueName]) {
                this.queues[queueName] = [];
            }
            this.queues[queueName].push(fn);
        }
    }, {
        key: 'flush',
        value: function flush(queueName) {
            var queue = this.queues[queueName];
            if (queue && queue.length) {
                while (queue.length) {
                    var task = queue.pop();
                    if (task && typeof task == 'function') task();
                }
            }
        }
    }, {
        key: 'createMap',
        value: function createMap() {
            var _this2 = this;

            if (!this.map) {
                this.mapOptions.then(function (mapOptions) {
                    log('createMap', mapOptions);
                    _this2.map = new _this2.google.maps.Map(_this2.$viewportElement.get(0), mapOptions);

                    if (_this2.options.cluster) {
                        _this2.clusterer = new _markerclustererV253Esm.MarkerClusterer({
                            algorithmOptions: {
                                maxZoom: _this2.options.maxClusterZoom
                            },
                            map: _this2.map,
                            markers: _this2.data,
                            renderer: {
                                render: _this2.renderCluster.bind(_this2)
                            }
                        });

                        _this2.flush('clustererReady');
                    }

                    log('createMap.done');
                });
            } else {
                // Destroying and recreating google map instances is not offically supported.
                //  - https://issuetracker.google.com/issues/35821412#comment32
                // But, there is community provided method to do this.
                //  - https://issuetracker.google.com/issues/35821412#comment53
                // I didn't implement it because it seems ecssive and not required for this use cause.
                log('createMap.alreadyExists');
            }
        }
    }, {
        key: 'getChildFromMarker',
        value: function getChildFromMarker(marker) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = marker.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var child = _step.value;

                    if (child.classList.contains("map-marker")) {
                        return child;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return marker.children[0];
        }
    }, {
        key: 'renderCluster',
        value: function renderCluster(cluster, stats, map) {
            var clusterCount = String(cluster.count);

            var clusterLocationMarker = new _locationMarker2.default({
                lat: cluster.position.lat(),
                lng: cluster.position.lng(),
                type: "cluster",
                isHighlighted: false,
                templateEl: this.markerTemplate,
                label: clusterCount
            });
            clusterLocationMarker.setMarkerIcons(this.markerIcons);

            var markerOptions = clusterLocationMarker.getMarkerOptions();
            markerOptions.title = clusterCount;
            markerOptions.zIndex = 1000 + cluster.count;
            log('renderCluster options', markerOptions);

            var marker = new this.google.maps.marker.AdvancedMarkerElement(markerOptions);

            var markerFirstChild = this.getChildFromMarker(marker);
            clusterLocationMarker.updateContentEl(markerFirstChild);

            markerFirstChild.addEventListener("mouseenter", function () {
                clusterLocationMarker.onMarkerMouseIn();
            });

            markerFirstChild.addEventListener("mouseleave", function () {
                clusterLocationMarker.onMarkerMouseOut();
            });

            return marker;
        }
    }, {
        key: 'getImageDimensions',
        value: function getImageDimensions(image) {
            return new Promise(function (resolve, reject) {
                var imageElement = new Image();
                imageElement.onload = function () {
                    resolve({
                        width: imageElement.width,
                        height: imageElement.height
                    });
                };
                imageElement.onerror = function (err) {
                    reject('Error loading markerIcon ' + image, { err: err });
                };
                imageElement.src = image;
            });
        }
    }, {
        key: 'addMarker',
        value: function addMarker(locationMarker) {
            var _this3 = this;

            log('addMarker');
            var markerOptions = locationMarker.getMarkerOptions(this.google.maps.Point);

            if (!this.options.cluster) {
                markerOptions.map = this.map;
            }

            var marker = new this.google.maps.marker.AdvancedMarkerElement(markerOptions);

            var markerFirstChild = this.getChildFromMarker(marker);
            locationMarker.updateContentEl(markerFirstChild);

            markerFirstChild.addEventListener("mouseenter", function () {
                locationMarker.onMarkerMouseIn();
            });

            markerFirstChild.addEventListener("mouseleave", function () {
                locationMarker.onMarkerMouseOut();
            });

            marker.addEventListener("gmp-click", function () {
                _this3.panAndOpenMarkerPopover(locationMarker);
            });

            this.markers.push(marker);

            if (this.options.cluster) {
                this.clusterer.addMarker(marker);
            };

            locationMarker.setMarker(marker);

            return Promise.resolve(locationMarker);
        }
    }, {
        key: 'showDirections',
        value: function showDirections(from, to) {
            var _this4 = this;

            var mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : google.maps.TravelMode.WALKING;

            if (!this.google.maps.DirectionsService || !this.google.maps.DirectionsRenderer) return;

            var directionsService = new this.google.maps.DirectionsService();
            var directionsDisplay = new this.google.maps.DirectionsRenderer();

            directionsDisplay.setMap(this.map);
            directionsService.route({
                origin: from,
                destination: to,
                travelMode: mode
            }, function (response, status) {
                if (status == _this4.google.maps.DirectionsStatus.OK) {
                    directionsDisplay.setDirections(response);
                    directionsDisplay.setOptions({
                        suppressMarkers: true,
                        preserveViewport: false
                    });

                    log('directions.set', response);
                }
            });
        }
    }, {
        key: 'placeMarkers',
        value: function placeMarkers() {
            var _this5 = this;

            log('placeMarkers');
            this.data.forEach(function (location) {
                var locationMarker = new _locationMarker2.default({
                    lat: location.lat,
                    lng: location.lng,
                    type: "store",

                    isHighlighted: false,
                    templateEl: _this5.markerTemplate,
                    popoverContent: location.html
                });
                locationMarker.setMarkerIcons(_this5.mapComponent.markerIcons);

                _this5.addMarker(locationMarker);
            });
            this.flush('markersPlaced');
        }
    }, {
        key: 'popoverContent',
        value: function popoverContent(_ref) {
            var html = _ref.html;

            this.$popoverContentElement.html(html);
        }
    }, {
        key: 'closePopover',
        value: function closePopover() {
            this.$element.removeClass(this.options.popoverOpenClass);
        }
    }, {
        key: 'openPopover',
        value: function openPopover() {
            this.$element.addClass(this.options.popoverOpenClass);
        }
    }, {
        key: 'panAndOpenMarkerPopover',
        value: function panAndOpenMarkerPopover(locationMarker) {
            this.selectedMarker = locationMarker.marker;
            this.popoverContent({ html: locationMarker.popoverContent });
            this.openPopover();
            this.offsetCenterPercentage(locationMarker.marker.position, this.options.mapCenterOffsetX, this.options.mapCenterOffsetY);
            this.pointPopoverAtMarker(locationMarker.marker.position);
        }
    }, {
        key: 'offsetCenter',
        value: function offsetCenter(latlng, offsetx, offsety) {

            // latlng is the apparent centre-point
            // offsetx is the distance you want that point to move to the right, in pixels
            // offsety is the distance you want that point to move upwards, in pixels
            // offset can be negative
            // offsetx and offsety are both optional

            var scale = Math.pow(2, this.map.getZoom());

            var worldCoordinateCenter = this.map.getProjection().fromLatLngToPoint(latlng);
            var pixelOffset = new this.google.maps.Point(offsetx / scale || 0, offsety / scale || 0);

            var worldCoordinateNewCenter = new this.google.maps.Point(worldCoordinateCenter.x - pixelOffset.x, worldCoordinateCenter.y + pixelOffset.y);

            var newCenter = this.map.getProjection().fromPointToLatLng(worldCoordinateNewCenter);

            this.map.setCenter(newCenter);
        }
    }, {
        key: 'offsetCenterPercentage',
        value: function offsetCenterPercentage(center) {
            var offsetX = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.25;
            var offsetY = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.25;

            var span = this.map.getBounds().toSpan(); // a latLng - # of deg map spans

            var newCenter = {
                lat: center.lat + span.lat() * offsetY,
                lng: center.lng + span.lng() * offsetX
            };

            this.map.setCenter(newCenter); // or map.setCenter(newCenter);
        }
    }, {
        key: 'latLngToPixels',
        value: function latLngToPixels(latlng) {
            var projection = this.map.getProjection();
            var bounds = this.map.getBounds();
            var topRight = projection.fromLatLngToPoint(bounds.getNorthEast());
            var bottomLeft = projection.fromLatLngToPoint(bounds.getSouthWest());
            var scale = Math.pow(2, this.map.getZoom());
            var worldPoint = projection.fromLatLngToPoint(latlng);
            return {
                x: Math.floor((worldPoint.x - bottomLeft.x) * scale),
                y: Math.floor((worldPoint.y - topRight.y) * scale)
            };
        }
    }, {
        key: 'pixelsToLatLng',
        value: function pixelsToLatLng(_ref2) {
            var x = _ref2.x,
                y = _ref2.y;

            // retrieve the lat lng for the far extremities of the (visible) map
            var latLngBounds = this.map.getBounds();
            var neBound = latLngBounds.getNorthEast();
            var swBound = latLngBounds.getSouthWest();

            // convert the bounds in pixels
            var neBoundInPx = this.map.getProjection().fromLatLngToPoint(neBound);
            var swBoundInPx = this.map.getProjection().fromLatLngToPoint(swBound);

            // compute the percent of x and y coordinates related to the div containing the map; in my case the screen
            var procX = x / this.$viewportElement.width();
            var procY = y / this.$viewportElement.height();

            // compute new coordinates in pixels for lat and lng;
            // for lng : subtract from the right edge of the container the left edge,
            // multiply it by the percentage where the x coordinate was on the screen
            // related to the container in which the map is placed and add back the left boundary
            // you should now have the Lng coordinate in pixels
            // do the same for lat
            var newLngInPx = (neBoundInPx.x - swBoundInPx.x) * procX + swBoundInPx.x;
            var newLatInPx = (swBoundInPx.y - neBoundInPx.y) * procY + neBoundInPx.y;

            // convert from google point in lat lng and have fun :)
            return this.map.getProjection().fromPointToLatLng(new this.google.maps.Point(newLngInPx, newLatInPx));
        }
    }, {
        key: 'pointPopoverAtMarker',
        value: function pointPopoverAtMarker(point) {
            var _latLngToPixels = this.latLngToPixels(point),
                x = _latLngToPixels.x,
                y = _latLngToPixels.y;

            this.$popoverElement.css({
                left: x,
                top: y - this.$popoverElement.height()
            });
        }
    }, {
        key: 'moveMapTo',
        value: function moveMapTo(point) {
            var zoom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.options.zoom;

            this.map.setCenter(point);
            this.map.setZoom(zoom);
        }
    }, {
        key: 'getNearestMarker',
        value: function getNearestMarker() {
            var _this6 = this;

            var marker = this.markers.map(function (marker) {
                marker.distance = _this6.google.maps.geometry.spherical.computeDistanceBetween(marker.position, _this6.map.getCenter());
                return marker;
            }).sort(function (current, next) {
                return current.distance > next.distance ? 1 : -1;
            }).slice(0, 1)[0];
            return marker;
        }
    }, {
        key: 'panToFitPosition',
        value: function panToFitPosition(position) {
            if (!position) return;
            var bounds = new this.google.maps.LatLngBounds();
            bounds.extend(this.map.getCenter());
            this.map.fitBounds(bounds);
        }
    }, {
        key: 'panToFitMarkers',
        value: function panToFitMarkers(markers) {
            if (!markers) return;
            if (markers && markers.length) {
                var bounds = markers.reduce(function (bounds, marker) {
                    if (!bounds.contains(marker.position)) bounds.extend(marker.position);
                    return bounds;
                }, new this.google.maps.LatLngBounds());

                if (bounds) {
                    bounds.extend(this.map.getCenter());
                    this.map.fitBounds(bounds);
                }
            }
        }
    }, {
        key: 'gpsLocation',
        get: function get() {
            return new Promise(function (resolve, reject) {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(resolve, reject);
                } else {
                    reject(new Error('navigator.geolocation not available'));
                }
            });
        }
    }, {
        key: 'mapOptions',
        get: function get() {
            var _this7 = this;

            return new Promise(function (resolve, reject) {
                var _options = _this7.options,
                    lat = _options.lat,
                    lng = _options.lng,
                    zoom = _options.zoom,
                    gestureHandling = _options.gestureHandling,
                    draggable = _options.draggable,
                    clickableIcons = _options.clickableIcons,
                    styles = _options.styles,
                    minZoom = _options.minZoom,
                    maxZoom = _options.maxZoom,
                    tilt = _options.tilt,
                    backgroundColor = _options.backgroundColor,
                    disableDefaultUI = _options.disableDefaultUI,
                    disableDoubleClickZoom = _options.disableDoubleClickZoom,
                    draggableCursor = _options.draggableCursor,
                    draggingCursor = _options.draggingCursor,
                    fullscreenControl = _options.fullscreenControl,
                    fullscreenControlOptions = _options.fullscreenControlOptions,
                    heading = _options.heading,
                    keyboardShortcuts = _options.keyboardShortcuts,
                    mapTypeControl = _options.mapTypeControl,
                    mapTypeControlOptions = _options.mapTypeControlOptions,
                    mapTypeId = _options.mapTypeId,
                    noClear = _options.noClear,
                    panControl = _options.panControl,
                    panControlOptions = _options.panControlOptions,
                    rotateControl = _options.rotateControl,
                    rotateControlOptions = _options.rotateControlOptions,
                    scaleControl = _options.scaleControl,
                    scaleControlOptions = _options.scaleControlOptions,
                    scrollwheel = _options.scrollwheel,
                    streetViewControl = _options.streetViewControl,
                    zoomControl = _options.zoomControl,
                    zoomControlOptions = _options.zoomControlOptions,
                    mapId = _options.mapId;


                var options = {
                    center: { lat: lat, lng: lng },
                    zoom: zoom,
                    minZoom: minZoom,
                    maxZoom: maxZoom,
                    tilt: tilt,
                    gestureHandling: gestureHandling,
                    draggable: draggable,
                    clickableIcons: clickableIcons,
                    styles: styles,
                    backgroundColor: backgroundColor,
                    disableDefaultUI: disableDefaultUI,
                    disableDoubleClickZoom: disableDoubleClickZoom,
                    draggableCursor: draggableCursor,
                    draggingCursor: draggingCursor,
                    fullscreenControl: fullscreenControl,
                    fullscreenControlOptions: fullscreenControlOptions,
                    heading: heading,
                    keyboardShortcuts: keyboardShortcuts,
                    mapTypeControl: mapTypeControl,
                    mapTypeControlOptions: mapTypeControlOptions,
                    mapTypeId: mapTypeId,
                    noClear: noClear,
                    panControl: panControl,
                    panControlOptions: panControlOptions,
                    rotateControl: rotateControl,
                    rotateControlOptions: rotateControlOptions,
                    scaleControl: scaleControl,
                    scaleControlOptions: scaleControlOptions,
                    scrollwheel: scrollwheel,
                    streetViewControl: streetViewControl,
                    zoomControl: zoomControl,
                    zoomControlOptions: zoomControlOptions,
                    mapId: mapId
                };

                resolve(options);
            });
        }
    }, {
        key: 'popoverIsOpen',
        get: function get() {
            return this.$element.hasClass(this.options.popoverOpenClass);
        }
    }]);

    return StoreLocatorMap;
}();

// Note to style maps you need a mapId and to use cloud styles
// https://developers.google.com/maps/documentation/javascript/styling#cloud_tooling

StoreLocatorMap.DEFAULTS = {
    lat: 0,
    lng: 0,
    zoom: 8,
    tilt: 0, // 0 or 45
    draggable: true,
    gestureHandling: null,
    maxZoom: 15,
    minZoom: 1,
    maxClusterZoom: 14,
    gridSize: 50,
    // reference: https://developers.google.com/maps/documentation/javascript/style-reference
    // wizard tool: https://mapstyle.withgoogle.com/
    styles: null,

    mapCenterOffsetX: 0,
    mapCenterOffsetY: 0.25,
    defaultMarkerIcon: null,

    cluster: true,
    defaultClusterIcon: null,
    clusterAverageCenter: true,
    clusterClass: 'store-locator-map__cluster',
    clusterLabelClass: 'store-locator-map__cluster-label',

    showDirections: false,
    useBrowserGps: false,
    minimumVisibleMarkers: 1,
    markerLabelClass: 'store-locator-map__marker-label',
    mapEdgePaddingPx: 32,
    viewportSelector: '.store-locator-map__viewport',
    maskSelector: '.store-locator-map__mask',
    popoverSelector: '.store-locator-map__popover',
    popoverCloseSelector: '.store-locator-map__popover-close-button',
    popoverContentSelector: '.store-locator-map__popover-content',
    popoverOpenClass: 'store-locator-map--popover-open',
    streetView: false,
    streetViewControl: false,
    mapTypeControl: false,
    fullscreenControl: false,
    rotateControl: false,
    scaleControl: false,
    disableDefaultUI: false
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/store-locator-map/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ELEMENT_SELECTOR = exports.MODULE_NAME = undefined;
exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = exports.MODULE_NAME = 'app.core/modules/store-locator-map';
var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-store-locator-map]';

var log = (0, _debug2.default)(MODULE_NAME);

function exec() {
    var elements = $(ELEMENT_SELECTOR).toArray();
    if (!elements || !elements.length) {
        return;
    }

    var _require = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/store-locator-map/component.js"),
        StoreLocatorMap = _require.StoreLocatorMap;

    (0, _plugin2.default)('storeLocatorMap', StoreLocatorMap);
    $(elements).storeLocatorMap();
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/store-locator-map/location-marker.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _debug2.default)("location-marker");

var LocationMarker = function () {
	function LocationMarker(_ref) {
		var id = _ref.id,
		    lat = _ref.lat,
		    lng = _ref.lng,
		    type = _ref.type,
		    isHighlighted = _ref.isHighlighted,
		    resultItem = _ref.resultItem,
		    templateEl = _ref.templateEl,
		    label = _ref.label,
		    popoverContent = _ref.popoverContent;

		_classCallCheck(this, LocationMarker);

		this.type = type;

		// Note all atm and branch markers are highlighted while all-locations is out of scope
		this.isHighlighted = isHighlighted;
		this.resultItem = resultItem;
		this.id = id;
		this.lat = lat;
		this.lng = lng;
		this.state = "idle";
		this.contentEl = this.generateMarkerContent(templateEl, label);
		this.popoverContent = popoverContent;
	}

	_createClass(LocationMarker, [{
		key: "setMarkerIcons",
		value: function setMarkerIcons(markerIcon) {
			this.markerIcon = markerIcon;
		}
	}, {
		key: "setMarker",
		value: function setMarker(marker) {
			this.marker = marker;
		}
	}, {
		key: "generateMarkerContent",
		value: function generateMarkerContent(templateEl, label) {
			var content = templateEl.content.cloneNode(true);
			if (label) {
				content.querySelectorAll("[data-label]").forEach(function (el) {
					return el.textContent = label;
				});
			}
			content.querySelector('.map-marker').classList.add("map-marker--" + this.type);
			return content;
		}
	}, {
		key: "getMarkerOptions",
		value: function getMarkerOptions(Point) {
			this.updateIconImage(this.getIdleIcon());
			return {
				position: { lat: this.lat, lng: this.lng },
				content: this.contentEl,
				gmpClickable: this.type != "search"
			};
		}

		// this is required as initializing the AdvancedMarkerElement causes the document fragment created in generateMarkerContent to become empty.

	}, {
		key: "updateContentEl",
		value: function updateContentEl(markerContentEl) {
			this.contentEl = markerContentEl;
		}

		// this logic is redundant while all-locations is in scope

	}, {
		key: "getIdleIcon",
		value: function getIdleIcon() {
			return this.markerIcon[this.type][this.isHighlighted ? "highlight" : "default"];
		}
	}, {
		key: "getHoverIcon",
		value: function getHoverIcon() {
			return this.markerIcon[this.type]["hover"];
		}
	}, {
		key: "getSelectIcon",
		value: function getSelectIcon() {
			return this.markerIcon[this.type]["selected"];
		}
	}, {
		key: "getWidth",
		value: function getWidth() {
			return this.markerIcon[this.type]["width"];
		}
	}, {
		key: "getHeight",
		value: function getHeight() {
			return this.markerIcon[this.type]["height"];
		}
	}, {
		key: "hoverMarker",
		value: function hoverMarker() {
			if (this.getHoverIcon()) {
				this.updateIconImage(this.getHoverIcon());
			}
		}
	}, {
		key: "unhoverMarker",
		value: function unhoverMarker() {
			this.updateIconImage(this.getIdleIcon());
		}
	}, {
		key: "selectMarker",
		value: function selectMarker() {
			this.state = "selected";
			this.updateIconImage(this.getSelectIcon());
		}
	}, {
		key: "deselectMarker",
		value: function deselectMarker() {
			this.state = "idle";
			this.updateIconImage(this.getIdleIcon());
		}
	}, {
		key: "updateIconImage",
		value: function updateIconImage(iconPath) {
			this.contentEl.querySelectorAll("[data-icon]").forEach(function (el) {
				return el.src = iconPath;
			});
		}
	}, {
		key: "onMarkerMouseIn",
		value: function onMarkerMouseIn() {
			if (this.state === "selected") {
				return false;
			}
			var hoverIcon = this.getHoverIcon();
			if (hoverIcon) {
				this.updateIconImage(hoverIcon);
			}
			if (this.resultItem) {
				this.resultItem.highlight();
			}
		}
	}, {
		key: "onMarkerMouseOut",
		value: function onMarkerMouseOut() {
			if (this.state === "selected") {
				return false;
			}
			this.updateIconImage(this.getIdleIcon());
			if (this.resultItem) {
				this.resultItem.unhighlight();
			}
		}
	}]);

	return LocationMarker;
}();

exports.default = LocationMarker;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/store-locator-map/map-marker-icons.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
// `default` icons for atm and branch are unused - associated with out-of-scope all-locations markers
// leaving them here in case this changes

exports.default = {
	store: {
		default: "data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M37.185 45.929C46.93 42.939 54 34.028 54 23.5 54 10.521 43.255 0 30 0S6 10.521 6 23.5c0 10.528 7.07 19.439 16.815 22.429L30 60l7.185-14.071Z' fill='%23C4122E'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M23.877 23.484h4.297c.382 0 .86-.193 1.146-.484l.573-.58c-.19 4.165-1.719 7.458-6.016 8.814v-7.75Zm7.067-.387-.572.582c.19-4.262 1.814-7.46 6.015-8.913v7.848h-4.201c-.477 0-.955.193-1.242.483Zm5.775 5.187c0 1.745-1.395 3.16-3.116 3.16H23.545V17.718c0-1.745 1.394-3.161 3.115-3.161h10.06v13.727ZM26.661 13c-2.57 0-4.66 2.116-4.66 4.717V33h11.602c2.57 0 4.661-2.117 4.661-4.718V13H26.661Z' fill='%23fff'/%3E%3C/svg%3E%0A",
		highlight: "data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M37.185 45.929C46.93 42.939 54 34.028 54 23.5 54 10.521 43.255 0 30 0S6 10.521 6 23.5c0 10.528 7.07 19.439 16.815 22.429L30 60l7.185-14.071Z' fill='%23C4122E'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M23.877 23.484h4.297c.382 0 .86-.193 1.146-.484l.573-.58c-.19 4.165-1.719 7.458-6.016 8.814v-7.75Zm7.067-.387-.572.582c.19-4.262 1.814-7.46 6.015-8.913v7.848h-4.201c-.477 0-.955.193-1.242.483Zm5.775 5.187c0 1.745-1.395 3.16-3.116 3.16H23.545V17.718c0-1.745 1.394-3.161 3.115-3.161h10.06v13.727ZM26.661 13c-2.57 0-4.66 2.116-4.66 4.717V33h11.602c2.57 0 4.661-2.117 4.661-4.718V13H26.661Z' fill='%23fff'/%3E%3C/svg%3E%0A",
		selected: "data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M37.185 45.929C46.93 42.939 54 34.028 54 23.5 54 10.521 43.255 0 30 0S6 10.521 6 23.5c0 10.528 7.07 19.439 16.815 22.429L30 60l7.185-14.071Z' fill='%23C4122E'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M23.877 23.484h4.297c.382 0 .86-.193 1.146-.484l.573-.58c-.19 4.165-1.719 7.458-6.016 8.814v-7.75Zm7.067-.387-.572.582c.19-4.262 1.814-7.46 6.015-8.913v7.848h-4.201c-.477 0-.955.193-1.242.483Zm5.775 5.187c0 1.745-1.395 3.16-3.116 3.16H23.545V17.718c0-1.745 1.394-3.161 3.115-3.161h10.06v13.727ZM26.661 13c-2.57 0-4.66 2.116-4.66 4.717V33h11.602c2.57 0 4.661-2.117 4.661-4.718V13H26.661Z' fill='%23fff'/%3E%3C/svg%3E%0A",
		hover: "data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M37.185 45.929C46.93 42.939 54 34.028 54 23.5 54 10.521 43.255 0 30 0S6 10.521 6 23.5c0 10.528 7.07 19.439 16.815 22.429L30 60l7.185-14.071Z' fill='%23C4122E'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M23.877 23.484h4.297c.382 0 .86-.193 1.146-.484l.573-.58c-.19 4.165-1.719 7.458-6.016 8.814v-7.75Zm7.067-.387-.572.582c.19-4.262 1.814-7.46 6.015-8.913v7.848h-4.201c-.477 0-.955.193-1.242.483Zm5.775 5.187c0 1.745-1.395 3.16-3.116 3.16H23.545V17.718c0-1.745 1.394-3.161 3.115-3.161h10.06v13.727ZM26.661 13c-2.57 0-4.66 2.116-4.66 4.717V33h11.602c2.57 0 4.661-2.117 4.661-4.718V13H26.661Z' fill='%23fff'/%3E%3C/svg%3E%0A",
		width: 60,
		height: 60
	},
	gardenCentre: {
		default: "data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M37.185 45.929C46.93 42.939 54 34.028 54 23.5 54 10.521 43.255 0 30 0S6 10.521 6 23.5c0 10.528 7.07 19.439 16.815 22.429L30 60l7.185-14.071Z' fill='%23C4122E'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M24.49 23.436h3.867c.344 0 .774-.174 1.031-.436l.516-.523c-.172 3.75-1.547 6.714-5.414 7.934v-6.975Zm6.36-.349-.516.524c.172-3.836 1.633-6.714 5.414-8.022v7.063h-3.781c-.43 0-.86.174-1.118.435Zm5.197 4.668c0 1.57-1.255 2.844-2.804 2.844h-9.052V18.246c0-1.57 1.254-2.845 2.803-2.845h9.053v12.354ZM26.995 14c-2.314 0-4.195 1.905-4.195 4.246V32h10.443c2.313 0 4.195-1.905 4.195-4.246V14H26.995Z' fill='%23fff'/%3E%3Cg clip-path='url(%23a)'%3E%3Crect x='38.5' y='.5' width='21' height='21' rx='10.5' fill='%23fff' stroke='%2308B040'/%3E%3Cg clip-path='url(%23b)'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M49 0c-6.075 0-11 4.925-11 11s4.925 11 11 11 11-4.925 11-11S55.075 0 49 0Zm-6.5 12c-.123-1.112 0-3 2.387-4.78 4.024-3 12.395-.432 12.105-.02-.595.82-1.12 1.578-1.607 2.28-1.663 2.399-2.878 4.152-4.911 5.587C48.5 16.5 45.097 15.633 44 14.5c0 0-1.214.832-2 2.5-.268.556-1.207-.526-1-1 2.566-5.992 11.295-7.441 11.295-7.441S46.805 7.943 42.5 12Z' fill='%23068932'/%3E%3C/g%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='a'%3E%3Crect x='38' width='22' height='22' rx='11' fill='%23fff'/%3E%3C/clipPath%3E%3CclipPath id='b'%3E%3Crect x='38' width='22' height='22' rx='11' fill='%23fff'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A",
		highlight: "data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M37.185 45.929C46.93 42.939 54 34.028 54 23.5 54 10.521 43.255 0 30 0S6 10.521 6 23.5c0 10.528 7.07 19.439 16.815 22.429L30 60l7.185-14.071Z' fill='%23C4122E'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M24.49 23.436h3.867c.344 0 .774-.174 1.031-.436l.516-.523c-.172 3.75-1.547 6.714-5.414 7.934v-6.975Zm6.36-.349-.516.524c.172-3.836 1.633-6.714 5.414-8.022v7.063h-3.781c-.43 0-.86.174-1.118.435Zm5.197 4.668c0 1.57-1.255 2.844-2.804 2.844h-9.052V18.246c0-1.57 1.254-2.845 2.803-2.845h9.053v12.354ZM26.995 14c-2.314 0-4.195 1.905-4.195 4.246V32h10.443c2.313 0 4.195-1.905 4.195-4.246V14H26.995Z' fill='%23fff'/%3E%3Cg clip-path='url(%23a)'%3E%3Crect x='38.5' y='.5' width='21' height='21' rx='10.5' fill='%23fff' stroke='%2308B040'/%3E%3Cg clip-path='url(%23b)'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M49 0c-6.075 0-11 4.925-11 11s4.925 11 11 11 11-4.925 11-11S55.075 0 49 0Zm-6.5 12c-.123-1.112 0-3 2.387-4.78 4.024-3 12.395-.432 12.105-.02-.595.82-1.12 1.578-1.607 2.28-1.663 2.399-2.878 4.152-4.911 5.587C48.5 16.5 45.097 15.633 44 14.5c0 0-1.214.832-2 2.5-.268.556-1.207-.526-1-1 2.566-5.992 11.295-7.441 11.295-7.441S46.805 7.943 42.5 12Z' fill='%23068932'/%3E%3C/g%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='a'%3E%3Crect x='38' width='22' height='22' rx='11' fill='%23fff'/%3E%3C/clipPath%3E%3CclipPath id='b'%3E%3Crect x='38' width='22' height='22' rx='11' fill='%23fff'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A",
		selected: "data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M37.185 45.929C46.93 42.939 54 34.028 54 23.5 54 10.521 43.255 0 30 0S6 10.521 6 23.5c0 10.528 7.07 19.439 16.815 22.429L30 60l7.185-14.071Z' fill='%23C4122E'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M24.49 23.436h3.867c.344 0 .774-.174 1.031-.436l.516-.523c-.172 3.75-1.547 6.714-5.414 7.934v-6.975Zm6.36-.349-.516.524c.172-3.836 1.633-6.714 5.414-8.022v7.063h-3.781c-.43 0-.86.174-1.118.435Zm5.197 4.668c0 1.57-1.255 2.844-2.804 2.844h-9.052V18.246c0-1.57 1.254-2.845 2.803-2.845h9.053v12.354ZM26.995 14c-2.314 0-4.195 1.905-4.195 4.246V32h10.443c2.313 0 4.195-1.905 4.195-4.246V14H26.995Z' fill='%23fff'/%3E%3Cg clip-path='url(%23a)'%3E%3Crect x='38.5' y='.5' width='21' height='21' rx='10.5' fill='%23fff' stroke='%2308B040'/%3E%3Cg clip-path='url(%23b)'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M49 0c-6.075 0-11 4.925-11 11s4.925 11 11 11 11-4.925 11-11S55.075 0 49 0Zm-6.5 12c-.123-1.112 0-3 2.387-4.78 4.024-3 12.395-.432 12.105-.02-.595.82-1.12 1.578-1.607 2.28-1.663 2.399-2.878 4.152-4.911 5.587C48.5 16.5 45.097 15.633 44 14.5c0 0-1.214.832-2 2.5-.268.556-1.207-.526-1-1 2.566-5.992 11.295-7.441 11.295-7.441S46.805 7.943 42.5 12Z' fill='%23068932'/%3E%3C/g%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='a'%3E%3Crect x='38' width='22' height='22' rx='11' fill='%23fff'/%3E%3C/clipPath%3E%3CclipPath id='b'%3E%3Crect x='38' width='22' height='22' rx='11' fill='%23fff'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A",
		hover: "data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M37.185 45.929C46.93 42.939 54 34.028 54 23.5 54 10.521 43.255 0 30 0S6 10.521 6 23.5c0 10.528 7.07 19.439 16.815 22.429L30 60l7.185-14.071Z' fill='%23C4122E'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M24.49 23.436h3.867c.344 0 .774-.174 1.031-.436l.516-.523c-.172 3.75-1.547 6.714-5.414 7.934v-6.975Zm6.36-.349-.516.524c.172-3.836 1.633-6.714 5.414-8.022v7.063h-3.781c-.43 0-.86.174-1.118.435Zm5.197 4.668c0 1.57-1.255 2.844-2.804 2.844h-9.052V18.246c0-1.57 1.254-2.845 2.803-2.845h9.053v12.354ZM26.995 14c-2.314 0-4.195 1.905-4.195 4.246V32h10.443c2.313 0 4.195-1.905 4.195-4.246V14H26.995Z' fill='%23fff'/%3E%3Cg clip-path='url(%23a)'%3E%3Crect x='38.5' y='.5' width='21' height='21' rx='10.5' fill='%23fff' stroke='%2308B040'/%3E%3Cg clip-path='url(%23b)'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M49 0c-6.075 0-11 4.925-11 11s4.925 11 11 11 11-4.925 11-11S55.075 0 49 0Zm-6.5 12c-.123-1.112 0-3 2.387-4.78 4.024-3 12.395-.432 12.105-.02-.595.82-1.12 1.578-1.607 2.28-1.663 2.399-2.878 4.152-4.911 5.587C48.5 16.5 45.097 15.633 44 14.5c0 0-1.214.832-2 2.5-.268.556-1.207-.526-1-1 2.566-5.992 11.295-7.441 11.295-7.441S46.805 7.943 42.5 12Z' fill='%23068932'/%3E%3C/g%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='a'%3E%3Crect x='38' width='22' height='22' rx='11' fill='%23fff'/%3E%3C/clipPath%3E%3CclipPath id='b'%3E%3Crect x='38' width='22' height='22' rx='11' fill='%23fff'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A",
		width: 60,
		height: 60
	},
	cluster: {
		default: "data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M41 6c10.493 0 19 8.507 19 19 0 8.622-5.743 15.9-13.612 18.223L41 54l-5.389-10.777C27.743 40.9 22 33.62 22 25c0-10.493 8.507-19 19-19Z' fill='%239D1225'/%3E%3Cpath d='M19 6c10.493 0 19 8.507 19 19 0 8.622-5.743 15.9-13.612 18.223L19 54l-5.389-10.777C5.743 40.9 0 33.62 0 25 0 14.507 8.507 6 19 6Z' fill='%239D1225'/%3E%3Cpath d='M30 0c13.255 0 24 10.521 24 23.5 0 10.528-7.07 19.438-16.815 22.428L30 60l-7.186-14.072C13.07 42.938 6 34.028 6 23.5 6 10.521 16.745 0 30 0Z' fill='%23C4122E'/%3E%3C/svg%3E%0A",
		hover: "data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M41 6c10.493 0 19 8.507 19 19 0 8.622-5.743 15.9-13.612 18.223L41 54l-5.389-10.777C27.743 40.9 22 33.62 22 25c0-10.493 8.507-19 19-19Z' fill='%239D1225'/%3E%3Cpath d='M19 6c10.493 0 19 8.507 19 19 0 8.622-5.743 15.9-13.612 18.223L19 54l-5.389-10.777C5.743 40.9 0 33.62 0 25 0 14.507 8.507 6 19 6Z' fill='%239D1225'/%3E%3Cpath d='M30 0c13.255 0 24 10.521 24 23.5 0 10.528-7.07 19.438-16.815 22.428L30 60l-7.186-14.072C13.07 42.938 6 34.028 6 23.5 6 10.521 16.745 0 30 0Z' fill='%23C4122E'/%3E%3C/svg%3E%0A",
		width: 60,
		height: 60
	}
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/store-locator-search/component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StoreLocatorSearch = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global $:true plyr:true */

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _index = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/store-locator-search/index.js");

var _googleMapsApi = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/services/google-maps-api/index.js");

var _googleMapsApi2 = _interopRequireDefault(_googleMapsApi);

var _debounce = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/debounce.js");

var _debounce2 = _interopRequireDefault(_debounce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _debug2.default)(_index.MODULE_NAME);

var StoreLocatorSearch = exports.StoreLocatorSearch = function () {
    function StoreLocatorSearch(element, options) {
        _classCallCheck(this, StoreLocatorSearch);

        this.element = element;
        this.$element = $(element);
        this.$form = this.$element;
        this.options = options;

        if (this.element.nodeName != 'form') {
            this.$form = this.$element.find(this.options.formSelector);
        }

        log('construct', this.element, this.options);

        this.$addressField = this.$element.find(this.options.addressFieldSelector);
        this.$addressGoogleComponent = this.$element.find(this.options.addressGoogleComponentSelector);
        this.$submitButton = this.$element.find(this.options.submitButtonSelector);
        this.$latField = this.$element.find('[' + this.options.latLngKeyAttribute + '="lat"]');
        this.$lngField = this.$element.find('[' + this.options.latLngKeyAttribute + '="lng"]');

        this.place = {};

        _googleMapsApi2.default.then(this.init.bind(this));
    }

    _createClass(StoreLocatorSearch, [{
        key: 'init',
        value: function init() {
            log('init');
            this.$form.on('submit', this.onSubmit.bind(this));
            this.$addressGoogleComponent.on('keypress', (0, _debounce2.default)(this.onKeyPress.bind(this), 150));
            this.$addressGoogleComponent.on('place_selected', this.onPlaceSelected.bind(this));
        }
    }, {
        key: 'onKeyPress',
        value: function onKeyPress(event) {
            switch (event.keycode) {
                case 13:
                    event.preventDefault();
                    break;

                default:
                    this.setFormLatLngValues('', ''); //blanks out the form field values
                    break;
            }
        }
    }, {
        key: 'onPlaceSelected',
        value: function onPlaceSelected(event) {

            if (!this.submitOnchange) {
                log('place_selected.preventDefault', event);
                event.preventDefault && event.preventDefault();
            }

            var place = event.place;

            if (!place || !place.location) return;

            this.setSelectedPlace(place);

            if (this.submitOnchange) {
                this.$form.submit();
            }
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit(event) {
            this.$submitButton.addClass('has-progress');
        }
    }, {
        key: 'setFormLatLngValues',
        value: function setFormLatLngValues(lat, lng) {
            this.$latField.get(0).value = lat || '';
            this.$lngField.get(0).value = lng || '';
        }
    }, {
        key: 'setSelectedPlace',
        value: function setSelectedPlace(place) {
            this.place = place;

            var _getSelectedLatLng = this.getSelectedLatLng(place),
                lat = _getSelectedLatLng.lat,
                lng = _getSelectedLatLng.lng;

            log('setSelectedPlace', { name: this.$addressField.val(), lat: lat, lng: lng });
            this.setFormLatLngValues(lat, lng);
        }
    }, {
        key: 'getSelectedLatLng',
        value: function getSelectedLatLng(place) {
            if (!place) {
                return {};
            }
            var _place$location = place.location,
                lat = _place$location.lat,
                lng = _place$location.lng;

            return {
                lat: lat(),
                lng: lng()
            };
        }
    }]);

    return StoreLocatorSearch;
}();

StoreLocatorSearch.DEFAULTS = {
    submitOnchange: false,
    addressFieldSelector: '.store-locator-search__address-field',
    submitButtonSelector: '.store-locator-search__submit-button',
    latLngKeyAttribute: 'data-store-locator-search-latlng', // also used to build the selector
    formSelector: 'form'
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/store-locator-search/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ELEMENT_SELECTOR = exports.MODULE_NAME = undefined;
exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = exports.MODULE_NAME = 'app.core/modules/store-locator-search';
var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-store-locator-search]';

var log = (0, _debug2.default)(MODULE_NAME);

function exec() {
    var elements = $(ELEMENT_SELECTOR).toArray();
    if (!elements || !elements.length) {
        return;
    }

    var _require = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/store-locator-search/component.js"),
        StoreLocatorSearch = _require.StoreLocatorSearch;

    (0, _plugin2.default)('storeLocatorSearch', StoreLocatorSearch);
    $(elements).storeLocatorSearch();
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/swatch-row/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.exec = exec;

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

var _selectors = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/selectors.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global $:true */
var ELEMENT_SELECTOR = '[data-swatch-row]';
var PLUGIN_NAME = 'swatchRow';

function exec() {
	_selectors.onAvailable.ready(ELEMENT_SELECTOR, function (element) {
		__webpack_require__.e/* import() */("plugin--swatch-row").then(__webpack_require__.bind(null, "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/swatch-row/swatch-row.js")).then(function (module) {
			(0, _plugin2.default)(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/sync-value/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

var _debounce = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/debounce.js");

var _debounce2 = _interopRequireDefault(_debounce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MODULE_NAME = 'app.core/modules/sync-value';
var log = (0, _debug2.default)(MODULE_NAME);

var ELEMENT_SELECTOR = '[data-sync-value]';

var SyncValue = function () {
    function SyncValue(element, options) {
        _classCallCheck(this, SyncValue);

        this.element = element;
        this.options = options;
        this.$element = $(element);
        log('SyncValue', element, options);
        this.watch();
    }

    _createClass(SyncValue, [{
        key: 'watch',
        value: function watch() {
            var _this = this;

            this.$element.on('keyup.syncvalue', (0, _debounce2.default)(function () {
                SyncValue.$bus.publish('syncvalue', {
                    value: _this.element.value
                });
            }, this.options.debounceMs));

            SyncValue.$bus.subscribe('syncvalue', function (event, _ref) {
                var _ref$value = _ref.value,
                    value = _ref$value === undefined ? '' : _ref$value;

                log('syncvalue', value);
                _this.element.value = value;
            });

            log('bound', this.element);
        }
    }, {
        key: 'unwatch',
        value: function unwatch() {
            this.$element.off('.syncvalue');
            log('unbound', this.element);
        }
    }]);

    return SyncValue;
}();

SyncValue.DEFAULTS = {
    debounceMs: 50
};

(0, _plugin2.default)('syncValue', SyncValue);

function exec() {
    $(document).ready(function () {
        log('binding');
        $(ELEMENT_SELECTOR).syncValue();
        log('bound');
    });
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/tabs/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.exec = exec;

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

var _selectors = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/selectors.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global $:true */
var ELEMENT_SELECTOR = '[data-tabs-controller]';
var PLUGIN_NAME = 'tabsController';

function exec() {
	_selectors.onAvailable.ready(ELEMENT_SELECTOR, function (element) {
		__webpack_require__.e/* import() */("plugin--tabs-controller").then(__webpack_require__.bind(null, "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/tabs/tabs-controller.js")).then(function (module) {
			(0, _plugin2.default)(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/toggle-class/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import plugin from '../../lib/plugin';

var MODULE_NAME = 'app.core/modules/toggle-class';
var log = (0, _debug2.default)(MODULE_NAME);

var TOGGLE_ELEMENT_ATTR = 'data-toggle-element';
var TOGGLE_ELEMENT_SELECTOR = '[' + TOGGLE_ELEMENT_ATTR + ']';

var TOGGLE_WITH_ELEMENT_ATTR = 'data-toggle-with-element';
var TOGGLE_WITH_ELEMENT_SELECTOR = '[' + TOGGLE_WITH_ELEMENT_ATTR + ']';

var HIDE_WITH_ELEMENT_ATTR = 'data-hide-with-element';

var TOGGLE_CLASSNAME_ATTR = 'data-toggle-class-name';

var TOGGLE_CLASS_ELEMENT_ATTR = 'data-toggle-class-target';
var TOGGLE_CLASS_ELEMENT_SELECTOR = '[' + TOGGLE_CLASS_ELEMENT_ATTR + ']';

var CHECK_TOGGLE_ELEMENT_ATTR = 'data-check-toggle-class-target';
var CHECK_TOGGLE_ELEMENT_SELECTOR = '[' + CHECK_TOGGLE_ELEMENT_ATTR + ']';

var CHECK_TOGGLE_CLASSNAME_ATTR = 'data-check-toggle-class-name';

var CHECK_TOGGLE_EVENT_ATTR = 'data-check-toggle-event';
var CHECK_TOGGLE_EVENT_SELECTOR = '[' + CHECK_TOGGLE_EVENT_ATTR + ']';

function toggleElementClassname() {
    var $this = $(this);
    var target = $this.attr(TOGGLE_CLASS_ELEMENT_ATTR);
    var classname = $this.attr(TOGGLE_CLASSNAME_ATTR);

    $(target).toggleClass(classname);
}

var defaultCheck = function defaultCheck($element, classname) {
    return $element.has(classname);
};

function checkToggleClass($trigger) {
    var checkFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultCheck;

    if ($trigger.length) {
        var target = $trigger.attr(CHECK_TOGGLE_ELEMENT_ATTR);
        var classname = $trigger.attr(CHECK_TOGGLE_CLASSNAME_ATTR);

        $(target).toggleClass(classname, checkFn($trigger, classname));
    }
}

function checkToggleEvent($trigger) {
    if ($trigger.length) {
        var eventName = $trigger.attr(CHECK_TOGGLE_EVENT_ATTR);
        var isUnchecked = !$trigger.is(':checked');

        $(document).trigger(eventName, isUnchecked);
    }
}

function toggleElement() {
    var $this = $(this);
    var target = $this.attr(TOGGLE_ELEMENT_ATTR);

    $(target).toggle();
}

function toggleWithElement() {
    var $this = $(this);
    var target = $this.attr(TOGGLE_WITH_ELEMENT_ATTR);
    var hideTarget = $this.attr(HIDE_WITH_ELEMENT_ATTR);

    $(hideTarget).hide();
    $(target).show();
}

function exec() {
    $(TOGGLE_CLASS_ELEMENT_SELECTOR).on('click', toggleElementClassname);

    $(TOGGLE_WITH_ELEMENT_SELECTOR).on('click', toggleWithElement);

    $(TOGGLE_ELEMENT_SELECTOR).on('click', toggleElement);

    $(CHECK_TOGGLE_EVENT_SELECTOR).on('change', function () {
        checkToggleEvent($(this));
    });

    $(CHECK_TOGGLE_ELEMENT_SELECTOR).on('change', function () {
        checkToggleClass($(this));
    });

    $(document).on('async_update', function (event, context) {
        log('element', $(context).find(CHECK_TOGGLE_ELEMENT_SELECTOR));

        $(context).find(CHECK_TOGGLE_ELEMENT_SELECTOR).on('change', function () {
            checkToggleClass($(this));
        });
    });

    $(document).ready(function () {
        checkToggleClass($(CHECK_TOGGLE_ELEMENT_SELECTOR), function ($element) {
            return $element.is(':checked');
        });

        checkToggleEvent($(CHECK_TOGGLE_EVENT_SELECTOR));
    });
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/toggle-disable/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MODULE_NAME = 'app.core/modules/toggle-disable';
var log = (0, _debug2.default)(MODULE_NAME);

var ELEMENT_SELECTOR = '[data-toggle-disable]';

function toggleDisabled() {
    var target = this.options.target;

    if ($(target).is(':disabled')) {
        $(target).removeAttr('disabled');
    } else {
        $(target).attr('disabled', 'disabled');
    }
}

function disableIfUnchecked(instance) {
    var target = instance.options.target;
    var $trigger = instance.$element;

    if ($trigger.is(':checked')) {
        $(target).removeAttr('disabled');
    } else {
        $(target).attr('disabled', 'disabled');
    }
}

var ToggleDisable = function () {
    function ToggleDisable(element, options) {
        _classCallCheck(this, ToggleDisable);

        this.element = element;
        this.options = options;
        this.$element = $(element);
        log('ToggleDisable', element, options);
        this.watch();
    }

    _createClass(ToggleDisable, [{
        key: 'watch',
        value: function watch() {
            this.$element.on('click.toggleDisable', toggleDisabled.bind(this));

            disableIfUnchecked(this);

            log('bound', this.element);
        }
    }, {
        key: 'unwatch',
        value: function unwatch() {
            this.$element.off('.toggleDisable');
            log('unbound', this.element);
        }
    }]);

    return ToggleDisable;
}();

ToggleDisable.DEFAULTS = {};

(0, _plugin2.default)('toggleDisable', ToggleDisable);

function exec() {
    $(document).on('async_update', function (event, context) {
        $(context).find(ELEMENT_SELECTOR).toggleDisable();
    });

    $(document).ready(function () {
        $(ELEMENT_SELECTOR).toggleDisable();
    });
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/toggle-if-value/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global $:true */


exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

var _jquery = __webpack_require__("external \"jQuery\"");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = '[data-toggle-if-value-element]';
var ATTR_ELEMENT_SELECTOR = 'data-toggle-if-value-element';
var ELEMENT_VALUE_SELECTOR = 'data-toggle-if-value-value';
var ELEMENT_NOT_VALUE_SELECTOR = 'data-toggle-if-value-not-values';
var REMOVE_CLASS_NAME_SELECTOR = 'data-toggle-if-value-remove-classname';
var ON_HIDE_ELEMENTS_DEFAULT = 'clear';
var PLUGIN_NAME = 'toggleIfValue';
var MODULE_NAME = 'app.core/modules/toggle-if-value';
var log = (0, _debug2.default)(MODULE_NAME);

log('registerd');

var ToggleIfValue = function () {
  function ToggleIfValue(element, options) {
    _classCallCheck(this, ToggleIfValue);

    log('new instance', element, options);

    this.element = element;
    this.options = options;
    this.$element = $(element);
    this.toggleElement = this.$element.attr(ATTR_ELEMENT_SELECTOR);
    this.$toggleElement = $(this.toggleElement);
    this.togglevalue = this.$element.attr(ELEMENT_VALUE_SELECTOR);
    this.toggleNotValue = this.$element.attr(ELEMENT_NOT_VALUE_SELECTOR);
    this.removeClassname = this.$element.attr(REMOVE_CLASS_NAME_SELECTOR);
    this.removeClassname = typeof this.removeClassname != 'undefined' ? this.removeClassname : '';
    this.onHideAction = this.element.dataset["toggleIfValueOnHideAction"] || ON_HIDE_ELEMENTS_DEFAULT;

    this.onShow = this.onHideAction === 'clear' ? function () {} : this.enableElements.bind(this);

    this.onHide = this.onHideAction === 'clear' ? this.clearElement.bind(this) : this.disableElements.bind(this);

    this.$toggleElement.on('keyup', this.change.bind(this));
    this.$toggleElement.on('change', this.change.bind(this));

    log('ready', this.$element);

    this.change();
  }

  _createClass(ToggleIfValue, [{
    key: 'change',
    value: function change() {
      var isChecked = this.$toggleElement.is(':checkbox') || this.$toggleElement.is(':radio') ? this.$toggleElement.is(':checked') : true;
      var toggleValues = typeof this.togglevalue !== 'undefined' ? this.togglevalue.split(',') : '';

      this.value = this.$toggleElement.val();
      if (this.$toggleElement.length > 1 && isChecked) {
        var selector = this.$element.attr(ATTR_ELEMENT_SELECTOR);
        this.value = $(selector + ':checked').val();
      }

      log('change', this.$element, this.value, this.initial);
      if (typeof this.toggleNotValue !== 'undefined') {
        var values = this.toggleNotValue.split(',');
        if (values.indexOf(this.value) >= 0 && isChecked) {
          this.$element.hide();
          this.onHide();
        } else {
          this.showElement();
          this.onShow();
        }
      } else if (toggleValues.indexOf(this.value) >= 0 && isChecked) {
        this.showElement();
        this.onShow();
      } else {
        this.$element.hide();
        this.onHide();
      }
    }
  }, {
    key: 'clearElement',
    value: function clearElement() {
      this.$element.find(':checked').removeAttr('checked').trigger('change');
      this.$element.find('[type="text"]').val('');
      this.$element.find('textarea').val('');
      this.$element.find('select').val('');
    }
  }, {
    key: 'disableElements',
    value: function disableElements() {
      Array.from(this.element.querySelectorAll("input, textarea, select")).forEach(function (element) {
        element.disabled = true;
      });
    }
  }, {
    key: 'enableElements',
    value: function enableElements() {
      Array.from(this.element.querySelectorAll("input, textarea, select")).forEach(function (element) {
        element.disabled = false;
      });
    }
  }, {
    key: 'showElement',
    value: function showElement() {
      this.$element.show();
      if (this.removeClassname.length > 0 && this.$element.hasClass(this.removeClassname)) {
        this.$element.removeClass(this.removeClassname);
      }
    }
  }]);

  return ToggleIfValue;
}();

(0, _plugin2.default)(PLUGIN_NAME, ToggleIfValue);

function exec() {
  $(document).ready(function () {
    $(ELEMENT_SELECTOR)[PLUGIN_NAME]();
  });
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/toggle-on-dirty/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global $:true */


exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = '[data-toggle-on-dirty]';
var PLUGIN_NAME = 'toggleOnDirty';
var MODULE_NAME = 'app.core/modules/updateable-textarea-component';
var log = (0, _debug2.default)(MODULE_NAME);

log('registerd');

var ToggleOnDirty = function () {
  function ToggleOnDirty(element, options) {
    _classCallCheck(this, ToggleOnDirty);

    log('new instance', element, options);

    this.element = element;
    this.options = options;

    this.$element = $(element);
    this.value = this.$element.val();
    this.initial = this.value;

    this.$element.on('keyup', this.change.bind(this));
    this.$element.on('change', this.change.bind(this));

    this.toggles = $(options.toggleSelectors);
    this.toggles.addClass('JS__toggle-on-dirty--target');

    log('ready', this.$element);

    this.change();
  }

  _createClass(ToggleOnDirty, [{
    key: 'change',
    value: function change() {
      this.value = this.$element.val();
      log('change', this.$element, this.value, this.initial);

      if (this.isDirty) {
        this.toggles.removeClass(this.options.toggleClassnames);
      } else {
        this.toggles.addClass(this.options.toggleClassnames);
      }
    }
  }, {
    key: 'isDirty',
    get: function get() {
      var yesno = this.initial !== this.value;
      log('isDirty', this.$element, yesno);

      return yesno;
    }
  }]);

  return ToggleOnDirty;
}();

ToggleOnDirty.DEFAULTS = {
  toggleSelectors: '',
  toggleClassnames: 'JS__toggle-on-dirty--is-clean'
};

(0, _plugin2.default)(PLUGIN_NAME, ToggleOnDirty);

function exec() {
  $(document).ready(function () {
    $(ELEMENT_SELECTOR)[PLUGIN_NAME]();
  });
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/transport-elements/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MODULE_NAME = 'app.core/modules/transport';
var log = (0, _debug2.default)(MODULE_NAME);

var TransportElementsPlugin = function () {
    function TransportElementsPlugin(element, options) {
        _classCallCheck(this, TransportElementsPlugin);

        log('new instance', element, options);

        this.element = element;
        this.options = options;

        if (!this.options.to) {
            throw new Error('Missing `to` option which is a target element selector.');
        }

        this.$element = $(element);
        this.$parent = this.$element.parent();

        // fire off an intial transport.
        this.check() && this.transport();
        this.watch();
    }

    /**
     * Determine if media query rule applies to this instance.
     *
     * @returns Boolean
     * @memberof TransportElementPlugin
     */


    _createClass(TransportElementsPlugin, [{
        key: 'check',
        value: function check() {
            var current = Foundation.MediaQuery.current;
            var result = false;

            if (this.options.at) {
                log('checking. Currently: ' + current + '. watching for: ' + this.options.at);
                result = current === this.options.at;
            } else if (this.options.atLeast) {
                log('checking. Currently: ' + current + '. watching for atLeast: ' + this.options.atLeast);
                result = Foundation.MediaQuery.atLeast(this.options.atLeast);
            }
            log('checked. ' + (result ? 'transporting' : 'waiting'));
            return result;
        }

        /**
         * transport element to the target element.
         *
         * @memberof TransportElementPlugin
         */

    }, {
        key: 'transport',
        value: function transport() {
            if (this.$element.parent().get(0) === this.$parent.get(0)) {
                log('transporting');
                this.$element.appendTo(this.options.to);
            }
        }

        /**
         * Return element back to its original place in the dom.
         *
         * @memberof TransportElementPlugin
         */

    }, {
        key: 'return',
        value: function _return() {
            if (this.$element.parent().get(0) !== this.$parent.get(0)) {
                log('returning');
                this.$element.appendTo(this.$parent);
            }
        }

        /**
         * Watch for window resize events.
         *
         * @memberof TransportElementPlugin
         */

    }, {
        key: 'watch',
        value: function watch() {
            var _this = this;

            log('watching');
            $(window).on('resize', function () {
                if (_this.check()) {
                    _this.transport();
                } else {
                    _this.return();
                }
            });
        }
    }]);

    return TransportElementsPlugin;
}();

TransportElementsPlugin.DEFAULTS = {
    at: null, // media query name at which this behaviour takes effect. outside the element is moved back.
    atLeast: null, // minimum media query name at which this behaviour takes effect. outside the element is moved back.
    to: null // target selector
};

(0, _plugin2.default)('transportElements', TransportElementsPlugin);

function exec() {
    $(document).ready(function () {
        log('binding');
        $("[data-transport-elements]").transportElements();
        log('bound');
    });
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/tree-menu/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.exec = exec;

var _treeMenu = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/tree-menu/tree-menu.js");

var _treeMenu2 = _interopRequireDefault(_treeMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function exec() {
    (0, _treeMenu2.default)();
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/tree-menu/load-tree-menu.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)("tree-menu");

function loadTreeMenu(url, target) {
    return fetch(url).then(function (response) {
        // log({response});
        if (response.ok) {
            return response.text();
        }
        return Promise.reject(response);
    }).then(function (htmlString) {
        var parser = new DOMParser();
        var html = parser.parseFromString(htmlString, 'text/html');

        target.after(html.body.firstChild);
        target.remove();
    }).catch(function () {
        log('error');
    });
}

exports.default = loadTreeMenu;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/tree-menu/tree-menu.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var menuElement = document.querySelector(menuSelector);
    if (!menuElement) {
        log("No tree-menu found. Aborting.");
        return false;
    }

    var parentMenu = menuElement.closest(menuElement.dataset.treeMenuMegaSelector);
    if (!parentMenu) {
        log("No parent menu found with selector: data-tree-menu-mega-selector=\"" + menuElement.dataset.treeMenuMegaSelector + "\". Aborting.");
        return false;
    }

    // Initialise upon first mega menu open
    // parentMenu.addEventListener("menu_opened", init, {
    //     once: true
    // });

    // Fetch menu returning promise when done
    var loadUrl = menuElement.dataset.treeMenuLoadUrl;
    var loadTarget = menuElement.querySelector(menuElement.dataset.treeMenuLoadTargetSelector);
    var errorMessage = menuElement.querySelector(menuElement.dataset.treeMenuErrorMessageSelector);
    var loadingIndicator = menuElement.querySelector(menuElement.dataset.treeMenuLoadingIndicatorSelector);

    (0, _loadTreeMenu2.default)(loadUrl, loadTarget).then(function () {
        treeMenu(menuElement);
    }).catch(function () {
        log("tree menu error");
        loadingIndicator.style.display = "none";
        errorMessage.style.display = "";
    });
};

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _focusable = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/is/focusable.js");

var _focusable2 = _interopRequireDefault(_focusable);

var _loadTreeMenu = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/tree-menu/load-tree-menu.js");

var _loadTreeMenu2 = _interopRequireDefault(_loadTreeMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /* global $:true */


var log = (0, _debug2.default)("tree-menu");

var menuSelector = "[data-tree-menu]";
var menuGroupSelector = "[data-tree-menu-group]";
var menuItemSelector = "[data-tree-menu-item]";
var menuButtonSelector = "[data-tree-menu-button]";
var menuBackButtonSelector = "[data-tree-menu-back]";

function treeMenu(element) {
    // todo: consider removing scope - will find first item so okay?
    var topGroupElement = element.querySelector(":scope > " + menuGroupSelector);

    var observer = new IntersectionObserver(intersectionHandler, {
        root: element,
        threshold: [0, 1]
    });

    var parentMenu = element.closest(element.dataset.treeMenuMegaSelector);

    menuGroup({ parentItem: element, observer: observer, rootMenu: element }, topGroupElement);

    // set depth - listening to events from contained buttons - including back button
    element.addEventListener("opened", handleMenuOpen);
    element.addEventListener("closed", handleMenuClosed);
    parentMenu.addEventListener("menu_closed", handleMegaClosed);

    function intersectionHandler(entries) {
        entries.forEach(function (item) {
            // The displayed button extends a little to the left to trigger an edge intersection
            if (item.isIntersecting && item.boundingClientRect.x < 0) {
                item.target.disabled = false;
            } else {
                item.target.disabled = true;
            }
        });
    }

    function handleMenuOpen(event) {
        setDepth(element, +event.detail.depth);
    }
    function handleMenuClosed(event) {
        setDepth(element, +event.detail.depth - 1);
    }
    function handleMegaClosed() {
        setDepth(element, 0);
        element.dispatchEvent(new CustomEvent("parent_closed", {
            bubbles: false
        }));
    }
}

function menuGroup(_ref, groupElement) {
    var observer = _ref.observer,
        rootMenu = _ref.rootMenu,
        parentItem = _ref.parentItem;

    // find/init contained menu items
    var menuItemElements = [].concat(_toConsumableArray(groupElement.querySelectorAll(":scope > " + menuItemSelector)));

    var backButton = groupElement.querySelector(":scope > " + menuBackButtonSelector);

    var menuItems = menuItemElements.map(menuItem.bind(null, { observer: observer, rootMenu: rootMenu }));

    // Top menu has no back button
    if (backButton) {
        observer.observe(backButton);
        backButton.addEventListener("click", handleBackClick);
    }

    // For top product menu the parent tree menu
    if (parentItem) {
        parentItem.addEventListener("parent_closed", handleParentClosed.bind(null, menuItems));
        parentItem.addEventListener("parent_opened", function () {
            setTimeout(function (backButton, isFocusable) {
                if (backButton && isFocusable(backButton)) {
                    backButton.focus();
                }
            }, 50, backButton, _focusable2.default);
        });
    }

    // close other child items when child item opened
    // deepest level has no menu items (just links)
    if (menuItems.length) {
        groupElement.addEventListener("opened", handleItemOpened.bind(null, { menuItems: menuItems, backButton: backButton }));
    }

    function handleBackClick() {
        groupElement.dispatchEvent(new CustomEvent("back", {
            bubbles: true
        }));
    }

    function handleParentClosed(items) {
        items.forEach(function (item) {
            item.dataset.treeMenuItemOpened = false;
        });
    }
}

function menuItem(_ref2, element) {
    var observer = _ref2.observer,
        rootMenu = _ref2.rootMenu;

    // find and init contained menuGroup if exists
    // (iterate into subsequent nested items and groups)
    // consider removing scope - first found element with be okay?
    var childGroup = element.querySelector(":scope > * > " + menuGroupSelector);
    if (childGroup) {
        menuGroup({ observer: observer, rootMenu: rootMenu, parentItem: element }, childGroup);
    }

    // consider removing scope - first found element with be okay?
    var button = element.querySelector(":scope > " + menuButtonSelector);

    var isMenuItemOpened = isOpened.bind(null, element);

    // View has expanded attr already set
    // button.setAttribute("aria-expanded", "false");

    button.addEventListener("click", handleButtonClick);
    element.addEventListener("back", handleBackEvent);

    // mutation observer updates button expanded state based on data attr
    // Parent component updates data attr
    var attributeObserver = new MutationObserver(attributeChangeHandler);
    attributeObserver.observe(element, { attributes: true });

    function handleButtonClick() {
        var action = isMenuItemOpened() ? buttonClose : buttonOpen;
        action();
    }

    function handleBackEvent(event) {
        // Immediate child menu events only
        if (event.target !== childGroup) {
            return false;
        }
        buttonClose();
        button.focus();
    }

    // emit opened events - bubble to parent group
    function buttonOpen() {
        element.dataset.treeMenuItemOpened = true;
        element.dispatchEvent(new CustomEvent("opened", {
            bubbles: true,
            detail: { depth: element.dataset.treeMenuItemDepth }
        }));
    }

    function buttonClose() {
        element.dataset.treeMenuItemOpened = false;
        // emit closed events - listened to by parent menu
        element.dispatchEvent(new CustomEvent("closed", {
            bubbles: true,
            detail: { depth: element.dataset.treeMenuItemDepth }
        }));
    }

    function attributeChangeHandler(mutationList, observer) {
        mutationList.filter(function (mutation) {
            return mutation.type === "attributes" && mutation.attributeName.startsWith("data-tree-menu-item-opened");
        }).forEach(updateButton);
    }

    function updateButton() {
        button.setAttribute("aria-expanded", isMenuItemOpened());

        var eventName = isMenuItemOpened() ? "parent_opened" : "parent_closed";
        // Direct listeners only i.e. contained menu group
        element.dispatchEvent(new CustomEvent(eventName, {
            bubbles: false
        }));
    }

    // Return an element hook to parent group
    return element;
}

function isOpened(menuItem) {
    return menuItem.dataset.treeMenuItemOpened === "true";
}

function setDepth(element, depth) {
    element.dataset.treeMenuOpenDepth = depth;
}

function handleItemOpened(_ref3, event) {
    var menuItems = _ref3.menuItems,
        backButton = _ref3.backButton;

    // Check if event target is a child menu item (not grandchild)
    if (!menuItems.includes(event.target)) {
        return true;
    }

    var siblingItems = menuItems.filter(function (item) {
        return item !== event.target;
    });

    // close siblings
    siblingItems.forEach(function (item) {
        item.dataset.treeMenuItemOpened = false;
    });
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/trigger-event/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.exec = exec;

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

var _selectors = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/selectors.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global $:true */
var ELEMENT_SELECTOR = '[data-trigger-event]';
var PLUGIN_NAME = 'triggerEvent';

function exec() {
	_selectors.onAvailable.ready(ELEMENT_SELECTOR, function (element) {
		__webpack_require__.e/* import() */("plugin--trigger-event").then(__webpack_require__.bind(null, "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/trigger-event/plugin.js")).then(function (module) {
			(0, _plugin2.default)(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/unbxd-implementation/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global $:true */
// http://unbxd.com/documentation/site-search/v2-recommendations-analytics/#integratinganalytics


exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MODULE_NAME = 'app.core/modules/unbxd-implementation';
var log = (0, _debug2.default)(MODULE_NAME);
var ELEMENT_SELECTOR = '[data-unbxd-skus-wrapper]';
var REMOVE_FROM_CART_ELEMENT_SELECTOR = '[data-remove-from-cart]';
var REMOVE_FROM_CART_ATTR = 'data-remove-from-cart';
var REMOVE_FROM_CART_PRICE_ATTR = 'data-remove-from-cart-price';
var REMOVE_FROM_CART_QTY_ATTR = 'data-remove-from-cart-qty';
var SEARCH_FORM = '#global-search-form';
var SEARCH_INPUT = '#q';
var SKU_ATTR = 'data-code';
var PRODUCT_SKU_ATTR = 'data-parentcode';
var RANK_ATTR = 'data-rank';
var PAGE_TYPE_ATTR = 'data-pagetype';
var WIDGET_ATTR = 'data-widget';
var REQUEST_ID_ATTR = 'data-request-id';
var SEARCH_QUERY_ATTR = 'data-search-query';
var CATEGORY_PATH_ATTR = 'data-category-path';
var CATEGORY_PAGE_TYPE_ATTR = 'data-category-page-type';
var PRODUCT_TEASER_SELECTOR = '[data-product-teaser]';
var UNBXD_RECOMMENDATIONS_BLOCK_SELECTOR = '[data-unbxd-recommendations-block]';

var UNBXD_ORDER_ATTR = '[data-unbxd-order-item]';
var UNBXD_PID_ATTR = 'data-unbxd-param_pid';
var UNBXD_PRICE_ATTR = 'data-unbxd-param_price';
var UNBXD_QTY_ATTR = 'data-unbxd-param_qty';
var UNBXD_COOKIE_ATTR = 'data-cookie-name';
var UNBXD_RECOMMENDATIONS_BLOCK_WIDGET_ATTR = 'data-unbxd-recommendations-block-widget';
var UNBXD_RECOMMENDATIONS_BLOCK_PAGETYPE_ATTR = 'data-unbxd-recommentaions-block-pagetype';

var UnbxdImplementation = function () {
	function UnbxdImplementation(element, options) {
		_classCallCheck(this, UnbxdImplementation);

		this.element = element;
		this.options = options;
		this.$element = $(element);
		this.$productTeaser = this.$element.find(PRODUCT_TEASER_SELECTOR);
		this.$removeFromCart = $(REMOVE_FROM_CART_ELEMENT_SELECTOR);
		this.$searchForm = $(SEARCH_FORM);
		this.$searchInput = $(SEARCH_INPUT);
		this.$recommendationsBlocks = $(UNBXD_RECOMMENDATIONS_BLOCK_SELECTOR);
		log('UnbxdImplementation', element);
		this.init();
		this.watch();
	}

	_createClass(UnbxdImplementation, [{
		key: 'onClick',
		value: function onClick(variantId, productId, rank, pagetype, widget, requestId) {
			if (typeof Unbxd !== 'undefined') {
				if (pagetype == '' || pagetype.length == 0) {
					pagetype = null;
				}
				if (widget == '' || widget.length == 0) {
					widget = null;
				}
				var pid = productId != null && productId.length > 0 ? productId : variantId;
				Unbxd.track("click", {
					"variantId": variantId,
					"pid": pid,
					"prank": rank,
					"boxType": null,
					"requestId": requestId,
					'experience_pagetype': pagetype,
					'experience_widget': widget
				});
			}
		}
	}, {
		key: 'getOrderCookie',
		value: function getOrderCookie(c_name) {
			if (document.cookie.length > 0) {
				var c_start = document.cookie.indexOf(c_name + "=");
				if (c_start != -1) {
					c_start = c_start + c_name.length + 1;
					var c_end = document.cookie.indexOf(";", c_start);
					if (c_end == -1) {
						c_end = document.cookie.length;
					}
					return unescape(document.cookie.substring(c_start, c_end));
				}
			}
			return "";
		}
	}, {
		key: 'createOrderCookie',
		value: function createOrderCookie(name, value, days) {
			var expires;
			if (days) {
				var date = new Date();
				date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
				expires = "; expires=" + date.toGMTString();
			} else {
				expires = "";
			}
			document.cookie = name + "=" + value + expires + "; path=/";
		}
	}, {
		key: 'order',
		value: function order() {
			window.dataLayer = window.dataLayer || [];
			var products = Array();
			var i = 0;
			var mod = this;
			var cookieWasSet = true;
			$(UNBXD_ORDER_ATTR).each(function () {
				var cookieId = $(this).attr(UNBXD_COOKIE_ATTR);
				var cookie = mod.getOrderCookie(cookieId);
				if (cookie === "") {
					mod.createOrderCookie(cookieId, "true", 365);
					cookieWasSet = false;
				}
				var pid = $(this).attr(UNBXD_PID_ATTR);
				var price = $(this).attr(UNBXD_PRICE_ATTR);
				var qty = $(this).attr(UNBXD_QTY_ATTR);
				var product = {};
				product.pid = pid;
				product.price = price;
				product.qty = qty;
				products[i] = product;
				i++;
			});

			if (!cookieWasSet && products.length > 0) {
				if (typeof Unbxd !== 'undefined') {
					products.forEach(function (product) {
						Unbxd.track("order", product);
					});
				}
			}
		}
	}, {
		key: 'addToCart',
		value: function addToCart(productId, qty, price, variantId, pagetype, widget) {
			window.dataLayer = window.dataLayer || [];
			if (pagetype == '' || pagetype.length == 0) {
				pagetype = null;
			}
			if (widget == '' || widget.length == 0) {
				widget = null;
			}
			if (typeof Unbxd !== 'undefined') {
				var pid = productId != null && productId.length > 0 ? productId : variantId;
				Unbxd.track("addToCart", {
					"pid": pid,
					"price": price,
					"qty": qty,
					'experience_pagetype': pagetype,
					'experience_widget': widget,
					"variantId": variantId
				});
				this.addToCartOnClick(productId, variantId, pagetype, widget);
			}
		}
	}, {
		key: 'addToCartOnClick',
		value: function addToCartOnClick(productId, variantId, pagetype, widget) {
			var pid = productId != null && productId.length > 0 ? productId : variantId;
			var teaser = this.$productTeaser.find('[' + SKU_ATTR + ' = "' + variantId + '"]');
			if (typeof teaser !== 'undefined' && teaser.length > 0) {
				var teaserEl = teaser[0];
				var rank = $(teaserEl).closest(PRODUCT_TEASER_SELECTOR).attr(RANK_ATTR);
				var requestId = $(teaserEl).attr(REQUEST_ID_ATTR);
				var pageType = $(teaserEl).attr(CATEGORY_PAGE_TYPE_ATTR);
				var categoryPath = $(teaserEl).attr(CATEGORY_PATH_ATTR);
				var searchQuery = $(teaserEl).attr(SEARCH_QUERY_ATTR);
				if (requestId.length == 0) {
					requestId = null;
				}
				if (categoryPath.length == 0) {
					categoryPath = null;
				}

				Unbxd.track("click", {
					"pid": pid,
					"prank": rank,
					"query": searchQuery,
					"page": categoryPath,
					"page_type": pageType,
					'experience_pagetype': pagetype,
					'experience_widget': widget,
					"requestId": requestId
				});
			}
		}
	}, {
		key: 'removeFromCart',
		value: function removeFromCart(variantId, productId, qty, price) {
			if (typeof Unbxd !== 'undefined') {
				var pid = productId != null && productId.length > 0 ? productId : variantId;
				Unbxd.track("cartRemoval", {
					'pid': pid,
					'variantId': variantId,
					'price': price,
					'qty': qty
				});
			}
		}
	}, {
		key: 'search',
		value: function search() {
			var searchQuery = this.$searchInput.val();
			if (searchQuery.length > 0) {
				if (typeof Unbxd !== 'undefined') {
					Unbxd.track("search", {
						"query": searchQuery
					});
				}
			}
		}
	}, {
		key: 'recommendationsBlockImpression',
		value: function recommendationsBlockImpression() {
			var mod = this;
			this.$recommendationsBlocks.each(function () {
				var $block = $(this);
				if (typeof Unbxd !== 'undefined') {
					var pagetype = $block.attr(UNBXD_RECOMMENDATIONS_BLOCK_PAGETYPE_ATTR);
					var widget = $block.attr(UNBXD_RECOMMENDATIONS_BLOCK_WIDGET_ATTR);
					var products = Array();
					var $teasers = $block.find(PRODUCT_TEASER_SELECTOR);
					$teasers.each(function () {
						var $teaser = $(this);
						var $teaserLink = $teaser.find('[' + SKU_ATTR + ']');
						if (typeof $teaserLink !== 'undefined') {
							var sku = $teaserLink.attr(SKU_ATTR);
							products.push(sku);
						}
					});
					if (pagetype == '' || pagetype.length == 0) {
						pagetype = null;
					}
					if (widget == '' || widget.length == 0) {
						widget = null;
					}
					Unbxd.track("experience_impression", {
						"experience_pagetype": pagetype,
						"experience_widget": widget,
						pids_list: products
					});
				}
			});
		}
	}, {
		key: 'init',
		value: function init() {
			var rank = 1;
			this.$productTeaser.each(function () {
				var $product = $(this);
				$product.attr(RANK_ATTR, rank);
				rank++;
			});

			var mod = this;
			setTimeout(function () {
				mod.order();
				mod.recommendationsBlockImpression();
			}, 200);
		}
	}, {
		key: 'watch',
		value: function watch() {
			var mod = this;
			this.$productTeaser.find('[' + SKU_ATTR + ']').on('click', function () {
				var sku = $(this).attr(SKU_ATTR);
				var productSku = $(this).attr(PRODUCT_SKU_ATTR);
				var rank = $(this).closest(PRODUCT_TEASER_SELECTOR).attr(RANK_ATTR);
				var widget = $(this).attr(WIDGET_ATTR);
				var requestId = $(this).attr(REQUEST_ID_ATTR);
				var pagetype = $(this).attr(PAGE_TYPE_ATTR);
				mod.onClick(sku, productSku, rank, pagetype, widget, requestId);
			});

			this.$searchForm.on('submit', function () {
				mod.search();
			});

			this.$removeFromCart.on('click', function () {
				var sku = $(this).attr(REMOVE_FROM_CART_ATTR);
				var productSku = $(this).attr(PRODUCT_SKU_ATTR);
				var qty = $(this).attr(REMOVE_FROM_CART_QTY_ATTR);
				var price = $(this).attr(REMOVE_FROM_CART_PRICE_ATTR);
				mod.removeFromCart(sku, productSku, qty, price);
			});

			$(document).on('added-to-cart', function (event, productId, qty, price, variantId) {
				var $teaser = $('[data-code="' + variantId + '"]');
				if ($teaser.length > 0) {
					var widget = $teaser.attr(WIDGET_ATTR);
					var pagetype = $teaser.attr(PAGE_TYPE_ATTR);
					mod.addToCart(productId, qty, price, variantId, pagetype, widget);
				}
			});
		}
	}]);

	return UnbxdImplementation;
}();

(0, _plugin2.default)('unbxdImplementation', UnbxdImplementation);

function exec() {
	$(document).ready(function () {
		log('binding');
		$(ELEMENT_SELECTOR).unbxdImplementation();
		log('bound');
	});
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/video-banner/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.exec = exec;

var _videoBanner = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/video-banner/video-banner.js");

var _videoBanner2 = _interopRequireDefault(_videoBanner);

var _extractOptions = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/utilities/extractOptions.js");

var _extractOptions2 = _interopRequireDefault(_extractOptions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function exec() {

    var videoBannerElements = document.querySelectorAll("[data-video-banner]");

    var videoBannerElementsArray = Array.prototype.slice.call(videoBannerElements);

    videoBannerElementsArray.forEach(function (element) {
        var options = Object.assign({}, _videoBanner2.default.DEFAULTS, (0, _extractOptions2.default)("video-banner", element));
        var instance = new _videoBanner2.default(element, options);
        element.instance = instance;
    });
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/video-banner/video-banner.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VideoBanner = function () {
  function VideoBanner(element, options) {
    _classCallCheck(this, VideoBanner);

    this.element = element;
    this.options = options;

    this.init();
    this.watch();
  }

  _createClass(VideoBanner, [{
    key: "init",
    value: function init() {

      var doc = this.element.ownerDocument;
      this.window = doc.defaultView || doc.parentWindow;

      //extract sources from <source> tags
      var sources = this.element.querySelectorAll("source");
      this.sourceArray = [].concat(_toConsumableArray(sources)).map(function (e) {
        return {
          "media": e.getAttribute("media"),
          "src": e.getAttribute("src")
        };
      });

      //remove <source> tags
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = sources[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var elem = _step.value;

          elem.remove();
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.updateSource();
    }
  }, {
    key: "watch",
    value: function watch() {

      var self = this;

      this.window.addEventListener("resize", self.debounce(self.updateSource.bind(self), self.options.refreshRate));
    }
  }, {
    key: "debounce",
    value: function debounce(func) {
      var _this = this;

      var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;

      var timer = void 0;
      return function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        clearTimeout(timer);
        timer = setTimeout(function () {
          func.apply(_this, args);
        }, timeout);
      };
    }
  }, {
    key: "updateSource",
    value: function updateSource() {
      var _this2 = this;

      var determinedSource = void 0;

      this.sourceArray.forEach(function (e) {

        var windowWidth = _this2.window.innerWidth;

        if (e.media) {
          var _e$media$split = e.media.split(":"),
              _e$media$split2 = _slicedToArray(_e$media$split, 2),
              dir = _e$media$split2[0],
              width = _e$media$split2[1];

          dir = dir.trim().toLowerCase();
          width = parseInt(width.replace(/\D/g, ''));

          if (dir === "min-width" && windowWidth > width || dir === "max-width" && windowWidth < width) {
            determinedSource = e.src;
          }
        } else if (determinedSource == null) {
          determinedSource = e.src;
        }
      });

      var currentSource = this.element.getAttribute("src");
      if (determinedSource != currentSource) {
        this.element.setAttribute("src", determinedSource);
      }
    }
  }]);

  return VideoBanner;
}();

exports.default = VideoBanner;


VideoBanner.DEFAULTS = {
  refreshRate: 300
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/video-blocks/component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.VideoBlockComponent = undefined;

var _toast = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/pyrsmk-toast/toast.js");

var _toast2 = _interopRequireDefault(_toast);

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _index = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/video-blocks/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /* global $:true plyr:true */

var log = (0, _debug2.default)(_index.MODULE_NAME);

// https://github.com/appleple/modal-video

var VideoBlockComponent = exports.VideoBlockComponent = function VideoBlockComponent(element, options) {
    var _this = this;

    _classCallCheck(this, VideoBlockComponent);

    this.element = element;
    this.$element = $(element);
    this.options = options;

    this.options.classNames = {
        modalVideo: this.options.class_modalVideo,
        modalVideoClose: this.options.class_modalVideoClose,
        modalVideoBody: this.options.class_modalVideoBody,
        modalVideoInner: this.options.class_modalVideoInner,
        modalVideoIframeWrap: this.options.class_modalVideoIframeWrap,
        modalVideoCloseBtn: this.options.class_modalVideoCloseBtn
    };

    this.options.aria = {
        openMessage: this.options.aria_openMessage,
        dismissBtnMessage: this.options.aria_dismissBtnMessage
    };

    (0, _toast2.default)('https://cdn.jsdelivr.net/npm/modal-video@2.4.5/js/jquery-modal-video.min.js', function () {
        log('construct', _this.element);
        _this.$element.modalVideo(_this.options);
    });
};

VideoBlockComponent.DEFAULTS = {
    channel: 'youtube',

    class_modalVideo: 'video-block-modal',
    class_modalVideoClose: 'video-block-modal--closing',
    class_modalVideoBody: 'video-block-modal__container',
    class_modalVideoInner: 'video-block-modal__video',
    class_modalVideoIframeWrap: 'video-block-modal__video-container',
    class_modalVideoCloseBtn: 'video-block-modal__close-button',

    aria_openMessage: 'You just openned the modal video',
    aria_dismissBtnMessage: 'Close the modal by clicking here'
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/video-blocks/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ELEMENT_SELECTOR = exports.MODULE_NAME = undefined;
exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = exports.MODULE_NAME = 'app.core/modules/video-blocks';
var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-video-modal-trigger]';

var log = (0, _debug2.default)(MODULE_NAME);

function exec() {
    $(document).ready(function () {
        var elements = $(ELEMENT_SELECTOR).toArray();
        if (!elements || !elements.length) {
            return;
        }

        var _require = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/video-blocks/component.js"),
            VideoBlockComponent = _require.VideoBlockComponent;

        (0, _plugin2.default)('videoBlock', VideoBlockComponent);
        $(elements).videoBlock();
    });
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/youtube-list-block/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global $:true dataLayer:true */
/**
 * Youtube List Block
 *
 *
 */

exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _plugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/lib/plugin.js");

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = '.g-ytsubscribe';
var MODULE_NAME = 'app.core/modules/youtube-list-block';
var log = (0, _debug2.default)(MODULE_NAME);
var ZERO = 0;
var SCRIPT = '<script src="https://apis.google.com/js/platform.js"></script>';

var YoutubeListBlock = function () {
    function YoutubeListBlock(element, options) {
        _classCallCheck(this, YoutubeListBlock);

        this.element = element;
        this.options = options;
        this.$element = $(element);
        this.$scriptContainer = $(this.options.scriptContainer);

        log('YoutubeListBlock', element);

        this.loadScript();

        log('ready', this.$element);
    }

    _createClass(YoutubeListBlock, [{
        key: 'loadScript',
        value: function loadScript() {
            if (typeof this.$scriptContainer !== 'undefined') {
                if (this.$scriptContainer.find('script').length == 0) {
                    this.$scriptContainer.html(SCRIPT);
                }
            }
        }
    }]);

    return YoutubeListBlock;
}();

YoutubeListBlock.DEFAULTS = {
    scriptContainer: '.youtube-list-block-scripts'
};

(0, _plugin2.default)('youtubeListBlock', YoutubeListBlock);

function exec() {
    $(document).ready(function () {
        log('binding');
        $(ELEMENT_SELECTOR).youtubeListBlock();
        log('bound');
    });
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/services/google-maps-api/config.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Config
 * Location Autocomplete
 * @author Rhys Lloyd
 */

var googleApiKey = undefined;
var mapsKeyElement = document.querySelector('meta[name="config:keys.google-maps"]');
if (mapsKeyElement) {
  googleApiKey = mapsKeyElement.content;
}

/**
 * Google API Key
 * @type {string}
 */
var GOOGLE_API_KEY = exports.GOOGLE_API_KEY = googleApiKey;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/services/google-maps-api/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _googleMapsApiLoader = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/google-maps-api-loader/index.js");

var _googleMapsApiLoader2 = _interopRequireDefault(_googleMapsApiLoader);

var _config = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/services/google-maps-api/config.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'app.core/services/google-maps-api'; /**
                                                        * Google Maps API Service
                                                        * @author Rhys Lloyd
                                                        */

//
// Utilities

var log = (0, _debug2.default)(MODULE_NAME);
//
// Dependencies


//
// Config
var GOOGLE_API_OPTIONS = {
  libraries: ['places', 'marker'],
  apiKey: _config.GOOGLE_API_KEY
};

//
// Exports
/**
 * @type {Promise.<google>}
 */
exports.default = (0, _googleMapsApiLoader2.default)(GOOGLE_API_OPTIONS);

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/utilities/ally.js.bundle.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _disabled = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/maintain/disabled.js");

var _disabled2 = _interopRequireDefault(_disabled);

var _hidden = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/maintain/hidden.js");

var _hidden2 = _interopRequireDefault(_hidden);

var _key = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/when/key.js");

var _key2 = _interopRequireDefault(_key);

var _focusable = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/is/focusable.js");

var _focusable2 = _interopRequireDefault(_focusable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/utilities/ally.js.focusSource.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _focusSource = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ally.js/src/style/focus-source.js");

var _focusSource2 = _interopRequireDefault(_focusSource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _focusSource2.default)();

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/utilities/extractOptions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function (name, element) {
	return extractComponentOptions(name, getOptionData(element));
};

/*
 * Unlike other utility files, this is not adding functions to the utility scope
 * This is instead included by some components
 */

function getJSONValue(stringValue) {
	try {
		return JSON.parse(stringValue);
	} catch (error) {
		return stringValue;
	}
}

function camelCase(string) {
	return string.replace(/^([A-Z])|[\s-_](\w)/g, function (match, p1, p2) {
		if (p2) {
			return p2.toUpperCase();
		}

		return p1.toLowerCase();
	});
}

function getOptionData(element) {
	var dataset = element.dataset;
	var data = {};

	for (var prop in dataset) {
		if (dataset.hasOwnProperty(prop)) {
			data[prop] = dataset[prop];
		}
	}
	return data || {};
}

function extractComponentOptions(name, data) {
	var options = {};
	var cameledName = camelCase(name);
	for (var prop in data) {
		if (prop.startsWith(cameledName) && prop !== cameledName) {
			options[camelCase(prop.slice(cameledName.length))] = getJSONValue(data[prop]);
		}
	}
	return options;
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/utilities/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/utilities/ally.js.bundle.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/utilities/ally.js.focusSource.js");

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/foundation/extensions/abide-validators.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Custom Validators for Foundation Abide
 */


// Utilities

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = run;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/foundation/js/foundation.core.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/foundation/js/foundation.abide.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'common/vendor/extensions/abide-validators';
var log = (0, _debug2.default)(MODULE_NAME);
// Foundation


// Constants
var ABIDE_SELECTOR = '[data-abide]';
var CHECKBOX_SELECTOR = '[type="checkbox"]';
var CHECKBOX_GROUP_SELECTOR = '.checkbox-group';

/**
 * Minimum required validator for checkbox groups.
 * Set `minRequired` on formFieldOptionList model to activate.
 * If upgrading Foundation to 6.3+, check if this PR has been accepted
 * because then this function will be redundant: https://github.com/zurb/foundation-sites/pull/8542
 *
 * @param $el
 * @param required
 * @param parent
 */
Foundation.Abide.defaults.validators['minRequired'] = function ($el, required) {
	var $group = $el.closest(CHECKBOX_GROUP_SELECTOR);

	var groupMinRequired = $group.data('min-required');
	var minRequired = groupMinRequired && groupMinRequired !== true ? groupMinRequired : 1;

	return $group.find(':checked').length >= minRequired;
};

// Export
function run() {
	log('Running...');
	log('[common/vendor/extensions/abide-validators] ...done.');

	/**
  * Handle Checkbox Groups (because Foundation doesn't <= 6.2.x
  */
	var $groupedCheckboxes = $(CHECKBOX_GROUP_SELECTOR).find(CHECKBOX_SELECTOR);

	if ($groupedCheckboxes.length) {
		log('$groupedCheckboxes:', $groupedCheckboxes);

		// When a checkbox in a group becomes valid
		$groupedCheckboxes.on('valid.zf.abide', function () {
			var $form = $(this).closest(ABIDE_SELECTOR);
			$(this).closest(CHECKBOX_GROUP_SELECTOR).find(CHECKBOX_SELECTOR).each(function () {
				$form.foundation('removeErrorClasses', $(this));
			});
		});

		// When a checkbox in a group is invalid
		$groupedCheckboxes.on('invalid.zf.abide', function () {
			var $form = $(this).closest(ABIDE_SELECTOR);
			$(this).closest(CHECKBOX_GROUP_SELECTOR).find(CHECKBOX_SELECTOR).each(function () {
				$form.foundation('addErrorClasses', $(this));
			});
		});
	} else {
		log('No $groupedCheckboxes found.');
	}

	log('[common/vendor/extensions/abide-validators] ...done.');
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/foundation/extensions/responsive-tabs.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function () {

	$(document).ready(function () {

		changeTabsToAccordions();
		$(window).on('changed.zf.mediaquery', changeTabsToAccordions);
	});
};

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'core/vendor/foundation/extensions/responsive-tabs'; /* global $:true module:true Foundation:true */

var log = (0, _debug2.default)(MODULE_NAME);

function changeTabsToAccordions(event, currentBreakpoint, previousBreakpoint) {

	var responsiveTabs = $('.responsive-tabs');
	var toggleType = $('.toggleType');
	var tabWrap = $('.tab-wrap');

	log('Changed ' + previousBreakpoint + ' > ' + previousBreakpoint);

	// small only
	if (Foundation.MediaQuery.current === 'small') {

		log("Foundation.MediaQuery.current === 'small'");

		if (responsiveTabs.hasClass('tabs-content')) {

			responsiveTabs.removeClass('tabs-content');
			responsiveTabs.addClass('accordion');
			responsiveTabs.attr('data-accordion', '');
			log("responsiveTabs.container.convertedToAccordion");

			tabWrap.css('display', 'none');
			tabWrap.addClass('accordion-content');
			log("responsiveTabs.tabWraps.convertedToAccordion");

			toggleType.addClass('accordion-item');
			toggleType.removeClass('tabs-panel');
			log("responsiveTabs.toggleTypes.convertedToAccordion");

			$('.toggleType.is-active').children('.tab-wrap').css('display', 'block');
			log("responsiveTabs.toggleTypeActiveTabWrap.displayed");
		}

		$('.accordion-title').on('click', function AccordionTitleClick() {
			var sharedId = $(this).attr('id');

			$(this).children('tab-wrap').css('display', 'none');

			$('.tabs-title.is-active').removeClass('is-active');
			$('ul.tabs li.' + sharedId).addClass('is-active');
			$('.tabs-title.is-active a').attr('aria-selected', 'true');
		});
	}

	if (Foundation.MediaQuery.atLeast('medium')) {

		log("Foundation.MediaQuery.atLeast('medium')");

		// medium

		if (responsiveTabs.hasClass('accordion')) {
			responsiveTabs.removeAttr('data-accordion');
			responsiveTabs.removeClass('accordion');
			responsiveTabs.addClass('tabs-content');

			tabWrap.removeClass('accordion-content');
			tabWrap.css('display', '');
			toggleType.removeClass('accordion-item');
			toggleType.addClass('tabs-panel');
		}
	}
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/foundation/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/foundation/js/foundation.core.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/foundation/js/foundation.util.mediaQuery.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/foundation/js/foundation.util.keyboard.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/foundation/js/foundation.util.box.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/foundation/js/foundation.util.triggers.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/foundation/js/foundation.util.motion.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/foundation/js/foundation.accordion.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/foundation/js/foundation.abide.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/foundation/js/foundation.dropdown.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/foundation/js/foundation.toggler.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/foundation/js/foundation.tabs.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/foundation/js/foundation.reveal.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/foundation/js/foundation.tooltip.js");

var _abideValidators = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/foundation/extensions/abide-validators.js");

var _abideValidators2 = _interopRequireDefault(_abideValidators);

var _responsiveTabs = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/foundation/extensions/responsive-tabs.js");

var _responsiveTabs2 = _interopRequireDefault(_responsiveTabs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'core/vendor/foundation'; /* global $:true module:true Foundation:true */
/**
 * Foundation Configuration
 */

// Utilities

var log = (0, _debug2.default)(MODULE_NAME);

// Foundation


// Imports


// Constants
var ABIDE_SELECTOR = 'form[data-abide]';

// Export
function exec() {
	log('Running...');
	log('Available foundation modules: ' + Object.keys(Foundation));

	// Check Foundation has loaded correctly
	if (!Foundation) {
		log('Foundation not found.');

		return;
	}

	if (Foundation.Abide) {
		// Add `novalidate` attribute if Abide is available
		$(ABIDE_SELECTOR).attr('novalidate', '');

		// Load extra validators
		(0, _abideValidators2.default)();
	} else {
		log('Foundation Abide module not loaded.');
	}

	if (Foundation.Tabs && Foundation.Accordion) {
		(0, _responsiveTabs2.default)();
	} else {
		log('Foundation tab and accordion modules not loaded');
	}

	// Configure and Run
	$(document).foundation();
	log('Foundation initialised.');

	if (Foundation.Reveal) {
		$('.reveal').each(function InitialiseRevealModals() {

			if ($(this).hasClass('is--open')) {
				$(this).foundation('open');
			}
		});
	} else {
		log('Foundation reveal module not loaded');
	}
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _foundation = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/foundation/index.js");

var foundation = _interopRequireWildcard(_foundation);

var _vue = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/vue/index.js");

var vue = _interopRequireWildcard(_vue);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * Core Vendor Index
 */
exports.default = {
  foundation: foundation,
  vue: vue
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/vue/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.addToQueue = addToQueue;
exports.processQueue = processQueue;
exports.onBeforePlugins = onBeforePlugins;
exports.onAfterPlugins = onAfterPlugins;
exports.onBeforeInit = onBeforeInit;
exports.onAfterInit = onAfterInit;
exports.onCreated = onCreated;
exports.exec = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _staticDataPlugin = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/vue/plugins/static-data-plugin.js");

var _staticDataPlugin2 = _interopRequireDefault(_staticDataPlugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global Vue:true  */
var MODULE_NAME = 'app.core/vendor/vue';
var log = (0, _debug2.default)(MODULE_NAME);

var VUE_QUEUES = {};

function addToQueue(name, fn) {
    var queue = VUE_QUEUES[name] || [];
    if (!VUE_QUEUES[name]) {
        VUE_QUEUES[name] = queue;
    }
    queue.push(fn);
}

function processQueue(name) {
    var queue = VUE_QUEUES[name];
    if (!queue) {
        return;
    }

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
    }

    while (queue.length) {
        queue.shift()(args);
    }
}

function onBeforePlugins(fn) {
    addToQueue('before-plugins', fn);
}

function onAfterPlugins(fn) {
    addToQueue('after-plugins', fn);
}

function onBeforeInit(fn) {
    addToQueue('before-init', fn);
}

function onAfterInit(fn) {
    addToQueue('after-init', fn);
}

function onCreated(fn) {
    addToQueue('done', fn);
}

function exec() {

    processQueue('before-init', window.App);

    log('init');
    // Set Vue Delimiters
    Vue.config.delimiters = ['${', '}'];
    Vue.config.unsafeDelimiters = ['${!', '!}'];

    processQueue('before-plugins', window.App);
    // plugins
    Vue.use(_staticDataPlugin2.default);
    processQueue('after-plugins', window.App);

    processQueue('after-init', window.App);

    log('done');
}

/**
 * Idea: pre load server data into vuex
 */
// $('script[data-vuex-module]').each((index, element) => {
// 	const name = $(element).attr('data-vuex-module');
// 	const data = Object.freeze($(element).eval());
// 	Vuex.modules.add(name, data);
// })
//

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/vue/plugins/static-data-plugin.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {

	install: function install(Vue) {

		Vue.loadStaticData = function loadStaticData(fromKey) {
			return new Promise(function (resolve, reject) {
				if (window[fromKey]) {
					var data = Object.freeze(Object.assign({}, window[fromKey]));
					resolve(data);
				} else {
					reject(Error("Missing window." + fromKey));
				}
			});
		};
	}

};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/fixed-sticky/fixedsticky.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (win, $) {

	function featureTest(property, value, noPrefixes) {
		// Thanks Modernizr! https://github.com/phistuck/Modernizr/commit/3fb7217f5f8274e2f11fe6cfeda7cfaf9948a1f5
		var prop = property + ':',
		    el = document.createElement('test'),
		    mStyle = el.style;

		if (!noPrefixes) {
			mStyle.cssText = prop + ['-webkit-', '-moz-', '-ms-', '-o-', ''].join(value + ';' + prop) + value + ';';
		} else {
			mStyle.cssText = prop + value;
		}
		return mStyle[property].indexOf(value) !== -1;
	}

	function getPx(unit) {
		return parseInt(unit, 10) || 0;
	}

	var uniqueIdCounter = 0;

	var S = {
		classes: {
			plugin: 'fixedsticky',
			active: 'fixedsticky-on',
			inactive: 'fixedsticky-off',
			clone: 'fixedsticky-dummy',
			withoutFixedFixed: 'fixedsticky-withoutfixedfixed'
		},
		keys: {
			offset: 'fixedStickyOffset',
			position: 'fixedStickyPosition',
			id: 'fixedStickyId'
		},
		tests: {
			sticky: featureTest('position', 'sticky'),
			fixed: featureTest('position', 'fixed', true)
		},
		// Thanks jQuery!
		getScrollTop: function getScrollTop() {
			var prop = 'pageYOffset',
			    method = 'scrollTop';
			return win ? prop in win ? win[prop] : win.document.documentElement[method] : win.document.body[method];
		},
		bypass: function bypass() {
			// Check native sticky, check fixed and if fixed-fixed is also included on the page and is supported
			return S.tests.sticky && !S.optOut || !S.tests.fixed || win.FixedFixed && !$(win.document.documentElement).hasClass('fixed-supported');
		},
		update: function update(el) {
			if (!el.offsetWidth) {
				return;
			}

			var $el = $(el),
			    height = $el.outerHeight(),
			    initialOffset = $el.data(S.keys.offset),
			    scroll = S.getScrollTop(),
			    isAlreadyOn = $el.is('.' + S.classes.active),
			    toggle = function toggle(turnOn) {
				$el[turnOn ? 'addClass' : 'removeClass'](S.classes.active)[!turnOn ? 'addClass' : 'removeClass'](S.classes.inactive);
			},
			    viewportHeight = $(window).height(),
			    position = $el.data(S.keys.position),
			    skipSettingToFixed,
			    elTop,
			    elBottom,
			    $parent = $el.parent(),
			    parentOffset = $parent.offset().top,
			    parentHeight = $parent.outerHeight();

			if (initialOffset === undefined) {
				initialOffset = $el.offset().top;
				$el.data(S.keys.offset, initialOffset);
				$el.after($('<div>').addClass(S.classes.clone).height(height));
			} else {
				$el.next('.' + S.classes.clone).height(height);
			}

			if (!position) {
				// Some browsers require fixed/absolute to report accurate top/left values.
				skipSettingToFixed = $el.css('top') !== 'auto' || $el.css('bottom') !== 'auto';

				if (!skipSettingToFixed) {
					$el.css('position', 'fixed');
				}

				position = {
					top: $el.css('top') !== 'auto',
					bottom: $el.css('bottom') !== 'auto'
				};

				if (!skipSettingToFixed) {
					$el.css('position', '');
				}

				$el.data(S.keys.position, position);
			}

			function isFixedToTop() {
				var offsetTop = scroll + elTop;

				// Initial Offset Top
				return initialOffset < offsetTop &&
				// Container Bottom
				offsetTop + height <= parentOffset + parentHeight;
			}

			function isFixedToBottom() {
				// Initial Offset Top + Height
				return initialOffset + (height || 0) > scroll + viewportHeight - elBottom &&
				// Container Top
				scroll + viewportHeight - elBottom >= parentOffset + (height || 0);
			}

			elTop = getPx($el.css('top'));
			elBottom = getPx($el.css('bottom'));

			if (position.top && isFixedToTop() || position.bottom && isFixedToBottom()) {
				if (!isAlreadyOn) {
					toggle(true);
				}
			} else {
				if (isAlreadyOn) {
					toggle(false);
				}
			}
		},
		destroy: function destroy(el) {
			var $el = $(el);
			if (S.bypass()) {
				return $el;
			}

			return $el.each(function () {
				var $this = $(this);
				var id = $this.data(S.keys.id);
				$(win).unbind('.fixedsticky' + id);

				$this.removeData([S.keys.offset, S.keys.position, S.keys.id]).removeClass(S.classes.active).removeClass(S.classes.inactive).next('.' + S.classes.clone).remove();
			});
		},
		init: function init(el) {
			var $el = $(el);

			if (S.bypass()) {
				return $el;
			}

			return $el.each(function () {
				var _this = this;
				var id = uniqueIdCounter++;
				$(this).data(S.keys.id, id);

				$(win).bind('scroll.fixedsticky' + id, function () {
					S.update(_this);
				}).trigger('scroll.fixedsticky' + id);

				$(win).bind('resize.fixedsticky' + id, function () {
					if ($el.is('.' + S.classes.active)) {
						S.update(_this);
					}
				});
			});
		}
	};

	win.FixedSticky = S;

	// Plugin
	$.fn.fixedsticky = function (method) {
		if (typeof S[method] === 'function') {
			return S[method].call(S, this);
		} else if ((typeof method === 'undefined' ? 'undefined' : _typeof(method)) === 'object' || !method) {
			return S.init.call(S, this);
		} else {
			throw new Error('Method `' + method + '` does not exist on jQuery.fixedsticky');
		}
	};

	// Add fallback when fixed-fixed is not available.
	if (!win.FixedFixed) {
		$(win.document.documentElement).addClass(S.classes.withoutFixedFixed);
	}
})(window, jQuery);

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/foundation/js/foundation.abide.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

!function ($) {

  /**
   * Abide module.
   * @module foundation.abide
   */

  var Abide = function () {
    /**
     * Creates a new instance of Abide.
     * @class
     * @fires Abide#init
     * @param {Object} element - jQuery object to add the trigger to.
     * @param {Object} options - Overrides to the default plugin settings.
     */
    function Abide(element) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _classCallCheck(this, Abide);

      this.$element = element;
      this.options = $.extend({}, Abide.defaults, this.$element.data(), options);

      this._init();

      Foundation.registerPlugin(this, 'Abide');
    }

    /**
     * Initializes the Abide plugin and calls functions to get Abide functioning on load.
     * @private
     */


    _createClass(Abide, [{
      key: '_init',
      value: function _init() {
        this.$inputs = this.$element.find('input, textarea, select');

        this._events();
      }

      /**
       * Initializes events for Abide.
       * @private
       */

    }, {
      key: '_events',
      value: function _events() {
        var _this2 = this;

        this.$element.off('.abide').on('reset.zf.abide', function () {
          _this2.resetForm();
        }).on('submit.zf.abide', function () {
          return _this2.validateForm();
        });

        if (this.options.validateOn === 'fieldChange') {
          this.$inputs.off('change.zf.abide').on('change.zf.abide', function (e) {
            _this2.validateInput($(e.target));
          });
        }

        if (this.options.liveValidate) {
          this.$inputs.off('input.zf.abide').on('input.zf.abide', function (e) {
            _this2.validateInput($(e.target));
          });
        }
      }

      /**
       * Calls necessary functions to update Abide upon DOM change
       * @private
       */

    }, {
      key: '_reflow',
      value: function _reflow() {
        this._init();
      }

      /**
       * Checks whether or not a form element has the required attribute and if it's checked or not
       * @param {Object} element - jQuery object to check for required attribute
       * @returns {Boolean} Boolean value depends on whether or not attribute is checked or empty
       */

    }, {
      key: 'requiredCheck',
      value: function requiredCheck($el) {
        if (!$el.attr('required')) return true;

        var isGood = true;

        switch ($el[0].type) {
          case 'checkbox':
            isGood = $el[0].checked;
            break;

          case 'select':
          case 'select-one':
          case 'select-multiple':
            var opt = $el.find('option:selected');
            if (!opt.length || !opt.val()) isGood = false;
            break;

          default:
            if (!$el.val() || !$el.val().length) isGood = false;
        }

        return isGood;
      }

      /**
       * Based on $el, get the first element with selector in this order:
       * 1. The element's direct sibling('s).
       * 3. The element's parent's children.
       *
       * This allows for multiple form errors per input, though if none are found, no form errors will be shown.
       *
       * @param {Object} $el - jQuery object to use as reference to find the form error selector.
       * @returns {Object} jQuery object with the selector.
       */

    }, {
      key: 'findFormError',
      value: function findFormError($el) {
        var $error = $el.siblings(this.options.formErrorSelector);

        if (!$error.length) {
          $error = $el.parent().find(this.options.formErrorSelector);
        }

        return $error;
      }

      /**
       * Get the first element in this order:
       * 2. The <label> with the attribute `[for="someInputId"]`
       * 3. The `.closest()` <label>
       *
       * @param {Object} $el - jQuery object to check for required attribute
       * @returns {Boolean} Boolean value depends on whether or not attribute is checked or empty
       */

    }, {
      key: 'findLabel',
      value: function findLabel($el) {
        var id = $el[0].id;
        var $label = this.$element.find('label[for="' + id + '"]');

        if (!$label.length) {
          return $el.closest('label');
        }

        return $label;
      }

      /**
       * Get the set of labels associated with a set of radio els in this order
       * 2. The <label> with the attribute `[for="someInputId"]`
       * 3. The `.closest()` <label>
       *
       * @param {Object} $el - jQuery object to check for required attribute
       * @returns {Boolean} Boolean value depends on whether or not attribute is checked or empty
       */

    }, {
      key: 'findRadioLabels',
      value: function findRadioLabels($els) {
        var _this3 = this;

        var labels = $els.map(function (i, el) {
          var id = el.id;
          var $label = _this3.$element.find('label[for="' + id + '"]');

          if (!$label.length) {
            $label = $(el).closest('label');
          }
          return $label[0];
        });

        return $(labels);
      }

      /**
       * Adds the CSS error class as specified by the Abide settings to the label, input, and the form
       * @param {Object} $el - jQuery object to add the class to
       */

    }, {
      key: 'addErrorClasses',
      value: function addErrorClasses($el) {
        var $label = this.findLabel($el);
        var $formError = this.findFormError($el);

        if ($label.length) {
          $label.addClass(this.options.labelErrorClass);
        }

        if ($formError.length) {
          $formError.addClass(this.options.formErrorClass);
        }

        $el.addClass(this.options.inputErrorClass).attr('data-invalid', '');
      }

      /**
       * Remove CSS error classes etc from an entire radio button group
       * @param {String} groupName - A string that specifies the name of a radio button group
       *
       */

    }, {
      key: 'removeRadioErrorClasses',
      value: function removeRadioErrorClasses(groupName) {
        var $els = this.$element.find(':radio[name="' + groupName + '"]');
        var $labels = this.findRadioLabels($els);
        var $formErrors = this.findFormError($els);

        if ($labels.length) {
          $labels.removeClass(this.options.labelErrorClass);
        }

        if ($formErrors.length) {
          $formErrors.removeClass(this.options.formErrorClass);
        }

        $els.removeClass(this.options.inputErrorClass).removeAttr('data-invalid');
      }

      /**
       * Removes CSS error class as specified by the Abide settings from the label, input, and the form
       * @param {Object} $el - jQuery object to remove the class from
       */

    }, {
      key: 'removeErrorClasses',
      value: function removeErrorClasses($el) {
        // radios need to clear all of the els
        if ($el[0].type == 'radio') {
          return this.removeRadioErrorClasses($el.attr('name'));
        }

        var $label = this.findLabel($el);
        var $formError = this.findFormError($el);

        if ($label.length) {
          $label.removeClass(this.options.labelErrorClass);
        }

        if ($formError.length) {
          $formError.removeClass(this.options.formErrorClass);
        }

        $el.removeClass(this.options.inputErrorClass).removeAttr('data-invalid');
      }

      /**
       * Goes through a form to find inputs and proceeds to validate them in ways specific to their type
       * @fires Abide#invalid
       * @fires Abide#valid
       * @param {Object} element - jQuery object to validate, should be an HTML input
       * @returns {Boolean} goodToGo - If the input is valid or not.
       */

    }, {
      key: 'validateInput',
      value: function validateInput($el) {
        var clearRequire = this.requiredCheck($el),
            validated = false,
            customValidator = true,
            validator = $el.attr('data-validator'),
            equalTo = true;

        // don't validate ignored inputs or hidden inputs
        if ($el.is('[data-abide-ignore]') || $el.is('[type="hidden"]')) {
          return true;
        }

        switch ($el[0].type) {
          case 'radio':
            validated = this.validateRadio($el.attr('name'));
            break;

          case 'checkbox':
            validated = clearRequire;
            break;

          case 'select':
          case 'select-one':
          case 'select-multiple':
            validated = clearRequire;
            break;

          default:
            validated = this.validateText($el);
        }

        if (validator) {
          customValidator = this.matchValidation($el, validator, $el.attr('required'));
        }

        if ($el.attr('data-equalto')) {
          equalTo = this.options.validators.equalTo($el);
        }

        var goodToGo = [clearRequire, validated, customValidator, equalTo].indexOf(false) === -1;
        var message = (goodToGo ? 'valid' : 'invalid') + '.zf.abide';

        this[goodToGo ? 'removeErrorClasses' : 'addErrorClasses']($el);

        /**
         * Fires when the input is done checking for validation. Event trigger is either `valid.zf.abide` or `invalid.zf.abide`
         * Trigger includes the DOM element of the input.
         * @event Abide#valid
         * @event Abide#invalid
         */
        $el.trigger(message, [$el]);

        return goodToGo;
      }

      /**
       * Goes through a form and if there are any invalid inputs, it will display the form error element
       * @returns {Boolean} noError - true if no errors were detected...
       * @fires Abide#formvalid
       * @fires Abide#forminvalid
       */

    }, {
      key: 'validateForm',
      value: function validateForm() {
        var acc = [];
        var _this = this;

        this.$inputs.each(function () {
          acc.push(_this.validateInput($(this)));
        });

        var noError = acc.indexOf(false) === -1;

        this.$element.find('[data-abide-error]').css('display', noError ? 'none' : 'block');

        /**
         * Fires when the form is finished validating. Event trigger is either `formvalid.zf.abide` or `forminvalid.zf.abide`.
         * Trigger includes the element of the form.
         * @event Abide#formvalid
         * @event Abide#forminvalid
         */
        this.$element.trigger((noError ? 'formvalid' : 'forminvalid') + '.zf.abide', [this.$element]);

        return noError;
      }

      /**
       * Determines whether or a not a text input is valid based on the pattern specified in the attribute. If no matching pattern is found, returns true.
       * @param {Object} $el - jQuery object to validate, should be a text input HTML element
       * @param {String} pattern - string value of one of the RegEx patterns in Abide.options.patterns
       * @returns {Boolean} Boolean value depends on whether or not the input value matches the pattern specified
       */

    }, {
      key: 'validateText',
      value: function validateText($el, pattern) {
        // A pattern can be passed to this function, or it will be infered from the input's "pattern" attribute, or it's "type" attribute
        pattern = pattern || $el.attr('pattern') || $el.attr('type');
        var inputText = $el.val();
        var valid = false;

        if (inputText.length) {
          // If the pattern attribute on the element is in Abide's list of patterns, then test that regexp
          if (this.options.patterns.hasOwnProperty(pattern)) {
            valid = this.options.patterns[pattern].test(inputText);
          }
          // If the pattern name isn't also the type attribute of the field, then test it as a regexp
          else if (pattern !== $el.attr('type')) {
              valid = new RegExp(pattern).test(inputText);
            } else {
              valid = true;
            }
        }
        // An empty field is valid if it's not required
        else if (!$el.prop('required')) {
            valid = true;
          }

        return valid;
      }

      /**
       * Determines whether or a not a radio input is valid based on whether or not it is required and selected. Although the function targets a single `<input>`, it validates by checking the `required` and `checked` properties of all radio buttons in its group.
       * @param {String} groupName - A string that specifies the name of a radio button group
       * @returns {Boolean} Boolean value depends on whether or not at least one radio input has been selected (if it's required)
       */

    }, {
      key: 'validateRadio',
      value: function validateRadio(groupName) {
        // If at least one radio in the group has the `required` attribute, the group is considered required
        // Per W3C spec, all radio buttons in a group should have `required`, but we're being nice
        var $group = this.$element.find(':radio[name="' + groupName + '"]');
        var valid = false,
            required = false;

        // For the group to be required, at least one radio needs to be required
        $group.each(function (i, e) {
          if ($(e).attr('required')) {
            required = true;
          }
        });
        if (!required) valid = true;

        if (!valid) {
          // For the group to be valid, at least one radio needs to be checked
          $group.each(function (i, e) {
            if ($(e).prop('checked')) {
              valid = true;
            }
          });
        };

        return valid;
      }

      /**
       * Determines if a selected input passes a custom validation function. Multiple validations can be used, if passed to the element with `data-validator="foo bar baz"` in a space separated listed.
       * @param {Object} $el - jQuery input element.
       * @param {String} validators - a string of function names matching functions in the Abide.options.validators object.
       * @param {Boolean} required - self explanatory?
       * @returns {Boolean} - true if validations passed.
       */

    }, {
      key: 'matchValidation',
      value: function matchValidation($el, validators, required) {
        var _this4 = this;

        required = required ? true : false;

        var clear = validators.split(' ').map(function (v) {
          return _this4.options.validators[v]($el, required, $el.parent());
        });
        return clear.indexOf(false) === -1;
      }

      /**
       * Resets form inputs and styles
       * @fires Abide#formreset
       */

    }, {
      key: 'resetForm',
      value: function resetForm() {
        var $form = this.$element,
            opts = this.options;

        $('.' + opts.labelErrorClass, $form).not('small').removeClass(opts.labelErrorClass);
        $('.' + opts.inputErrorClass, $form).not('small').removeClass(opts.inputErrorClass);
        $(opts.formErrorSelector + '.' + opts.formErrorClass).removeClass(opts.formErrorClass);
        $form.find('[data-abide-error]').css('display', 'none');
        $(':input', $form).not(':button, :submit, :reset, :hidden, :radio, :checkbox, [data-abide-ignore]').val('').removeAttr('data-invalid');
        $(':input:radio', $form).not('[data-abide-ignore]').prop('checked', false).removeAttr('data-invalid');
        $(':input:checkbox', $form).not('[data-abide-ignore]').prop('checked', false).removeAttr('data-invalid');
        /**
         * Fires when the form has been reset.
         * @event Abide#formreset
         */
        $form.trigger('formreset.zf.abide', [$form]);
      }

      /**
       * Destroys an instance of Abide.
       * Removes error styles and classes from elements, without resetting their values.
       */

    }, {
      key: 'destroy',
      value: function destroy() {
        var _this = this;
        this.$element.off('.abide').find('[data-abide-error]').css('display', 'none');

        this.$inputs.off('.abide').each(function () {
          _this.removeErrorClasses($(this));
        });

        Foundation.unregisterPlugin(this);
      }
    }]);

    return Abide;
  }();

  /**
   * Default settings for plugin
   */


  Abide.defaults = {
    /**
     * The default event to validate inputs. Checkboxes and radios validate immediately.
     * Remove or change this value for manual validation.
     * @option
     * @example 'fieldChange'
     */
    validateOn: 'fieldChange',

    /**
     * Class to be applied to input labels on failed validation.
     * @option
     * @example 'is-invalid-label'
     */
    labelErrorClass: 'is-invalid-label',

    /**
     * Class to be applied to inputs on failed validation.
     * @option
     * @example 'is-invalid-input'
     */
    inputErrorClass: 'is-invalid-input',

    /**
     * Class selector to use to target Form Errors for show/hide.
     * @option
     * @example '.form-error'
     */
    formErrorSelector: '.form-error',

    /**
     * Class added to Form Errors on failed validation.
     * @option
     * @example 'is-visible'
     */
    formErrorClass: 'is-visible',

    /**
     * Set to true to validate text inputs on any value change.
     * @option
     * @example false
     */
    liveValidate: false,

    patterns: {
      alpha: /^[a-zA-Z]+$/,
      alpha_numeric: /^[a-zA-Z0-9]+$/,
      integer: /^[-+]?\d+$/,
      number: /^[-+]?\d*(?:[\.\,]\d+)?$/,

      // amex, visa, diners
      card: /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/,
      cvv: /^([0-9]){3,4}$/,

      // http://www.whatwg.org/specs/web-apps/current-work/multipage/states-of-the-type-attribute.html#valid-e-mail-address
      email: /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/,

      url: /^(https?|ftp|file|ssh):\/\/(((([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-zA-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-zA-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-zA-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/,
      // abc.de
      domain: /^([a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,8}$/,

      datetime: /^([0-2][0-9]{3})\-([0-1][0-9])\-([0-3][0-9])T([0-5][0-9])\:([0-5][0-9])\:([0-5][0-9])(Z|([\-\+]([0-1][0-9])\:00))$/,
      // YYYY-MM-DD
      date: /(?:19|20)[0-9]{2}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1[0-9]|2[0-9])|(?:(?!02)(?:0[1-9]|1[0-2])-(?:30))|(?:(?:0[13578]|1[02])-31))$/,
      // HH:MM:SS
      time: /^(0[0-9]|1[0-9]|2[0-3])(:[0-5][0-9]){2}$/,
      dateISO: /^\d{4}[\/\-]\d{1,2}[\/\-]\d{1,2}$/,
      // MM/DD/YYYY
      month_day_year: /^(0[1-9]|1[012])[- \/.](0[1-9]|[12][0-9]|3[01])[- \/.]\d{4}$/,
      // DD/MM/YYYY
      day_month_year: /^(0[1-9]|[12][0-9]|3[01])[- \/.](0[1-9]|1[012])[- \/.]\d{4}$/,

      // #FFF or #FFFFFF
      color: /^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/
    },

    /**
     * Optional validation functions to be used. `equalTo` being the only default included function.
     * Functions should return only a boolean if the input is valid or not. Functions are given the following arguments:
     * el : The jQuery element to validate.
     * required : Boolean value of the required attribute be present or not.
     * parent : The direct parent of the input.
     * @option
     */
    validators: {
      equalTo: function equalTo(el, required, parent) {
        return $('#' + el.attr('data-equalto')).val() === el.val();
      }
    }
  };

  // Window exports
  Foundation.plugin(Abide, 'Abide');
}(jQuery);

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/foundation/js/foundation.accordion.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

!function ($) {

  /**
   * Accordion module.
   * @module foundation.accordion
   * @requires foundation.util.keyboard
   * @requires foundation.util.motion
   */

  var Accordion = function () {
    /**
     * Creates a new instance of an accordion.
     * @class
     * @fires Accordion#init
     * @param {jQuery} element - jQuery object to make into an accordion.
     * @param {Object} options - a plain object with settings to override the default options.
     */
    function Accordion(element, options) {
      _classCallCheck(this, Accordion);

      this.$element = element;
      this.options = $.extend({}, Accordion.defaults, this.$element.data(), options);

      this._init();

      Foundation.registerPlugin(this, 'Accordion');
      Foundation.Keyboard.register('Accordion', {
        'ENTER': 'toggle',
        'SPACE': 'toggle',
        'ARROW_DOWN': 'next',
        'ARROW_UP': 'previous'
      });
    }

    /**
     * Initializes the accordion by animating the preset active pane(s).
     * @private
     */


    _createClass(Accordion, [{
      key: '_init',
      value: function _init() {
        this.$element.attr('role', 'tablist');
        this.$tabs = this.$element.children('li, [data-accordion-item]');

        this.$tabs.each(function (idx, el) {
          var $el = $(el),
              $content = $el.children('[data-tab-content]'),
              id = $content[0].id || Foundation.GetYoDigits(6, 'accordion'),
              linkId = el.id || id + '-label';

          $el.find('a:first').attr({
            'aria-controls': id,
            'role': 'tab',
            'id': linkId,
            'aria-expanded': false,
            'aria-selected': false
          });

          $content.attr({ 'role': 'tabpanel', 'aria-labelledby': linkId, 'aria-hidden': true, 'id': id });
        });
        var $initActive = this.$element.find('.is-active').children('[data-tab-content]');
        if ($initActive.length) {
          this.down($initActive, true);
        }
        this._events();
      }

      /**
       * Adds event handlers for items within the accordion.
       * @private
       */

    }, {
      key: '_events',
      value: function _events() {
        var _this = this;

        this.$tabs.each(function () {
          var $elem = $(this);
          var $tabContent = $elem.children('[data-tab-content]');
          if ($tabContent.length) {
            $elem.children('a').off('click.zf.accordion keydown.zf.accordion').on('click.zf.accordion', function (e) {
              // $(this).children('a').on('click.zf.accordion', function(e) {
              e.preventDefault();
              if ($elem.hasClass('is-active')) {
                if (_this.options.allowAllClosed || $elem.siblings().hasClass('is-active')) {
                  _this.up($tabContent);
                }
              } else {
                _this.down($tabContent);
              }
            }).on('keydown.zf.accordion', function (e) {
              Foundation.Keyboard.handleKey(e, 'Accordion', {
                toggle: function toggle() {
                  _this.toggle($tabContent);
                },
                next: function next() {
                  var $a = $elem.next().find('a').focus();
                  if (!_this.options.multiExpand) {
                    $a.trigger('click.zf.accordion');
                  }
                },
                previous: function previous() {
                  var $a = $elem.prev().find('a').focus();
                  if (!_this.options.multiExpand) {
                    $a.trigger('click.zf.accordion');
                  }
                },
                handled: function handled() {
                  e.preventDefault();
                  e.stopPropagation();
                }
              });
            });
          }
        });
      }

      /**
       * Toggles the selected content pane's open/close state.
       * @param {jQuery} $target - jQuery object of the pane to toggle.
       * @function
       */

    }, {
      key: 'toggle',
      value: function toggle($target) {
        if ($target.parent().hasClass('is-active')) {
          if (this.options.allowAllClosed || $target.parent().siblings().hasClass('is-active')) {
            this.up($target);
          } else {
            return;
          }
        } else {
          this.down($target);
        }
      }

      /**
       * Opens the accordion tab defined by `$target`.
       * @param {jQuery} $target - Accordion pane to open.
       * @param {Boolean} firstTime - flag to determine if reflow should happen.
       * @fires Accordion#down
       * @function
       */

    }, {
      key: 'down',
      value: function down($target, firstTime) {
        var _this2 = this;

        if (!this.options.multiExpand && !firstTime) {
          var $currentActive = this.$element.children('.is-active').children('[data-tab-content]');
          if ($currentActive.length) {
            this.up($currentActive);
          }
        }

        $target.attr('aria-hidden', false).parent('[data-tab-content]').addBack().parent().addClass('is-active');

        $target.slideDown(this.options.slideSpeed, function () {
          /**
           * Fires when the tab is done opening.
           * @event Accordion#down
           */
          _this2.$element.trigger('down.zf.accordion', [$target]);
        });

        $('#' + $target.attr('aria-labelledby')).attr({
          'aria-expanded': true,
          'aria-selected': true
        });
      }

      /**
       * Closes the tab defined by `$target`.
       * @param {jQuery} $target - Accordion tab to close.
       * @fires Accordion#up
       * @function
       */

    }, {
      key: 'up',
      value: function up($target) {
        var $aunts = $target.parent().siblings(),
            _this = this;
        var canClose = this.options.multiExpand ? $aunts.hasClass('is-active') : $target.parent().hasClass('is-active');

        if (!this.options.allowAllClosed && !canClose) {
          return;
        }

        // Foundation.Move(this.options.slideSpeed, $target, function(){
        $target.slideUp(_this.options.slideSpeed, function () {
          /**
           * Fires when the tab is done collapsing up.
           * @event Accordion#up
           */
          _this.$element.trigger('up.zf.accordion', [$target]);
        });
        // });

        $target.attr('aria-hidden', true).parent().removeClass('is-active');

        $('#' + $target.attr('aria-labelledby')).attr({
          'aria-expanded': false,
          'aria-selected': false
        });
      }

      /**
       * Destroys an instance of an accordion.
       * @fires Accordion#destroyed
       * @function
       */

    }, {
      key: 'destroy',
      value: function destroy() {
        this.$element.find('[data-tab-content]').stop(true).slideUp(0).css('display', '');
        this.$element.find('a').off('.zf.accordion');

        Foundation.unregisterPlugin(this);
      }
    }]);

    return Accordion;
  }();

  Accordion.defaults = {
    /**
     * Amount of time to animate the opening of an accordion pane.
     * @option
     * @example 250
     */
    slideSpeed: 250,
    /**
     * Allow the accordion to have multiple open panes.
     * @option
     * @example false
     */
    multiExpand: false,
    /**
     * Allow the accordion to close all panes.
     * @option
     * @example false
     */
    allowAllClosed: false
  };

  // Window exports
  Foundation.plugin(Accordion, 'Accordion');
}(jQuery);

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/foundation/js/foundation.core.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function ($) {

  "use strict";

  var FOUNDATION_VERSION = '6.2.2';

  // Global Foundation object
  // This is attached to the window, or used as a module for AMD/Browserify
  var Foundation = {
    version: FOUNDATION_VERSION,

    /**
     * Stores initialized plugins.
     */
    _plugins: {},

    /**
     * Stores generated unique ids for plugin instances
     */
    _uuids: [],

    /**
     * Returns a boolean for RTL support
     */
    rtl: function rtl() {
      return $('html').attr('dir') === 'rtl';
    },
    /**
     * Defines a Foundation plugin, adding it to the `Foundation` namespace and the list of plugins to initialize when reflowing.
     * @param {Object} plugin - The constructor of the plugin.
     */
    plugin: function plugin(_plugin, name) {
      // Object key to use when adding to global Foundation object
      // Examples: Foundation.Reveal, Foundation.OffCanvas
      var className = name || functionName(_plugin);
      // Object key to use when storing the plugin, also used to create the identifying data attribute for the plugin
      // Examples: data-reveal, data-off-canvas
      var attrName = hyphenate(className);

      // Add to the Foundation object and the plugins list (for reflowing)
      this._plugins[attrName] = this[className] = _plugin;
    },
    /**
     * @function
     * Populates the _uuids array with pointers to each individual plugin instance.
     * Adds the `zfPlugin` data-attribute to programmatically created plugins to allow use of $(selector).foundation(method) calls.
     * Also fires the initialization event for each plugin, consolidating repetitive code.
     * @param {Object} plugin - an instance of a plugin, usually `this` in context.
     * @param {String} name - the name of the plugin, passed as a camelCased string.
     * @fires Plugin#init
     */
    registerPlugin: function registerPlugin(plugin, name) {
      var pluginName = name ? hyphenate(name) : functionName(plugin.constructor).toLowerCase();
      plugin.uuid = this.GetYoDigits(6, pluginName);

      if (!plugin.$element.attr('data-' + pluginName)) {
        plugin.$element.attr('data-' + pluginName, plugin.uuid);
      }
      if (!plugin.$element.data('zfPlugin')) {
        plugin.$element.data('zfPlugin', plugin);
      }
      /**
       * Fires when the plugin has initialized.
       * @event Plugin#init
       */
      plugin.$element.trigger('init.zf.' + pluginName);

      this._uuids.push(plugin.uuid);

      return;
    },
    /**
     * @function
     * Removes the plugins uuid from the _uuids array.
     * Removes the zfPlugin data attribute, as well as the data-plugin-name attribute.
     * Also fires the destroyed event for the plugin, consolidating repetitive code.
     * @param {Object} plugin - an instance of a plugin, usually `this` in context.
     * @fires Plugin#destroyed
     */
    unregisterPlugin: function unregisterPlugin(plugin) {
      var pluginName = hyphenate(functionName(plugin.$element.data('zfPlugin').constructor));

      this._uuids.splice(this._uuids.indexOf(plugin.uuid), 1);
      plugin.$element.removeAttr('data-' + pluginName).removeData('zfPlugin')
      /**
       * Fires when the plugin has been destroyed.
       * @event Plugin#destroyed
       */
      .trigger('destroyed.zf.' + pluginName);
      for (var prop in plugin) {
        plugin[prop] = null; //clean up script to prep for garbage collection.
      }
      return;
    },

    /**
     * @function
     * Causes one or more active plugins to re-initialize, resetting event listeners, recalculating positions, etc.
     * @param {String} plugins - optional string of an individual plugin key, attained by calling `$(element).data('pluginName')`, or string of a plugin class i.e. `'dropdown'`
     * @default If no argument is passed, reflow all currently active plugins.
     */
    reInit: function reInit(plugins) {
      var isJQ = plugins instanceof $;
      try {
        if (isJQ) {
          plugins.each(function () {
            $(this).data('zfPlugin')._init();
          });
        } else {
          var type = typeof plugins === 'undefined' ? 'undefined' : _typeof(plugins),
              _this = this,
              fns = {
            'object': function object(plgs) {
              plgs.forEach(function (p) {
                p = hyphenate(p);
                $('[data-' + p + ']').foundation('_init');
              });
            },
            'string': function string() {
              plugins = hyphenate(plugins);
              $('[data-' + plugins + ']').foundation('_init');
            },
            'undefined': function undefined() {
              this['object'](Object.keys(_this._plugins));
            }
          };
          fns[type](plugins);
        }
      } catch (err) {
        console.error(err);
      } finally {
        return plugins;
      }
    },

    /**
     * returns a random base-36 uid with namespacing
     * @function
     * @param {Number} length - number of random base-36 digits desired. Increase for more random strings.
     * @param {String} namespace - name of plugin to be incorporated in uid, optional.
     * @default {String} '' - if no plugin name is provided, nothing is appended to the uid.
     * @returns {String} - unique id
     */
    GetYoDigits: function GetYoDigits(length, namespace) {
      length = length || 6;
      return Math.round(Math.pow(36, length + 1) - Math.random() * Math.pow(36, length)).toString(36).slice(1) + (namespace ? '-' + namespace : '');
    },
    /**
     * Initialize plugins on any elements within `elem` (and `elem` itself) that aren't already initialized.
     * @param {Object} elem - jQuery object containing the element to check inside. Also checks the element itself, unless it's the `document` object.
     * @param {String|Array} plugins - A list of plugins to initialize. Leave this out to initialize everything.
     */
    reflow: function reflow(elem, plugins) {

      // If plugins is undefined, just grab everything
      if (typeof plugins === 'undefined') {
        plugins = Object.keys(this._plugins);
      }
      // If plugins is a string, convert it to an array with one item
      else if (typeof plugins === 'string') {
          plugins = [plugins];
        }

      var _this = this;

      // Iterate through each plugin
      $.each(plugins, function (i, name) {
        // Get the current plugin
        var plugin = _this._plugins[name];

        // Localize the search to all elements inside elem, as well as elem itself, unless elem === document
        var $elem = $(elem).find('[data-' + name + ']').addBack('[data-' + name + ']');

        // For each plugin found, initialize it
        $elem.each(function () {
          var $el = $(this),
              opts = {};
          // Don't double-dip on plugins
          if ($el.data('zfPlugin')) {
            console.warn("Tried to initialize " + name + " on an element that already has a Foundation plugin.");
            return;
          }

          if ($el.attr('data-options')) {
            var thing = $el.attr('data-options').split(';').forEach(function (e, i) {
              var opt = e.split(':').map(function (el) {
                return el.trim();
              });
              if (opt[0]) opts[opt[0]] = parseValue(opt[1]);
            });
          }
          try {
            $el.data('zfPlugin', new plugin($(this), opts));
          } catch (er) {
            console.error(er);
          } finally {
            return;
          }
        });
      });
    },
    getFnName: functionName,
    transitionend: function transitionend($elem) {
      var transitions = {
        'transition': 'transitionend',
        'WebkitTransition': 'webkitTransitionEnd',
        'MozTransition': 'transitionend',
        'OTransition': 'otransitionend'
      };
      var elem = document.createElement('div'),
          end;

      for (var t in transitions) {
        if (typeof elem.style[t] !== 'undefined') {
          end = transitions[t];
        }
      }
      if (end) {
        return end;
      } else {
        end = setTimeout(function () {
          $elem.triggerHandler('transitionend', [$elem]);
        }, 1);
        return 'transitionend';
      }
    }
  };

  Foundation.util = {
    /**
     * Function for applying a debounce effect to a function call.
     * @function
     * @param {Function} func - Function to be called at end of timeout.
     * @param {Number} delay - Time in ms to delay the call of `func`.
     * @returns function
     */
    throttle: function throttle(func, delay) {
      var timer = null;

      return function () {
        var context = this,
            args = arguments;

        if (timer === null) {
          timer = setTimeout(function () {
            func.apply(context, args);
            timer = null;
          }, delay);
        }
      };
    }
  };

  // TODO: consider not making this a jQuery function
  // TODO: need way to reflow vs. re-initialize
  /**
   * The Foundation jQuery method.
   * @param {String|Array} method - An action to perform on the current jQuery object.
   */
  var foundation = function foundation(method) {
    var type = typeof method === 'undefined' ? 'undefined' : _typeof(method),
        $meta = $('meta.foundation-mq'),
        $noJS = $('.no-js');

    if (!$meta.length) {
      $('<meta class="foundation-mq">').appendTo(document.head);
    }
    if ($noJS.length) {
      $noJS.removeClass('no-js');
    }

    if (type === 'undefined') {
      //needs to initialize the Foundation object, or an individual plugin.
      Foundation.MediaQuery._init();
      Foundation.reflow(this);
    } else if (type === 'string') {
      //an individual method to invoke on a plugin or group of plugins
      var args = Array.prototype.slice.call(arguments, 1); //collect all the arguments, if necessary
      var plugClass = this.data('zfPlugin'); //determine the class of plugin

      if (plugClass !== undefined && plugClass[method] !== undefined) {
        //make sure both the class and method exist
        if (this.length === 1) {
          //if there's only one, call it directly.
          plugClass[method].apply(plugClass, args);
        } else {
          this.each(function (i, el) {
            //otherwise loop through the jQuery collection and invoke the method on each
            plugClass[method].apply($(el).data('zfPlugin'), args);
          });
        }
      } else {
        //error for no class or no method
        throw new ReferenceError("We're sorry, '" + method + "' is not an available method for " + (plugClass ? functionName(plugClass) : 'this element') + '.');
      }
    } else {
      //error for invalid argument type
      throw new TypeError('We\'re sorry, ' + type + ' is not a valid parameter. You must use a string representing the method you wish to invoke.');
    }
    return this;
  };

  window.Foundation = Foundation;
  $.fn.foundation = foundation;

  // Polyfill for requestAnimationFrame
  (function () {
    if (!Date.now || !window.Date.now) window.Date.now = Date.now = function () {
      return new Date().getTime();
    };

    var vendors = ['webkit', 'moz'];
    for (var i = 0; i < vendors.length && !window.requestAnimationFrame; ++i) {
      var vp = vendors[i];
      window.requestAnimationFrame = window[vp + 'RequestAnimationFrame'];
      window.cancelAnimationFrame = window[vp + 'CancelAnimationFrame'] || window[vp + 'CancelRequestAnimationFrame'];
    }
    if (/iP(ad|hone|od).*OS 6/.test(window.navigator.userAgent) || !window.requestAnimationFrame || !window.cancelAnimationFrame) {
      var lastTime = 0;
      window.requestAnimationFrame = function (callback) {
        var now = Date.now();
        var nextTime = Math.max(lastTime + 16, now);
        return setTimeout(function () {
          callback(lastTime = nextTime);
        }, nextTime - now);
      };
      window.cancelAnimationFrame = clearTimeout;
    }
    /**
     * Polyfill for performance.now, required by rAF
     */
    if (!window.performance || !window.performance.now) {
      window.performance = {
        start: Date.now(),
        now: function now() {
          return Date.now() - this.start;
        }
      };
    }
  })();
  if (!Function.prototype.bind) {
    Function.prototype.bind = function (oThis) {
      if (typeof this !== 'function') {
        // closest thing possible to the ECMAScript 5
        // internal IsCallable function
        throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
      }

      var aArgs = Array.prototype.slice.call(arguments, 1),
          fToBind = this,
          fNOP = function fNOP() {},
          fBound = function fBound() {
        return fToBind.apply(this instanceof fNOP ? this : oThis, aArgs.concat(Array.prototype.slice.call(arguments)));
      };

      if (this.prototype) {
        // native functions don't have a prototype
        fNOP.prototype = this.prototype;
      }
      fBound.prototype = new fNOP();

      return fBound;
    };
  }
  // Polyfill to get the name of a function in IE9
  function functionName(fn) {
    if (Function.prototype.name === undefined) {
      var funcNameRegex = /function\s([^(]{1,})\(/;
      var results = funcNameRegex.exec(fn.toString());
      return results && results.length > 1 ? results[1].trim() : "";
    } else if (fn.prototype === undefined) {
      return fn.constructor.name;
    } else {
      return fn.prototype.constructor.name;
    }
  }
  function parseValue(str) {
    if (/true/.test(str)) return true;else if (/false/.test(str)) return false;else if (!isNaN(str * 1)) return parseFloat(str);
    return str;
  }
  // Convert PascalCase to kebab-case
  // Thank you: http://stackoverflow.com/a/8955580
  function hyphenate(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
  }
}(jQuery);

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/foundation/js/foundation.dropdown.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

!function ($) {

  /**
   * Dropdown module.
   * @module foundation.dropdown
   * @requires foundation.util.keyboard
   * @requires foundation.util.box
   * @requires foundation.util.triggers
   */

  var Dropdown = function () {
    /**
     * Creates a new instance of a dropdown.
     * @class
     * @param {jQuery} element - jQuery object to make into a dropdown.
     *        Object should be of the dropdown panel, rather than its anchor.
     * @param {Object} options - Overrides to the default plugin settings.
     */
    function Dropdown(element, options) {
      _classCallCheck(this, Dropdown);

      this.$element = element;
      this.options = $.extend({}, Dropdown.defaults, this.$element.data(), options);
      this._init();

      Foundation.registerPlugin(this, 'Dropdown');
      Foundation.Keyboard.register('Dropdown', {
        'ENTER': 'open',
        'SPACE': 'open',
        'ESCAPE': 'close',
        'TAB': 'tab_forward',
        'SHIFT_TAB': 'tab_backward'
      });
    }

    /**
     * Initializes the plugin by setting/checking options and attributes, adding helper variables, and saving the anchor.
     * @function
     * @private
     */


    _createClass(Dropdown, [{
      key: '_init',
      value: function _init() {
        var $id = this.$element.attr('id');

        this.$anchor = $('[data-toggle="' + $id + '"]') || $('[data-open="' + $id + '"]');
        this.$anchor.attr({
          'aria-controls': $id,
          'data-is-focus': false,
          'data-yeti-box': $id,
          'aria-haspopup': true,
          'aria-expanded': false

        });

        this.options.positionClass = this.getPositionClass();
        this.counter = 4;
        this.usedPositions = [];
        this.$element.attr({
          'aria-hidden': 'true',
          'data-yeti-box': $id,
          'data-resize': $id,
          'aria-labelledby': this.$anchor[0].id || Foundation.GetYoDigits(6, 'dd-anchor')
        });
        this._events();
      }

      /**
       * Helper function to determine current orientation of dropdown pane.
       * @function
       * @returns {String} position - string value of a position class.
       */

    }, {
      key: 'getPositionClass',
      value: function getPositionClass() {
        var verticalPosition = this.$element[0].className.match(/(top|left|right|bottom)/g);
        verticalPosition = verticalPosition ? verticalPosition[0] : '';
        var horizontalPosition = /float-(\S+)\s/.exec(this.$anchor[0].className);
        horizontalPosition = horizontalPosition ? horizontalPosition[1] : '';
        var position = horizontalPosition ? horizontalPosition + ' ' + verticalPosition : verticalPosition;
        return position;
      }

      /**
       * Adjusts the dropdown panes orientation by adding/removing positioning classes.
       * @function
       * @private
       * @param {String} position - position class to remove.
       */

    }, {
      key: '_reposition',
      value: function _reposition(position) {
        this.usedPositions.push(position ? position : 'bottom');
        //default, try switching to opposite side
        if (!position && this.usedPositions.indexOf('top') < 0) {
          this.$element.addClass('top');
        } else if (position === 'top' && this.usedPositions.indexOf('bottom') < 0) {
          this.$element.removeClass(position);
        } else if (position === 'left' && this.usedPositions.indexOf('right') < 0) {
          this.$element.removeClass(position).addClass('right');
        } else if (position === 'right' && this.usedPositions.indexOf('left') < 0) {
          this.$element.removeClass(position).addClass('left');
        }

        //if default change didn't work, try bottom or left first
        else if (!position && this.usedPositions.indexOf('top') > -1 && this.usedPositions.indexOf('left') < 0) {
            this.$element.addClass('left');
          } else if (position === 'top' && this.usedPositions.indexOf('bottom') > -1 && this.usedPositions.indexOf('left') < 0) {
            this.$element.removeClass(position).addClass('left');
          } else if (position === 'left' && this.usedPositions.indexOf('right') > -1 && this.usedPositions.indexOf('bottom') < 0) {
            this.$element.removeClass(position);
          } else if (position === 'right' && this.usedPositions.indexOf('left') > -1 && this.usedPositions.indexOf('bottom') < 0) {
            this.$element.removeClass(position);
          }
          //if nothing cleared, set to bottom
          else {
              this.$element.removeClass(position);
            }
        this.classChanged = true;
        this.counter--;
      }

      /**
       * Sets the position and orientation of the dropdown pane, checks for collisions.
       * Recursively calls itself if a collision is detected, with a new position class.
       * @function
       * @private
       */

    }, {
      key: '_setPosition',
      value: function _setPosition() {
        if (this.$anchor.attr('aria-expanded') === 'false') {
          return false;
        }
        var position = this.getPositionClass(),
            $eleDims = Foundation.Box.GetDimensions(this.$element),
            $anchorDims = Foundation.Box.GetDimensions(this.$anchor),
            _this = this,
            direction = position === 'left' ? 'left' : position === 'right' ? 'left' : 'top',
            param = direction === 'top' ? 'height' : 'width',
            offset = param === 'height' ? this.options.vOffset : this.options.hOffset;

        if ($eleDims.width >= $eleDims.windowDims.width || !this.counter && !Foundation.Box.ImNotTouchingYou(this.$element)) {
          this.$element.offset(Foundation.Box.GetOffsets(this.$element, this.$anchor, 'center bottom', this.options.vOffset, this.options.hOffset, true)).css({
            'width': $eleDims.windowDims.width - this.options.hOffset * 2,
            'height': 'auto'
          });
          this.classChanged = true;
          return false;
        }

        this.$element.offset(Foundation.Box.GetOffsets(this.$element, this.$anchor, position, this.options.vOffset, this.options.hOffset));

        while (!Foundation.Box.ImNotTouchingYou(this.$element, false, true) && this.counter) {
          this._reposition(position);
          this._setPosition();
        }
      }

      /**
       * Adds event listeners to the element utilizing the triggers utility library.
       * @function
       * @private
       */

    }, {
      key: '_events',
      value: function _events() {
        var _this = this;
        this.$element.on({
          'open.zf.trigger': this.open.bind(this),
          'close.zf.trigger': this.close.bind(this),
          'toggle.zf.trigger': this.toggle.bind(this),
          'resizeme.zf.trigger': this._setPosition.bind(this)
        });

        if (this.options.hover) {
          this.$anchor.off('mouseenter.zf.dropdown mouseleave.zf.dropdown').on('mouseenter.zf.dropdown', function () {
            clearTimeout(_this.timeout);
            _this.timeout = setTimeout(function () {
              _this.open();
              _this.$anchor.data('hover', true);
            }, _this.options.hoverDelay);
          }).on('mouseleave.zf.dropdown', function () {
            clearTimeout(_this.timeout);
            _this.timeout = setTimeout(function () {
              _this.close();
              _this.$anchor.data('hover', false);
            }, _this.options.hoverDelay);
          });
          if (this.options.hoverPane) {
            this.$element.off('mouseenter.zf.dropdown mouseleave.zf.dropdown').on('mouseenter.zf.dropdown', function () {
              clearTimeout(_this.timeout);
            }).on('mouseleave.zf.dropdown', function () {
              clearTimeout(_this.timeout);
              _this.timeout = setTimeout(function () {
                _this.close();
                _this.$anchor.data('hover', false);
              }, _this.options.hoverDelay);
            });
          }
        }
        this.$anchor.add(this.$element).on('keydown.zf.dropdown', function (e) {

          var $target = $(this),
              visibleFocusableElements = Foundation.Keyboard.findFocusable(_this.$element);

          Foundation.Keyboard.handleKey(e, 'Dropdown', {
            tab_forward: function tab_forward() {
              if (_this.$element.find(':focus').is(visibleFocusableElements.eq(-1))) {
                // left modal downwards, setting focus to first element
                if (_this.options.trapFocus) {
                  // if focus shall be trapped
                  visibleFocusableElements.eq(0).focus();
                  e.preventDefault();
                } else {
                  // if focus is not trapped, close dropdown on focus out
                  _this.close();
                }
              }
            },
            tab_backward: function tab_backward() {
              if (_this.$element.find(':focus').is(visibleFocusableElements.eq(0)) || _this.$element.is(':focus')) {
                // left modal upwards, setting focus to last element
                if (_this.options.trapFocus) {
                  // if focus shall be trapped
                  visibleFocusableElements.eq(-1).focus();
                  e.preventDefault();
                } else {
                  // if focus is not trapped, close dropdown on focus out
                  _this.close();
                }
              }
            },
            open: function open() {
              if ($target.is(_this.$anchor)) {
                _this.open();
                _this.$element.attr('tabindex', -1).focus();
                e.preventDefault();
              }
            },
            close: function close() {
              _this.close();
              _this.$anchor.focus();
            }
          });
        });
      }

      /**
       * Adds an event handler to the body to close any dropdowns on a click.
       * @function
       * @private
       */

    }, {
      key: '_addBodyHandler',
      value: function _addBodyHandler() {
        var $body = $(document.body).not(this.$element),
            _this = this;
        $body.off('click.zf.dropdown').on('click.zf.dropdown', function (e) {
          if (_this.$anchor.is(e.target) || _this.$anchor.find(e.target).length) {
            return;
          }
          if (_this.$element.find(e.target).length) {
            return;
          }
          _this.close();
          $body.off('click.zf.dropdown');
        });
      }

      /**
       * Opens the dropdown pane, and fires a bubbling event to close other dropdowns.
       * @function
       * @fires Dropdown#closeme
       * @fires Dropdown#show
       */

    }, {
      key: 'open',
      value: function open() {
        // var _this = this;
        /**
         * Fires to close other open dropdowns
         * @event Dropdown#closeme
         */
        this.$element.trigger('closeme.zf.dropdown', this.$element.attr('id'));
        this.$anchor.addClass('hover').attr({ 'aria-expanded': true });
        // this.$element/*.show()*/;
        this._setPosition();
        this.$element.addClass('is-open').attr({ 'aria-hidden': false });

        if (this.options.autoFocus) {
          var $focusable = Foundation.Keyboard.findFocusable(this.$element);
          if ($focusable.length) {
            $focusable.eq(0).focus();
          }
        }

        if (this.options.closeOnClick) {
          this._addBodyHandler();
        }

        /**
         * Fires once the dropdown is visible.
         * @event Dropdown#show
         */
        this.$element.trigger('show.zf.dropdown', [this.$element]);
      }

      /**
       * Closes the open dropdown pane.
       * @function
       * @fires Dropdown#hide
       */

    }, {
      key: 'close',
      value: function close() {
        if (!this.$element.hasClass('is-open')) {
          return false;
        }
        this.$element.removeClass('is-open').attr({ 'aria-hidden': true });

        this.$anchor.removeClass('hover').attr('aria-expanded', false);

        if (this.classChanged) {
          var curPositionClass = this.getPositionClass();
          if (curPositionClass) {
            this.$element.removeClass(curPositionClass);
          }
          this.$element.addClass(this.options.positionClass)
          /*.hide()*/.css({ height: '', width: '' });
          this.classChanged = false;
          this.counter = 4;
          this.usedPositions.length = 0;
        }
        this.$element.trigger('hide.zf.dropdown', [this.$element]);
      }

      /**
       * Toggles the dropdown pane's visibility.
       * @function
       */

    }, {
      key: 'toggle',
      value: function toggle() {
        if (this.$element.hasClass('is-open')) {
          if (this.$anchor.data('hover')) return;
          this.close();
        } else {
          this.open();
        }
      }

      /**
       * Destroys the dropdown.
       * @function
       */

    }, {
      key: 'destroy',
      value: function destroy() {
        this.$element.off('.zf.trigger').hide();
        this.$anchor.off('.zf.dropdown');

        Foundation.unregisterPlugin(this);
      }
    }]);

    return Dropdown;
  }();

  Dropdown.defaults = {
    /**
     * Amount of time to delay opening a submenu on hover event.
     * @option
     * @example 250
     */
    hoverDelay: 250,
    /**
     * Allow submenus to open on hover events
     * @option
     * @example false
     */
    hover: false,
    /**
     * Don't close dropdown when hovering over dropdown pane
     * @option
     * @example true
     */
    hoverPane: false,
    /**
     * Number of pixels between the dropdown pane and the triggering element on open.
     * @option
     * @example 1
     */
    vOffset: 1,
    /**
     * Number of pixels between the dropdown pane and the triggering element on open.
     * @option
     * @example 1
     */
    hOffset: 1,
    /**
     * Class applied to adjust open position. JS will test and fill this in.
     * @option
     * @example 'top'
     */
    positionClass: '',
    /**
     * Allow the plugin to trap focus to the dropdown pane if opened with keyboard commands.
     * @option
     * @example false
     */
    trapFocus: false,
    /**
     * Allow the plugin to set focus to the first focusable element within the pane, regardless of method of opening.
     * @option
     * @example true
     */
    autoFocus: false,
    /**
     * Allows a click on the body to close the dropdown.
     * @option
     * @example false
     */
    closeOnClick: false
  };

  // Window exports
  Foundation.plugin(Dropdown, 'Dropdown');
}(jQuery);

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/foundation/js/foundation.reveal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

!function ($) {

  /**
   * Reveal module.
   * @module foundation.reveal
   * @requires foundation.util.keyboard
   * @requires foundation.util.box
   * @requires foundation.util.triggers
   * @requires foundation.util.mediaQuery
   * @requires foundation.util.motion if using animations
   */

  var Reveal = function () {
    /**
     * Creates a new instance of Reveal.
     * @class
     * @param {jQuery} element - jQuery object to use for the modal.
     * @param {Object} options - optional parameters.
     */
    function Reveal(element, options) {
      _classCallCheck(this, Reveal);

      this.$element = element;
      this.options = $.extend({}, Reveal.defaults, this.$element.data(), options);
      this._init();

      Foundation.registerPlugin(this, 'Reveal');
      Foundation.Keyboard.register('Reveal', {
        'ENTER': 'open',
        'SPACE': 'open',
        'ESCAPE': 'close',
        'TAB': 'tab_forward',
        'SHIFT_TAB': 'tab_backward'
      });
    }

    /**
     * Initializes the modal by adding the overlay and close buttons, (if selected).
     * @private
     */


    _createClass(Reveal, [{
      key: '_init',
      value: function _init() {
        this.id = this.$element.attr('id');
        this.isActive = false;
        this.cached = { mq: Foundation.MediaQuery.current };
        this.isMobile = mobileSniff();

        this.$anchor = $('[data-open="' + this.id + '"]').length ? $('[data-open="' + this.id + '"]') : $('[data-toggle="' + this.id + '"]');
        this.$anchor.attr({
          'aria-controls': this.id,
          'aria-haspopup': true,
          'tabindex': 0
        });

        if (this.options.fullScreen || this.$element.hasClass('full')) {
          this.options.fullScreen = true;
          this.options.overlay = false;
        }
        if (this.options.overlay && !this.$overlay) {
          this.$overlay = this._makeOverlay(this.id);
        }

        this.$element.attr({
          'role': 'dialog',
          'aria-hidden': true,
          'data-yeti-box': this.id,
          'data-resize': this.id
        });

        if (this.$overlay) {
          this.$element.detach().appendTo(this.$overlay);
        } else {
          this.$element.detach().appendTo($('body'));
          this.$element.addClass('without-overlay');
        }
        this._events();
        if (this.options.deepLink && window.location.hash === '#' + this.id) {
          $(window).one('load.zf.reveal', this.open.bind(this));
        }
      }

      /**
       * Creates an overlay div to display behind the modal.
       * @private
       */

    }, {
      key: '_makeOverlay',
      value: function _makeOverlay(id) {
        var $overlay = $('<div></div>').addClass('reveal-overlay').appendTo('body');
        return $overlay;
      }

      /**
       * Updates position of modal
       * TODO:  Figure out if we actually need to cache these values or if it doesn't matter
       * @private
       */

    }, {
      key: '_updatePosition',
      value: function _updatePosition() {
        var width = this.$element.outerWidth();
        var outerWidth = $(window).width();
        var height = this.$element.outerHeight();
        var outerHeight = $(window).height();
        var left, top;
        if (this.options.hOffset === 'auto') {
          left = parseInt((outerWidth - width) / 2, 10);
        } else {
          left = parseInt(this.options.hOffset, 10);
        }
        if (this.options.vOffset === 'auto') {
          if (height > outerHeight) {
            top = parseInt(Math.min(100, outerHeight / 10), 10);
          } else {
            top = parseInt((outerHeight - height) / 4, 10);
          }
        } else {
          top = parseInt(this.options.vOffset, 10);
        }
        this.$element.css({ top: top + 'px' });
        // only worry about left if we don't have an overlay or we havea  horizontal offset,
        // otherwise we're perfectly in the middle
        if (!this.$overlay || this.options.hOffset !== 'auto') {
          this.$element.css({ left: left + 'px' });
          this.$element.css({ margin: '0px' });
        }
      }

      /**
       * Adds event handlers for the modal.
       * @private
       */

    }, {
      key: '_events',
      value: function _events() {
        var _this2 = this;

        var _this = this;

        this.$element.on({
          'open.zf.trigger': this.open.bind(this),
          'close.zf.trigger': function closeZfTrigger(event, $element) {
            if (event.target === _this.$element[0] || $(event.target).parents('[data-closable]')[0] === $element) {
              // only close reveal when it's explicitly called
              return _this2.close.apply(_this2);
            }
          },
          'toggle.zf.trigger': this.toggle.bind(this),
          'resizeme.zf.trigger': function resizemeZfTrigger() {
            _this._updatePosition();
          }
        });

        if (this.$anchor.length) {
          this.$anchor.on('keydown.zf.reveal', function (e) {
            if (e.which === 13 || e.which === 32) {
              e.stopPropagation();
              e.preventDefault();
              _this.open();
            }
          });
        }

        if (this.options.closeOnClick && this.options.overlay) {
          this.$overlay.off('.zf.reveal').on('click.zf.reveal', function (e) {
            if (e.target === _this.$element[0] || $.contains(_this.$element[0], e.target)) {
              return;
            }
            _this.close();
          });
        }
        if (this.options.deepLink) {
          $(window).on('popstate.zf.reveal:' + this.id, this._handleState.bind(this));
        }
      }

      /**
       * Handles modal methods on back/forward button clicks or any other event that triggers popstate.
       * @private
       */

    }, {
      key: '_handleState',
      value: function _handleState(e) {
        if (window.location.hash === '#' + this.id && !this.isActive) {
          this.open();
        } else {
          this.close();
        }
      }

      /**
       * Opens the modal controlled by `this.$anchor`, and closes all others by default.
       * @function
       * @fires Reveal#closeme
       * @fires Reveal#open
       */

    }, {
      key: 'open',
      value: function open() {
        var _this3 = this;

        if (this.options.deepLink) {
          var hash = '#' + this.id;

          if (window.history.pushState) {
            window.history.pushState(null, null, hash);
          } else {
            window.location.hash = hash;
          }
        }

        this.isActive = true;

        // Make elements invisible, but remove display: none so we can get size and positioning
        this.$element.css({ 'visibility': 'hidden' }).show().scrollTop(0);
        if (this.options.overlay) {
          this.$overlay.css({ 'visibility': 'hidden' }).show();
        }

        this._updatePosition();

        this.$element.hide().css({ 'visibility': '' });

        if (this.$overlay) {
          this.$overlay.css({ 'visibility': '' }).hide();
          if (this.$element.hasClass('fast')) {
            this.$overlay.addClass('fast');
          } else if (this.$element.hasClass('slow')) {
            this.$overlay.addClass('slow');
          }
        }

        if (!this.options.multipleOpened) {
          /**
           * Fires immediately before the modal opens.
           * Closes any other modals that are currently open
           * @event Reveal#closeme
           */
          this.$element.trigger('closeme.zf.reveal', this.id);
        }
        // Motion UI method of reveal
        if (this.options.animationIn) {
          var _this = this;
          function afterAnimationFocus() {
            _this.$element.attr({
              'aria-hidden': false,
              'tabindex': -1
            }).focus();
            console.log('focus');
          }
          if (this.options.overlay) {
            Foundation.Motion.animateIn(this.$overlay, 'fade-in');
          }
          Foundation.Motion.animateIn(this.$element, this.options.animationIn, function () {
            _this3.focusableElements = Foundation.Keyboard.findFocusable(_this3.$element);
            afterAnimationFocus();
          });
        }
        // jQuery method of reveal
        else {
            if (this.options.overlay) {
              this.$overlay.show(0);
            }
            this.$element.show(this.options.showDelay);
          }

        // handle accessibility
        this.$element.attr({
          'aria-hidden': false,
          'tabindex': -1
        }).focus();

        /**
         * Fires when the modal has successfully opened.
         * @event Reveal#open
         */
        this.$element.trigger('open.zf.reveal');

        if (this.isMobile) {
          this.originalScrollPos = window.pageYOffset;
          $('html, body').addClass('is-reveal-open');
        } else {
          $('body').addClass('is-reveal-open');
        }

        setTimeout(function () {
          _this3._extraHandlers();
        }, 0);
      }

      /**
       * Adds extra event handlers for the body and window if necessary.
       * @private
       */

    }, {
      key: '_extraHandlers',
      value: function _extraHandlers() {
        var _this = this;
        this.focusableElements = Foundation.Keyboard.findFocusable(this.$element);

        if (!this.options.overlay && this.options.closeOnClick && !this.options.fullScreen) {
          $('body').on('click.zf.reveal', function (e) {
            if (e.target === _this.$element[0] || $.contains(_this.$element[0], e.target)) {
              return;
            }
            _this.close();
          });
        }

        if (this.options.closeOnEsc) {
          $(window).on('keydown.zf.reveal', function (e) {
            Foundation.Keyboard.handleKey(e, 'Reveal', {
              close: function close() {
                if (_this.options.closeOnEsc) {
                  _this.close();
                  _this.$anchor.focus();
                }
              }
            });
          });
        }

        // lock focus within modal while tabbing
        this.$element.on('keydown.zf.reveal', function (e) {
          var $target = $(this);
          // handle keyboard event with keyboard util
          Foundation.Keyboard.handleKey(e, 'Reveal', {
            tab_forward: function tab_forward() {
              if (_this.$element.find(':focus').is(_this.focusableElements.eq(-1))) {
                // left modal downwards, setting focus to first element
                _this.focusableElements.eq(0).focus();
                return true;
              }
              if (_this.focusableElements.length === 0) {
                // no focusable elements inside the modal at all, prevent tabbing in general
                return true;
              }
            },
            tab_backward: function tab_backward() {
              if (_this.$element.find(':focus').is(_this.focusableElements.eq(0)) || _this.$element.is(':focus')) {
                // left modal upwards, setting focus to last element
                _this.focusableElements.eq(-1).focus();
                return true;
              }
              if (_this.focusableElements.length === 0) {
                // no focusable elements inside the modal at all, prevent tabbing in general
                return true;
              }
            },
            open: function open() {
              if (_this.$element.find(':focus').is(_this.$element.find('[data-close]'))) {
                setTimeout(function () {
                  // set focus back to anchor if close button has been activated
                  _this.$anchor.focus();
                }, 1);
              } else if ($target.is(_this.focusableElements)) {
                // dont't trigger if acual element has focus (i.e. inputs, links, ...)
                _this.open();
              }
            },
            close: function close() {
              if (_this.options.closeOnEsc) {
                _this.close();
                _this.$anchor.focus();
              }
            },
            handled: function handled(preventDefault) {
              if (preventDefault) {
                e.preventDefault();
              }
            }
          });
        });
      }

      /**
       * Closes the modal.
       * @function
       * @fires Reveal#closed
       */

    }, {
      key: 'close',
      value: function close() {
        if (!this.isActive || !this.$element.is(':visible')) {
          return false;
        }
        var _this = this;

        // Motion UI method of hiding
        if (this.options.animationOut) {
          if (this.options.overlay) {
            Foundation.Motion.animateOut(this.$overlay, 'fade-out', finishUp);
          } else {
            finishUp();
          }

          Foundation.Motion.animateOut(this.$element, this.options.animationOut);
        }
        // jQuery method of hiding
        else {
            if (this.options.overlay) {
              this.$overlay.hide(0, finishUp);
            } else {
              finishUp();
            }

            this.$element.hide(this.options.hideDelay);
          }

        // Conditionals to remove extra event listeners added on open
        if (this.options.closeOnEsc) {
          $(window).off('keydown.zf.reveal');
        }

        if (!this.options.overlay && this.options.closeOnClick) {
          $('body').off('click.zf.reveal');
        }

        this.$element.off('keydown.zf.reveal');

        function finishUp() {
          if (_this.isMobile) {
            $('html, body').removeClass('is-reveal-open');
            if (_this.originalScrollPos) {
              $('body').scrollTop(_this.originalScrollPos);
              _this.originalScrollPos = null;
            }
          } else {
            $('body').removeClass('is-reveal-open');
          }

          _this.$element.attr('aria-hidden', true);

          /**
          * Fires when the modal is done closing.
          * @event Reveal#closed
          */
          _this.$element.trigger('closed.zf.reveal');
        }

        /**
        * Resets the modal content
        * This prevents a running video to keep going in the background
        */
        if (this.options.resetOnClose) {
          this.$element.html(this.$element.html());
        }

        this.isActive = false;
        if (_this.options.deepLink) {
          if (window.history.replaceState) {
            window.history.replaceState("", document.title, window.location.pathname);
          } else {
            window.location.hash = '';
          }
        }
      }

      /**
       * Toggles the open/closed state of a modal.
       * @function
       */

    }, {
      key: 'toggle',
      value: function toggle() {
        if (this.isActive) {
          this.close();
        } else {
          this.open();
        }
      }
    }, {
      key: 'destroy',


      /**
       * Destroys an instance of a modal.
       * @function
       */
      value: function destroy() {
        if (this.options.overlay) {
          this.$element.appendTo($('body')); // move $element outside of $overlay to prevent error unregisterPlugin()
          this.$overlay.hide().off().remove();
        }
        this.$element.hide().off();
        this.$anchor.off('.zf');
        $(window).off('.zf.reveal:' + this.id);

        Foundation.unregisterPlugin(this);
      }
    }]);

    return Reveal;
  }();

  Reveal.defaults = {
    /**
     * Motion-UI class to use for animated elements. If none used, defaults to simple show/hide.
     * @option
     * @example 'slide-in-left'
     */
    animationIn: '',
    /**
     * Motion-UI class to use for animated elements. If none used, defaults to simple show/hide.
     * @option
     * @example 'slide-out-right'
     */
    animationOut: '',
    /**
     * Time, in ms, to delay the opening of a modal after a click if no animation used.
     * @option
     * @example 10
     */
    showDelay: 0,
    /**
     * Time, in ms, to delay the closing of a modal after a click if no animation used.
     * @option
     * @example 10
     */
    hideDelay: 0,
    /**
     * Allows a click on the body/overlay to close the modal.
     * @option
     * @example true
     */
    closeOnClick: true,
    /**
     * Allows the modal to close if the user presses the `ESCAPE` key.
     * @option
     * @example true
     */
    closeOnEsc: true,
    /**
     * If true, allows multiple modals to be displayed at once.
     * @option
     * @example false
     */
    multipleOpened: false,
    /**
     * Distance, in pixels, the modal should push down from the top of the screen.
     * @option
     * @example auto
     */
    vOffset: 'auto',
    /**
     * Distance, in pixels, the modal should push in from the side of the screen.
     * @option
     * @example auto
     */
    hOffset: 'auto',
    /**
     * Allows the modal to be fullscreen, completely blocking out the rest of the view. JS checks for this as well.
     * @option
     * @example false
     */
    fullScreen: false,
    /**
     * Percentage of screen height the modal should push up from the bottom of the view.
     * @option
     * @example 10
     */
    btmOffsetPct: 10,
    /**
     * Allows the modal to generate an overlay div, which will cover the view when modal opens.
     * @option
     * @example true
     */
    overlay: true,
    /**
     * Allows the modal to remove and reinject markup on close. Should be true if using video elements w/o using provider's api, otherwise, videos will continue to play in the background.
     * @option
     * @example false
     */
    resetOnClose: false,
    /**
     * Allows the modal to alter the url on open/close, and allows the use of the `back` button to close modals. ALSO, allows a modal to auto-maniacally open on page load IF the hash === the modal's user-set id.
     * @option
     * @example false
     */
    deepLink: false
  };

  // Window exports
  Foundation.plugin(Reveal, 'Reveal');

  function iPhoneSniff() {
    return (/iP(ad|hone|od).*OS/.test(window.navigator.userAgent)
    );
  }

  function androidSniff() {
    return (/Android/.test(window.navigator.userAgent)
    );
  }

  function mobileSniff() {
    return iPhoneSniff() || androidSniff();
  }
}(jQuery);

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/foundation/js/foundation.tabs.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

!function ($) {

  /**
   * Tabs module.
   * @module foundation.tabs
   * @requires foundation.util.keyboard
   * @requires foundation.util.timerAndImageLoader if tabs contain images
   */

  var Tabs = function () {
    /**
     * Creates a new instance of tabs.
     * @class
     * @fires Tabs#init
     * @param {jQuery} element - jQuery object to make into tabs.
     * @param {Object} options - Overrides to the default plugin settings.
     */
    function Tabs(element, options) {
      _classCallCheck(this, Tabs);

      this.$element = element;
      this.options = $.extend({}, Tabs.defaults, this.$element.data(), options);

      this._init();
      Foundation.registerPlugin(this, 'Tabs');
      Foundation.Keyboard.register('Tabs', {
        'ENTER': 'open',
        'SPACE': 'open',
        'ARROW_RIGHT': 'next',
        'ARROW_UP': 'previous',
        'ARROW_DOWN': 'next',
        'ARROW_LEFT': 'previous'
        // 'TAB': 'next',
        // 'SHIFT_TAB': 'previous'
      });
    }

    /**
     * Initializes the tabs by showing and focusing (if autoFocus=true) the preset active tab.
     * @private
     */


    _createClass(Tabs, [{
      key: '_init',
      value: function _init() {
        var _this = this;

        this.$tabTitles = this.$element.find('.' + this.options.linkClass);
        this.$tabContent = $('[data-tabs-content="' + this.$element[0].id + '"]');

        this.$tabTitles.each(function () {
          var $elem = $(this),
              $link = $elem.find('a'),
              isActive = $elem.hasClass('is-active'),
              hash = $link[0].hash.slice(1),
              linkId = $link[0].id ? $link[0].id : hash + '-label',
              $tabContent = $('#' + hash);

          $elem.attr({ 'role': 'presentation' });

          $link.attr({
            'role': 'tab',
            'aria-controls': hash,
            'aria-selected': isActive,
            'id': linkId
          });

          $tabContent.attr({
            'role': 'tabpanel',
            'aria-hidden': !isActive,
            'aria-labelledby': linkId
          });

          if (isActive && _this.options.autoFocus) {
            $link.focus();
          }
        });

        if (this.options.matchHeight) {
          var $images = this.$tabContent.find('img');

          if ($images.length) {
            Foundation.onImagesLoaded($images, this._setHeight.bind(this));
          } else {
            this._setHeight();
          }
        }

        this._events();
      }

      /**
       * Adds event handlers for items within the tabs.
       * @private
       */

    }, {
      key: '_events',
      value: function _events() {
        this._addKeyHandler();
        this._addClickHandler();
        this._setHeightMqHandler = null;

        if (this.options.matchHeight) {
          this._setHeightMqHandler = this._setHeight.bind(this);

          $(window).on('changed.zf.mediaquery', this._setHeightMqHandler);
        }
      }

      /**
       * Adds click handlers for items within the tabs.
       * @private
       */

    }, {
      key: '_addClickHandler',
      value: function _addClickHandler() {
        var _this = this;

        this.$element.off('click.zf.tabs').on('click.zf.tabs', '.' + this.options.linkClass, function (e) {
          e.preventDefault();
          e.stopPropagation();
          if ($(this).hasClass('is-active')) {
            return;
          }
          _this._handleTabChange($(this));
        });
      }

      /**
       * Adds keyboard event handlers for items within the tabs.
       * @private
       */

    }, {
      key: '_addKeyHandler',
      value: function _addKeyHandler() {
        var _this = this;
        var $firstTab = _this.$element.find('li:first-of-type');
        var $lastTab = _this.$element.find('li:last-of-type');

        this.$tabTitles.off('keydown.zf.tabs').on('keydown.zf.tabs', function (e) {
          if (e.which === 9) return;

          var $element = $(this),
              $elements = $element.parent('ul').children('li'),
              $prevElement,
              $nextElement;

          $elements.each(function (i) {
            if ($(this).is($element)) {
              if (_this.options.wrapOnKeys) {
                $prevElement = i === 0 ? $elements.last() : $elements.eq(i - 1);
                $nextElement = i === $elements.length - 1 ? $elements.first() : $elements.eq(i + 1);
              } else {
                $prevElement = $elements.eq(Math.max(0, i - 1));
                $nextElement = $elements.eq(Math.min(i + 1, $elements.length - 1));
              }
              return;
            }
          });

          // handle keyboard event with keyboard util
          Foundation.Keyboard.handleKey(e, 'Tabs', {
            open: function open() {
              $element.find('[role="tab"]').focus();
              _this._handleTabChange($element);
            },
            previous: function previous() {
              $prevElement.find('[role="tab"]').focus();
              _this._handleTabChange($prevElement);
            },
            next: function next() {
              $nextElement.find('[role="tab"]').focus();
              _this._handleTabChange($nextElement);
            },
            handled: function handled() {
              e.stopPropagation();
              e.preventDefault();
            }
          });
        });
      }

      /**
       * Opens the tab `$targetContent` defined by `$target`.
       * @param {jQuery} $target - Tab to open.
       * @fires Tabs#change
       * @function
       */

    }, {
      key: '_handleTabChange',
      value: function _handleTabChange($target) {
        var $tabLink = $target.find('[role="tab"]'),
            hash = $tabLink[0].hash,
            $targetContent = this.$tabContent.find(hash),
            $oldTab = this.$element.find('.' + this.options.linkClass + '.is-active').removeClass('is-active').find('[role="tab"]').attr({ 'aria-selected': 'false' });

        $('#' + $oldTab.attr('aria-controls')).removeClass('is-active').attr({ 'aria-hidden': 'true' });

        $target.addClass('is-active');

        $tabLink.attr({ 'aria-selected': 'true' });

        $targetContent.addClass('is-active').attr({ 'aria-hidden': 'false' });

        /**
         * Fires when the plugin has successfully changed tabs.
         * @event Tabs#change
         */
        this.$element.trigger('change.zf.tabs', [$target]);
      }

      /**
       * Public method for selecting a content pane to display.
       * @param {jQuery | String} elem - jQuery object or string of the id of the pane to display.
       * @function
       */

    }, {
      key: 'selectTab',
      value: function selectTab(elem) {
        var idStr;

        if ((typeof elem === 'undefined' ? 'undefined' : _typeof(elem)) === 'object') {
          idStr = elem[0].id;
        } else {
          idStr = elem;
        }

        if (idStr.indexOf('#') < 0) {
          idStr = '#' + idStr;
        }

        var $target = this.$tabTitles.find('[href="' + idStr + '"]').parent('.' + this.options.linkClass);

        this._handleTabChange($target);
      }
    }, {
      key: '_setHeight',

      /**
       * Sets the height of each panel to the height of the tallest panel.
       * If enabled in options, gets called on media query change.
       * If loading content via external source, can be called directly or with _reflow.
       * @function
       * @private
       */
      value: function _setHeight() {
        var max = 0;
        this.$tabContent.find('.' + this.options.panelClass).css('height', '').each(function () {
          var panel = $(this),
              isActive = panel.hasClass('is-active');

          if (!isActive) {
            panel.css({ 'visibility': 'hidden', 'display': 'block' });
          }

          var temp = this.getBoundingClientRect().height;

          if (!isActive) {
            panel.css({
              'visibility': '',
              'display': ''
            });
          }

          max = temp > max ? temp : max;
        }).css('height', max + 'px');
      }

      /**
       * Destroys an instance of an tabs.
       * @fires Tabs#destroyed
       */

    }, {
      key: 'destroy',
      value: function destroy() {
        this.$element.find('.' + this.options.linkClass).off('.zf.tabs').hide().end().find('.' + this.options.panelClass).hide();

        if (this.options.matchHeight) {
          if (this._setHeightMqHandler != null) {
            $(window).off('changed.zf.mediaquery', this._setHeightMqHandler);
          }
        }

        Foundation.unregisterPlugin(this);
      }
    }]);

    return Tabs;
  }();

  Tabs.defaults = {
    /**
     * Allows the window to scroll to content of active pane on load if set to true.
     * @option
     * @example false
     */
    autoFocus: false,

    /**
     * Allows keyboard input to 'wrap' around the tab links.
     * @option
     * @example true
     */
    wrapOnKeys: true,

    /**
     * Allows the tab content panes to match heights if set to true.
     * @option
     * @example false
     */
    matchHeight: false,

    /**
     * Class applied to `li`'s in tab link list.
     * @option
     * @example 'tabs-title'
     */
    linkClass: 'tabs-title',

    /**
     * Class applied to the content containers.
     * @option
     * @example 'tabs-panel'
     */
    panelClass: 'tabs-panel'
  };

  function checkClass($elem) {
    return $elem.hasClass('is-active');
  }

  // Window exports
  Foundation.plugin(Tabs, 'Tabs');
}(jQuery);

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/foundation/js/foundation.toggler.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

!function ($) {

  /**
   * Toggler module.
   * @module foundation.toggler
   * @requires foundation.util.motion
   * @requires foundation.util.triggers
   */

  var Toggler = function () {
    /**
     * Creates a new instance of Toggler.
     * @class
     * @fires Toggler#init
     * @param {Object} element - jQuery object to add the trigger to.
     * @param {Object} options - Overrides to the default plugin settings.
     */
    function Toggler(element, options) {
      _classCallCheck(this, Toggler);

      this.$element = element;
      this.options = $.extend({}, Toggler.defaults, element.data(), options);
      this.className = '';

      this._init();
      this._events();

      Foundation.registerPlugin(this, 'Toggler');
    }

    /**
     * Initializes the Toggler plugin by parsing the toggle class from data-toggler, or animation classes from data-animate.
     * @function
     * @private
     */


    _createClass(Toggler, [{
      key: '_init',
      value: function _init() {
        var input;
        // Parse animation classes if they were set
        if (this.options.animate) {
          input = this.options.animate.split(' ');

          this.animationIn = input[0];
          this.animationOut = input[1] || null;
        }
        // Otherwise, parse toggle class
        else {
            input = this.$element.data('toggler');
            // Allow for a . at the beginning of the string
            this.className = input[0] === '.' ? input.slice(1) : input;
          }

        // Add ARIA attributes to triggers
        var id = this.$element[0].id;
        $('[data-open="' + id + '"], [data-close="' + id + '"], [data-toggle="' + id + '"]').attr('aria-controls', id);
        // If the target is hidden, add aria-hidden
        this.$element.attr('aria-expanded', this.$element.is(':hidden') ? false : true);
      }

      /**
       * Initializes events for the toggle trigger.
       * @function
       * @private
       */

    }, {
      key: '_events',
      value: function _events() {
        this.$element.off('toggle.zf.trigger').on('toggle.zf.trigger', this.toggle.bind(this));
      }

      /**
       * Toggles the target class on the target element. An event is fired from the original trigger depending on if the resultant state was "on" or "off".
       * @function
       * @fires Toggler#on
       * @fires Toggler#off
       */

    }, {
      key: 'toggle',
      value: function toggle() {
        this[this.options.animate ? '_toggleAnimate' : '_toggleClass']();
      }
    }, {
      key: '_toggleClass',
      value: function _toggleClass() {
        this.$element.toggleClass(this.className);

        var isOn = this.$element.hasClass(this.className);
        if (isOn) {
          /**
           * Fires if the target element has the class after a toggle.
           * @event Toggler#on
           */
          this.$element.trigger('on.zf.toggler');
        } else {
          /**
           * Fires if the target element does not have the class after a toggle.
           * @event Toggler#off
           */
          this.$element.trigger('off.zf.toggler');
        }

        this._updateARIA(isOn);
      }
    }, {
      key: '_toggleAnimate',
      value: function _toggleAnimate() {
        var _this = this;

        if (this.$element.is(':hidden')) {
          Foundation.Motion.animateIn(this.$element, this.animationIn, function () {
            _this._updateARIA(true);
            this.trigger('on.zf.toggler');
          });
        } else {
          Foundation.Motion.animateOut(this.$element, this.animationOut, function () {
            _this._updateARIA(false);
            this.trigger('off.zf.toggler');
          });
        }
      }
    }, {
      key: '_updateARIA',
      value: function _updateARIA(isOn) {
        this.$element.attr('aria-expanded', isOn ? true : false);
      }

      /**
       * Destroys the instance of Toggler on the element.
       * @function
       */

    }, {
      key: 'destroy',
      value: function destroy() {
        this.$element.off('.zf.toggler');
        Foundation.unregisterPlugin(this);
      }
    }]);

    return Toggler;
  }();

  Toggler.defaults = {
    /**
     * Tells the plugin if the element should animated when toggled.
     * @option
     * @example false
     */
    animate: false
  };

  // Window exports
  Foundation.plugin(Toggler, 'Toggler');
}(jQuery);

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/foundation/js/foundation.tooltip.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

!function ($) {

  /**
   * Tooltip module.
   * @module foundation.tooltip
   * @requires foundation.util.box
   * @requires foundation.util.triggers
   */

  var Tooltip = function () {
    /**
     * Creates a new instance of a Tooltip.
     * @class
     * @fires Tooltip#init
     * @param {jQuery} element - jQuery object to attach a tooltip to.
     * @param {Object} options - object to extend the default configuration.
     */
    function Tooltip(element, options) {
      _classCallCheck(this, Tooltip);

      this.$element = element;
      this.options = $.extend({}, Tooltip.defaults, this.$element.data(), options);

      this.isActive = false;
      this.isClick = false;
      this._init();

      Foundation.registerPlugin(this, 'Tooltip');
    }

    /**
     * Initializes the tooltip by setting the creating the tip element, adding it's text, setting private variables and setting attributes on the anchor.
     * @private
     */


    _createClass(Tooltip, [{
      key: '_init',
      value: function _init() {
        var elemId = this.$element.attr('aria-describedby') || Foundation.GetYoDigits(6, 'tooltip');

        this.options.positionClass = this.options.positionClass || this._getPositionClass(this.$element);
        this.options.tipText = this.options.tipText || this.$element.attr('title');
        this.template = this.options.template ? $(this.options.template) : this._buildTemplate(elemId);

        this.template.appendTo(document.body).text(this.options.tipText).hide();

        this.$element.attr({
          'title': '',
          'aria-describedby': elemId,
          'data-yeti-box': elemId,
          'data-toggle': elemId,
          'data-resize': elemId
        }).addClass(this.triggerClass);

        //helper variables to track movement on collisions
        this.usedPositions = [];
        this.counter = 4;
        this.classChanged = false;

        this._events();
      }

      /**
       * Grabs the current positioning class, if present, and returns the value or an empty string.
       * @private
       */

    }, {
      key: '_getPositionClass',
      value: function _getPositionClass(element) {
        if (!element) {
          return '';
        }
        // var position = element.attr('class').match(/top|left|right/g);
        var position = element[0].className.match(/\b(top|left|right)\b/g);
        position = position ? position[0] : '';
        return position;
      }
    }, {
      key: '_buildTemplate',

      /**
       * builds the tooltip element, adds attributes, and returns the template.
       * @private
       */
      value: function _buildTemplate(id) {
        var templateClasses = (this.options.tooltipClass + ' ' + this.options.positionClass + ' ' + this.options.templateClasses).trim();
        var $template = $('<div></div>').addClass(templateClasses).attr({
          'role': 'tooltip',
          'aria-hidden': true,
          'data-is-active': false,
          'data-is-focus': false,
          'id': id
        });
        return $template;
      }

      /**
       * Function that gets called if a collision event is detected.
       * @param {String} position - positioning class to try
       * @private
       */

    }, {
      key: '_reposition',
      value: function _reposition(position) {
        this.usedPositions.push(position ? position : 'bottom');

        //default, try switching to opposite side
        if (!position && this.usedPositions.indexOf('top') < 0) {
          this.template.addClass('top');
        } else if (position === 'top' && this.usedPositions.indexOf('bottom') < 0) {
          this.template.removeClass(position);
        } else if (position === 'left' && this.usedPositions.indexOf('right') < 0) {
          this.template.removeClass(position).addClass('right');
        } else if (position === 'right' && this.usedPositions.indexOf('left') < 0) {
          this.template.removeClass(position).addClass('left');
        }

        //if default change didn't work, try bottom or left first
        else if (!position && this.usedPositions.indexOf('top') > -1 && this.usedPositions.indexOf('left') < 0) {
            this.template.addClass('left');
          } else if (position === 'top' && this.usedPositions.indexOf('bottom') > -1 && this.usedPositions.indexOf('left') < 0) {
            this.template.removeClass(position).addClass('left');
          } else if (position === 'left' && this.usedPositions.indexOf('right') > -1 && this.usedPositions.indexOf('bottom') < 0) {
            this.template.removeClass(position);
          } else if (position === 'right' && this.usedPositions.indexOf('left') > -1 && this.usedPositions.indexOf('bottom') < 0) {
            this.template.removeClass(position);
          }
          //if nothing cleared, set to bottom
          else {
              this.template.removeClass(position);
            }
        this.classChanged = true;
        this.counter--;
      }

      /**
       * sets the position class of an element and recursively calls itself until there are no more possible positions to attempt, or the tooltip element is no longer colliding.
       * if the tooltip is larger than the screen width, default to full width - any user selected margin
       * @private
       */

    }, {
      key: '_setPosition',
      value: function _setPosition() {
        var position = this._getPositionClass(this.template),
            $tipDims = Foundation.Box.GetDimensions(this.template),
            $anchorDims = Foundation.Box.GetDimensions(this.$element),
            direction = position === 'left' ? 'left' : position === 'right' ? 'left' : 'top',
            param = direction === 'top' ? 'height' : 'width',
            offset = param === 'height' ? this.options.vOffset : this.options.hOffset,
            _this = this;

        if ($tipDims.width >= $tipDims.windowDims.width || !this.counter && !Foundation.Box.ImNotTouchingYou(this.template)) {
          this.template.offset(Foundation.Box.GetOffsets(this.template, this.$element, 'center bottom', this.options.vOffset, this.options.hOffset, true)).css({
            // this.$element.offset(Foundation.GetOffsets(this.template, this.$element, 'center bottom', this.options.vOffset, this.options.hOffset, true)).css({
            'width': $anchorDims.windowDims.width - this.options.hOffset * 2,
            'height': 'auto'
          });
          return false;
        }

        this.template.offset(Foundation.Box.GetOffsets(this.template, this.$element, 'center ' + (position || 'bottom'), this.options.vOffset, this.options.hOffset));

        while (!Foundation.Box.ImNotTouchingYou(this.template) && this.counter) {
          this._reposition(position);
          this._setPosition();
        }
      }

      /**
       * reveals the tooltip, and fires an event to close any other open tooltips on the page
       * @fires Tooltip#closeme
       * @fires Tooltip#show
       * @function
       */

    }, {
      key: 'show',
      value: function show() {
        if (this.options.showOn !== 'all' && !Foundation.MediaQuery.atLeast(this.options.showOn)) {
          // console.error('The screen is too small to display this tooltip');
          return false;
        }

        var _this = this;
        this.template.css('visibility', 'hidden').show();
        this._setPosition();

        /**
         * Fires to close all other open tooltips on the page
         * @event Closeme#tooltip
         */
        this.$element.trigger('closeme.zf.tooltip', this.template.attr('id'));

        this.template.attr({
          'data-is-active': true,
          'aria-hidden': false
        });
        _this.isActive = true;
        // console.log(this.template);
        this.template.stop().hide().css('visibility', '').fadeIn(this.options.fadeInDuration, function () {
          //maybe do stuff?
        });
        /**
         * Fires when the tooltip is shown
         * @event Tooltip#show
         */
        this.$element.trigger('show.zf.tooltip');
      }

      /**
       * Hides the current tooltip, and resets the positioning class if it was changed due to collision
       * @fires Tooltip#hide
       * @function
       */

    }, {
      key: 'hide',
      value: function hide() {
        // console.log('hiding', this.$element.data('yeti-box'));
        var _this = this;
        this.template.stop().attr({
          'aria-hidden': true,
          'data-is-active': false
        }).fadeOut(this.options.fadeOutDuration, function () {
          _this.isActive = false;
          _this.isClick = false;
          if (_this.classChanged) {
            _this.template.removeClass(_this._getPositionClass(_this.template)).addClass(_this.options.positionClass);

            _this.usedPositions = [];
            _this.counter = 4;
            _this.classChanged = false;
          }
        });
        /**
         * fires when the tooltip is hidden
         * @event Tooltip#hide
         */
        this.$element.trigger('hide.zf.tooltip');
      }

      /**
       * adds event listeners for the tooltip and its anchor
       * TODO combine some of the listeners like focus and mouseenter, etc.
       * @private
       */

    }, {
      key: '_events',
      value: function _events() {
        var _this = this;
        var $template = this.template;
        var isFocus = false;

        if (!this.options.disableHover) {

          this.$element.on('mouseenter.zf.tooltip', function (e) {
            if (!_this.isActive) {
              _this.timeout = setTimeout(function () {
                _this.show();
              }, _this.options.hoverDelay);
            }
          }).on('mouseleave.zf.tooltip', function (e) {
            clearTimeout(_this.timeout);
            if (!isFocus || _this.isClick && !_this.options.clickOpen) {
              _this.hide();
            }
          });
        }

        if (this.options.clickOpen) {
          this.$element.on('mousedown.zf.tooltip', function (e) {
            e.stopImmediatePropagation();
            if (_this.isClick) {
              //_this.hide();
              // _this.isClick = false;
            } else {
              _this.isClick = true;
              if ((_this.options.disableHover || !_this.$element.attr('tabindex')) && !_this.isActive) {
                _this.show();
              }
            }
          });
        } else {
          this.$element.on('mousedown.zf.tooltip', function (e) {
            e.stopImmediatePropagation();
            _this.isClick = true;
          });
        }

        if (!this.options.disableForTouch) {
          this.$element.on('tap.zf.tooltip touchend.zf.tooltip', function (e) {
            _this.isActive ? _this.hide() : _this.show();
          });
        }

        this.$element.on({
          // 'toggle.zf.trigger': this.toggle.bind(this),
          // 'close.zf.trigger': this.hide.bind(this)
          'close.zf.trigger': this.hide.bind(this)
        });

        this.$element.on('focus.zf.tooltip', function (e) {
          isFocus = true;
          if (_this.isClick) {
            // If we're not showing open on clicks, we need to pretend a click-launched focus isn't
            // a real focus, otherwise on hover and come back we get bad behavior
            if (!_this.options.clickOpen) {
              isFocus = false;
            }
            return false;
          } else {
            _this.show();
          }
        }).on('focusout.zf.tooltip', function (e) {
          isFocus = false;
          _this.isClick = false;
          _this.hide();
        }).on('resizeme.zf.trigger', function () {
          if (_this.isActive) {
            _this._setPosition();
          }
        });
      }

      /**
       * adds a toggle method, in addition to the static show() & hide() functions
       * @function
       */

    }, {
      key: 'toggle',
      value: function toggle() {
        if (this.isActive) {
          this.hide();
        } else {
          this.show();
        }
      }

      /**
       * Destroys an instance of tooltip, removes template element from the view.
       * @function
       */

    }, {
      key: 'destroy',
      value: function destroy() {
        this.$element.attr('title', this.template.text()).off('.zf.trigger .zf.tootip')
        //  .removeClass('has-tip')
        .removeAttr('aria-describedby').removeAttr('data-yeti-box').removeAttr('data-toggle').removeAttr('data-resize');

        this.template.remove();

        Foundation.unregisterPlugin(this);
      }
    }]);

    return Tooltip;
  }();

  Tooltip.defaults = {
    disableForTouch: false,
    /**
     * Time, in ms, before a tooltip should open on hover.
     * @option
     * @example 200
     */
    hoverDelay: 200,
    /**
     * Time, in ms, a tooltip should take to fade into view.
     * @option
     * @example 150
     */
    fadeInDuration: 150,
    /**
     * Time, in ms, a tooltip should take to fade out of view.
     * @option
     * @example 150
     */
    fadeOutDuration: 150,
    /**
     * Disables hover events from opening the tooltip if set to true
     * @option
     * @example false
     */
    disableHover: false,
    /**
     * Optional addtional classes to apply to the tooltip template on init.
     * @option
     * @example 'my-cool-tip-class'
     */
    templateClasses: '',
    /**
     * Non-optional class added to tooltip templates. Foundation default is 'tooltip'.
     * @option
     * @example 'tooltip'
     */
    tooltipClass: 'tooltip',
    /**
     * Class applied to the tooltip anchor element.
     * @option
     * @example 'has-tip'
     */
    triggerClass: 'has-tip',
    /**
     * Minimum breakpoint size at which to open the tooltip.
     * @option
     * @example 'small'
     */
    showOn: 'small',
    /**
     * Custom template to be used to generate markup for tooltip.
     * @option
     * @example '&lt;div class="tooltip"&gt;&lt;/div&gt;'
     */
    template: '',
    /**
     * Text displayed in the tooltip template on open.
     * @option
     * @example 'Some cool space fact here.'
     */
    tipText: '',
    touchCloseText: 'Tap to close.',
    /**
     * Allows the tooltip to remain open if triggered with a click or touch event.
     * @option
     * @example true
     */
    clickOpen: true,
    /**
     * Additional positioning classes, set by the JS
     * @option
     * @example 'top'
     */
    positionClass: '',
    /**
     * Distance, in pixels, the template should push away from the anchor on the Y axis.
     * @option
     * @example 10
     */
    vOffset: 10,
    /**
     * Distance, in pixels, the template should push away from the anchor on the X axis, if aligned to a side.
     * @option
     * @example 12
     */
    hOffset: 12
  };

  /**
   * TODO utilize resize event trigger
   */

  // Window exports
  Foundation.plugin(Tooltip, 'Tooltip');
}(jQuery);

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/foundation/js/foundation.util.box.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


!function ($) {

  Foundation.Box = {
    ImNotTouchingYou: ImNotTouchingYou,
    GetDimensions: GetDimensions,
    GetOffsets: GetOffsets
  };

  /**
   * Compares the dimensions of an element to a container and determines collision events with container.
   * @function
   * @param {jQuery} element - jQuery object to test for collisions.
   * @param {jQuery} parent - jQuery object to use as bounding container.
   * @param {Boolean} lrOnly - set to true to check left and right values only.
   * @param {Boolean} tbOnly - set to true to check top and bottom values only.
   * @default if no parent object passed, detects collisions with `window`.
   * @returns {Boolean} - true if collision free, false if a collision in any direction.
   */
  function ImNotTouchingYou(element, parent, lrOnly, tbOnly) {
    var eleDims = GetDimensions(element),
        top,
        bottom,
        left,
        right;

    if (parent) {
      var parDims = GetDimensions(parent);

      bottom = eleDims.offset.top + eleDims.height <= parDims.height + parDims.offset.top;
      top = eleDims.offset.top >= parDims.offset.top;
      left = eleDims.offset.left >= parDims.offset.left;
      right = eleDims.offset.left + eleDims.width <= parDims.width + parDims.offset.left;
    } else {
      bottom = eleDims.offset.top + eleDims.height <= eleDims.windowDims.height + eleDims.windowDims.offset.top;
      top = eleDims.offset.top >= eleDims.windowDims.offset.top;
      left = eleDims.offset.left >= eleDims.windowDims.offset.left;
      right = eleDims.offset.left + eleDims.width <= eleDims.windowDims.width;
    }

    var allDirs = [bottom, top, left, right];

    if (lrOnly) {
      return left === right === true;
    }

    if (tbOnly) {
      return top === bottom === true;
    }

    return allDirs.indexOf(false) === -1;
  };

  /**
   * Uses native methods to return an object of dimension values.
   * @function
   * @param {jQuery || HTML} element - jQuery object or DOM element for which to get the dimensions. Can be any element other that document or window.
   * @returns {Object} - nested object of integer pixel values
   * TODO - if element is window, return only those values.
   */
  function GetDimensions(elem, test) {
    elem = elem.length ? elem[0] : elem;

    if (elem === window || elem === document) {
      throw new Error("I'm sorry, Dave. I'm afraid I can't do that.");
    }

    var rect = elem.getBoundingClientRect(),
        parRect = elem.parentNode.getBoundingClientRect(),
        winRect = document.body.getBoundingClientRect(),
        winY = window.pageYOffset,
        winX = window.pageXOffset;

    return {
      width: rect.width,
      height: rect.height,
      offset: {
        top: rect.top + winY,
        left: rect.left + winX
      },
      parentDims: {
        width: parRect.width,
        height: parRect.height,
        offset: {
          top: parRect.top + winY,
          left: parRect.left + winX
        }
      },
      windowDims: {
        width: winRect.width,
        height: winRect.height,
        offset: {
          top: winY,
          left: winX
        }
      }
    };
  }

  /**
   * Returns an object of top and left integer pixel values for dynamically rendered elements,
   * such as: Tooltip, Reveal, and Dropdown
   * @function
   * @param {jQuery} element - jQuery object for the element being positioned.
   * @param {jQuery} anchor - jQuery object for the element's anchor point.
   * @param {String} position - a string relating to the desired position of the element, relative to it's anchor
   * @param {Number} vOffset - integer pixel value of desired vertical separation between anchor and element.
   * @param {Number} hOffset - integer pixel value of desired horizontal separation between anchor and element.
   * @param {Boolean} isOverflow - if a collision event is detected, sets to true to default the element to full width - any desired offset.
   * TODO alter/rewrite to work with `em` values as well/instead of pixels
   */
  function GetOffsets(element, anchor, position, vOffset, hOffset, isOverflow) {
    var $eleDims = GetDimensions(element),
        $anchorDims = anchor ? GetDimensions(anchor) : null;

    switch (position) {
      case 'top':
        return {
          left: Foundation.rtl() ? $anchorDims.offset.left - $eleDims.width + $anchorDims.width : $anchorDims.offset.left,
          top: $anchorDims.offset.top - ($eleDims.height + vOffset)
        };
        break;
      case 'left':
        return {
          left: $anchorDims.offset.left - ($eleDims.width + hOffset),
          top: $anchorDims.offset.top
        };
        break;
      case 'right':
        return {
          left: $anchorDims.offset.left + $anchorDims.width + hOffset,
          top: $anchorDims.offset.top
        };
        break;
      case 'center top':
        return {
          left: $anchorDims.offset.left + $anchorDims.width / 2 - $eleDims.width / 2,
          top: $anchorDims.offset.top - ($eleDims.height + vOffset)
        };
        break;
      case 'center bottom':
        return {
          left: isOverflow ? hOffset : $anchorDims.offset.left + $anchorDims.width / 2 - $eleDims.width / 2,
          top: $anchorDims.offset.top + $anchorDims.height + vOffset
        };
        break;
      case 'center left':
        return {
          left: $anchorDims.offset.left - ($eleDims.width + hOffset),
          top: $anchorDims.offset.top + $anchorDims.height / 2 - $eleDims.height / 2
        };
        break;
      case 'center right':
        return {
          left: $anchorDims.offset.left + $anchorDims.width + hOffset + 1,
          top: $anchorDims.offset.top + $anchorDims.height / 2 - $eleDims.height / 2
        };
        break;
      case 'center':
        return {
          left: $eleDims.windowDims.offset.left + $eleDims.windowDims.width / 2 - $eleDims.width / 2,
          top: $eleDims.windowDims.offset.top + $eleDims.windowDims.height / 2 - $eleDims.height / 2
        };
        break;
      case 'reveal':
        return {
          left: ($eleDims.windowDims.width - $eleDims.width) / 2,
          top: $eleDims.windowDims.offset.top + vOffset
        };
      case 'reveal full':
        return {
          left: $eleDims.windowDims.offset.left,
          top: $eleDims.windowDims.offset.top
        };
        break;
      case 'left bottom':
        return {
          left: $anchorDims.offset.left - ($eleDims.width + hOffset),
          top: $anchorDims.offset.top + $anchorDims.height
        };
        break;
      case 'right bottom':
        return {
          left: $anchorDims.offset.left + $anchorDims.width + hOffset - $eleDims.width,
          top: $anchorDims.offset.top + $anchorDims.height
        };
        break;
      default:
        return {
          left: Foundation.rtl() ? $anchorDims.offset.left - $eleDims.width + $anchorDims.width : $anchorDims.offset.left,
          top: $anchorDims.offset.top + $anchorDims.height + vOffset
        };
    }
  }
}(jQuery);

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/foundation/js/foundation.util.keyboard.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*******************************************
 *                                         *
 * This util was created by Marius Olbertz *
 * Please thank Marius on GitHub /owlbertz *
 * or the web http://www.mariusolbertz.de/ *
 *                                         *
 ******************************************/



!function ($) {

  var keyCodes = {
    9: 'TAB',
    13: 'ENTER',
    27: 'ESCAPE',
    32: 'SPACE',
    37: 'ARROW_LEFT',
    38: 'ARROW_UP',
    39: 'ARROW_RIGHT',
    40: 'ARROW_DOWN'
  };

  var commands = {};

  var Keyboard = {
    keys: getKeyCodes(keyCodes),

    /**
     * Parses the (keyboard) event and returns a String that represents its key
     * Can be used like Foundation.parseKey(event) === Foundation.keys.SPACE
     * @param {Event} event - the event generated by the event handler
     * @return String key - String that represents the key pressed
     */
    parseKey: function parseKey(event) {
      var key = keyCodes[event.which || event.keyCode] || String.fromCharCode(event.which).toUpperCase();
      if (event.shiftKey) key = 'SHIFT_' + key;
      if (event.ctrlKey) key = 'CTRL_' + key;
      if (event.altKey) key = 'ALT_' + key;
      return key;
    },


    /**
     * Handles the given (keyboard) event
     * @param {Event} event - the event generated by the event handler
     * @param {String} component - Foundation component's name, e.g. Slider or Reveal
     * @param {Objects} functions - collection of functions that are to be executed
     */
    handleKey: function handleKey(event, component, functions) {
      var commandList = commands[component],
          keyCode = this.parseKey(event),
          cmds,
          command,
          fn;

      if (!commandList) return console.warn('Component not defined!');

      if (typeof commandList.ltr === 'undefined') {
        // this component does not differentiate between ltr and rtl
        cmds = commandList; // use plain list
      } else {
        // merge ltr and rtl: if document is rtl, rtl overwrites ltr and vice versa
        if (Foundation.rtl()) cmds = $.extend({}, commandList.ltr, commandList.rtl);else cmds = $.extend({}, commandList.rtl, commandList.ltr);
      }
      command = cmds[keyCode];

      fn = functions[command];
      if (fn && typeof fn === 'function') {
        // execute function  if exists
        var returnValue = fn.apply();
        if (functions.handled || typeof functions.handled === 'function') {
          // execute function when event was handled
          functions.handled(returnValue);
        }
      } else {
        if (functions.unhandled || typeof functions.unhandled === 'function') {
          // execute function when event was not handled
          functions.unhandled();
        }
      }
    },


    /**
     * Finds all focusable elements within the given `$element`
     * @param {jQuery} $element - jQuery object to search within
     * @return {jQuery} $focusable - all focusable elements within `$element`
     */
    findFocusable: function findFocusable($element) {
      return $element.find('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]').filter(function () {
        if (!$(this).is(':visible') || $(this).attr('tabindex') < 0) {
          return false;
        } //only have visible elements and those that have a tabindex greater or equal 0
        return true;
      });
    },


    /**
     * Returns the component name name
     * @param {Object} component - Foundation component, e.g. Slider or Reveal
     * @return String componentName
     */

    register: function register(componentName, cmds) {
      commands[componentName] = cmds;
    }
  };

  /*
   * Constants for easier comparing.
   * Can be used like Foundation.parseKey(event) === Foundation.keys.SPACE
   */
  function getKeyCodes(kcs) {
    var k = {};
    for (var kc in kcs) {
      k[kcs[kc]] = kcs[kc];
    }return k;
  }

  Foundation.Keyboard = Keyboard;
}(jQuery);

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/foundation/js/foundation.util.mediaQuery.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function ($) {

  // Default set of media queries
  var defaultQueries = {
    'default': 'only screen',
    landscape: 'only screen and (orientation: landscape)',
    portrait: 'only screen and (orientation: portrait)',
    retina: 'only screen and (-webkit-min-device-pixel-ratio: 2),' + 'only screen and (min--moz-device-pixel-ratio: 2),' + 'only screen and (-o-min-device-pixel-ratio: 2/1),' + 'only screen and (min-device-pixel-ratio: 2),' + 'only screen and (min-resolution: 192dpi),' + 'only screen and (min-resolution: 2dppx)'
  };

  var MediaQuery = {
    queries: [],

    current: '',

    /**
     * Initializes the media query helper, by extracting the breakpoint list from the CSS and activating the breakpoint watcher.
     * @function
     * @private
     */
    _init: function _init() {
      var self = this;
      var extractedStyles = $('.foundation-mq').css('font-family');
      var namedQueries;

      namedQueries = parseStyleToObject(extractedStyles);

      for (var key in namedQueries) {
        if (namedQueries.hasOwnProperty(key)) {
          self.queries.push({
            name: key,
            value: 'only screen and (min-width: ' + namedQueries[key] + ')'
          });
        }
      }

      this.current = this._getCurrentSize();

      this._watcher();
    },


    /**
     * Checks if the screen is at least as wide as a breakpoint.
     * @function
     * @param {String} size - Name of the breakpoint to check.
     * @returns {Boolean} `true` if the breakpoint matches, `false` if it's smaller.
     */
    atLeast: function atLeast(size) {
      var query = this.get(size);

      if (query) {
        return window.matchMedia(query).matches;
      }

      return false;
    },


    /**
     * Gets the media query of a breakpoint.
     * @function
     * @param {String} size - Name of the breakpoint to get.
     * @returns {String|null} - The media query of the breakpoint, or `null` if the breakpoint doesn't exist.
     */
    get: function get(size) {
      for (var i in this.queries) {
        if (this.queries.hasOwnProperty(i)) {
          var query = this.queries[i];
          if (size === query.name) return query.value;
        }
      }

      return null;
    },


    /**
     * Gets the current breakpoint name by testing every breakpoint and returning the last one to match (the biggest one).
     * @function
     * @private
     * @returns {String} Name of the current breakpoint.
     */
    _getCurrentSize: function _getCurrentSize() {
      var matched;

      for (var i = 0; i < this.queries.length; i++) {
        var query = this.queries[i];

        if (window.matchMedia(query.value).matches) {
          matched = query;
        }
      }

      if ((typeof matched === 'undefined' ? 'undefined' : _typeof(matched)) === 'object') {
        return matched.name;
      } else {
        return matched;
      }
    },


    /**
     * Activates the breakpoint watcher, which fires an event on the window whenever the breakpoint changes.
     * @function
     * @private
     */
    _watcher: function _watcher() {
      var _this = this;

      $(window).on('resize.zf.mediaquery', function () {
        var newSize = _this._getCurrentSize(),
            currentSize = _this.current;

        if (newSize !== currentSize) {
          // Change the current media query
          _this.current = newSize;

          // Broadcast the media query change on the window
          $(window).trigger('changed.zf.mediaquery', [newSize, currentSize]);
        }
      });
    }
  };

  Foundation.MediaQuery = MediaQuery;

  // matchMedia() polyfill - Test a CSS media type/query in JS.
  // Authors & copyright (c) 2012: Scott Jehl, Paul Irish, Nicholas Zakas, David Knight. Dual MIT/BSD license
  window.matchMedia || (window.matchMedia = function () {
    'use strict';

    // For browsers that support matchMedium api such as IE 9 and webkit

    var styleMedia = window.styleMedia || window.media;

    // For those that don't support matchMedium
    if (!styleMedia) {
      var style = document.createElement('style'),
          script = document.getElementsByTagName('script')[0],
          info = null;

      style.type = 'text/css';
      style.id = 'matchmediajs-test';

      script.parentNode.insertBefore(style, script);

      // 'style.currentStyle' is used by IE <= 8 and 'window.getComputedStyle' for all other browsers
      info = 'getComputedStyle' in window && window.getComputedStyle(style, null) || style.currentStyle;

      styleMedia = {
        matchMedium: function matchMedium(media) {
          var text = '@media ' + media + '{ #matchmediajs-test { width: 1px; } }';

          // 'style.styleSheet' is used by IE <= 8 and 'style.textContent' for all other browsers
          if (style.styleSheet) {
            style.styleSheet.cssText = text;
          } else {
            style.textContent = text;
          }

          // Test if media query is true or false
          return info.width === '1px';
        }
      };
    }

    return function (media) {
      return {
        matches: styleMedia.matchMedium(media || 'all'),
        media: media || 'all'
      };
    };
  }());

  // Thank you: https://github.com/sindresorhus/query-string
  function parseStyleToObject(str) {
    var styleObject = {};

    if (typeof str !== 'string') {
      return styleObject;
    }

    str = str.trim().slice(1, -1); // browsers re-quote string style values

    if (!str) {
      return styleObject;
    }

    styleObject = str.split('&').reduce(function (ret, param) {
      var parts = param.replace(/\+/g, ' ').split('=');
      var key = parts[0];
      var val = parts[1];
      key = decodeURIComponent(key);

      // missing `=` should be `null`:
      // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
      val = val === undefined ? null : decodeURIComponent(val);

      if (!ret.hasOwnProperty(key)) {
        ret[key] = val;
      } else if (Array.isArray(ret[key])) {
        ret[key].push(val);
      } else {
        ret[key] = [ret[key], val];
      }
      return ret;
    }, {});

    return styleObject;
  }

  Foundation.MediaQuery = MediaQuery;
}(jQuery);

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/foundation/js/foundation.util.motion.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


!function ($) {

  /**
   * Motion module.
   * @module foundation.motion
   */

  var initClasses = ['mui-enter', 'mui-leave'];
  var activeClasses = ['mui-enter-active', 'mui-leave-active'];

  var Motion = {
    animateIn: function animateIn(element, animation, cb) {
      animate(true, element, animation, cb);
    },

    animateOut: function animateOut(element, animation, cb) {
      animate(false, element, animation, cb);
    }
  };

  function Move(duration, elem, fn) {
    var anim,
        prog,
        start = null;
    // console.log('called');

    function move(ts) {
      if (!start) start = window.performance.now();
      // console.log(start, ts);
      prog = ts - start;
      fn.apply(elem);

      if (prog < duration) {
        anim = window.requestAnimationFrame(move, elem);
      } else {
        window.cancelAnimationFrame(anim);
        elem.trigger('finished.zf.animate', [elem]).triggerHandler('finished.zf.animate', [elem]);
      }
    }
    anim = window.requestAnimationFrame(move);
  }

  /**
   * Animates an element in or out using a CSS transition class.
   * @function
   * @private
   * @param {Boolean} isIn - Defines if the animation is in or out.
   * @param {Object} element - jQuery or HTML object to animate.
   * @param {String} animation - CSS class to use.
   * @param {Function} cb - Callback to run when animation is finished.
   */
  function animate(isIn, element, animation, cb) {
    element = $(element).eq(0);

    if (!element.length) return;

    var initClass = isIn ? initClasses[0] : initClasses[1];
    var activeClass = isIn ? activeClasses[0] : activeClasses[1];

    // Set up the animation
    reset();

    element.addClass(animation).css('transition', 'none');

    requestAnimationFrame(function () {
      element.addClass(initClass);
      if (isIn) element.show();
    });

    // Start the animation
    requestAnimationFrame(function () {
      element[0].offsetWidth;
      element.css('transition', '').addClass(activeClass);
    });

    // Clean up the animation when it finishes
    element.one(Foundation.transitionend(element), finish);

    // Hides the element (for out animations), resets the element, and runs a callback
    function finish() {
      if (!isIn) element.hide();
      reset();
      if (cb) cb.apply(element);
    }

    // Resets transitions and removes motion-specific classes
    function reset() {
      element[0].style.transitionDuration = 0;
      element.removeClass(initClass + ' ' + activeClass + ' ' + animation);
    }
  }

  Foundation.Move = Move;
  Foundation.Motion = Motion;
}(jQuery);

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/foundation/js/foundation.util.triggers.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function ($) {

  var MutationObserver = function () {
    var prefixes = ['WebKit', 'Moz', 'O', 'Ms', ''];
    for (var i = 0; i < prefixes.length; i++) {
      if (prefixes[i] + 'MutationObserver' in window) {
        return window[prefixes[i] + 'MutationObserver'];
      }
    }
    return false;
  }();

  var triggers = function triggers(el, type) {
    el.data(type).split(' ').forEach(function (id) {
      $('#' + id)[type === 'close' ? 'trigger' : 'triggerHandler'](type + '.zf.trigger', [el]);
    });
  };
  // Elements with [data-open] will reveal a plugin that supports it when clicked.
  $(document).on('click.zf.trigger', '[data-open]', function () {
    triggers($(this), 'open');
  });

  // Elements with [data-close] will close a plugin that supports it when clicked.
  // If used without a value on [data-close], the event will bubble, allowing it to close a parent component.
  $(document).on('click.zf.trigger', '[data-close]', function () {
    var id = $(this).data('close');
    if (id) {
      triggers($(this), 'close');
    } else {
      $(this).trigger('close.zf.trigger');
    }
  });

  // Elements with [data-toggle] will toggle a plugin that supports it when clicked.
  $(document).on('click.zf.trigger', '[data-toggle]', function () {
    triggers($(this), 'toggle');
  });

  // Elements with [data-closable] will respond to close.zf.trigger events.
  $(document).on('close.zf.trigger', '[data-closable]', function (e) {
    e.stopPropagation();
    var animation = $(this).data('closable');

    if (animation !== '') {
      Foundation.Motion.animateOut($(this), animation, function () {
        $(this).trigger('closed.zf');
      });
    } else {
      $(this).fadeOut().trigger('closed.zf');
    }
  });

  $(document).on('focus.zf.trigger blur.zf.trigger', '[data-toggle-focus]', function () {
    var id = $(this).data('toggle-focus');
    $('#' + id).triggerHandler('toggle.zf.trigger', [$(this)]);
  });

  /**
  * Fires once after all other scripts have loaded
  * @function
  * @private
  */
  $(window).load(function () {
    checkListeners();
  });

  function checkListeners() {
    eventsListener();
    resizeListener();
    scrollListener();
    closemeListener();
  }

  //******** only fires this function once on load, if there's something to watch ********
  function closemeListener(pluginName) {
    var yetiBoxes = $('[data-yeti-box]'),
        plugNames = ['dropdown', 'tooltip', 'reveal'];

    if (pluginName) {
      if (typeof pluginName === 'string') {
        plugNames.push(pluginName);
      } else if ((typeof pluginName === 'undefined' ? 'undefined' : _typeof(pluginName)) === 'object' && typeof pluginName[0] === 'string') {
        plugNames.concat(pluginName);
      } else {
        console.error('Plugin names must be strings');
      }
    }
    if (yetiBoxes.length) {
      var listeners = plugNames.map(function (name) {
        return 'closeme.zf.' + name;
      }).join(' ');

      $(window).off(listeners).on(listeners, function (e, pluginId) {
        var plugin = e.namespace.split('.')[0];
        var plugins = $('[data-' + plugin + ']').not('[data-yeti-box="' + pluginId + '"]');

        plugins.each(function () {
          var _this = $(this);

          _this.triggerHandler('close.zf.trigger', [_this]);
        });
      });
    }
  }

  function resizeListener(debounce) {
    var timer = void 0,
        $nodes = $('[data-resize]');
    if ($nodes.length) {
      $(window).off('resize.zf.trigger').on('resize.zf.trigger', function (e) {
        if (timer) {
          clearTimeout(timer);
        }

        timer = setTimeout(function () {

          if (!MutationObserver) {
            //fallback for IE 9
            $nodes.each(function () {
              $(this).triggerHandler('resizeme.zf.trigger');
            });
          }
          //trigger all listening elements and signal a resize event
          $nodes.attr('data-events', "resize");
        }, debounce || 10); //default time to emit resize event
      });
    }
  }

  function scrollListener(debounce) {
    var timer = void 0,
        $nodes = $('[data-scroll]');
    if ($nodes.length) {
      $(window).off('scroll.zf.trigger').on('scroll.zf.trigger', function (e) {
        if (timer) {
          clearTimeout(timer);
        }

        timer = setTimeout(function () {

          if (!MutationObserver) {
            //fallback for IE 9
            $nodes.each(function () {
              $(this).triggerHandler('scrollme.zf.trigger');
            });
          }
          //trigger all listening elements and signal a scroll event
          $nodes.attr('data-events', "scroll");
        }, debounce || 10); //default time to emit scroll event
      });
    }
  }

  function eventsListener() {
    if (!MutationObserver) {
      return false;
    }
    var nodes = document.querySelectorAll('[data-resize], [data-scroll], [data-mutate]');

    //element callback
    var listeningElementsMutation = function listeningElementsMutation(mutationRecordsList) {
      var $target = $(mutationRecordsList[0].target);
      //trigger the event handler for the element depending on type
      switch ($target.attr("data-events")) {

        case "resize":
          $target.triggerHandler('resizeme.zf.trigger', [$target]);
          break;

        case "scroll":
          $target.triggerHandler('scrollme.zf.trigger', [$target, window.pageYOffset]);
          break;

        // case "mutate" :
        // console.log('mutate', $target);
        // $target.triggerHandler('mutate.zf.trigger');
        //
        // //make sure we don't get stuck in an infinite loop from sloppy codeing
        // if ($target.index('[data-mutate]') == $("[data-mutate]").length-1) {
        //   domMutationObserver();
        // }
        // break;

        default:
          return false;
        //nothing
      }
    };

    if (nodes.length) {
      //for each element that needs to listen for resizing, scrolling, (or coming soon mutation) add a single observer
      for (var i = 0; i <= nodes.length - 1; i++) {
        var elementObserver = new MutationObserver(listeningElementsMutation);
        elementObserver.observe(nodes[i], { attributes: true, childList: false, characterData: false, subtree: false, attributeFilter: ["data-events"] });
      }
    }
  }

  // ------------------------------------

  // [PH]
  // Foundation.CheckWatchers = checkWatchers;
  Foundation.IHearYou = checkListeners;
  // Foundation.ISeeYou = scrollListener;
  // Foundation.IFeelYou = closemeListener;
}(jQuery);

// function domMutationObserver(debounce) {
//   // !!! This is coming soon and needs more work; not active  !!! //
//   var timer,
//   nodes = document.querySelectorAll('[data-mutate]');
//   //
//   if (nodes.length) {
//     // var MutationObserver = (function () {
//     //   var prefixes = ['WebKit', 'Moz', 'O', 'Ms', ''];
//     //   for (var i=0; i < prefixes.length; i++) {
//     //     if (prefixes[i] + 'MutationObserver' in window) {
//     //       return window[prefixes[i] + 'MutationObserver'];
//     //     }
//     //   }
//     //   return false;
//     // }());
//
//
//     //for the body, we need to listen for all changes effecting the style and class attributes
//     var bodyObserver = new MutationObserver(bodyMutation);
//     bodyObserver.observe(document.body, { attributes: true, childList: true, characterData: false, subtree:true, attributeFilter:["style", "class"]});
//
//
//     //body callback
//     function bodyMutation(mutate) {
//       //trigger all listening elements and signal a mutation event
//       if (timer) { clearTimeout(timer); }
//
//       timer = setTimeout(function() {
//         bodyObserver.disconnect();
//         $('[data-mutate]').attr('data-events',"mutate");
//       }, debounce || 150);
//     }
//   }
// }

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/google-maps-api-loader/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/google-maps-api-loader/src/google-maps-api-loader.js");

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/google-maps-api-loader/lib/url-builder.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * urlBuilder
 *
 * @param  {object} params
 * @param  {string} params.base       the base url
 * @param  {array}  params.libraries  an array of the libraries to be requested
 * @param  {string} params.callback   the callback function
 *
 * @return {string}
 */

function urlBuilder(params) {
  var builtUrl = params.base;

  builtUrl += '?';

  if (params.apiKey) {
    builtUrl += 'key=' + params.apiKey + '&';
  }

  if (params.client) {
    builtUrl += 'client=' + params.client + '&';
  }

  if (params.libraries.length > 0) {
    builtUrl += 'libraries=';

    params.libraries.forEach(function (library, index) {
      builtUrl += library;

      if (index !== params.libraries.length - 1) {
        builtUrl += ',';
      }
    });

    builtUrl += '&';
  }

  builtUrl += 'callback=' + params.callback;

  return builtUrl;
}

module.exports = urlBuilder;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/google-maps-api-loader/src/google-maps-api-loader.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/es6-promise/dist/es6-promise.js").Promise;
var urlBuilder = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/google-maps-api-loader/lib/url-builder.js");

var googleApi;

function loadAutoCompleteAPI(params) {
  var script = document.createElement('script');

  script.type = 'text/javascript';

  script.src = urlBuilder({
    base: 'https://maps.googleapis.com/maps/api/js',
    libraries: params.libraries || [],
    callback: 'googleMapsAutoCompleteAPILoad',
    apiKey: params.apiKey,
    client: params.client,
    v: params.version || "beta"
  });

  document.querySelector('head').appendChild(script);
}

/**
 * googleMapsApiLoader
 *
 * @param  {object} params
 * @param  {object} params.libraries
 *
 * @return {promise}
 */
function googleMapsApiLoader(params) {
  if (googleApi) {
    return Promise.resolve(googleApi);
  }

  var windowRef = window ? window : {};

  var deferred = function deferred(resolve, reject) {
    loadAutoCompleteAPI(params);

    windowRef.googleMapsAutoCompleteAPILoad = function () {
      googleApi = windowRef.google;
      resolve(googleApi);
    };

    setTimeout(function () {
      if (!windowRef.google) {
        reject(new Error('Loading took too long.'));
      }
    }, 5000);
  };

  return new Promise(deferred);
}

module.exports = googleMapsApiLoader;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/googlemaps/fast-deep-equal-v3.1.3.esm.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Bundled by jsDelivr using Rollup v2.79.2 and Terser v5.39.0.
 * Original file: /npm/fast-deep-equal@3.1.3/index.js
 *
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */
var r = function r(t, e) {
	if (t === e) return !0;
	if (t && e && "object" == (typeof t === "undefined" ? "undefined" : _typeof(t)) && "object" == (typeof e === "undefined" ? "undefined" : _typeof(e))) {
		if (t.constructor !== e.constructor) return !1;
		var o, n, f;
		if (Array.isArray(t)) {
			if ((o = t.length) != e.length) return !1;
			for (n = o; 0 != n--;) {
				if (!r(t[n], e[n])) return !1;
			}return !0;
		}
		if (t.constructor === RegExp) return t.source === e.source && t.flags === e.flags;
		if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === e.valueOf();
		if (t.toString !== Object.prototype.toString) return t.toString() === e.toString();
		if ((o = (f = Object.keys(t)).length) !== Object.keys(e).length) return !1;
		for (n = o; 0 != n--;) {
			if (!Object.prototype.hasOwnProperty.call(e, f[n])) return !1;
		}for (n = o; 0 != n--;) {
			var u = f[n];
			if (!r(t[u], e[u])) return !1;
		}
		return !0;
	}
	return t != t && e != e;
};
exports.default = r;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/googlemaps/kdbush-v4.0.2.esm.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Bundled by jsDelivr using Rollup v2.79.2 and Terser v5.39.0.
 * Original file: /npm/kdbush@4.0.2/index.js
 *
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */
var t = [Int8Array, Uint8Array, Uint8ClampedArray, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array];

var r = function () {
	_createClass(r, null, [{
		key: "from",
		value: function from(s) {
			if (!(s instanceof ArrayBuffer)) throw new Error("Data must be an instance of ArrayBuffer.");

			var _ref = new Uint8Array(s, 0, 2),
			    _ref2 = _slicedToArray(_ref, 2),
			    n = _ref2[0],
			    i = _ref2[1];

			if (219 !== n) throw new Error("Data does not appear to be in a KDBush format.");
			var e = i >> 4;
			if (1 !== e) throw new Error("Got v" + e + " data when expected v1.");
			var o = t[15 & i];
			if (!o) throw new Error("Unrecognized array type.");

			var _ref3 = new Uint16Array(s, 2, 1),
			    _ref4 = _slicedToArray(_ref3, 1),
			    a = _ref4[0],
			    _ref5 = new Uint32Array(s, 4, 1),
			    _ref6 = _slicedToArray(_ref5, 1),
			    h = _ref6[0];

			return new r(h, a, o, s);
		}
	}]);

	function r(_r) {
		var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 64;
		var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Float64Array;
		var i = arguments[3];

		_classCallCheck(this, r);

		if (isNaN(_r) || _r < 0) throw new Error("Unpexpected numItems value: " + _r + ".");
		this.numItems = +_r, this.nodeSize = Math.min(Math.max(+s, 2), 65535), this.ArrayType = n, this.IndexArrayType = _r < 65536 ? Uint16Array : Uint32Array;
		var e = t.indexOf(this.ArrayType),
		    o = 2 * _r * this.ArrayType.BYTES_PER_ELEMENT,
		    a = _r * this.IndexArrayType.BYTES_PER_ELEMENT,
		    h = (8 - a % 8) % 8;
		if (e < 0) throw new Error("Unexpected typed array class: " + n + ".");
		i && i instanceof ArrayBuffer ? (this.data = i, this.ids = new this.IndexArrayType(this.data, 8, _r), this.coords = new this.ArrayType(this.data, 8 + a + h, 2 * _r), this._pos = 2 * _r, this._finished = !0) : (this.data = new ArrayBuffer(8 + o + a + h), this.ids = new this.IndexArrayType(this.data, 8, _r), this.coords = new this.ArrayType(this.data, 8 + a + h, 2 * _r), this._pos = 0, this._finished = !1, new Uint8Array(this.data, 0, 2).set([219, 16 + e]), new Uint16Array(this.data, 2, 1)[0] = s, new Uint32Array(this.data, 4, 1)[0] = _r);
	}

	_createClass(r, [{
		key: "add",
		value: function add(t, r) {
			var s = this._pos >> 1;
			return this.ids[s] = s, this.coords[this._pos++] = t, this.coords[this._pos++] = r, s;
		}
	}, {
		key: "finish",
		value: function finish() {
			var t = this._pos >> 1;
			if (t !== this.numItems) throw new Error("Added " + t + " items when expected " + this.numItems + ".");
			return s(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = !0, this;
		}
	}, {
		key: "range",
		value: function range(t, r, s, n) {
			if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
			var i = this.ids,
			    e = this.coords,
			    o = this.nodeSize,
			    a = [0, i.length - 1, 0],
			    h = [];

			for (; a.length;) {
				var d = a.pop() || 0,
				    p = a.pop() || 0,
				    f = a.pop() || 0;
				if (p - f <= o) {
					for (var _o = f; _o <= p; _o++) {
						var _a = e[2 * _o],
						    _d = e[2 * _o + 1];
						_a >= t && _a <= s && _d >= r && _d <= n && h.push(i[_o]);
					}
					continue;
				}
				var c = f + p >> 1,
				    y = e[2 * c],
				    u = e[2 * c + 1];
				y >= t && y <= s && u >= r && u <= n && h.push(i[c]), (0 === d ? t <= y : r <= u) && (a.push(f), a.push(c - 1), a.push(1 - d)), (0 === d ? s >= y : n >= u) && (a.push(c + 1), a.push(p), a.push(1 - d));
			}
			return h;
		}
	}, {
		key: "within",
		value: function within(t, r, s) {
			if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
			var n = this.ids,
			    i = this.coords,
			    e = this.nodeSize,
			    a = [0, n.length - 1, 0],
			    h = [],
			    d = s * s;

			for (; a.length;) {
				var p = a.pop() || 0,
				    f = a.pop() || 0,
				    c = a.pop() || 0;
				if (f - c <= e) {
					for (var _s = c; _s <= f; _s++) {
						o(i[2 * _s], i[2 * _s + 1], t, r) <= d && h.push(n[_s]);
					}continue;
				}
				var y = c + f >> 1,
				    u = i[2 * y],
				    w = i[2 * y + 1];
				o(u, w, t, r) <= d && h.push(n[y]), (0 === p ? t - s <= u : r - s <= w) && (a.push(c), a.push(y - 1), a.push(1 - p)), (0 === p ? t + s >= u : r + s >= w) && (a.push(y + 1), a.push(f), a.push(1 - p));
			}
			return h;
		}
	}]);

	return r;
}();

function s(t, r, i, e, o, a) {
	if (o - e <= i) return;
	var h = e + o >> 1;
	n(t, r, h, e, o, a), s(t, r, i, e, h - 1, 1 - a), s(t, r, i, h + 1, o, 1 - a);
}
function n(t, r, s, e, o, a) {
	for (; o > e;) {
		if (o - e > 600) {
			var i = o - e + 1,
			    _h = s - e + 1,
			    _d2 = Math.log(i),
			    _p = 0.5 * Math.exp(2 * _d2 / 3),
			    f = 0.5 * Math.sqrt(_d2 * _p * (i - _p) / i) * (_h - i / 2 < 0 ? -1 : 1);
			n(t, r, s, Math.max(e, Math.floor(s - _h * _p / i + f)), Math.min(o, Math.floor(s + (i - _h) * _p / i + f)), a);
		}
		var h = r[2 * s + a];
		var d = e,
		    p = o;
		for (i(t, r, e, s), r[2 * o + a] > h && i(t, r, e, o); d < p;) {
			for (i(t, r, d, p), d++, p--; r[2 * d + a] < h;) {
				d++;
			}for (; r[2 * p + a] > h;) {
				p--;
			}
		}
		r[2 * e + a] === h ? i(t, r, e, p) : (p++, i(t, r, p, o)), p <= s && (e = p + 1), s <= p && (o = p - 1);
	}
}
function i(t, r, s, n) {
	e(t, s, n), e(r, 2 * s, 2 * n), e(r, 2 * s + 1, 2 * n + 1);
}
function e(t, r, s) {
	var n = t[r];
	t[r] = t[s], t[s] = n;
}
function o(t, r, s, n) {
	var i = t - s,
	    e = r - n;
	return i * i + e * e;
}
exports.default = r;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/googlemaps/markerclusterer-v2.5.3.esm.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.pixelBoundsToLatLngBounds = exports.noop = exports.getPaddedViewport = exports.filterMarkersToPaddedViewport = exports.extendPixelBounds = exports.extendBoundsToPaddedViewport = exports.distanceBetweenPoints = exports.defaultOnClusterClickHandler = exports.SuperClusterViewportAlgorithm = exports.SuperClusterAlgorithm = exports.NoopAlgorithm = exports.MarkerUtils = exports.MarkerClustererEvents = exports.MarkerClusterer = exports.GridAlgorithm = exports.DefaultRenderer = exports.ClusterStats = exports.Cluster = exports.AbstractViewportAlgorithm = exports.AbstractAlgorithm = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
/**
 * Bundled by jsDelivr using Rollup v2.79.2 and Terser v5.39.0.
 * Original file: /npm/@googlemaps/markerclusterer@2.5.3/dist/index.esm.js
 *
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */


var _fastDeepEqualV313Esm = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/googlemaps/fast-deep-equal-v3.1.3.esm.js");

var _fastDeepEqualV313Esm2 = _interopRequireDefault(_fastDeepEqualV313Esm);

var _superclusterV801Esm = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/googlemaps/supercluster-v8.0.1.esm.js");

var _superclusterV801Esm2 = _interopRequireDefault(_superclusterV801Esm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function s(t, e) {
	var s = {};
	for (var r in t) {
		Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (s[r] = t[r]);
	}if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
		var o = 0;
		for (r = Object.getOwnPropertySymbols(t); o < r.length; o++) {
			e.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[o]) && (s[r[o]] = t[r[o]]);
		}
	}
	return s;
}

var r = function () {
	function r() {
		_classCallCheck(this, r);
	}

	_createClass(r, null, [{
		key: "isAdvancedMarkerAvailable",
		value: function isAdvancedMarkerAvailable(t) {
			return google.maps.marker && !0 === t.getMapCapabilities().isAdvancedMarkersAvailable;
		}
	}, {
		key: "isAdvancedMarker",
		value: function isAdvancedMarker(t) {
			return google.maps.marker && t instanceof google.maps.marker.AdvancedMarkerElement;
		}
	}, {
		key: "setMap",
		value: function setMap(t, e) {
			this.isAdvancedMarker(t) ? t.map = e : t.setMap(e);
		}
	}, {
		key: "getPosition",
		value: function getPosition(t) {
			if (this.isAdvancedMarker(t)) {
				if (t.position) {
					if (t.position instanceof google.maps.LatLng) return t.position;
					if (t.position.lat && t.position.lng) return new google.maps.LatLng(t.position.lat, t.position.lng);
				}
				return new google.maps.LatLng(null);
			}
			return t.getPosition();
		}
	}, {
		key: "getVisible",
		value: function getVisible(t) {
			return !!this.isAdvancedMarker(t) || t.getVisible();
		}
	}]);

	return r;
}();

var o = function () {
	function o(_ref) {
		var t = _ref.markers,
		    e = _ref.position;

		_classCallCheck(this, o);

		this.markers = t, e && (e instanceof google.maps.LatLng ? this._position = e : this._position = new google.maps.LatLng(e));
	}

	_createClass(o, [{
		key: "push",
		value: function push(t) {
			this.markers.push(t);
		}
	}, {
		key: "delete",
		value: function _delete() {
			this.marker && (r.setMap(this.marker, null), this.marker = void 0), this.markers.length = 0;
		}
	}, {
		key: "bounds",
		get: function get() {
			if (0 === this.markers.length && !this._position) return;
			var t = new google.maps.LatLngBounds(this._position, this._position);
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = this.markers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var _e = _step.value;
					t.extend(r.getPosition(_e));
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			return t;
		}
	}, {
		key: "position",
		get: function get() {
			return this._position || this.bounds.getCenter();
		}
	}, {
		key: "count",
		get: function get() {
			return this.markers.filter(function (t) {
				return r.getVisible(t);
			}).length;
		}
	}]);

	return o;
}();

var a = function a(t, e, s, o) {
	var a = i(t.getBounds(), e, o);
	return s.filter(function (t) {
		return a.contains(r.getPosition(t));
	});
},
    i = function i(t, e, s) {
	var _m = m(t, e),
	    r = _m.northEast,
	    o = _m.southWest,
	    a = c({ northEast: r, southWest: o }, s);

	return h(a, e);
},
    n = function n(t, e, s) {
	var r = i(t, e, s),
	    o = r.getNorthEast(),
	    a = r.getSouthWest();
	return [a.lng(), a.lat(), o.lng(), o.lat()];
},
    l = function l(t, e) {
	var s = (e.lat - t.lat) * Math.PI / 180,
	    r = (e.lng - t.lng) * Math.PI / 180,
	    o = Math.sin(s / 2),
	    a = Math.sin(r / 2),
	    i = o * o + Math.cos(t.lat * Math.PI / 180) * Math.cos(e.lat * Math.PI / 180) * a * a;
	return 6371 * (2 * Math.atan2(Math.sqrt(i), Math.sqrt(1 - i)));
},
    m = function m(t, e) {
	return {
		northEast: e.fromLatLngToDivPixel(t.getNorthEast()),
		southWest: e.fromLatLngToDivPixel(t.getSouthWest())
	};
},
    c = function c(_ref2, s) {
	var t = _ref2.northEast,
	    e = _ref2.southWest;
	return t.x += s, t.y -= s, e.x -= s, e.y += s, { northEast: t, southWest: e };
},
    h = function h(_ref3, s) {
	var t = _ref3.northEast,
	    e = _ref3.southWest;

	var r = s.fromDivPixelToLatLng(e),
	    o = s.fromDivPixelToLatLng(t);
	return new google.maps.LatLngBounds(r, o);
};

var u = function () {
	function u(_ref4) {
		var _ref4$maxZoom = _ref4.maxZoom,
		    t = _ref4$maxZoom === undefined ? 16 : _ref4$maxZoom;

		_classCallCheck(this, u);

		this.maxZoom = t;
	}

	_createClass(u, [{
		key: "noop",
		value: function noop(_ref5) {
			var t = _ref5.markers;

			return g(t);
		}
	}]);

	return u;
}();

var p = function (_u) {
	_inherits(p, _u);

	function p(t) {
		var _this;

		_classCallCheck(this, p);

		var _t$viewportPadding = t.viewportPadding,
		    e = _t$viewportPadding === undefined ? 60 : _t$viewportPadding;

		(_this = _possibleConstructorReturn(this, (p.__proto__ || Object.getPrototypeOf(p)).call(this, s(t, ["viewportPadding"]))), _this), _this.viewportPadding = 60, _this.viewportPadding = e;
		return _this;
	}

	_createClass(p, [{
		key: "calculate",
		value: function calculate(_ref6) {
			var t = _ref6.markers,
			    e = _ref6.map,
			    s = _ref6.mapCanvasProjection;

			return e.getZoom() >= this.maxZoom ? { clusters: this.noop({ markers: t }), changed: !1 } : {
				clusters: this.cluster({
					markers: a(e, s, t, this.viewportPadding),
					map: e,
					mapCanvasProjection: s
				})
			};
		}
	}]);

	return p;
}(u);

var g = function g(t) {
	return t.map(function (t) {
		return new o({ position: r.getPosition(t), markers: [t] });
	});
};

var d = function (_p) {
	_inherits(d, _p);

	function d(t) {
		var _this2;

		_classCallCheck(this, d);

		var _t$maxDistance = t.maxDistance,
		    e = _t$maxDistance === undefined ? 4e4 : _t$maxDistance,
		    _t$gridSize = t.gridSize,
		    r = _t$gridSize === undefined ? 40 : _t$gridSize;

		(_this2 = _possibleConstructorReturn(this, (d.__proto__ || Object.getPrototypeOf(d)).call(this, s(t, ["maxDistance", "gridSize"]))), _this2), _this2.clusters = [], _this2.state = { zoom: -1 }, _this2.maxDistance = e, _this2.gridSize = r;
		return _this2;
	}

	_createClass(d, [{
		key: "calculate",
		value: function calculate(_ref7) {
			var e = _ref7.markers,
			    s = _ref7.map,
			    r = _ref7.mapCanvasProjection;

			var o = { zoom: s.getZoom() };
			var i = !1;
			return this.state.zoom >= this.maxZoom && o.zoom >= this.maxZoom || (i = !(0, _fastDeepEqualV313Esm2.default)(this.state, o)), this.state = o, s.getZoom() >= this.maxZoom ? { clusters: this.noop({ markers: e }), changed: i } : {
				clusters: this.cluster({
					markers: a(s, r, e, this.viewportPadding),
					map: s,
					mapCanvasProjection: r
				})
			};
		}
	}, {
		key: "cluster",
		value: function cluster(_ref8) {
			var _this3 = this;

			var t = _ref8.markers,
			    e = _ref8.map,
			    s = _ref8.mapCanvasProjection;

			return this.clusters = [], t.forEach(function (t) {
				_this3.addToClosestCluster(t, e, s);
			}), this.clusters;
		}
	}, {
		key: "addToClosestCluster",
		value: function addToClosestCluster(t, e, s) {
			var a = this.maxDistance,
			    n = null;
			for (var _e2 = 0; _e2 < this.clusters.length; _e2++) {
				var _s = this.clusters[_e2],
				    _o = l(_s.bounds.getCenter().toJSON(), r.getPosition(t).toJSON());
				_o < a && (a = _o, n = _s);
			}
			if (n && i(n.bounds, s, this.gridSize).contains(r.getPosition(t))) n.push(t);else {
				var _e3 = new o({ markers: [t] });
				this.clusters.push(_e3);
			}
		}
	}]);

	return d;
}(p);

var k = function (_u2) {
	_inherits(k, _u2);

	function k(t) {
		_classCallCheck(this, k);

		return _possibleConstructorReturn(this, (k.__proto__ || Object.getPrototypeOf(k)).call(this, s(t, [])));
	}

	_createClass(k, [{
		key: "calculate",
		value: function calculate(_ref9) {
			var t = _ref9.markers,
			    e = _ref9.map,
			    s = _ref9.mapCanvasProjection;

			return {
				clusters: this.cluster({
					markers: t,
					map: e,
					mapCanvasProjection: s
				}),
				changed: !1
			};
		}
	}, {
		key: "cluster",
		value: function cluster(t) {
			return this.noop(t);
		}
	}]);

	return k;
}(u);

var f = function (_u3) {
	_inherits(f, _u3);

	function f(t) {
		var _this5;

		_classCallCheck(this, f);

		var r = t.maxZoom,
		    _t$radius = t.radius,
		    o = _t$radius === undefined ? 60 : _t$radius,
		    a = s(t, ["maxZoom", "radius"]);

		(_this5 = _possibleConstructorReturn(this, (f.__proto__ || Object.getPrototypeOf(f)).call(this, { maxZoom: r })), _this5), _this5.state = { zoom: -1 }, _this5.superCluster = new _superclusterV801Esm2.default(Object.assign({ maxZoom: _this5.maxZoom, radius: o }, a));
		return _this5;
	}

	_createClass(f, [{
		key: "calculate",
		value: function calculate(e) {
			var s = !1;
			var o = { zoom: e.map.getZoom() };
			if (!(0, _fastDeepEqualV313Esm2.default)(e.markers, this.markers)) {
				s = !0, this.markers = [].concat(_toConsumableArray(e.markers));
				var _t = this.markers.map(function (t) {
					var e = r.getPosition(t);
					return {
						type: "Feature",
						geometry: {
							type: "Point",
							coordinates: [e.lng(), e.lat()]
						},
						properties: { marker: t }
					};
				});
				this.superCluster.load(_t);
			}
			return s || (this.state.zoom <= this.maxZoom || o.zoom <= this.maxZoom) && (s = !(0, _fastDeepEqualV313Esm2.default)(this.state, o)), this.state = o, s && (this.clusters = this.cluster(e)), { clusters: this.clusters, changed: s };
		}
	}, {
		key: "cluster",
		value: function cluster(_ref10) {
			var _this6 = this;

			var t = _ref10.map;

			return this.superCluster.getClusters([-180, -90, 180, 90], Math.round(t.getZoom())).map(function (t) {
				return _this6.transformCluster(t);
			});
		}
	}, {
		key: "transformCluster",
		value: function transformCluster(_ref11) {
			var _ref11$geometry$coord = _slicedToArray(_ref11.geometry.coordinates, 2),
			    t = _ref11$geometry$coord[0],
			    e = _ref11$geometry$coord[1],
			    s = _ref11.properties;

			if (s.cluster) return new o({
				markers: this.superCluster.getLeaves(s.cluster_id, 1 / 0).map(function (t) {
					return t.properties.marker;
				}),
				position: { lat: e, lng: t }
			});
			var a = s.marker;
			return new o({ markers: [a], position: r.getPosition(a) });
		}
	}]);

	return f;
}(u);

var v = function (_p2) {
	_inherits(v, _p2);

	function v(t) {
		var _this7;

		_classCallCheck(this, v);

		var r = t.maxZoom,
		    _t$radius2 = t.radius,
		    o = _t$radius2 === undefined ? 60 : _t$radius2,
		    _t$viewportPadding2 = t.viewportPadding,
		    a = _t$viewportPadding2 === undefined ? 60 : _t$viewportPadding2,
		    i = s(t, ["maxZoom", "radius", "viewportPadding"]);

		(_this7 = _possibleConstructorReturn(this, (v.__proto__ || Object.getPrototypeOf(v)).call(this, { maxZoom: r, viewportPadding: a })), _this7), _this7.superCluster = new _superclusterV801Esm2.default(Object.assign({ maxZoom: _this7.maxZoom, radius: o }, i)), _this7.state = { zoom: -1, view: [0, 0, 0, 0] };
		return _this7;
	}

	_createClass(v, [{
		key: "calculate",
		value: function calculate(e) {
			var s = {
				zoom: Math.round(e.map.getZoom()),
				view: n(e.map.getBounds(), e.mapCanvasProjection, this.viewportPadding)
			};
			var o = !(0, _fastDeepEqualV313Esm2.default)(this.state, s);
			if (!(0, _fastDeepEqualV313Esm2.default)(e.markers, this.markers)) {
				o = !0, this.markers = [].concat(_toConsumableArray(e.markers));
				var _t2 = this.markers.map(function (t) {
					var e = r.getPosition(t);
					return {
						type: "Feature",
						geometry: {
							type: "Point",
							coordinates: [e.lng(), e.lat()]
						},
						properties: { marker: t }
					};
				});
				this.superCluster.load(_t2);
			}
			return o && (this.clusters = this.cluster(e), this.state = s), { clusters: this.clusters, changed: o };
		}
	}, {
		key: "cluster",
		value: function cluster(_ref12) {
			var _this8 = this;

			var t = _ref12.map,
			    e = _ref12.mapCanvasProjection;

			var s = {
				zoom: Math.round(t.getZoom()),
				view: n(t.getBounds(), e, this.viewportPadding)
			};
			return this.superCluster.getClusters(s.view, s.zoom).map(function (t) {
				return _this8.transformCluster(t);
			});
		}
	}, {
		key: "transformCluster",
		value: function transformCluster(_ref13) {
			var _ref13$geometry$coord = _slicedToArray(_ref13.geometry.coordinates, 2),
			    t = _ref13$geometry$coord[0],
			    e = _ref13$geometry$coord[1],
			    s = _ref13.properties;

			if (s.cluster) return new o({
				markers: this.superCluster.getLeaves(s.cluster_id, 1 / 0).map(function (t) {
					return t.properties.marker;
				}),
				position: { lat: e, lng: t }
			});
			var a = s.marker;
			return new o({ markers: [a], position: r.getPosition(a) });
		}
	}]);

	return v;
}(p);

var x = function x(t, e) {
	_classCallCheck(this, x);

	this.markers = { sum: t.length };
	var s = e.map(function (t) {
		return t.count;
	}),
	    r = s.reduce(function (t, e) {
		return t + e;
	}, 0);
	this.clusters = {
		count: e.length,
		markers: {
			mean: r / e.length,
			sum: r,
			min: Math.min.apply(Math, _toConsumableArray(s)),
			max: Math.max.apply(Math, _toConsumableArray(s))
		}
	};
};

var C = function () {
	function C() {
		_classCallCheck(this, C);
	}

	_createClass(C, [{
		key: "render",
		value: function render(_ref14, s, o) {
			var t = _ref14.count,
			    e = _ref14.position;

			var a = "<svg fill=\"" + (t > Math.max(10, s.clusters.markers.mean) ? "#ff0000" : "#0000ff") + "\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 240 240\" width=\"50\" height=\"50\">\n<circle cx=\"120\" cy=\"120\" opacity=\".6\" r=\"70\" />\n<circle cx=\"120\" cy=\"120\" opacity=\".3\" r=\"90\" />\n<circle cx=\"120\" cy=\"120\" opacity=\".2\" r=\"110\" />\n<text x=\"50%\" y=\"50%\" style=\"fill:#fff\" text-anchor=\"middle\" font-size=\"50\" dominant-baseline=\"middle\" font-family=\"roboto,arial,sans-serif\">" + t + "</text>\n</svg>",
			    i = "Cluster of " + t + " markers",
			    n = Number(google.maps.Marker.MAX_ZINDEX) + t;
			if (r.isAdvancedMarkerAvailable(o)) {
				var _t3 = new DOMParser().parseFromString(a, "image/svg+xml").documentElement;
				_t3.setAttribute("transform", "translate(0 25)");
				var _s2 = { map: o, position: e, zIndex: n, title: i, content: _t3 };
				return new google.maps.marker.AdvancedMarkerElement(_s2);
			}
			var l = {
				position: e,
				zIndex: n,
				title: i,
				icon: {
					url: "data:image/svg+xml;base64," + btoa(a),
					anchor: new google.maps.Point(25, 25)
				}
			};
			return new google.maps.Marker(l);
		}
	}]);

	return C;
}();

var M = function M() {
	_classCallCheck(this, M);

	!function (t, e) {
		for (var _s3 in e.prototype) {
			t.prototype[_s3] = e.prototype[_s3];
		}
	}(M, google.maps.OverlayView);
};

var P;
!function (t) {
	t.CLUSTERING_BEGIN = "clusteringbegin", t.CLUSTERING_END = "clusteringend", t.CLUSTER_CLICK = "click";
}(P || (exports.MarkerClustererEvents = P = {}));
var w = function w(t, e, s) {
	s.fitBounds(e.bounds);
};

var L = function (_M) {
	_inherits(L, _M);

	function L(_ref15) {
		var _this9;

		var t = _ref15.map,
		    _ref15$markers = _ref15.markers,
		    e = _ref15$markers === undefined ? [] : _ref15$markers,
		    _ref15$algorithmOptio = _ref15.algorithmOptions,
		    s = _ref15$algorithmOptio === undefined ? {} : _ref15$algorithmOptio,
		    _ref15$algorithm = _ref15.algorithm,
		    r = _ref15$algorithm === undefined ? new f(s) : _ref15$algorithm,
		    _ref15$renderer = _ref15.renderer,
		    o = _ref15$renderer === undefined ? new C() : _ref15$renderer,
		    _ref15$onClusterClick = _ref15.onClusterClick,
		    a = _ref15$onClusterClick === undefined ? w : _ref15$onClusterClick;

		_classCallCheck(this, L);

		(_this9 = _possibleConstructorReturn(this, (L.__proto__ || Object.getPrototypeOf(L)).call(this)), _this9), _this9.markers = [].concat(_toConsumableArray(e)), _this9.clusters = [], _this9.algorithm = r, _this9.renderer = o, _this9.onClusterClick = a, t && _this9.setMap(t);
		return _this9;
	}

	_createClass(L, [{
		key: "addMarker",
		value: function addMarker(t, e) {
			this.markers.includes(t) || (this.markers.push(t), e || this.render());
		}
	}, {
		key: "addMarkers",
		value: function addMarkers(t, e) {
			var _this10 = this;

			t.forEach(function (t) {
				_this10.addMarker(t, !0);
			}), e || this.render();
		}
	}, {
		key: "removeMarker",
		value: function removeMarker(t, e) {
			var s = this.markers.indexOf(t);
			return -1 !== s && (r.setMap(t, null), this.markers.splice(s, 1), e || this.render(), !0);
		}
	}, {
		key: "removeMarkers",
		value: function removeMarkers(t, e) {
			var _this11 = this;

			var s = !1;
			return t.forEach(function (t) {
				s = _this11.removeMarker(t, !0) || s;
			}), s && !e && this.render(), s;
		}
	}, {
		key: "clearMarkers",
		value: function clearMarkers(t) {
			this.markers.length = 0, t || this.render();
		}
	}, {
		key: "render",
		value: function render() {
			var t = this.getMap();
			if (t instanceof google.maps.Map && t.getProjection()) {
				google.maps.event.trigger(this, P.CLUSTERING_BEGIN, this);

				var _algorithm$calculate = this.algorithm.calculate({
					markers: this.markers,
					map: t,
					mapCanvasProjection: this.getProjection()
				}),
				    _e4 = _algorithm$calculate.clusters,
				    _s4 = _algorithm$calculate.changed;

				if (_s4 || null == _s4) {
					var _t4 = new Set();
					var _iteratorNormalCompletion2 = true;
					var _didIteratorError2 = false;
					var _iteratorError2 = undefined;

					try {
						for (var _iterator2 = _e4[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
							var _s6 = _step2.value;
							1 == _s6.markers.length && _t4.add(_s6.markers[0]);
						}
					} catch (err) {
						_didIteratorError2 = true;
						_iteratorError2 = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion2 && _iterator2.return) {
								_iterator2.return();
							}
						} finally {
							if (_didIteratorError2) {
								throw _iteratorError2;
							}
						}
					}

					var _s5 = [];
					var _iteratorNormalCompletion3 = true;
					var _didIteratorError3 = false;
					var _iteratorError3 = undefined;

					try {
						for (var _iterator3 = this.clusters[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
							var _e5 = _step3.value;

							null != _e5.marker && (1 == _e5.markers.length ? _t4.has(_e5.marker) || r.setMap(_e5.marker, null) : _s5.push(_e5.marker));
						}
					} catch (err) {
						_didIteratorError3 = true;
						_iteratorError3 = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion3 && _iterator3.return) {
								_iterator3.return();
							}
						} finally {
							if (_didIteratorError3) {
								throw _iteratorError3;
							}
						}
					}

					this.clusters = _e4, this.renderClusters(), requestAnimationFrame(function () {
						return _s5.forEach(function (t) {
							return r.setMap(t, null);
						});
					});
				}
				google.maps.event.trigger(this, P.CLUSTERING_END, this);
			}
		}
	}, {
		key: "onAdd",
		value: function onAdd() {
			this.idleListener = this.getMap().addListener("idle", this.render.bind(this)), this.render();
		}
	}, {
		key: "onRemove",
		value: function onRemove() {
			google.maps.event.removeListener(this.idleListener), this.reset();
		}
	}, {
		key: "reset",
		value: function reset() {
			this.markers.forEach(function (t) {
				return r.setMap(t, null);
			}), this.clusters.forEach(function (t) {
				return t.delete();
			}), this.clusters = [];
		}
	}, {
		key: "renderClusters",
		value: function renderClusters() {
			var _this12 = this;

			var t = new x(this.markers, this.clusters),
			    e = this.getMap();
			this.clusters.forEach(function (s) {
				1 === s.markers.length ? s.marker = s.markers[0] : (s.marker = _this12.renderer.render(s, t, e), s.markers.forEach(function (t) {
					return r.setMap(t, null);
				}), _this12.onClusterClick && s.marker.addListener("click", function (t) {
					google.maps.event.trigger(_this12, P.CLUSTER_CLICK, s), _this12.onClusterClick(t, s, e);
				})), r.setMap(s.marker, e);
			});
		}
	}]);

	return L;
}(M);

exports.AbstractAlgorithm = u;
exports.AbstractViewportAlgorithm = p;
exports.Cluster = o;
exports.ClusterStats = x;
exports.DefaultRenderer = C;
exports.GridAlgorithm = d;
exports.MarkerClusterer = L;
exports.MarkerClustererEvents = P;
exports.MarkerUtils = r;
exports.NoopAlgorithm = k;
exports.SuperClusterAlgorithm = f;
exports.SuperClusterViewportAlgorithm = v;
exports.defaultOnClusterClickHandler = w;
exports.distanceBetweenPoints = l;
exports.extendBoundsToPaddedViewport = i;
exports.extendPixelBounds = c;
exports.filterMarkersToPaddedViewport = a;
exports.getPaddedViewport = n;
exports.noop = g;
exports.pixelBoundsToLatLngBounds = h;
exports.default = null;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/googlemaps/supercluster-v8.0.1.esm.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Bundled by jsDelivr using Rollup v2.79.2 and Terser v5.39.0.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Original file: /npm/supercluster@8.0.1/index.js
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */


var _kdbushV402Esm = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/googlemaps/kdbush-v4.0.2.esm.js");

var _kdbushV402Esm2 = _interopRequireDefault(_kdbushV402Esm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var e = {
	minZoom: 0,
	maxZoom: 16,
	minPoints: 2,
	radius: 40,
	extent: 512,
	nodeSize: 64,
	log: !1,
	generateId: !1,
	reduce: null,
	map: function map(t) {
		return t;
	}
},
    s = Math.fround || (o = new Float32Array(1), function (t) {
	return o[0] = +t, o[0];
});
var o;

var i = function () {
	function i(t) {
		_classCallCheck(this, i);

		this.options = Object.assign(Object.create(e), t), this.trees = new Array(this.options.maxZoom + 1), this.stride = this.options.reduce ? 7 : 6, this.clusterProps = [];
	}

	_createClass(i, [{
		key: "load",
		value: function load(t) {
			var _options = this.options,
			    e = _options.log,
			    o = _options.minZoom,
			    i = _options.maxZoom;

			e && console.time("total time");
			var n = "prepare " + t.length + " points";
			e && console.time(n), this.points = t;
			var r = [];
			for (var _e = 0; _e < t.length; _e++) {
				var _o = t[_e];
				if (!_o.geometry) continue;

				var _o$geometry$coordinat = _slicedToArray(_o.geometry.coordinates, 2),
				    _i = _o$geometry$coordinat[0],
				    _n = _o$geometry$coordinat[1],
				    _c = s(h(_i)),
				    u = s(a(_n));

				r.push(_c, u, 1 / 0, _e, -1, 1), this.options.reduce && r.push(0);
			}
			var c = this.trees[i + 1] = this._createTree(r);
			e && console.timeEnd(n);
			for (var _t = i; _t >= o; _t--) {
				var _s = +Date.now();
				c = this.trees[_t] = this._createTree(this._cluster(c, _t)), e && console.log("z%d: %d clusters in %dms", _t, c.numItems, +Date.now() - _s);
			}
			return e && console.timeEnd("total time"), this;
		}
	}, {
		key: "getClusters",
		value: function getClusters(t, e) {
			var s = ((t[0] + 180) % 360 + 360) % 360 - 180;
			var o = Math.max(-90, Math.min(90, t[1]));
			var i = 180 === t[2] ? 180 : ((t[2] + 180) % 360 + 360) % 360 - 180;
			var r = Math.max(-90, Math.min(90, t[3]));
			if (t[2] - t[0] >= 360) s = -180, i = 180;else if (s > i) {
				var _t2 = this.getClusters([s, o, 180, r], e),
				    _n2 = this.getClusters([-180, o, i, r], e);
				return _t2.concat(_n2);
			}
			var c = this.trees[this._limitZoom(e)],
			    u = c.range(h(s), a(r), h(i), a(o)),
			    p = c.data,
			    l = [];
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = u[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var _t3 = _step.value;

					var _e2 = this.stride * _t3;
					l.push(p[_e2 + 5] > 1 ? n(p, _e2, this.clusterProps) : this.points[p[_e2 + 3]]);
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			return l;
		}
	}, {
		key: "getChildren",
		value: function getChildren(t) {
			var e = this._getOriginId(t),
			    s = this._getOriginZoom(t),
			    o = "No cluster with the specified id.",
			    i = this.trees[s];
			if (!i) throw new Error(o);
			var r = i.data;
			if (e * this.stride >= r.length) throw new Error(o);
			var h = this.options.radius / (this.options.extent * Math.pow(2, s - 1)),
			    a = r[e * this.stride],
			    c = r[e * this.stride + 1],
			    u = i.within(a, c, h),
			    p = [];
			var _iteratorNormalCompletion2 = true;
			var _didIteratorError2 = false;
			var _iteratorError2 = undefined;

			try {
				for (var _iterator2 = u[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
					var _e3 = _step2.value;

					var _s2 = _e3 * this.stride;
					r[_s2 + 4] === t && p.push(r[_s2 + 5] > 1 ? n(r, _s2, this.clusterProps) : this.points[r[_s2 + 3]]);
				}
			} catch (err) {
				_didIteratorError2 = true;
				_iteratorError2 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion2 && _iterator2.return) {
						_iterator2.return();
					}
				} finally {
					if (_didIteratorError2) {
						throw _iteratorError2;
					}
				}
			}

			if (0 === p.length) throw new Error(o);
			return p;
		}
	}, {
		key: "getLeaves",
		value: function getLeaves(t, e, s) {
			e = e || 10, s = s || 0;
			var o = [];
			return this._appendLeaves(o, t, e, s, 0), o;
		}
	}, {
		key: "getTile",
		value: function getTile(t, e, s) {
			var o = this.trees[this._limitZoom(t)],
			    i = Math.pow(2, t),
			    _options2 = this.options,
			    n = _options2.extent,
			    r = _options2.radius,
			    h = r / n,
			    a = (s - h) / i,
			    c = (s + 1 + h) / i,
			    u = { features: [] };

			return this._addTileFeatures(o.range((e - h) / i, a, (e + 1 + h) / i, c), o.data, e, s, i, u), 0 === e && this._addTileFeatures(o.range(1 - h / i, a, 1, c), o.data, i, s, i, u), e === i - 1 && this._addTileFeatures(o.range(0, a, h / i, c), o.data, -1, s, i, u), u.features.length ? u : null;
		}
	}, {
		key: "getClusterExpansionZoom",
		value: function getClusterExpansionZoom(t) {
			var e = this._getOriginZoom(t) - 1;
			for (; e <= this.options.maxZoom;) {
				var _s3 = this.getChildren(t);
				if (e++, 1 !== _s3.length) break;
				t = _s3[0].properties.cluster_id;
			}
			return e;
		}
	}, {
		key: "_appendLeaves",
		value: function _appendLeaves(t, e, s, o, i) {
			var n = this.getChildren(e);
			var _iteratorNormalCompletion3 = true;
			var _didIteratorError3 = false;
			var _iteratorError3 = undefined;

			try {
				for (var _iterator3 = n[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
					var _e4 = _step3.value;

					var _n3 = _e4.properties;
					if (_n3 && _n3.cluster ? i + _n3.point_count <= o ? i += _n3.point_count : i = this._appendLeaves(t, _n3.cluster_id, s, o, i) : i < o ? i++ : t.push(_e4), t.length === s) break;
				}
			} catch (err) {
				_didIteratorError3 = true;
				_iteratorError3 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion3 && _iterator3.return) {
						_iterator3.return();
					}
				} finally {
					if (_didIteratorError3) {
						throw _iteratorError3;
					}
				}
			}

			return i;
		}
	}, {
		key: "_createTree",
		value: function _createTree(e) {
			var s = new _kdbushV402Esm2.default(e.length / this.stride | 0, this.options.nodeSize, Float32Array);
			for (var _t4 = 0; _t4 < e.length; _t4 += this.stride) {
				s.add(e[_t4], e[_t4 + 1]);
			}return s.finish(), s.data = e, s;
		}
	}, {
		key: "_addTileFeatures",
		value: function _addTileFeatures(t, e, s, o, i, n) {
			var _iteratorNormalCompletion4 = true;
			var _didIteratorError4 = false;
			var _iteratorError4 = undefined;

			try {
				for (var _iterator4 = t[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
					var _c2 = _step4.value;

					var _t5 = _c2 * this.stride,
					    u = e[_t5 + 5] > 1;
					var p = void 0,
					    l = void 0,
					    d = void 0;
					if (u) p = r(e, _t5, this.clusterProps), l = e[_t5], d = e[_t5 + 1];else {
						var _s4 = this.points[e[_t5 + 3]];
						p = _s4.properties;

						var _s4$geometry$coordina = _slicedToArray(_s4.geometry.coordinates, 2),
						    _o2 = _s4$geometry$coordina[0],
						    _i2 = _s4$geometry$coordina[1];

						l = h(_o2), d = a(_i2);
					}
					var m = {
						type: 1,
						geometry: [[Math.round(this.options.extent * (l * i - s)), Math.round(this.options.extent * (d * i - o))]],
						tags: p
					};
					var g = void 0;
					g = u || this.options.generateId ? e[_t5 + 3] : this.points[e[_t5 + 3]].id, void 0 !== g && (m.id = g), n.features.push(m);
				}
			} catch (err) {
				_didIteratorError4 = true;
				_iteratorError4 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion4 && _iterator4.return) {
						_iterator4.return();
					}
				} finally {
					if (_didIteratorError4) {
						throw _iteratorError4;
					}
				}
			}
		}
	}, {
		key: "_limitZoom",
		value: function _limitZoom(t) {
			return Math.max(this.options.minZoom, Math.min(Math.floor(+t), this.options.maxZoom + 1));
		}
	}, {
		key: "_cluster",
		value: function _cluster(t, e) {
			var _options3 = this.options,
			    s = _options3.radius,
			    o = _options3.extent,
			    i = _options3.reduce,
			    n = _options3.minPoints,
			    r = s / (o * Math.pow(2, e)),
			    h = t.data,
			    a = [],
			    c = this.stride;

			for (var _s5 = 0; _s5 < h.length; _s5 += c) {
				if (h[_s5 + 2] <= e) continue;
				h[_s5 + 2] = e;
				var _o3 = h[_s5],
				    u = h[_s5 + 1],
				    p = t.within(h[_s5], h[_s5 + 1], r),
				    l = h[_s5 + 5];
				var d = l;
				var _iteratorNormalCompletion5 = true;
				var _didIteratorError5 = false;
				var _iteratorError5 = undefined;

				try {
					for (var _iterator5 = p[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
						var _t6 = _step5.value;

						var _s6 = _t6 * c;
						h[_s6 + 2] > e && (d += h[_s6 + 5]);
					}
				} catch (err) {
					_didIteratorError5 = true;
					_iteratorError5 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion5 && _iterator5.return) {
							_iterator5.return();
						}
					} finally {
						if (_didIteratorError5) {
							throw _iteratorError5;
						}
					}
				}

				if (d > l && d >= n) {
					var _t7 = void 0,
					    _n4 = _o3 * l,
					    _r = u * l,
					    m = -1;
					var g = (_s5 / c << 5) + (e + 1) + this.points.length;
					var _iteratorNormalCompletion6 = true;
					var _didIteratorError6 = false;
					var _iteratorError6 = undefined;

					try {
						for (var _iterator6 = p[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
							var _o4 = _step6.value;

							var _a = _o4 * c;
							if (h[_a + 2] <= e) continue;
							h[_a + 2] = e;
							var _u = h[_a + 5];
							_n4 += h[_a] * _u, _r += h[_a + 1] * _u, h[_a + 4] = g, i && (_t7 || (_t7 = this._map(h, _s5, !0), m = this.clusterProps.length, this.clusterProps.push(_t7)), i(_t7, this._map(h, _a)));
						}
					} catch (err) {
						_didIteratorError6 = true;
						_iteratorError6 = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion6 && _iterator6.return) {
								_iterator6.return();
							}
						} finally {
							if (_didIteratorError6) {
								throw _iteratorError6;
							}
						}
					}

					h[_s5 + 4] = g, a.push(_n4 / d, _r / d, 1 / 0, g, -1, d), i && a.push(m);
				} else {
					for (var _t8 = 0; _t8 < c; _t8++) {
						a.push(h[_s5 + _t8]);
					}if (d > 1) {
						var _iteratorNormalCompletion7 = true;
						var _didIteratorError7 = false;
						var _iteratorError7 = undefined;

						try {
							for (var _iterator7 = p[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
								var _t9 = _step7.value;

								var _s7 = _t9 * c;
								if (!(h[_s7 + 2] <= e)) {
									h[_s7 + 2] = e;
									for (var _t10 = 0; _t10 < c; _t10++) {
										a.push(h[_s7 + _t10]);
									}
								}
							}
						} catch (err) {
							_didIteratorError7 = true;
							_iteratorError7 = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion7 && _iterator7.return) {
									_iterator7.return();
								}
							} finally {
								if (_didIteratorError7) {
									throw _iteratorError7;
								}
							}
						}
					}
				}
			}
			return a;
		}
	}, {
		key: "_getOriginId",
		value: function _getOriginId(t) {
			return t - this.points.length >> 5;
		}
	}, {
		key: "_getOriginZoom",
		value: function _getOriginZoom(t) {
			return (t - this.points.length) % 32;
		}
	}, {
		key: "_map",
		value: function _map(t, e, s) {
			if (t[e + 5] > 1) {
				var _o5 = this.clusterProps[t[e + 6]];
				return s ? Object.assign({}, _o5) : _o5;
			}
			var o = this.points[t[e + 3]].properties,
			    i = this.options.map(o);
			return s && i === o ? Object.assign({}, i) : i;
		}
	}]);

	return i;
}();

function n(t, e, s) {
	return {
		type: "Feature",
		id: t[e + 3],
		properties: r(t, e, s),
		geometry: {
			type: "Point",
			coordinates: [(o = t[e], 360 * (o - 0.5)), c(t[e + 1])]
		}
	};
	var o;
}
function r(t, e, s) {
	var o = t[e + 5],
	    i = o >= 1e4 ? Math.round(o / 1e3) + "k" : o >= 1e3 ? Math.round(o / 100) / 10 + "k" : o,
	    n = t[e + 6],
	    r = -1 === n ? {} : Object.assign({}, s[n]);
	return Object.assign(r, {
		cluster: !0,
		cluster_id: t[e + 3],
		point_count: o,
		point_count_abbreviated: i
	});
}
function h(t) {
	return t / 360 + 0.5;
}
function a(t) {
	var e = Math.sin(t * Math.PI / 180),
	    s = 0.5 - 0.25 * Math.log((1 + e) / (1 - e)) / Math.PI;
	return s < 0 ? 0 : s > 1 ? 1 : s;
}
function c(t) {
	var e = (180 - 360 * t) * Math.PI / 180;
	return 360 * Math.atan(Math.exp(e)) / Math.PI - 90;
}
exports.default = i;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/mousetrap/mousetrap.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

/*global define:false */
/**
 * Copyright 2012-2017 Craig Campbell
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Mousetrap is a simple keyboard shortcut library for Javascript with
 * no external dependencies
 *
 * @version 1.6.1
 * @url craig.is/killing/mice
 */
(function (window, document, undefined) {

    // Check if mousetrap is used inside browser, if not, return
    if (!window) {
        return;
    }

    /**
     * mapping of special keycodes to their corresponding keys
     *
     * everything in this dictionary cannot use keypress events
     * so it has to be here to map to the correct keycodes for
     * keyup/keydown events
     *
     * @type {Object}
     */
    var _MAP = {
        8: 'backspace',
        9: 'tab',
        13: 'enter',
        16: 'shift',
        17: 'ctrl',
        18: 'alt',
        20: 'capslock',
        27: 'esc',
        32: 'space',
        33: 'pageup',
        34: 'pagedown',
        35: 'end',
        36: 'home',
        37: 'left',
        38: 'up',
        39: 'right',
        40: 'down',
        45: 'ins',
        46: 'del',
        91: 'meta',
        93: 'meta',
        224: 'meta'
    };

    /**
     * mapping for special characters so they can support
     *
     * this dictionary is only used incase you want to bind a
     * keyup or keydown event to one of these keys
     *
     * @type {Object}
     */
    var _KEYCODE_MAP = {
        106: '*',
        107: '+',
        109: '-',
        110: '.',
        111: '/',
        186: ';',
        187: '=',
        188: ',',
        189: '-',
        190: '.',
        191: '/',
        192: '`',
        219: '[',
        220: '\\',
        221: ']',
        222: '\''
    };

    /**
     * this is a mapping of keys that require shift on a US keypad
     * back to the non shift equivelents
     *
     * this is so you can use keyup events with these keys
     *
     * note that this will only work reliably on US keyboards
     *
     * @type {Object}
     */
    var _SHIFT_MAP = {
        '~': '`',
        '!': '1',
        '@': '2',
        '#': '3',
        '$': '4',
        '%': '5',
        '^': '6',
        '&': '7',
        '*': '8',
        '(': '9',
        ')': '0',
        '_': '-',
        '+': '=',
        ':': ';',
        '\"': '\'',
        '<': ',',
        '>': '.',
        '?': '/',
        '|': '\\'
    };

    /**
     * this is a list of special strings you can use to map
     * to modifier keys when you specify your keyboard shortcuts
     *
     * @type {Object}
     */
    var _SPECIAL_ALIASES = {
        'option': 'alt',
        'command': 'meta',
        'return': 'enter',
        'escape': 'esc',
        'plus': '+',
        'mod': /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? 'meta' : 'ctrl'
    };

    /**
     * variable to store the flipped version of _MAP from above
     * needed to check if we should use keypress or not when no action
     * is specified
     *
     * @type {Object|undefined}
     */
    var _REVERSE_MAP;

    /**
     * loop through the f keys, f1 to f19 and add them to the map
     * programatically
     */
    for (var i = 1; i < 20; ++i) {
        _MAP[111 + i] = 'f' + i;
    }

    /**
     * loop through to map numbers on the numeric keypad
     */
    for (i = 0; i <= 9; ++i) {

        // This needs to use a string cause otherwise since 0 is falsey
        // mousetrap will never fire for numpad 0 pressed as part of a keydown
        // event.
        //
        // @see https://github.com/ccampbell/mousetrap/pull/258
        _MAP[i + 96] = i.toString();
    }

    /**
     * cross browser add event method
     *
     * @param {Element|HTMLDocument} object
     * @param {string} type
     * @param {Function} callback
     * @returns void
     */
    function _addEvent(object, type, callback) {
        if (object.addEventListener) {
            object.addEventListener(type, callback, false);
            return;
        }

        object.attachEvent('on' + type, callback);
    }

    /**
     * takes the event and returns the key character
     *
     * @param {Event} e
     * @return {string}
     */
    function _characterFromEvent(e) {

        // for keypress events we should return the character as is
        if (e.type == 'keypress') {
            var character = String.fromCharCode(e.which);

            // if the shift key is not pressed then it is safe to assume
            // that we want the character to be lowercase.  this means if
            // you accidentally have caps lock on then your key bindings
            // will continue to work
            //
            // the only side effect that might not be desired is if you
            // bind something like 'A' cause you want to trigger an
            // event when capital A is pressed caps lock will no longer
            // trigger the event.  shift+a will though.
            if (!e.shiftKey) {
                character = character.toLowerCase();
            }

            return character;
        }

        // for non keypress events the special maps are needed
        if (_MAP[e.which]) {
            return _MAP[e.which];
        }

        if (_KEYCODE_MAP[e.which]) {
            return _KEYCODE_MAP[e.which];
        }

        // if it is not in the special map

        // with keydown and keyup events the character seems to always
        // come in as an uppercase character whether you are pressing shift
        // or not.  we should make sure it is always lowercase for comparisons
        return String.fromCharCode(e.which).toLowerCase();
    }

    /**
     * checks if two arrays are equal
     *
     * @param {Array} modifiers1
     * @param {Array} modifiers2
     * @returns {boolean}
     */
    function _modifiersMatch(modifiers1, modifiers2) {
        return modifiers1.sort().join(',') === modifiers2.sort().join(',');
    }

    /**
     * takes a key event and figures out what the modifiers are
     *
     * @param {Event} e
     * @returns {Array}
     */
    function _eventModifiers(e) {
        var modifiers = [];

        if (e.shiftKey) {
            modifiers.push('shift');
        }

        if (e.altKey) {
            modifiers.push('alt');
        }

        if (e.ctrlKey) {
            modifiers.push('ctrl');
        }

        if (e.metaKey) {
            modifiers.push('meta');
        }

        return modifiers;
    }

    /**
     * prevents default for this event
     *
     * @param {Event} e
     * @returns void
     */
    function _preventDefault(e) {
        if (e.preventDefault) {
            e.preventDefault();
            return;
        }

        e.returnValue = false;
    }

    /**
     * stops propogation for this event
     *
     * @param {Event} e
     * @returns void
     */
    function _stopPropagation(e) {
        if (e.stopPropagation) {
            e.stopPropagation();
            return;
        }

        e.cancelBubble = true;
    }

    /**
     * determines if the keycode specified is a modifier key or not
     *
     * @param {string} key
     * @returns {boolean}
     */
    function _isModifier(key) {
        return key == 'shift' || key == 'ctrl' || key == 'alt' || key == 'meta';
    }

    /**
     * reverses the map lookup so that we can look for specific keys
     * to see what can and can't use keypress
     *
     * @return {Object}
     */
    function _getReverseMap() {
        if (!_REVERSE_MAP) {
            _REVERSE_MAP = {};
            for (var key in _MAP) {

                // pull out the numeric keypad from here cause keypress should
                // be able to detect the keys from the character
                if (key > 95 && key < 112) {
                    continue;
                }

                if (_MAP.hasOwnProperty(key)) {
                    _REVERSE_MAP[_MAP[key]] = key;
                }
            }
        }
        return _REVERSE_MAP;
    }

    /**
     * picks the best action based on the key combination
     *
     * @param {string} key - character for key
     * @param {Array} modifiers
     * @param {string=} action passed in
     */
    function _pickBestAction(key, modifiers, action) {

        // if no action was picked in we should try to pick the one
        // that we think would work best for this key
        if (!action) {
            action = _getReverseMap()[key] ? 'keydown' : 'keypress';
        }

        // modifier keys don't work as expected with keypress,
        // switch to keydown
        if (action == 'keypress' && modifiers.length) {
            action = 'keydown';
        }

        return action;
    }

    /**
     * Converts from a string key combination to an array
     *
     * @param  {string} combination like "command+shift+l"
     * @return {Array}
     */
    function _keysFromString(combination) {
        if (combination === '+') {
            return ['+'];
        }

        combination = combination.replace(/\+{2}/g, '+plus');
        return combination.split('+');
    }

    /**
     * Gets info for a specific key combination
     *
     * @param  {string} combination key combination ("command+s" or "a" or "*")
     * @param  {string=} action
     * @returns {Object}
     */
    function _getKeyInfo(combination, action) {
        var keys;
        var key;
        var i;
        var modifiers = [];

        // take the keys from this pattern and figure out what the actual
        // pattern is all about
        keys = _keysFromString(combination);

        for (i = 0; i < keys.length; ++i) {
            key = keys[i];

            // normalize key names
            if (_SPECIAL_ALIASES[key]) {
                key = _SPECIAL_ALIASES[key];
            }

            // if this is not a keypress event then we should
            // be smart about using shift keys
            // this will only work for US keyboards however
            if (action && action != 'keypress' && _SHIFT_MAP[key]) {
                key = _SHIFT_MAP[key];
                modifiers.push('shift');
            }

            // if this key is a modifier then add it to the list of modifiers
            if (_isModifier(key)) {
                modifiers.push(key);
            }
        }

        // depending on what the key combination is
        // we will try to pick the best event for it
        action = _pickBestAction(key, modifiers, action);

        return {
            key: key,
            modifiers: modifiers,
            action: action
        };
    }

    function _belongsTo(element, ancestor) {
        if (element === null || element === document) {
            return false;
        }

        if (element === ancestor) {
            return true;
        }

        return _belongsTo(element.parentNode, ancestor);
    }

    function Mousetrap(targetElement) {
        var self = this;

        targetElement = targetElement || document;

        if (!(self instanceof Mousetrap)) {
            return new Mousetrap(targetElement);
        }

        /**
         * element to attach key events to
         *
         * @type {Element}
         */
        self.target = targetElement;

        /**
         * a list of all the callbacks setup via Mousetrap.bind()
         *
         * @type {Object}
         */
        self._callbacks = {};

        /**
         * direct map of string combinations to callbacks used for trigger()
         *
         * @type {Object}
         */
        self._directMap = {};

        /**
         * keeps track of what level each sequence is at since multiple
         * sequences can start out with the same sequence
         *
         * @type {Object}
         */
        var _sequenceLevels = {};

        /**
         * variable to store the setTimeout call
         *
         * @type {null|number}
         */
        var _resetTimer;

        /**
         * temporary state where we will ignore the next keyup
         *
         * @type {boolean|string}
         */
        var _ignoreNextKeyup = false;

        /**
         * temporary state where we will ignore the next keypress
         *
         * @type {boolean}
         */
        var _ignoreNextKeypress = false;

        /**
         * are we currently inside of a sequence?
         * type of action ("keyup" or "keydown" or "keypress") or false
         *
         * @type {boolean|string}
         */
        var _nextExpectedAction = false;

        /**
         * resets all sequence counters except for the ones passed in
         *
         * @param {Object} doNotReset
         * @returns void
         */
        function _resetSequences(doNotReset) {
            doNotReset = doNotReset || {};

            var activeSequences = false,
                key;

            for (key in _sequenceLevels) {
                if (doNotReset[key]) {
                    activeSequences = true;
                    continue;
                }
                _sequenceLevels[key] = 0;
            }

            if (!activeSequences) {
                _nextExpectedAction = false;
            }
        }

        /**
         * finds all callbacks that match based on the keycode, modifiers,
         * and action
         *
         * @param {string} character
         * @param {Array} modifiers
         * @param {Event|Object} e
         * @param {string=} sequenceName - name of the sequence we are looking for
         * @param {string=} combination
         * @param {number=} level
         * @returns {Array}
         */
        function _getMatches(character, modifiers, e, sequenceName, combination, level) {
            var i;
            var callback;
            var matches = [];
            var action = e.type;

            // if there are no events related to this keycode
            if (!self._callbacks[character]) {
                return [];
            }

            // if a modifier key is coming up on its own we should allow it
            if (action == 'keyup' && _isModifier(character)) {
                modifiers = [character];
            }

            // loop through all callbacks for the key that was pressed
            // and see if any of them match
            for (i = 0; i < self._callbacks[character].length; ++i) {
                callback = self._callbacks[character][i];

                // if a sequence name is not specified, but this is a sequence at
                // the wrong level then move onto the next match
                if (!sequenceName && callback.seq && _sequenceLevels[callback.seq] != callback.level) {
                    continue;
                }

                // if the action we are looking for doesn't match the action we got
                // then we should keep going
                if (action != callback.action) {
                    continue;
                }

                // if this is a keypress event and the meta key and control key
                // are not pressed that means that we need to only look at the
                // character, otherwise check the modifiers as well
                //
                // chrome will not fire a keypress if meta or control is down
                // safari will fire a keypress if meta or meta+shift is down
                // firefox will fire a keypress if meta or control is down
                if (action == 'keypress' && !e.metaKey && !e.ctrlKey || _modifiersMatch(modifiers, callback.modifiers)) {

                    // when you bind a combination or sequence a second time it
                    // should overwrite the first one.  if a sequenceName or
                    // combination is specified in this call it does just that
                    //
                    // @todo make deleting its own method?
                    var deleteCombo = !sequenceName && callback.combo == combination;
                    var deleteSequence = sequenceName && callback.seq == sequenceName && callback.level == level;
                    if (deleteCombo || deleteSequence) {
                        self._callbacks[character].splice(i, 1);
                    }

                    matches.push(callback);
                }
            }

            return matches;
        }

        /**
         * actually calls the callback function
         *
         * if your callback function returns false this will use the jquery
         * convention - prevent default and stop propogation on the event
         *
         * @param {Function} callback
         * @param {Event} e
         * @returns void
         */
        function _fireCallback(callback, e, combo, sequence) {

            // if this event should not happen stop here
            if (self.stopCallback(e, e.target || e.srcElement, combo, sequence)) {
                return;
            }

            if (callback(e, combo) === false) {
                _preventDefault(e);
                _stopPropagation(e);
            }
        }

        /**
         * handles a character key event
         *
         * @param {string} character
         * @param {Array} modifiers
         * @param {Event} e
         * @returns void
         */
        self._handleKey = function (character, modifiers, e) {
            var callbacks = _getMatches(character, modifiers, e);
            var i;
            var doNotReset = {};
            var maxLevel = 0;
            var processedSequenceCallback = false;

            // Calculate the maxLevel for sequences so we can only execute the longest callback sequence
            for (i = 0; i < callbacks.length; ++i) {
                if (callbacks[i].seq) {
                    maxLevel = Math.max(maxLevel, callbacks[i].level);
                }
            }

            // loop through matching callbacks for this key event
            for (i = 0; i < callbacks.length; ++i) {

                // fire for all sequence callbacks
                // this is because if for example you have multiple sequences
                // bound such as "g i" and "g t" they both need to fire the
                // callback for matching g cause otherwise you can only ever
                // match the first one
                if (callbacks[i].seq) {

                    // only fire callbacks for the maxLevel to prevent
                    // subsequences from also firing
                    //
                    // for example 'a option b' should not cause 'option b' to fire
                    // even though 'option b' is part of the other sequence
                    //
                    // any sequences that do not match here will be discarded
                    // below by the _resetSequences call
                    if (callbacks[i].level != maxLevel) {
                        continue;
                    }

                    processedSequenceCallback = true;

                    // keep a list of which sequences were matches for later
                    doNotReset[callbacks[i].seq] = 1;
                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo, callbacks[i].seq);
                    continue;
                }

                // if there were no sequence matches but we are still here
                // that means this is a regular match so we should fire that
                if (!processedSequenceCallback) {
                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo);
                }
            }

            // if the key you pressed matches the type of sequence without
            // being a modifier (ie "keyup" or "keypress") then we should
            // reset all sequences that were not matched by this event
            //
            // this is so, for example, if you have the sequence "h a t" and you
            // type "h e a r t" it does not match.  in this case the "e" will
            // cause the sequence to reset
            //
            // modifier keys are ignored because you can have a sequence
            // that contains modifiers such as "enter ctrl+space" and in most
            // cases the modifier key will be pressed before the next key
            //
            // also if you have a sequence such as "ctrl+b a" then pressing the
            // "b" key will trigger a "keypress" and a "keydown"
            //
            // the "keydown" is expected when there is a modifier, but the
            // "keypress" ends up matching the _nextExpectedAction since it occurs
            // after and that causes the sequence to reset
            //
            // we ignore keypresses in a sequence that directly follow a keydown
            // for the same character
            var ignoreThisKeypress = e.type == 'keypress' && _ignoreNextKeypress;
            if (e.type == _nextExpectedAction && !_isModifier(character) && !ignoreThisKeypress) {
                _resetSequences(doNotReset);
            }

            _ignoreNextKeypress = processedSequenceCallback && e.type == 'keydown';
        };

        /**
         * handles a keydown event
         *
         * @param {Event} e
         * @returns void
         */
        function _handleKeyEvent(e) {

            // normalize e.which for key events
            // @see http://stackoverflow.com/questions/4285627/javascript-keycode-vs-charcode-utter-confusion
            if (typeof e.which !== 'number') {
                e.which = e.keyCode;
            }

            var character = _characterFromEvent(e);

            // no character found then stop
            if (!character) {
                return;
            }

            // need to use === for the character check because the character can be 0
            if (e.type == 'keyup' && _ignoreNextKeyup === character) {
                _ignoreNextKeyup = false;
                return;
            }

            self.handleKey(character, _eventModifiers(e), e);
        }

        /**
         * called to set a 1 second timeout on the specified sequence
         *
         * this is so after each key press in the sequence you have 1 second
         * to press the next key before you have to start over
         *
         * @returns void
         */
        function _resetSequenceTimer() {
            clearTimeout(_resetTimer);
            _resetTimer = setTimeout(_resetSequences, 1000);
        }

        /**
         * binds a key sequence to an event
         *
         * @param {string} combo - combo specified in bind call
         * @param {Array} keys
         * @param {Function} callback
         * @param {string=} action
         * @returns void
         */
        function _bindSequence(combo, keys, callback, action) {

            // start off by adding a sequence level record for this combination
            // and setting the level to 0
            _sequenceLevels[combo] = 0;

            /**
             * callback to increase the sequence level for this sequence and reset
             * all other sequences that were active
             *
             * @param {string} nextAction
             * @returns {Function}
             */
            function _increaseSequence(nextAction) {
                return function () {
                    _nextExpectedAction = nextAction;
                    ++_sequenceLevels[combo];
                    _resetSequenceTimer();
                };
            }

            /**
             * wraps the specified callback inside of another function in order
             * to reset all sequence counters as soon as this sequence is done
             *
             * @param {Event} e
             * @returns void
             */
            function _callbackAndReset(e) {
                _fireCallback(callback, e, combo);

                // we should ignore the next key up if the action is key down
                // or keypress.  this is so if you finish a sequence and
                // release the key the final key will not trigger a keyup
                if (action !== 'keyup') {
                    _ignoreNextKeyup = _characterFromEvent(e);
                }

                // weird race condition if a sequence ends with the key
                // another sequence begins with
                setTimeout(_resetSequences, 10);
            }

            // loop through keys one at a time and bind the appropriate callback
            // function.  for any key leading up to the final one it should
            // increase the sequence. after the final, it should reset all sequences
            //
            // if an action is specified in the original bind call then that will
            // be used throughout.  otherwise we will pass the action that the
            // next key in the sequence should match.  this allows a sequence
            // to mix and match keypress and keydown events depending on which
            // ones are better suited to the key provided
            for (var i = 0; i < keys.length; ++i) {
                var isFinal = i + 1 === keys.length;
                var wrappedCallback = isFinal ? _callbackAndReset : _increaseSequence(action || _getKeyInfo(keys[i + 1]).action);
                _bindSingle(keys[i], wrappedCallback, action, combo, i);
            }
        }

        /**
         * binds a single keyboard combination
         *
         * @param {string} combination
         * @param {Function} callback
         * @param {string=} action
         * @param {string=} sequenceName - name of sequence if part of sequence
         * @param {number=} level - what part of the sequence the command is
         * @returns void
         */
        function _bindSingle(combination, callback, action, sequenceName, level) {

            // store a direct mapped reference for use with Mousetrap.trigger
            self._directMap[combination + ':' + action] = callback;

            // make sure multiple spaces in a row become a single space
            combination = combination.replace(/\s+/g, ' ');

            var sequence = combination.split(' ');
            var info;

            // if this pattern is a sequence of keys then run through this method
            // to reprocess each pattern one key at a time
            if (sequence.length > 1) {
                _bindSequence(combination, sequence, callback, action);
                return;
            }

            info = _getKeyInfo(combination, action);

            // make sure to initialize array if this is the first time
            // a callback is added for this key
            self._callbacks[info.key] = self._callbacks[info.key] || [];

            // remove an existing match if there is one
            _getMatches(info.key, info.modifiers, { type: info.action }, sequenceName, combination, level);

            // add this call back to the array
            // if it is a sequence put it at the beginning
            // if not put it at the end
            //
            // this is important because the way these are processed expects
            // the sequence ones to come first
            self._callbacks[info.key][sequenceName ? 'unshift' : 'push']({
                callback: callback,
                modifiers: info.modifiers,
                action: info.action,
                seq: sequenceName,
                level: level,
                combo: combination
            });
        }

        /**
         * binds multiple combinations to the same callback
         *
         * @param {Array} combinations
         * @param {Function} callback
         * @param {string|undefined} action
         * @returns void
         */
        self._bindMultiple = function (combinations, callback, action) {
            for (var i = 0; i < combinations.length; ++i) {
                _bindSingle(combinations[i], callback, action);
            }
        };

        // start!
        _addEvent(targetElement, 'keypress', _handleKeyEvent);
        _addEvent(targetElement, 'keydown', _handleKeyEvent);
        _addEvent(targetElement, 'keyup', _handleKeyEvent);
    }

    /**
     * binds an event to mousetrap
     *
     * can be a single key, a combination of keys separated with +,
     * an array of keys, or a sequence of keys separated by spaces
     *
     * be sure to list the modifier keys first to make sure that the
     * correct key ends up getting bound (the last key in the pattern)
     *
     * @param {string|Array} keys
     * @param {Function} callback
     * @param {string=} action - 'keypress', 'keydown', or 'keyup'
     * @returns void
     */
    Mousetrap.prototype.bind = function (keys, callback, action) {
        var self = this;
        keys = keys instanceof Array ? keys : [keys];
        self._bindMultiple.call(self, keys, callback, action);
        return self;
    };

    /**
     * unbinds an event to mousetrap
     *
     * the unbinding sets the callback function of the specified key combo
     * to an empty function and deletes the corresponding key in the
     * _directMap dict.
     *
     * TODO: actually remove this from the _callbacks dictionary instead
     * of binding an empty function
     *
     * the keycombo+action has to be exactly the same as
     * it was defined in the bind method
     *
     * @param {string|Array} keys
     * @param {string} action
     * @returns void
     */
    Mousetrap.prototype.unbind = function (keys, action) {
        var self = this;
        return self.bind.call(self, keys, function () {}, action);
    };

    /**
     * triggers an event that has already been bound
     *
     * @param {string} keys
     * @param {string=} action
     * @returns void
     */
    Mousetrap.prototype.trigger = function (keys, action) {
        var self = this;
        if (self._directMap[keys + ':' + action]) {
            self._directMap[keys + ':' + action]({}, keys);
        }
        return self;
    };

    /**
     * resets the library back to its initial state.  this is useful
     * if you want to clear out the current keyboard shortcuts and bind
     * new ones - for example if you switch to another page
     *
     * @returns void
     */
    Mousetrap.prototype.reset = function () {
        var self = this;
        self._callbacks = {};
        self._directMap = {};
        return self;
    };

    /**
     * should we stop this event before firing off callbacks
     *
     * @param {Event} e
     * @param {Element} element
     * @return {boolean}
     */
    Mousetrap.prototype.stopCallback = function (e, element) {
        var self = this;

        // if the element has the class "mousetrap" then no need to stop
        if ((' ' + element.className + ' ').indexOf(' mousetrap ') > -1) {
            return false;
        }

        if (_belongsTo(element, self.target)) {
            return false;
        }

        // stop for input, select, and textarea
        return element.tagName == 'INPUT' || element.tagName == 'SELECT' || element.tagName == 'TEXTAREA' || element.isContentEditable;
    };

    /**
     * exposes _handleKey publicly so it can be overwritten by extensions
     */
    Mousetrap.prototype.handleKey = function () {
        var self = this;
        return self._handleKey.apply(self, arguments);
    };

    /**
     * allow custom key mappings
     */
    Mousetrap.addKeycodes = function (object) {
        for (var key in object) {
            if (object.hasOwnProperty(key)) {
                _MAP[key] = object[key];
            }
        }
        _REVERSE_MAP = null;
    };

    /**
     * Init the global mousetrap functions
     *
     * This method is needed to allow the global mousetrap functions to work
     * now that mousetrap is a constructor function.
     */
    Mousetrap.init = function () {
        var documentMousetrap = Mousetrap(document);
        for (var method in documentMousetrap) {
            if (method.charAt(0) !== '_') {
                Mousetrap[method] = function (method) {
                    return function () {
                        return documentMousetrap[method].apply(documentMousetrap, arguments);
                    };
                }(method);
            }
        }
    };

    Mousetrap.init();

    // expose mousetrap to the global object
    window.Mousetrap = Mousetrap;

    // expose as a common js module
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = Mousetrap;
    }

    // expose mousetrap as an AMD module
    if (true) {
        !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
            return Mousetrap;
        }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
})(typeof window !== 'undefined' ? window : null, typeof window !== 'undefined' ? document : null);

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/pyrsmk-toast/toast.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (root, factory) {
	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
		module.exports = factory();
	} else {
		root.toast = factory();
	}
})(undefined, function () {
	/*! toast 2.1.0 (https://github.com/pyrsmk/toast) */

	var handled_resources = {};

	function toast() {
		var head = document.getElementsByTagName('head')[0],


		// Load as much resources as we can
		loadResources = function loadResources(resources) {
			// Waiting for DOM readiness then load resources
			if (!head) {
				setTimeout(function () {
					loadResources(resources);
				}, 50);
			}
			// Load resources
			else if (resources.length) {
					var i = -1,
					    resource,
					    callback;
					while (resource = resources[++i]) {
						// Resource
						if (typeof resource == 'string') {
							loadResource(resource);
						}
						// Callback
						else if (typeof resource == 'function') {
								callback = resource;
								break;
							}
					}
					watchResources(callback, Array.prototype.slice.call(resources, i + 1));
				}
		},


		// Load one resource
		loadResource = function loadResource(resource) {
			// Extract resource type
			var implicit_type = /\.(\w+)$/.exec(resource),
			    explicit_type = /^\[(\w+)\](.+)/.exec(resource),
			    type,
			    node;
			if (explicit_type !== null) {
				type = explicit_type[1];
				resource = explicit_type[2];
			} else if (implicit_type !== null) {
				type = implicit_type[1];
			} else {
				return;
			}
			// Verify if the resource is not already handled
			if (resource in handled_resources) {
				return;
			}
			// Mark the resource as handled (but not loaded yet)
			handled_resources[resource] = false;
			// Load resource
			switch (type) {
				case 'js':
					// Create SCRIPT element
					node = document.createElement('script');
					node.src = resource;
					node.type = 'text/javascript';
					head.appendChild(node);
					// Watch loading state
					var version = navigator.appVersion.match(/MSIE (\d)/);
					if (version !== null && parseInt(version[1], 10) < 9) {
						// IE<9
						node.onreadystatechange = function () {
							if (/ded|co/.test(this.readyState)) {
								handled_resources[resource] = true;
							}
						};
					} else {
						// Other browsers
						node.onload = function () {
							handled_resources[resource] = true;
						};
					}
					break;
				case 'css':
					// Create LINK element
					node = document.createElement('link');
					node.rel = 'styleSheet';
					node.href = resource;
					head.appendChild(node);
					// Watch loading state
					watchStylesheet(node, resource);
					break;
				default:
					delete handled_resources[resource];
					return;
			}
		},


		// Watch if all resources have been loaded
		watchResources = function watchResources(callback, resourcesToLoad) {
			for (var resource in handled_resources) {
				if (!handled_resources[resource]) {
					setTimeout(function () {
						watchResources(callback, resourcesToLoad);
					}, 50);
					return;
				}
			}
			if (typeof callback == 'function') {
				callback();
			}
			loadResources(resourcesToLoad);
		},


		// Watch if a CSS resource has been loaded
		watchStylesheet = function watchStylesheet(node, resource) {
			if (node.sheet || node.styleSheet) {
				handled_resources[resource] = true;
			} else {
				setTimeout(function () {
					watchStylesheet(node, resource);
				}, 50);
			}
		};

		// Load resources
		loadResources(arguments);
	}
	return toast;
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/sortablejs/Sortable.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**!
 * Sortable
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */

(function sortableModule(factory) {
	"use strict";

	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module != "undefined" && typeof module.exports != "undefined") {
		module.exports = factory();
	} else {
		/* jshint sub:true */
		window["Sortable"] = factory();
	}
})(function sortableFactory() {
	"use strict";

	if (typeof window === "undefined" || !window.document) {
		return function sortableError() {
			throw new Error("Sortable.js requires a window with a document");
		};
	}

	var dragEl,
	    parentEl,
	    ghostEl,
	    cloneEl,
	    rootEl,
	    nextEl,
	    lastDownEl,
	    scrollEl,
	    scrollParentEl,
	    scrollCustomFn,
	    oldIndex,
	    newIndex,
	    oldDraggableIndex,
	    newDraggableIndex,
	    activeGroup,
	    putSortable,
	    autoScrolls = [],
	    scrolling = false,
	    awaitingDragStarted = false,
	    ignoreNextClick = false,
	    sortables = [],
	    pointerElemChangedInterval,
	    lastPointerElemX,
	    lastPointerElemY,
	    tapEvt,
	    touchEvt,
	    moved,
	    lastTarget,
	    lastDirection,
	    pastFirstInvertThresh = false,
	    isCircumstantialInvert = false,
	    lastMode,
	    // 'swap' or 'insert'

	targetMoveDistance,


	// For positioning ghost absolutely
	ghostRelativeParent,
	    ghostRelativeParentInitialScroll = [],
	    // (left, top)

	realDragElRect,
	    // dragEl rect after current animation

	/** @const */
	R_SPACE = /\s+/g,
	    expando = 'Sortable' + new Date().getTime(),
	    win = window,
	    document = win.document,
	    parseInt = win.parseInt,
	    setTimeout = win.setTimeout,
	    $ = win.jQuery || win.Zepto,
	    Polymer = win.Polymer,
	    captureMode = {
		capture: false,
		passive: false
	},
	    IE11OrLess = !!navigator.userAgent.match(/(?:Trident.*rv[ :]?11\.|msie|iemobile)/i),
	    Edge = !!navigator.userAgent.match(/Edge/i),
	    FireFox = !!navigator.userAgent.match(/firefox/i),
	    Safari = !!(navigator.userAgent.match(/safari/i) && !navigator.userAgent.match(/chrome/i) && !navigator.userAgent.match(/android/i)),
	    IOS = !!navigator.userAgent.match(/iP(ad|od|hone)/i),
	    PositionGhostAbsolutely = IOS,
	    CSSFloatProperty = Edge || IE11OrLess ? 'cssFloat' : 'float',


	// This will not pass for IE9, because IE9 DnD only works on anchors
	supportDraggable = 'draggable' in document.createElement('div'),
	    supportCssPointerEvents = function () {
		// false when <= IE11
		if (IE11OrLess) {
			return false;
		}
		var el = document.createElement('x');
		el.style.cssText = 'pointer-events:auto';
		return el.style.pointerEvents === 'auto';
	}(),
	    _silent = false,
	    _alignedSilent = false,
	    abs = Math.abs,
	    min = Math.min,
	    max = Math.max,
	    savedInputChecked = [],
	    _detectDirection = function _detectDirection(el, options) {
		var elCSS = _css(el),
		    elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth),
		    child1 = _getChild(el, 0, options),
		    child2 = _getChild(el, 1, options),
		    firstChildCSS = child1 && _css(child1),
		    secondChildCSS = child2 && _css(child2),
		    firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + _getRect(child1).width,
		    secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + _getRect(child2).width;

		if (elCSS.display === 'flex') {
			return elCSS.flexDirection === 'column' || elCSS.flexDirection === 'column-reverse' ? 'vertical' : 'horizontal';
		}

		if (elCSS.display === 'grid') {
			return elCSS.gridTemplateColumns.split(' ').length <= 1 ? 'vertical' : 'horizontal';
		}

		if (child1 && firstChildCSS.float !== 'none') {
			var touchingSideChild2 = firstChildCSS.float === 'left' ? 'left' : 'right';

			return child2 && (secondChildCSS.clear === 'both' || secondChildCSS.clear === touchingSideChild2) ? 'vertical' : 'horizontal';
		}

		return child1 && (firstChildCSS.display === 'block' || firstChildCSS.display === 'flex' || firstChildCSS.display === 'table' || firstChildCSS.display === 'grid' || firstChildWidth >= elWidth && elCSS[CSSFloatProperty] === 'none' || child2 && elCSS[CSSFloatProperty] === 'none' && firstChildWidth + secondChildWidth > elWidth) ? 'vertical' : 'horizontal';
	},


	/**
  * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
  * @param  {Number} x      X position
  * @param  {Number} y      Y position
  * @return {HTMLElement}   Element of the first found nearest Sortable
  */
	_detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
		for (var i = 0; i < sortables.length; i++) {
			if (_lastChild(sortables[i])) continue;

			var rect = _getRect(sortables[i]),
			    threshold = sortables[i][expando].options.emptyInsertThreshold,
			    insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold,
			    insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;

			if (threshold && insideHorizontally && insideVertically) {
				return sortables[i];
			}
		}
	},
	    _isClientInRowColumn = function _isClientInRowColumn(x, y, el, axis, options) {
		var targetRect = _getRect(el),
		    targetS1Opp = axis === 'vertical' ? targetRect.left : targetRect.top,
		    targetS2Opp = axis === 'vertical' ? targetRect.right : targetRect.bottom,
		    mouseOnOppAxis = axis === 'vertical' ? x : y;

		return targetS1Opp < mouseOnOppAxis && mouseOnOppAxis < targetS2Opp;
	},
	    _isElInRowColumn = function _isElInRowColumn(el1, el2, axis) {
		var el1Rect = el1 === dragEl && realDragElRect || _getRect(el1),
		    el2Rect = el2 === dragEl && realDragElRect || _getRect(el2),
		    el1S1Opp = axis === 'vertical' ? el1Rect.left : el1Rect.top,
		    el1S2Opp = axis === 'vertical' ? el1Rect.right : el1Rect.bottom,
		    el1OppLength = axis === 'vertical' ? el1Rect.width : el1Rect.height,
		    el2S1Opp = axis === 'vertical' ? el2Rect.left : el2Rect.top,
		    el2S2Opp = axis === 'vertical' ? el2Rect.right : el2Rect.bottom,
		    el2OppLength = axis === 'vertical' ? el2Rect.width : el2Rect.height;

		return el1S1Opp === el2S1Opp || el1S2Opp === el2S2Opp || el1S1Opp + el1OppLength / 2 === el2S1Opp + el2OppLength / 2;
	},
	    _getParentAutoScrollElement = function _getParentAutoScrollElement(el, includeSelf) {
		// skip to window
		if (!el || !el.getBoundingClientRect) return _getWindowScrollingElement();

		var elem = el;
		var gotSelf = false;
		do {
			// we don't need to get elem css if it isn't even overflowing in the first place (performance)
			if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
				var elemCSS = _css(elem);
				if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == 'auto' || elemCSS.overflowX == 'scroll') || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == 'auto' || elemCSS.overflowY == 'scroll')) {
					if (!elem || !elem.getBoundingClientRect || elem === document.body) return _getWindowScrollingElement();

					if (gotSelf || includeSelf) return elem;
					gotSelf = true;
				}
			}
			/* jshint boss:true */
		} while (elem = elem.parentNode);

		return _getWindowScrollingElement();
	},
	    _getWindowScrollingElement = function _getWindowScrollingElement() {
		if (IE11OrLess) {
			return document.documentElement;
		} else {
			return document.scrollingElement;
		}
	},
	    _scrollBy = function _scrollBy(el, x, y) {
		el.scrollLeft += x;
		el.scrollTop += y;
	},
	    _autoScroll = _throttle(function ( /**Event*/evt, /**Object*/options, /**HTMLElement*/rootEl, /**Boolean*/isFallback) {
		// Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
		if (options.scroll) {
			var _this = rootEl ? rootEl[expando] : window,
			    sens = options.scrollSensitivity,
			    speed = options.scrollSpeed,
			    x = evt.clientX,
			    y = evt.clientY,
			    winScroller = _getWindowScrollingElement(),
			    scrollThisInstance = false;

			// Detect scrollEl
			if (scrollParentEl !== rootEl) {
				_clearAutoScrolls();

				scrollEl = options.scroll;
				scrollCustomFn = options.scrollFn;

				if (scrollEl === true) {
					scrollEl = _getParentAutoScrollElement(rootEl, true);
					scrollParentEl = scrollEl;
				}
			}

			var layersOut = 0;
			var currentParent = scrollEl;
			do {
				var el = currentParent,
				    rect = _getRect(el),
				    top = rect.top,
				    bottom = rect.bottom,
				    left = rect.left,
				    right = rect.right,
				    width = rect.width,
				    height = rect.height,
				    scrollWidth,
				    scrollHeight,
				    css,
				    vx,
				    vy,
				    canScrollX,
				    canScrollY,
				    scrollPosX,
				    scrollPosY;

				scrollWidth = el.scrollWidth;
				scrollHeight = el.scrollHeight;

				css = _css(el);

				scrollPosX = el.scrollLeft;
				scrollPosY = el.scrollTop;

				if (el === winScroller) {
					canScrollX = width < scrollWidth && (css.overflowX === 'auto' || css.overflowX === 'scroll' || css.overflowX === 'visible');
					canScrollY = height < scrollHeight && (css.overflowY === 'auto' || css.overflowY === 'scroll' || css.overflowY === 'visible');
				} else {
					canScrollX = width < scrollWidth && (css.overflowX === 'auto' || css.overflowX === 'scroll');
					canScrollY = height < scrollHeight && (css.overflowY === 'auto' || css.overflowY === 'scroll');
				}

				vx = canScrollX && (abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (abs(left - x) <= sens && !!scrollPosX);

				vy = canScrollY && (abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (abs(top - y) <= sens && !!scrollPosY);

				if (!autoScrolls[layersOut]) {
					for (var i = 0; i <= layersOut; i++) {
						if (!autoScrolls[i]) {
							autoScrolls[i] = {};
						}
					}
				}

				if (autoScrolls[layersOut].vx != vx || autoScrolls[layersOut].vy != vy || autoScrolls[layersOut].el !== el) {
					autoScrolls[layersOut].el = el;
					autoScrolls[layersOut].vx = vx;
					autoScrolls[layersOut].vy = vy;

					clearInterval(autoScrolls[layersOut].pid);

					if (el && (vx != 0 || vy != 0)) {
						scrollThisInstance = true;
						/* jshint loopfunc:true */
						autoScrolls[layersOut].pid = setInterval(function () {
							// emulate drag over during autoscroll (fallback), emulating native DnD behaviour
							if (isFallback && this.layer === 0) {
								Sortable.active._emulateDragOver(true);
								Sortable.active._onTouchMove(touchEvt, true);
							}
							var scrollOffsetY = autoScrolls[this.layer].vy ? autoScrolls[this.layer].vy * speed : 0;
							var scrollOffsetX = autoScrolls[this.layer].vx ? autoScrolls[this.layer].vx * speed : 0;

							if ('function' === typeof scrollCustomFn) {
								if (scrollCustomFn.call(_this, scrollOffsetX, scrollOffsetY, evt, touchEvt, autoScrolls[this.layer].el) !== 'continue') {
									return;
								}
							}

							_scrollBy(autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
						}.bind({ layer: layersOut }), 24);
					}
				}
				layersOut++;
			} while (options.bubbleScroll && currentParent !== winScroller && (currentParent = _getParentAutoScrollElement(currentParent, false)));
			scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
		}
	}, 30),
	    _clearAutoScrolls = function _clearAutoScrolls() {
		autoScrolls.forEach(function (autoScroll) {
			clearInterval(autoScroll.pid);
		});
		autoScrolls = [];
	},
	    _prepareGroup = function _prepareGroup(options) {
		function toFn(value, pull) {
			return function (to, from, dragEl, evt) {
				var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;

				if (value == null && (pull || sameGroup)) {
					// Default pull value
					// Default pull and put value if same group
					return true;
				} else if (value == null || value === false) {
					return false;
				} else if (pull && value === 'clone') {
					return value;
				} else if (typeof value === 'function') {
					return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
				} else {
					var otherGroup = (pull ? to : from).options.group.name;

					return value === true || typeof value === 'string' && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
				}
			};
		}

		var group = {};
		var originalGroup = options.group;

		if (!originalGroup || (typeof originalGroup === "undefined" ? "undefined" : _typeof(originalGroup)) != 'object') {
			originalGroup = { name: originalGroup };
		}

		group.name = originalGroup.name;
		group.checkPull = toFn(originalGroup.pull, true);
		group.checkPut = toFn(originalGroup.put);
		group.revertClone = originalGroup.revertClone;

		options.group = group;
	},
	    _checkAlignment = function _checkAlignment(evt) {
		if (!dragEl || !dragEl.parentNode) return;
		dragEl.parentNode[expando] && dragEl.parentNode[expando]._computeIsAligned(evt);
	},
	    _hideGhostForTarget = function _hideGhostForTarget() {
		if (!supportCssPointerEvents && ghostEl) {
			_css(ghostEl, 'display', 'none');
		}
	},
	    _unhideGhostForTarget = function _unhideGhostForTarget() {
		if (!supportCssPointerEvents && ghostEl) {
			_css(ghostEl, 'display', '');
		}
	};

	// #1184 fix - Prevent click event on fallback if dragged but item not changed position
	document.addEventListener('click', function (evt) {
		if (ignoreNextClick) {
			evt.preventDefault();
			evt.stopPropagation && evt.stopPropagation();
			evt.stopImmediatePropagation && evt.stopImmediatePropagation();
			ignoreNextClick = false;
			return false;
		}
	}, true);

	var nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
		if (dragEl) {
			evt = evt.touches ? evt.touches[0] : evt;
			var nearest = _detectNearestEmptySortable(evt.clientX, evt.clientY);

			if (nearest) {
				// Create imitation event
				var event = {};
				for (var i in evt) {
					event[i] = evt[i];
				}
				event.target = event.rootEl = nearest;
				event.preventDefault = void 0;
				event.stopPropagation = void 0;
				nearest[expando]._onDragOver(event);
			}
		}
	};

	/**
  * @class  Sortable
  * @param  {HTMLElement}  el
  * @param  {Object}       [options]
  */
	function Sortable(el, options) {
		if (!(el && el.nodeType && el.nodeType === 1)) {
			throw 'Sortable: `el` must be HTMLElement, not ' + {}.toString.call(el);
		}

		this.el = el; // root element
		this.options = options = _extend({}, options);

		// Export instance
		el[expando] = this;

		// Default options
		var defaults = {
			group: null,
			sort: true,
			disabled: false,
			store: null,
			handle: null,
			scroll: true,
			scrollSensitivity: 30,
			scrollSpeed: 10,
			bubbleScroll: true,
			draggable: /[uo]l/i.test(el.nodeName) ? '>li' : '>*',
			swapThreshold: 1, // percentage; 0 <= x <= 1
			invertSwap: false, // invert always
			invertedSwapThreshold: null, // will be set to same as swapThreshold if default
			removeCloneOnHide: true,
			direction: function direction() {
				return _detectDirection(el, this.options);
			},
			ghostClass: 'sortable-ghost',
			chosenClass: 'sortable-chosen',
			dragClass: 'sortable-drag',
			ignore: 'a, img',
			filter: null,
			preventOnFilter: true,
			animation: 0,
			easing: null,
			setData: function setData(dataTransfer, dragEl) {
				dataTransfer.setData('Text', dragEl.textContent);
			},
			dropBubble: false,
			dragoverBubble: false,
			dataIdAttr: 'data-id',
			delay: 0,
			delayOnTouchOnly: false,
			touchStartThreshold: parseInt(window.devicePixelRatio, 10) || 1,
			forceFallback: false,
			fallbackClass: 'sortable-fallback',
			fallbackOnBody: false,
			fallbackTolerance: 0,
			fallbackOffset: { x: 0, y: 0 },
			supportPointer: Sortable.supportPointer !== false && 'PointerEvent' in window,
			emptyInsertThreshold: 5
		};

		// Set default options
		for (var name in defaults) {
			!(name in options) && (options[name] = defaults[name]);
		}

		_prepareGroup(options);

		// Bind all private methods
		for (var fn in this) {
			if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
				this[fn] = this[fn].bind(this);
			}
		}

		// Setup drag mode
		this.nativeDraggable = options.forceFallback ? false : supportDraggable;

		if (this.nativeDraggable) {
			// Touch start threshold cannot be greater than the native dragstart threshold
			this.options.touchStartThreshold = 1;
		}

		// Bind events
		if (options.supportPointer) {
			_on(el, 'pointerdown', this._onTapStart);
		} else {
			_on(el, 'mousedown', this._onTapStart);
			_on(el, 'touchstart', this._onTapStart);
		}

		if (this.nativeDraggable) {
			_on(el, 'dragover', this);
			_on(el, 'dragenter', this);
		}

		sortables.push(this.el);

		// Restore sorting
		options.store && options.store.get && this.sort(options.store.get(this) || []);
	}

	Sortable.prototype = /** @lends Sortable.prototype */{
		constructor: Sortable,

		_computeIsAligned: function _computeIsAligned(evt) {
			var target;

			if (ghostEl && !supportCssPointerEvents) {
				_hideGhostForTarget();
				target = document.elementFromPoint(evt.clientX, evt.clientY);
				_unhideGhostForTarget();
			} else {
				target = evt.target;
			}

			target = _closest(target, this.options.draggable, this.el, false);
			if (_alignedSilent) return;
			if (!dragEl || dragEl.parentNode !== this.el) return;

			var children = this.el.children;
			for (var i = 0; i < children.length; i++) {
				// Don't change for target in case it is changed to aligned before onDragOver is fired
				if (_closest(children[i], this.options.draggable, this.el, false) && children[i] !== target) {
					children[i].sortableMouseAligned = _isClientInRowColumn(evt.clientX, evt.clientY, children[i], this._getDirection(evt, null), this.options);
				}
			}
			// Used for nulling last target when not in element, nothing to do with checking if aligned
			if (!_closest(target, this.options.draggable, this.el, true)) {
				lastTarget = null;
			}

			_alignedSilent = true;
			setTimeout(function () {
				_alignedSilent = false;
			}, 30);
		},

		_getDirection: function _getDirection(evt, target) {
			return typeof this.options.direction === 'function' ? this.options.direction.call(this, evt, target, dragEl) : this.options.direction;
		},

		_onTapStart: function _onTapStart( /** Event|TouchEvent */evt) {
			if (!evt.cancelable) return;
			var _this = this,
			    el = this.el,
			    options = this.options,
			    preventOnFilter = options.preventOnFilter,
			    type = evt.type,
			    touch = evt.touches && evt.touches[0],
			    target = (touch || evt).target,
			    originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target,
			    filter = options.filter,
			    startIndex,
			    startDraggableIndex;

			_saveInputCheckedState(el);

			// Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.
			if (dragEl) {
				return;
			}

			if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) {
				return; // only left button and enabled
			}

			// cancel dnd if original target is content editable
			if (originalTarget.isContentEditable) {
				return;
			}

			target = _closest(target, options.draggable, el, false);

			if (lastDownEl === target) {
				// Ignoring duplicate `down`
				return;
			}

			// Get the index of the dragged element within its parent
			startIndex = _index(target);
			startDraggableIndex = _index(target, options.draggable);

			// Check filter
			if (typeof filter === 'function') {
				if (filter.call(this, evt, target, this)) {
					_dispatchEvent(_this, originalTarget, 'filter', target, el, el, startIndex, undefined, startDraggableIndex);
					preventOnFilter && evt.cancelable && evt.preventDefault();
					return; // cancel dnd
				}
			} else if (filter) {
				filter = filter.split(',').some(function (criteria) {
					criteria = _closest(originalTarget, criteria.trim(), el, false);

					if (criteria) {
						_dispatchEvent(_this, criteria, 'filter', target, el, el, startIndex, undefined, startDraggableIndex);
						return true;
					}
				});

				if (filter) {
					preventOnFilter && evt.cancelable && evt.preventDefault();
					return; // cancel dnd
				}
			}

			if (options.handle && !_closest(originalTarget, options.handle, el, false)) {
				return;
			}

			// Prepare `dragstart`
			this._prepareDragStart(evt, touch, target, startIndex, startDraggableIndex);
		},

		_handleAutoScroll: function _handleAutoScroll(evt, fallback) {
			if (!dragEl || !this.options.scroll) return;
			var x = evt.clientX,
			    y = evt.clientY,
			    elem = document.elementFromPoint(x, y),
			    _this = this;

			// IE does not seem to have native autoscroll,
			// Edge's autoscroll seems too conditional,
			// MACOS Safari does not have autoscroll,
			// Firefox and Chrome are good
			if (fallback || Edge || IE11OrLess || Safari) {
				_autoScroll(evt, _this.options, elem, fallback);

				// Listener for pointer element change
				var ogElemScroller = _getParentAutoScrollElement(elem, true);
				if (scrolling && (!pointerElemChangedInterval || x !== lastPointerElemX || y !== lastPointerElemY)) {

					pointerElemChangedInterval && clearInterval(pointerElemChangedInterval);
					// Detect for pointer elem change, emulating native DnD behaviour
					pointerElemChangedInterval = setInterval(function () {
						if (!dragEl) return;
						// could also check if scroll direction on newElem changes due to parent autoscrolling
						var newElem = _getParentAutoScrollElement(document.elementFromPoint(x, y), true);
						if (newElem !== ogElemScroller) {
							ogElemScroller = newElem;
							_clearAutoScrolls();
							_autoScroll(evt, _this.options, ogElemScroller, fallback);
						}
					}, 10);
					lastPointerElemX = x;
					lastPointerElemY = y;
				}
			} else {
				// if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
				if (!_this.options.bubbleScroll || _getParentAutoScrollElement(elem, true) === _getWindowScrollingElement()) {
					_clearAutoScrolls();
					return;
				}
				_autoScroll(evt, _this.options, _getParentAutoScrollElement(elem, false), false);
			}
		},

		_prepareDragStart: function _prepareDragStart( /** Event */evt, /** Touch */touch, /** HTMLElement */target, /** Number */startIndex, /** Number */startDraggableIndex) {
			var _this = this,
			    el = _this.el,
			    options = _this.options,
			    ownerDocument = el.ownerDocument,
			    dragStartFn;

			if (target && !dragEl && target.parentNode === el) {
				rootEl = el;
				dragEl = target;
				parentEl = dragEl.parentNode;
				nextEl = dragEl.nextSibling;
				lastDownEl = target;
				activeGroup = options.group;
				oldIndex = startIndex;
				oldDraggableIndex = startDraggableIndex;

				tapEvt = {
					target: dragEl,
					clientX: (touch || evt).clientX,
					clientY: (touch || evt).clientY
				};

				this._lastX = (touch || evt).clientX;
				this._lastY = (touch || evt).clientY;

				dragEl.style['will-change'] = 'all';
				// undo animation if needed
				dragEl.style.transition = '';
				dragEl.style.transform = '';

				dragStartFn = function dragStartFn() {
					// Delayed drag has been triggered
					// we can re-enable the events: touchmove/mousemove
					_this._disableDelayedDragEvents();

					if (!FireFox && _this.nativeDraggable) {
						dragEl.draggable = true;
					}

					// Bind the events: dragstart/dragend
					_this._triggerDragStart(evt, touch);

					// Drag start event
					_dispatchEvent(_this, rootEl, 'choose', dragEl, rootEl, rootEl, oldIndex, undefined, oldDraggableIndex);

					// Chosen item
					_toggleClass(dragEl, options.chosenClass, true);
				};

				// Disable "draggable"
				options.ignore.split(',').forEach(function (criteria) {
					_find(dragEl, criteria.trim(), _disableDraggable);
				});

				_on(ownerDocument, 'dragover', nearestEmptyInsertDetectEvent);
				_on(ownerDocument, 'mousemove', nearestEmptyInsertDetectEvent);
				_on(ownerDocument, 'touchmove', nearestEmptyInsertDetectEvent);

				_on(ownerDocument, 'mouseup', _this._onDrop);
				_on(ownerDocument, 'touchend', _this._onDrop);
				_on(ownerDocument, 'touchcancel', _this._onDrop);

				// Make dragEl draggable (must be before delay for FireFox)
				if (FireFox && this.nativeDraggable) {
					this.options.touchStartThreshold = 4;
					dragEl.draggable = true;
				}

				// Delay is impossible for native DnD in Edge or IE
				if (options.delay && (options.delayOnTouchOnly ? touch : true) && (!this.nativeDraggable || !(Edge || IE11OrLess))) {
					// If the user moves the pointer or let go the click or touch
					// before the delay has been reached:
					// disable the delayed drag
					_on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
					_on(ownerDocument, 'touchend', _this._disableDelayedDrag);
					_on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
					_on(ownerDocument, 'mousemove', _this._delayedDragTouchMoveHandler);
					_on(ownerDocument, 'touchmove', _this._delayedDragTouchMoveHandler);
					options.supportPointer && _on(ownerDocument, 'pointermove', _this._delayedDragTouchMoveHandler);

					_this._dragStartTimer = setTimeout(dragStartFn, options.delay);
				} else {
					dragStartFn();
				}
			}
		},

		_delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler( /** TouchEvent|PointerEvent **/e) {
			var touch = e.touches ? e.touches[0] : e;
			if (max(abs(touch.clientX - this._lastX), abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) {
				this._disableDelayedDrag();
			}
		},

		_disableDelayedDrag: function _disableDelayedDrag() {
			dragEl && _disableDraggable(dragEl);
			clearTimeout(this._dragStartTimer);

			this._disableDelayedDragEvents();
		},

		_disableDelayedDragEvents: function _disableDelayedDragEvents() {
			var ownerDocument = this.el.ownerDocument;
			_off(ownerDocument, 'mouseup', this._disableDelayedDrag);
			_off(ownerDocument, 'touchend', this._disableDelayedDrag);
			_off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
			_off(ownerDocument, 'mousemove', this._delayedDragTouchMoveHandler);
			_off(ownerDocument, 'touchmove', this._delayedDragTouchMoveHandler);
			_off(ownerDocument, 'pointermove', this._delayedDragTouchMoveHandler);
		},

		_triggerDragStart: function _triggerDragStart( /** Event */evt, /** Touch */touch) {
			touch = touch || (evt.pointerType == 'touch' ? evt : null);

			if (!this.nativeDraggable || touch) {
				if (this.options.supportPointer) {
					_on(document, 'pointermove', this._onTouchMove);
				} else if (touch) {
					_on(document, 'touchmove', this._onTouchMove);
				} else {
					_on(document, 'mousemove', this._onTouchMove);
				}
			} else {
				_on(dragEl, 'dragend', this);
				_on(rootEl, 'dragstart', this._onDragStart);
			}

			try {
				if (document.selection) {
					// Timeout neccessary for IE9
					_nextTick(function () {
						document.selection.empty();
					});
				} else {
					window.getSelection().removeAllRanges();
				}
			} catch (err) {}
		},

		_dragStarted: function _dragStarted(fallback, evt) {
			awaitingDragStarted = false;
			if (rootEl && dragEl) {
				if (this.nativeDraggable) {
					_on(document, 'dragover', this._handleAutoScroll);
					_on(document, 'dragover', _checkAlignment);
				}
				var options = this.options;

				// Apply effect
				!fallback && _toggleClass(dragEl, options.dragClass, false);
				_toggleClass(dragEl, options.ghostClass, true);

				// In case dragging an animated element
				_css(dragEl, 'transform', '');

				Sortable.active = this;

				fallback && this._appendGhost();

				// Drag start event
				_dispatchEvent(this, rootEl, 'start', dragEl, rootEl, rootEl, oldIndex, undefined, oldDraggableIndex, undefined, evt);
			} else {
				this._nulling();
			}
		},

		_emulateDragOver: function _emulateDragOver(forAutoScroll) {
			if (touchEvt) {
				if (this._lastX === touchEvt.clientX && this._lastY === touchEvt.clientY && !forAutoScroll) {
					return;
				}
				this._lastX = touchEvt.clientX;
				this._lastY = touchEvt.clientY;

				_hideGhostForTarget();

				var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
				var parent = target;

				while (target && target.shadowRoot) {
					target = target.shadowRoot.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
					if (target === parent) break;
					parent = target;
				}

				if (parent) {
					do {
						if (parent[expando]) {
							var inserted;

							inserted = parent[expando]._onDragOver({
								clientX: touchEvt.clientX,
								clientY: touchEvt.clientY,
								target: target,
								rootEl: parent
							});

							if (inserted && !this.options.dragoverBubble) {
								break;
							}
						}

						target = parent; // store last element
					}
					/* jshint boss:true */
					while (parent = parent.parentNode);
				}
				dragEl.parentNode[expando]._computeIsAligned(touchEvt);

				_unhideGhostForTarget();
			}
		},

		_onTouchMove: function _onTouchMove( /**TouchEvent*/evt, forAutoScroll) {
			if (tapEvt) {
				var options = this.options,
				    fallbackTolerance = options.fallbackTolerance,
				    fallbackOffset = options.fallbackOffset,
				    touch = evt.touches ? evt.touches[0] : evt,
				    matrix = ghostEl && _matrix(ghostEl),
				    scaleX = ghostEl && matrix && matrix.a,
				    scaleY = ghostEl && matrix && matrix.d,
				    relativeScrollOffset = PositionGhostAbsolutely && ghostRelativeParent && _getRelativeScrollOffset(ghostRelativeParent),
				    dx = (touch.clientX - tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1),
				    dy = (touch.clientY - tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1),
				    translate3d = evt.touches ? 'translate3d(' + dx + 'px,' + dy + 'px,0)' : 'translate(' + dx + 'px,' + dy + 'px)';

				// only set the status to dragging, when we are actually dragging
				if (!Sortable.active && !awaitingDragStarted) {
					if (fallbackTolerance && min(abs(touch.clientX - this._lastX), abs(touch.clientY - this._lastY)) < fallbackTolerance) {
						return;
					}
					this._onDragStart(evt, true);
				}

				!forAutoScroll && this._handleAutoScroll(touch, true);

				moved = true;
				touchEvt = touch;

				_css(ghostEl, 'webkitTransform', translate3d);
				_css(ghostEl, 'mozTransform', translate3d);
				_css(ghostEl, 'msTransform', translate3d);
				_css(ghostEl, 'transform', translate3d);

				evt.cancelable && evt.preventDefault();
			}
		},

		_appendGhost: function _appendGhost() {
			// Bug if using scale(): https://stackoverflow.com/questions/2637058
			// Not being adjusted for
			if (!ghostEl) {
				var container = this.options.fallbackOnBody ? document.body : rootEl,
				    rect = _getRect(dragEl, true, container, !PositionGhostAbsolutely),
				    css = _css(dragEl),
				    options = this.options;

				// Position absolutely
				if (PositionGhostAbsolutely) {
					// Get relatively positioned parent
					ghostRelativeParent = container;

					while (_css(ghostRelativeParent, 'position') === 'static' && _css(ghostRelativeParent, 'transform') === 'none' && ghostRelativeParent !== document) {
						ghostRelativeParent = ghostRelativeParent.parentNode;
					}

					if (ghostRelativeParent !== document) {
						var ghostRelativeParentRect = _getRect(ghostRelativeParent, true);

						rect.top -= ghostRelativeParentRect.top;
						rect.left -= ghostRelativeParentRect.left;
					}

					if (ghostRelativeParent !== document.body && ghostRelativeParent !== document.documentElement) {
						if (ghostRelativeParent === document) ghostRelativeParent = _getWindowScrollingElement();

						rect.top += ghostRelativeParent.scrollTop;
						rect.left += ghostRelativeParent.scrollLeft;
					} else {
						ghostRelativeParent = _getWindowScrollingElement();
					}
					ghostRelativeParentInitialScroll = _getRelativeScrollOffset(ghostRelativeParent);
				}

				ghostEl = dragEl.cloneNode(true);

				_toggleClass(ghostEl, options.ghostClass, false);
				_toggleClass(ghostEl, options.fallbackClass, true);
				_toggleClass(ghostEl, options.dragClass, true);

				_css(ghostEl, 'box-sizing', 'border-box');
				_css(ghostEl, 'margin', 0);
				_css(ghostEl, 'top', rect.top);
				_css(ghostEl, 'left', rect.left);
				_css(ghostEl, 'width', rect.width);
				_css(ghostEl, 'height', rect.height);
				_css(ghostEl, 'opacity', '0.8');
				_css(ghostEl, 'position', PositionGhostAbsolutely ? 'absolute' : 'fixed');
				_css(ghostEl, 'zIndex', '100000');
				_css(ghostEl, 'pointerEvents', 'none');

				container.appendChild(ghostEl);
			}
		},

		_onDragStart: function _onDragStart( /**Event*/evt, /**boolean*/fallback) {
			var _this = this;
			var dataTransfer = evt.dataTransfer;
			var options = _this.options;

			// Setup clone
			cloneEl = _clone(dragEl);

			cloneEl.draggable = false;
			cloneEl.style['will-change'] = '';

			this._hideClone();

			_toggleClass(cloneEl, _this.options.chosenClass, false);

			// #1143: IFrame support workaround
			_this._cloneId = _nextTick(function () {
				if (!_this.options.removeCloneOnHide) {
					rootEl.insertBefore(cloneEl, dragEl);
				}
				_dispatchEvent(_this, rootEl, 'clone', dragEl);
			});

			!fallback && _toggleClass(dragEl, options.dragClass, true);

			// Set proper drop events
			if (fallback) {
				ignoreNextClick = true;
				_this._loopId = setInterval(_this._emulateDragOver, 50);
			} else {
				// Undo what was set in _prepareDragStart before drag started
				_off(document, 'mouseup', _this._onDrop);
				_off(document, 'touchend', _this._onDrop);
				_off(document, 'touchcancel', _this._onDrop);

				if (dataTransfer) {
					dataTransfer.effectAllowed = 'move';
					options.setData && options.setData.call(_this, dataTransfer, dragEl);
				}

				_on(document, 'drop', _this);

				// #1276 fix:
				_css(dragEl, 'transform', 'translateZ(0)');
			}

			awaitingDragStarted = true;

			_this._dragStartId = _nextTick(_this._dragStarted.bind(_this, fallback, evt));
			_on(document, 'selectstart', _this);
			if (Safari) {
				_css(document.body, 'user-select', 'none');
			}
		},

		// Returns true - if no further action is needed (either inserted or another condition)
		_onDragOver: function _onDragOver( /**Event*/evt) {
			var el = this.el,
			    target = evt.target,
			    dragRect,
			    targetRect,
			    revert,
			    options = this.options,
			    group = options.group,
			    activeSortable = Sortable.active,
			    isOwner = activeGroup === group,
			    canSort = options.sort,
			    _this = this;

			if (_silent) return;

			// Return invocation when dragEl is inserted (or completed)
			function completed(insertion) {
				if (insertion) {
					if (isOwner) {
						activeSortable._hideClone();
					} else {
						activeSortable._showClone(_this);
					}

					if (activeSortable) {
						// Set ghost class to new sortable's ghost class
						_toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
						_toggleClass(dragEl, options.ghostClass, true);
					}

					if (putSortable !== _this && _this !== Sortable.active) {
						putSortable = _this;
					} else if (_this === Sortable.active) {
						putSortable = null;
					}

					// Animation
					dragRect && _this._animate(dragRect, dragEl);
					target && targetRect && _this._animate(targetRect, target);
				}

				// Null lastTarget if it is not inside a previously swapped element
				if (target === dragEl && !dragEl.animated || target === el && !target.animated) {
					lastTarget = null;
				}

				// no bubbling and not fallback
				if (!options.dragoverBubble && !evt.rootEl && target !== document) {
					_this._handleAutoScroll(evt);
					dragEl.parentNode[expando]._computeIsAligned(evt);

					// Do not detect for empty insert if already inserted
					!insertion && nearestEmptyInsertDetectEvent(evt);
				}

				!options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();

				return true;
			}

			// Call when dragEl has been inserted
			function changed() {
				_dispatchEvent(_this, rootEl, 'change', target, el, rootEl, oldIndex, _index(dragEl), oldDraggableIndex, _index(dragEl, options.draggable), evt);
			}

			if (evt.preventDefault !== void 0) {
				evt.cancelable && evt.preventDefault();
			}

			moved = true;

			target = _closest(target, options.draggable, el, true);

			// target is dragEl or target is animated
			if (dragEl.contains(evt.target) || target.animated) {
				return completed(false);
			}

			if (target !== dragEl) {
				ignoreNextClick = false;
			}

			if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = !rootEl.contains(dragEl)) // Reverting item into the original list
			: putSortable === this || (this.lastPutMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) && group.checkPut(this, activeSortable, dragEl, evt))) {
				var axis = this._getDirection(evt, target);

				dragRect = _getRect(dragEl);

				if (revert) {
					this._hideClone();
					parentEl = rootEl; // actualization

					if (nextEl) {
						rootEl.insertBefore(dragEl, nextEl);
					} else {
						rootEl.appendChild(dragEl);
					}

					return completed(true);
				}

				var elLastChild = _lastChild(el);

				if (!elLastChild || _ghostIsLast(evt, axis, el) && !elLastChild.animated) {
					// assign target only if condition is true
					if (elLastChild && el === evt.target) {
						target = elLastChild;
					}

					if (target) {
						targetRect = _getRect(target);
					}

					if (isOwner) {
						activeSortable._hideClone();
					} else {
						activeSortable._showClone(this);
					}

					if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
						el.appendChild(dragEl);
						parentEl = el; // actualization
						realDragElRect = null;

						changed();
						return completed(true);
					}
				} else if (target && target !== dragEl && target.parentNode === el) {
					var direction = 0,
					    targetBeforeFirstSwap,
					    aligned = target.sortableMouseAligned,
					    differentLevel = dragEl.parentNode !== el,
					    side1 = axis === 'vertical' ? 'top' : 'left',
					    scrolledPastTop = _isScrolledPast(target, 'top') || _isScrolledPast(dragEl, 'top'),
					    scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;

					if (lastTarget !== target) {
						lastMode = null;
						targetBeforeFirstSwap = _getRect(target)[side1];
						pastFirstInvertThresh = false;
					}

					// Reference: https://www.lucidchart.com/documents/view/10fa0e93-e362-4126-aca2-b709ee56bd8b/0
					if (_isElInRowColumn(dragEl, target, axis) && aligned || differentLevel || scrolledPastTop || options.invertSwap || lastMode === 'insert' ||
					// Needed, in the case that we are inside target and inserted because not aligned... aligned will stay false while inside
					// and lastMode will change to 'insert', but we must swap
					lastMode === 'swap') {
						// New target that we will be inside
						if (lastMode !== 'swap') {
							isCircumstantialInvert = options.invertSwap || differentLevel;
						}

						direction = _getSwapDirection(evt, target, axis, options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, isCircumstantialInvert, lastTarget === target);
						lastMode = 'swap';
					} else {
						// Insert at position
						direction = _getInsertDirection(target);
						lastMode = 'insert';
					}
					if (direction === 0) return completed(false);

					realDragElRect = null;
					lastTarget = target;

					lastDirection = direction;

					targetRect = _getRect(target);

					var nextSibling = target.nextElementSibling,
					    after = false;

					after = direction === 1;

					var moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, after);

					if (moveVector !== false) {
						if (moveVector === 1 || moveVector === -1) {
							after = moveVector === 1;
						}

						_silent = true;
						setTimeout(_unsilent, 30);

						if (isOwner) {
							activeSortable._hideClone();
						} else {
							activeSortable._showClone(this);
						}

						if (after && !nextSibling) {
							el.appendChild(dragEl);
						} else {
							target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
						}

						// Undo chrome's scroll adjustment
						if (scrolledPastTop) {
							_scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
						}

						parentEl = dragEl.parentNode; // actualization

						// must be done before animation
						if (targetBeforeFirstSwap !== undefined && !isCircumstantialInvert) {
							targetMoveDistance = abs(targetBeforeFirstSwap - _getRect(target)[side1]);
						}
						changed();

						return completed(true);
					}
				}

				if (el.contains(dragEl)) {
					return completed(false);
				}
			}

			return false;
		},

		_animate: function _animate(prevRect, target) {
			var ms = this.options.animation;

			if (ms) {
				var currentRect = _getRect(target);

				if (target === dragEl) {
					realDragElRect = currentRect;
				}

				if (prevRect.nodeType === 1) {
					prevRect = _getRect(prevRect);
				}

				// Check if actually moving position
				if (prevRect.left + prevRect.width / 2 !== currentRect.left + currentRect.width / 2 || prevRect.top + prevRect.height / 2 !== currentRect.top + currentRect.height / 2) {
					var matrix = _matrix(this.el),
					    scaleX = matrix && matrix.a,
					    scaleY = matrix && matrix.d;

					_css(target, 'transition', 'none');
					_css(target, 'transform', 'translate3d(' + (prevRect.left - currentRect.left) / (scaleX ? scaleX : 1) + 'px,' + (prevRect.top - currentRect.top) / (scaleY ? scaleY : 1) + 'px,0)');

					this._repaint(target);
					_css(target, 'transition', 'transform ' + ms + 'ms' + (this.options.easing ? ' ' + this.options.easing : ''));
					_css(target, 'transform', 'translate3d(0,0,0)');
				}

				typeof target.animated === 'number' && clearTimeout(target.animated);
				target.animated = setTimeout(function () {
					_css(target, 'transition', '');
					_css(target, 'transform', '');
					target.animated = false;
				}, ms);
			}
		},

		_repaint: function _repaint(target) {
			return target.offsetWidth;
		},

		_offMoveEvents: function _offMoveEvents() {
			_off(document, 'touchmove', this._onTouchMove);
			_off(document, 'pointermove', this._onTouchMove);
			_off(document, 'dragover', nearestEmptyInsertDetectEvent);
			_off(document, 'mousemove', nearestEmptyInsertDetectEvent);
			_off(document, 'touchmove', nearestEmptyInsertDetectEvent);
		},

		_offUpEvents: function _offUpEvents() {
			var ownerDocument = this.el.ownerDocument;

			_off(ownerDocument, 'mouseup', this._onDrop);
			_off(ownerDocument, 'touchend', this._onDrop);
			_off(ownerDocument, 'pointerup', this._onDrop);
			_off(ownerDocument, 'touchcancel', this._onDrop);
			_off(document, 'selectstart', this);
		},

		_onDrop: function _onDrop( /**Event*/evt) {
			var el = this.el,
			    options = this.options;
			awaitingDragStarted = false;
			scrolling = false;
			isCircumstantialInvert = false;
			pastFirstInvertThresh = false;

			clearInterval(this._loopId);

			clearInterval(pointerElemChangedInterval);
			_clearAutoScrolls();
			_cancelThrottle();

			clearTimeout(this._dragStartTimer);

			_cancelNextTick(this._cloneId);
			_cancelNextTick(this._dragStartId);

			// Unbind events
			_off(document, 'mousemove', this._onTouchMove);

			if (this.nativeDraggable) {
				_off(document, 'drop', this);
				_off(el, 'dragstart', this._onDragStart);
				_off(document, 'dragover', this._handleAutoScroll);
				_off(document, 'dragover', _checkAlignment);
			}

			if (Safari) {
				_css(document.body, 'user-select', '');
			}

			this._offMoveEvents();
			this._offUpEvents();

			if (evt) {
				if (moved) {
					evt.cancelable && evt.preventDefault();
					!options.dropBubble && evt.stopPropagation();
				}

				ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);

				if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
					// Remove clone
					cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
				}

				if (dragEl) {
					if (this.nativeDraggable) {
						_off(dragEl, 'dragend', this);
					}

					_disableDraggable(dragEl);
					dragEl.style['will-change'] = '';

					// Remove class's
					_toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : this.options.ghostClass, false);
					_toggleClass(dragEl, this.options.chosenClass, false);

					// Drag stop event
					_dispatchEvent(this, rootEl, 'unchoose', dragEl, parentEl, rootEl, oldIndex, null, oldDraggableIndex, null, evt);

					if (rootEl !== parentEl) {
						newIndex = _index(dragEl);
						newDraggableIndex = _index(dragEl, options.draggable);

						if (newIndex >= 0) {
							// Add event
							_dispatchEvent(null, parentEl, 'add', dragEl, parentEl, rootEl, oldIndex, newIndex, oldDraggableIndex, newDraggableIndex, evt);

							// Remove event
							_dispatchEvent(this, rootEl, 'remove', dragEl, parentEl, rootEl, oldIndex, newIndex, oldDraggableIndex, newDraggableIndex, evt);

							// drag from one list and drop into another
							_dispatchEvent(null, parentEl, 'sort', dragEl, parentEl, rootEl, oldIndex, newIndex, oldDraggableIndex, newDraggableIndex, evt);
							_dispatchEvent(this, rootEl, 'sort', dragEl, parentEl, rootEl, oldIndex, newIndex, oldDraggableIndex, newDraggableIndex, evt);
						}

						putSortable && putSortable.save();
					} else {
						if (dragEl.nextSibling !== nextEl) {
							// Get the index of the dragged element within its parent
							newIndex = _index(dragEl);
							newDraggableIndex = _index(dragEl, options.draggable);

							if (newIndex >= 0) {
								// drag & drop within the same list
								_dispatchEvent(this, rootEl, 'update', dragEl, parentEl, rootEl, oldIndex, newIndex, oldDraggableIndex, newDraggableIndex, evt);
								_dispatchEvent(this, rootEl, 'sort', dragEl, parentEl, rootEl, oldIndex, newIndex, oldDraggableIndex, newDraggableIndex, evt);
							}
						}
					}

					if (Sortable.active) {
						/* jshint eqnull:true */
						if (newIndex == null || newIndex === -1) {
							newIndex = oldIndex;
							newDraggableIndex = oldDraggableIndex;
						}
						_dispatchEvent(this, rootEl, 'end', dragEl, parentEl, rootEl, oldIndex, newIndex, oldDraggableIndex, newDraggableIndex, evt);

						// Save sorting
						this.save();
					}
				}
			}
			this._nulling();
		},

		_nulling: function _nulling() {
			rootEl = dragEl = parentEl = ghostEl = nextEl = cloneEl = lastDownEl = scrollEl = scrollParentEl = autoScrolls.length = pointerElemChangedInterval = lastPointerElemX = lastPointerElemY = tapEvt = touchEvt = moved = newIndex = oldIndex = lastTarget = lastDirection = realDragElRect = putSortable = activeGroup = Sortable.active = null;

			savedInputChecked.forEach(function (el) {
				el.checked = true;
			});

			savedInputChecked.length = 0;
		},

		handleEvent: function handleEvent( /**Event*/evt) {
			switch (evt.type) {
				case 'drop':
				case 'dragend':
					this._onDrop(evt);
					break;

				case 'dragenter':
				case 'dragover':
					if (dragEl) {
						this._onDragOver(evt);
						_globalDragOver(evt);
					}
					break;

				case 'selectstart':
					evt.preventDefault();
					break;
			}
		},

		/**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */
		toArray: function toArray() {
			var order = [],
			    el,
			    children = this.el.children,
			    i = 0,
			    n = children.length,
			    options = this.options;

			for (; i < n; i++) {
				el = children[i];
				if (_closest(el, options.draggable, this.el, false)) {
					order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
				}
			}

			return order;
		},

		/**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */
		sort: function sort(order) {
			var items = {},
			    rootEl = this.el;

			this.toArray().forEach(function (id, i) {
				var el = rootEl.children[i];

				if (_closest(el, this.options.draggable, rootEl, false)) {
					items[id] = el;
				}
			}, this);

			order.forEach(function (id) {
				if (items[id]) {
					rootEl.removeChild(items[id]);
					rootEl.appendChild(items[id]);
				}
			});
		},

		/**
   * Save the current sorting
   */
		save: function save() {
			var store = this.options.store;
			store && store.set && store.set(this);
		},

		/**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */
		closest: function closest(el, selector) {
			return _closest(el, selector || this.options.draggable, this.el, false);
		},

		/**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */
		option: function option(name, value) {
			var options = this.options;

			if (value === void 0) {
				return options[name];
			} else {
				options[name] = value;

				if (name === 'group') {
					_prepareGroup(options);
				}
			}
		},

		/**
   * Destroy
   */
		destroy: function destroy() {
			var el = this.el;

			el[expando] = null;

			_off(el, 'mousedown', this._onTapStart);
			_off(el, 'touchstart', this._onTapStart);
			_off(el, 'pointerdown', this._onTapStart);

			if (this.nativeDraggable) {
				_off(el, 'dragover', this);
				_off(el, 'dragenter', this);
			}
			// Remove draggable attributes
			Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function (el) {
				el.removeAttribute('draggable');
			});

			this._onDrop();

			sortables.splice(sortables.indexOf(this.el), 1);

			this.el = el = null;
		},

		_hideClone: function _hideClone() {
			if (!cloneEl.cloneHidden) {
				_css(cloneEl, 'display', 'none');
				cloneEl.cloneHidden = true;
				if (cloneEl.parentNode && this.options.removeCloneOnHide) {
					cloneEl.parentNode.removeChild(cloneEl);
				}
			}
		},

		_showClone: function _showClone(putSortable) {
			if (putSortable.lastPutMode !== 'clone') {
				this._hideClone();
				return;
			}

			if (cloneEl.cloneHidden) {
				// show clone at dragEl or original position
				if (rootEl.contains(dragEl) && !this.options.group.revertClone) {
					rootEl.insertBefore(cloneEl, dragEl);
				} else if (nextEl) {
					rootEl.insertBefore(cloneEl, nextEl);
				} else {
					rootEl.appendChild(cloneEl);
				}

				if (this.options.group.revertClone) {
					this._animate(dragEl, cloneEl);
				}
				_css(cloneEl, 'display', '');
				cloneEl.cloneHidden = false;
			}
		}
	};

	function _closest( /**HTMLElement*/el, /**String*/selector, /**HTMLElement*/ctx, includeCTX) {
		if (el) {
			ctx = ctx || document;

			do {
				if (selector != null && (selector[0] === '>' ? el.parentNode === ctx && _matches(el, selector) : _matches(el, selector)) || includeCTX && el === ctx) {
					return el;
				}

				if (el === ctx) break;
				/* jshint boss:true */
			} while (el = _getParentOrHost(el));
		}

		return null;
	}

	function _getParentOrHost(el) {
		return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
	}

	function _globalDragOver( /**Event*/evt) {
		if (evt.dataTransfer) {
			evt.dataTransfer.dropEffect = 'move';
		}
		evt.cancelable && evt.preventDefault();
	}

	function _on(el, event, fn) {
		el.addEventListener(event, fn, IE11OrLess ? false : captureMode);
	}

	function _off(el, event, fn) {
		el.removeEventListener(event, fn, IE11OrLess ? false : captureMode);
	}

	function _toggleClass(el, name, state) {
		if (el && name) {
			if (el.classList) {
				el.classList[state ? 'add' : 'remove'](name);
			} else {
				var className = (' ' + el.className + ' ').replace(R_SPACE, ' ').replace(' ' + name + ' ', ' ');
				el.className = (className + (state ? ' ' + name : '')).replace(R_SPACE, ' ');
			}
		}
	}

	function _css(el, prop, val) {
		var style = el && el.style;

		if (style) {
			if (val === void 0) {
				if (document.defaultView && document.defaultView.getComputedStyle) {
					val = document.defaultView.getComputedStyle(el, '');
				} else if (el.currentStyle) {
					val = el.currentStyle;
				}

				return prop === void 0 ? val : val[prop];
			} else {
				if (!(prop in style) && prop.indexOf('webkit') === -1) {
					prop = '-webkit-' + prop;
				}

				style[prop] = val + (typeof val === 'string' ? '' : 'px');
			}
		}
	}

	function _matrix(el) {
		var appliedTransforms = '';
		do {
			var transform = _css(el, 'transform');

			if (transform && transform !== 'none') {
				appliedTransforms = transform + ' ' + appliedTransforms;
			}
			/* jshint boss:true */
		} while (el = el.parentNode);

		if (window.DOMMatrix) {
			return new DOMMatrix(appliedTransforms);
		} else if (window.WebKitCSSMatrix) {
			return new WebKitCSSMatrix(appliedTransforms);
		} else if (window.CSSMatrix) {
			return new CSSMatrix(appliedTransforms);
		}
	}

	function _find(ctx, tagName, iterator) {
		if (ctx) {
			var list = ctx.getElementsByTagName(tagName),
			    i = 0,
			    n = list.length;

			if (iterator) {
				for (; i < n; i++) {
					iterator(list[i], i);
				}
			}

			return list;
		}

		return [];
	}

	function _dispatchEvent(sortable, rootEl, name, targetEl, toEl, fromEl, startIndex, newIndex, startDraggableIndex, newDraggableIndex, originalEvt) {
		sortable = sortable || rootEl[expando];
		var evt,
		    options = sortable.options,
		    onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1);
		// Support for new CustomEvent feature
		if (window.CustomEvent && !IE11OrLess && !Edge) {
			evt = new CustomEvent(name, {
				bubbles: true,
				cancelable: true
			});
		} else {
			evt = document.createEvent('Event');
			evt.initEvent(name, true, true);
		}

		evt.to = toEl || rootEl;
		evt.from = fromEl || rootEl;
		evt.item = targetEl || rootEl;
		evt.clone = cloneEl;

		evt.oldIndex = startIndex;
		evt.newIndex = newIndex;

		evt.oldDraggableIndex = startDraggableIndex;
		evt.newDraggableIndex = newDraggableIndex;

		evt.originalEvent = originalEvt;
		evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;

		if (rootEl) {
			rootEl.dispatchEvent(evt);
		}

		if (options[onName]) {
			options[onName].call(sortable, evt);
		}
	}

	function _onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvt, willInsertAfter) {
		var evt,
		    sortable = fromEl[expando],
		    onMoveFn = sortable.options.onMove,
		    retVal;
		// Support for new CustomEvent feature
		if (window.CustomEvent && !IE11OrLess && !Edge) {
			evt = new CustomEvent('move', {
				bubbles: true,
				cancelable: true
			});
		} else {
			evt = document.createEvent('Event');
			evt.initEvent('move', true, true);
		}

		evt.to = toEl;
		evt.from = fromEl;
		evt.dragged = dragEl;
		evt.draggedRect = dragRect;
		evt.related = targetEl || toEl;
		evt.relatedRect = targetRect || _getRect(toEl);
		evt.willInsertAfter = willInsertAfter;

		evt.originalEvent = originalEvt;

		fromEl.dispatchEvent(evt);

		if (onMoveFn) {
			retVal = onMoveFn.call(sortable, evt, originalEvt);
		}

		return retVal;
	}

	function _disableDraggable(el) {
		el.draggable = false;
	}

	function _unsilent() {
		_silent = false;
	}

	/**
  * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
  * and non-draggable elements
  * @param  {HTMLElement} el       The parent element
  * @param  {Number} childNum      The index of the child
  * @param  {Object} options       Parent Sortable's options
  * @return {HTMLElement}          The child at index childNum, or null if not found
  */
	function _getChild(el, childNum, options) {
		var currentChild = 0,
		    i = 0,
		    children = el.children;

		while (i < children.length) {
			if (children[i].style.display !== 'none' && children[i] !== ghostEl && children[i] !== dragEl && _closest(children[i], options.draggable, el, false)) {
				if (currentChild === childNum) {
					return children[i];
				}
				currentChild++;
			}

			i++;
		}
		return null;
	}

	/**
  * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
  * @param  {HTMLElement} el       Parent element
  * @return {HTMLElement}          The last child, ignoring ghostEl
  */
	function _lastChild(el) {
		var last = el.lastElementChild;

		while (last && (last === ghostEl || _css(last, 'display') === 'none')) {
			last = last.previousElementSibling;
		}

		return last || null;
	}

	function _ghostIsLast(evt, axis, el) {
		var elRect = _getRect(_lastChild(el)),
		    mouseOnAxis = axis === 'vertical' ? evt.clientY : evt.clientX,
		    mouseOnOppAxis = axis === 'vertical' ? evt.clientX : evt.clientY,
		    targetS2 = axis === 'vertical' ? elRect.bottom : elRect.right,
		    targetS1Opp = axis === 'vertical' ? elRect.left : elRect.top,
		    targetS2Opp = axis === 'vertical' ? elRect.right : elRect.bottom,
		    spacer = 10;

		return axis === 'vertical' ? mouseOnOppAxis > targetS2Opp + spacer || mouseOnOppAxis <= targetS2Opp && mouseOnAxis > targetS2 && mouseOnOppAxis >= targetS1Opp : mouseOnAxis > targetS2 && mouseOnOppAxis > targetS1Opp || mouseOnAxis <= targetS2 && mouseOnOppAxis > targetS2Opp + spacer;
	}

	function _getSwapDirection(evt, target, axis, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
		var targetRect = _getRect(target),
		    mouseOnAxis = axis === 'vertical' ? evt.clientY : evt.clientX,
		    targetLength = axis === 'vertical' ? targetRect.height : targetRect.width,
		    targetS1 = axis === 'vertical' ? targetRect.top : targetRect.left,
		    targetS2 = axis === 'vertical' ? targetRect.bottom : targetRect.right,
		    dragRect = _getRect(dragEl),
		    invert = false;

		if (!invertSwap) {
			// Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
			if (isLastTarget && targetMoveDistance < targetLength * swapThreshold) {
				// multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
				// check if past first invert threshold on side opposite of lastDirection
				if (!pastFirstInvertThresh && (lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) {
					// past first invert threshold, do not restrict inverted threshold to dragEl shadow
					pastFirstInvertThresh = true;
				}

				if (!pastFirstInvertThresh) {
					var dragS1 = axis === 'vertical' ? dragRect.top : dragRect.left,
					    dragS2 = axis === 'vertical' ? dragRect.bottom : dragRect.right;
					// dragEl shadow (target move distance shadow)
					if (lastDirection === 1 ? mouseOnAxis < targetS1 + targetMoveDistance // over dragEl shadow
					: mouseOnAxis > targetS2 - targetMoveDistance) {
						return lastDirection * -1;
					}
				} else {
					invert = true;
				}
			} else {
				// Regular
				if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) {
					return _getInsertDirection(target);
				}
			}
		}

		invert = invert || invertSwap;

		if (invert) {
			// Invert of regular
			if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) {
				return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
			}
		}

		return 0;
	}

	/**
  * Gets the direction dragEl must be swapped relative to target in order to make it
  * seem that dragEl has been "inserted" into that element's position
  * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
  * @return {Number}                   Direction dragEl must be swapped
  */
	function _getInsertDirection(target) {
		var dragElIndex = _index(dragEl),
		    targetIndex = _index(target);

		if (dragElIndex < targetIndex) {
			return 1;
		} else {
			return -1;
		}
	}

	/**
  * Generate id
  * @param   {HTMLElement} el
  * @returns {String}
  * @private
  */
	function _generateId(el) {
		var str = el.tagName + el.className + el.src + el.href + el.textContent,
		    i = str.length,
		    sum = 0;

		while (i--) {
			sum += str.charCodeAt(i);
		}

		return sum.toString(36);
	}

	/**
  * Returns the index of an element within its parent for a selected set of
  * elements
  * @param  {HTMLElement} el
  * @param  {selector} selector
  * @return {number}
  */
	function _index(el, selector) {
		var index = 0;

		if (!el || !el.parentNode) {
			return -1;
		}

		while (el && (el = el.previousElementSibling)) {
			if (el.nodeName.toUpperCase() !== 'TEMPLATE' && el !== cloneEl && (!selector || _matches(el, selector))) {
				index++;
			}
		}

		return index;
	}

	function _matches( /**HTMLElement*/el, /**String*/selector) {
		if (!selector) return;

		selector[0] === '>' && (selector = selector.substring(1));

		if (el) {
			try {
				if (el.matches) {
					return el.matches(selector);
				} else if (el.msMatchesSelector) {
					return el.msMatchesSelector(selector);
				} else if (el.webkitMatchesSelector) {
					return el.webkitMatchesSelector(selector);
				}
			} catch (_) {
				return false;
			}
		}

		return false;
	}

	var _throttleTimeout;
	function _throttle(callback, ms) {
		return function () {
			if (!_throttleTimeout) {
				var args = arguments,
				    _this = this;

				_throttleTimeout = setTimeout(function () {
					if (args.length === 1) {
						callback.call(_this, args[0]);
					} else {
						callback.apply(_this, args);
					}

					_throttleTimeout = void 0;
				}, ms);
			}
		};
	}

	function _cancelThrottle() {
		clearTimeout(_throttleTimeout);
		_throttleTimeout = void 0;
	}

	function _extend(dst, src) {
		if (dst && src) {
			for (var key in src) {
				if (src.hasOwnProperty(key)) {
					dst[key] = src[key];
				}
			}
		}

		return dst;
	}

	function _clone(el) {
		if (Polymer && Polymer.dom) {
			return Polymer.dom(el).cloneNode(true);
		} else if ($) {
			return $(el).clone(true)[0];
		} else {
			return el.cloneNode(true);
		}
	}

	function _saveInputCheckedState(root) {
		savedInputChecked.length = 0;

		var inputs = root.getElementsByTagName('input');
		var idx = inputs.length;

		while (idx--) {
			var el = inputs[idx];
			el.checked && savedInputChecked.push(el);
		}
	}

	function _nextTick(fn) {
		return setTimeout(fn, 0);
	}

	function _cancelNextTick(id) {
		return clearTimeout(id);
	}

	/**
  * Returns the "bounding client rect" of given element
  * @param  {HTMLElement} el                The element whose boundingClientRect is wanted
  * @param  {[HTMLElement]} container       the parent the element will be placed in
  * @param  {[Boolean]} adjustForTransform  Whether the rect should compensate for parent's transform
  * @return {Object}                        The boundingClientRect of el
  */
	function _getRect(el, adjustForTransform, container, adjustForFixed) {
		if (!el.getBoundingClientRect && el !== win) return;

		var elRect, top, left, bottom, right, height, width;

		if (el !== win && el !== _getWindowScrollingElement()) {
			elRect = el.getBoundingClientRect();
			top = elRect.top;
			left = elRect.left;
			bottom = elRect.bottom;
			right = elRect.right;
			height = elRect.height;
			width = elRect.width;
		} else {
			top = 0;
			left = 0;
			bottom = window.innerHeight;
			right = window.innerWidth;
			height = window.innerHeight;
			width = window.innerWidth;
		}

		if (adjustForFixed && el !== win) {
			// Adjust for translate()
			container = container || el.parentNode;

			// solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
			// Not needed on <= IE11
			if (!IE11OrLess) {
				do {
					if (container && container.getBoundingClientRect && _css(container, 'transform') !== 'none') {
						var containerRect = container.getBoundingClientRect();

						// Set relative to edges of padding box of container
						top -= containerRect.top + parseInt(_css(container, 'border-top-width'));
						left -= containerRect.left + parseInt(_css(container, 'border-left-width'));
						bottom = top + elRect.height;
						right = left + elRect.width;

						break;
					}
					/* jshint boss:true */
				} while (container = container.parentNode);
			}
		}

		if (adjustForTransform && el !== win) {
			// Adjust for scale()
			var matrix = _matrix(container || el),
			    scaleX = matrix && matrix.a,
			    scaleY = matrix && matrix.d;

			if (matrix) {
				top /= scaleY;
				left /= scaleX;

				width /= scaleX;
				height /= scaleY;

				bottom = top + height;
				right = left + width;
			}
		}

		return {
			top: top,
			left: left,
			bottom: bottom,
			right: right,
			width: width,
			height: height
		};
	}

	/**
  * Checks if a side of an element is scrolled past a side of it's parents
  * @param  {HTMLElement}  el       The element who's side being scrolled out of view is in question
  * @param  {String}       side     Side of the element in question ('top', 'left', 'right', 'bottom')
  * @return {HTMLElement}           The parent scroll element that the el's side is scrolled past, or null if there is no such element
  */
	function _isScrolledPast(el, side) {
		var parent = _getParentAutoScrollElement(el, true),
		    elSide = _getRect(el)[side];

		/* jshint boss:true */
		while (parent) {
			var parentSide = _getRect(parent)[side],
			    visible;

			if (side === 'top' || side === 'left') {
				visible = elSide >= parentSide;
			} else {
				visible = elSide <= parentSide;
			}

			if (!visible) return parent;

			if (parent === _getWindowScrollingElement()) break;

			parent = _getParentAutoScrollElement(parent, false);
		}

		return false;
	}

	/**
  * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
  * The value is returned in real pixels.
  * @param  {HTMLElement} el
  * @return {Array}             Offsets in the format of [left, top]
  */
	function _getRelativeScrollOffset(el) {
		var offsetLeft = 0,
		    offsetTop = 0,
		    winScroller = _getWindowScrollingElement();

		if (el) {
			do {
				var matrix = _matrix(el),
				    scaleX = matrix.a,
				    scaleY = matrix.d;

				offsetLeft += el.scrollLeft * scaleX;
				offsetTop += el.scrollTop * scaleY;
			} while (el !== winScroller && (el = el.parentNode));
		}

		return [offsetLeft, offsetTop];
	}

	// Fixed #973:
	_on(document, 'touchmove', function (evt) {
		if ((Sortable.active || awaitingDragStarted) && evt.cancelable) {
			evt.preventDefault();
		}
	});

	// Export utils
	Sortable.utils = {
		on: _on,
		off: _off,
		css: _css,
		find: _find,
		is: function is(el, selector) {
			return !!_closest(el, selector, el, false);
		},
		extend: _extend,
		throttle: _throttle,
		closest: _closest,
		toggleClass: _toggleClass,
		clone: _clone,
		index: _index,
		nextTick: _nextTick,
		cancelNextTick: _cancelNextTick,
		detectDirection: _detectDirection,
		getChild: _getChild
	};

	/**
  * Create sortable instance
  * @param {HTMLElement}  el
  * @param {Object}      [options]
  */
	Sortable.create = function (el, options) {
		return new Sortable(el, options);
	};

	// Export
	Sortable.version = '1.9.0';
	return Sortable;
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/vendor/store/store.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function (root, factory) {
	if (true) {
		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
		// Node. Does not work with strict CommonJS, but
		// only CommonJS-like environments that support module.exports,
		// like Node.
		module.exports = factory();
	} else {
		// Browser globals (root is window)
		root.store = factory();
	}
})(undefined, function () {

	// Store.js
	var store = {},
	    win = typeof window != 'undefined' ? window : global,
	    doc = win.document,
	    localStorageName = 'localStorage',
	    scriptTag = 'script',
	    storage;

	store.disabled = false;
	store.version = '1.3.20';
	store.set = function (key, value) {};
	store.get = function (key, defaultVal) {};
	store.has = function (key) {
		return store.get(key) !== undefined;
	};
	store.remove = function (key) {};
	store.clear = function () {};
	store.transact = function (key, defaultVal, transactionFn) {
		if (transactionFn == null) {
			transactionFn = defaultVal;
			defaultVal = null;
		}
		if (defaultVal == null) {
			defaultVal = {};
		}
		var val = store.get(key, defaultVal);
		transactionFn(val);
		store.set(key, val);
	};
	store.getAll = function () {};
	store.forEach = function () {};

	store.serialize = function (value) {
		return JSON.stringify(value);
	};
	store.deserialize = function (value) {
		if (typeof value != 'string') {
			return undefined;
		}
		try {
			return JSON.parse(value);
		} catch (e) {
			return value || undefined;
		}
	};

	// Functions to encapsulate questionable FireFox 3.6.13 behavior
	// when about.config::dom.storage.enabled === false
	// See https://github.com/marcuswestin/store.js/issues#issue/13
	function isLocalStorageNameSupported() {
		try {
			return localStorageName in win && win[localStorageName];
		} catch (err) {
			return false;
		}
	}

	if (isLocalStorageNameSupported()) {
		storage = win[localStorageName];
		store.set = function (key, val) {
			if (val === undefined) {
				return store.remove(key);
			}
			storage.setItem(key, store.serialize(val));
			return val;
		};
		store.get = function (key, defaultVal) {
			var val = store.deserialize(storage.getItem(key));
			return val === undefined ? defaultVal : val;
		};
		store.remove = function (key) {
			storage.removeItem(key);
		};
		store.clear = function () {
			storage.clear();
		};
		store.getAll = function () {
			var ret = {};
			store.forEach(function (key, val) {
				ret[key] = val;
			});
			return ret;
		};
		store.forEach = function (callback) {
			for (var i = 0; i < storage.length; i++) {
				var key = storage.key(i);
				callback(key, store.get(key));
			}
		};
	} else if (doc && doc.documentElement.addBehavior) {
		var storageOwner, storageContainer;
		// Since #userData storage applies only to specific paths, we need to
		// somehow link our data to a specific path.  We choose /favicon.ico
		// as a pretty safe option, since all browsers already make a request to
		// this URL anyway and being a 404 will not hurt us here.  We wrap an
		// iframe pointing to the favicon in an ActiveXObject(htmlfile) object
		// (see: http://msdn.microsoft.com/en-us/library/aa752574(v=VS.85).aspx)
		// since the iframe access rules appear to allow direct access and
		// manipulation of the document element, even for a 404 page.  This
		// document can be used instead of the current document (which would
		// have been limited to the current path) to perform #userData storage.
		try {
			storageContainer = new ActiveXObject('htmlfile');
			storageContainer.open();
			storageContainer.write('<' + scriptTag + '>document.w=window</' + scriptTag + '><iframe src="/favicon.ico"></iframe>');
			storageContainer.close();
			storageOwner = storageContainer.w.frames[0].document;
			storage = storageOwner.createElement('div');
		} catch (e) {
			// somehow ActiveXObject instantiation failed (perhaps some special
			// security settings or otherwse), fall back to per-path storage
			storage = doc.createElement('div');
			storageOwner = doc.body;
		}
		var withIEStorage = function withIEStorage(storeFunction) {
			return function () {
				var args = Array.prototype.slice.call(arguments, 0);
				args.unshift(storage);
				// See http://msdn.microsoft.com/en-us/library/ms531081(v=VS.85).aspx
				// and http://msdn.microsoft.com/en-us/library/ms531424(v=VS.85).aspx
				storageOwner.appendChild(storage);
				storage.addBehavior('#default#userData');
				storage.load(localStorageName);
				var result = storeFunction.apply(store, args);
				storageOwner.removeChild(storage);
				return result;
			};
		};

		// In IE7, keys cannot start with a digit or contain certain chars.
		// See https://github.com/marcuswestin/store.js/issues/40
		// See https://github.com/marcuswestin/store.js/issues/83
		var forbiddenCharsRegex = new RegExp("[!\"#$%&'()*+,/\\\\:;<=>?@[\\]^`{|}~]", "g");
		var ieKeyFix = function ieKeyFix(key) {
			return key.replace(/^d/, '___$&').replace(forbiddenCharsRegex, '___');
		};
		store.set = withIEStorage(function (storage, key, val) {
			key = ieKeyFix(key);
			if (val === undefined) {
				return store.remove(key);
			}
			storage.setAttribute(key, store.serialize(val));
			storage.save(localStorageName);
			return val;
		});
		store.get = withIEStorage(function (storage, key, defaultVal) {
			key = ieKeyFix(key);
			var val = store.deserialize(storage.getAttribute(key));
			return val === undefined ? defaultVal : val;
		});
		store.remove = withIEStorage(function (storage, key) {
			key = ieKeyFix(key);
			storage.removeAttribute(key);
			storage.save(localStorageName);
		});
		store.clear = withIEStorage(function (storage) {
			var attributes = storage.XMLDocument.documentElement.attributes;
			storage.load(localStorageName);
			for (var i = attributes.length - 1; i >= 0; i--) {
				storage.removeAttribute(attributes[i].name);
			}
			storage.save(localStorageName);
		});
		store.getAll = function (storage) {
			var ret = {};
			store.forEach(function (key, val) {
				ret[key] = val;
			});
			return ret;
		};
		store.forEach = withIEStorage(function (storage, callback) {
			var attributes = storage.XMLDocument.documentElement.attributes;
			for (var i = 0, attr; attr = attributes[i]; ++i) {
				callback(attr.name, store.deserialize(storage.getAttribute(attr.name)));
			}
		});
	}

	try {
		var testKey = '__storejs__';
		store.set(testKey, testKey);
		if (store.get(testKey) != testKey) {
			store.disabled = true;
		}
		store.remove(testKey);
	} catch (e) {
		store.disabled = true;
	}
	store.enabled = !store.disabled;

	return store;
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "/tool/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--10-0!/tool/node_modules/css-loader/index.js??ref--10-1!/tool/node_modules/postcss-loader/lib/index.js??ref--10-2!/tool/node_modules/sass-loader/lib/loader.js??ref--10-3!/tool/project/client/src/site__stratco/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/tool/node_modules/webpack/buildin/amd-options.js":
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),

/***/ "external \"jQuery\"":
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),

/***/ "multi /tool/project/client/src/core/index.js /tool/project/client/src/site__stratco/index.scss":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/index.js");
module.exports = __webpack_require__("/tool/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--10-0!/tool/node_modules/css-loader/index.js??ref--10-1!/tool/node_modules/postcss-loader/lib/index.js??ref--10-2!/tool/node_modules/sass-loader/lib/loader.js??ref--10-3!/tool/project/client/src/site__stratco/index.scss");


/***/ })

},["multi /tool/project/client/src/core/index.js /tool/project/client/src/site__stratco/index.scss"]);


// WEBPACK FOOTER //
// scripts/site__stratco--6c46a034bc59136f228f.js